const messagesFR = {
    code: "fr",
    messages: {
        zoho: {
            SETTING_GROUP: "Paramètres",
            usermapping: "Mappage des utilisateurs",
        },
        chatWindow: {
            descending: "Décroissant",
            ascending: "Croissant",
            filterTable:"Filtrer",
            thereIsNoChatContent: "Aucun contenu de chat disponible.",
            thereIsNoChatContentDsc: "Vous pouvez voir le contenu du chat et envoyer des messages ici.",
            interactions: "Interactions :",
            departments: "Départements",
            channels: "Canaux",
            date: "Date",
            lastChatStatus: "Dernier statut du chat",
            all: "Tous",
            queued: "En attente",
            open: "Ouvert",
            closed: "Fermé",
            private: "Privé",
            chatbot: "Chatbot",
            lostMissed: "Perdu / Manqué",
            interaction: "Interaction",
            myActiveInbox: "Ma boîte de réception active",
            activeQueueInbox: "Boîte de réception active + file d'attente",
            chatbotActiveInbox: "Boîte de réception active du chatbot",
            myDepartmentsActiveInbox: "Boîte de réception active de mes départements",
            notInteractedYesterday: "Aucune interaction hier",
            queueInbox: "File d'attente de la boîte de réception",
            whatsappActiveInbox: "Boîte de réception active WhatsApp",
            socialMediaActiveInbox: "Boîte de réception active des réseaux sociaux",
            missedThisMonth: "Chats manqués ce mois-ci",
            chooseAFileOrDragItHere: "Choisissez un fichier ou faites-le glisser ici!",
            watching: "En train de regarder",
            selectFilter: "Sélectionner un filtre",
            clearAll: "Tout effacer",
            me: "Moi",
            today: "Aujourd'hui",
            yesterday: "Hier",
            thisWeek: "Cette semaine",
            lastWeek: "La semaine dernière",
            last7Days: "Les 7 derniers jours",
            last30Days: "Les 30 derniers jours",
            thisMonth: "Ce mois-ci",
            lastMonth: "Le mois dernier",
            last24h: "Les dernières 24 heures",
            custom: "Personnalisé",
            startMessage: "Démarrer le message",
            goToAgentReport: "Aller au rapport d'agent",
            agentDetail: "Détail de l'agent",
            agentList: "Liste des agents",
            selectedFilter: "Filtre sélectionné",
            groupBy: "Grouper",
            none: "Pas de groupe",
            agent: "Représentant",
            department: "Département",
            tag: "Tag",
            website: "Website",
            channel: "Channel",
            platform: "Plateforme",
            answerStatus: "Answer Status",
            sortBy: "Trier",
            lastPostAbove: "Dernier message en haut",
            newChatsAbove: "Nouveaux chats en haut",
            oldChatsAbove: "Anciens chats en haut",
            live: "En direct",
            systemStatus: "État du système",
            refresh: "Rafraîchir",
            close: "Fermer",
            totalCustomers: "Nombre total de clients",
            totalAnswered: "Total répondu",
            waitingAnswer: "En attente de réponse",
            totalAgentInChat: "Nombre total d'agents en chat",
            onlineAgentCount: "Nombre d'agents en ligne",
            totalCustomer: "Client total",
            answered: "Répondu",
            unanswered: "Non répondu",
            noContactWasFoundMatchingTheCurrentFilters: "Aucun contact ne correspond aux filtres actuels.",
            you: "Vous",
            others: "Autres",
            queue: "File d'attente",
            chatbotContact: "Chatbot",
            closedContact: "Fermé",
            myInteractions: "Mes Interactions",
            special: "Spécial",
            allInteractions: "Tous les contacts",
            waiting: "En attente",
            departmentToWhichItIsAffiliated: "Département auquel il est affilié",
            owner: "Propriétaire",
        },
        chat: {
            inbox: "Boîte de Réception",
            layouts: {
                chat: "Vue Chat",
                table: "Vue Tableau",
                kanban: "Vue Kanban",
            },
            filters: {
                allContacts: "Tous les Contacts",
                myInbox: "Ma Boîte de Réception",
                myContacts: "Mes Contacts",
                missed: "Manqués",
                unanswered: "Sans réponse",
                unassigned: "Non Assignés",
                chatbot: "Chatbot",
            },
            groups: {
                views: "Vues",
                customFilters: "Filtres Personnalisés",
                team: "Équipe",
                contacts: "Contacts",
                system: "Système",
            },
            gridContactList: {
                emptyConversationsTitle: "Aucun chat trouvé",
                emptyConversationsDescription: "Vous n'avez pas encore de chat actif. Vous pouvez démarrer un nouveau chat depuis la page client.",
                markAsUnanswered: "Marquer comme sans réponse",
                markAsAnswered: "Marquer comme répondu",
                removeVIP: "Retirer VIP",
                markAsVIP: "Marquer comme VIP",
                markAsRead: "Marquer comme lu",
                markAsUnread: "Marquer comme non lu",
                closeChat: "Fermer le chat",
                markedAsAnswered: "Marqué comme répondu",
                markedAsUnanswered: "Marqué comme sans réponse",
                operationFailed: "Opération échouée",
                markedAsVIP: "Marqué comme VIP",
                vipRemoved: "VIP retiré",
                markedAsUnread: "Marqué comme non lu",
                markedAsRead: "Marqué comme lu",
                confirmCloseChat: "Êtes-vous sûr de vouloir terminer le chat ?",
                chatClosed: "Chat fermé",
            },
            gridContactListToolBar: {
                chatStatus: "Statut du Chat",
                sortBy: "Trier par",
                all: "Tous",
                open: "Ouvert",
                closed: "Fermé",
                allStatus: "Tous",
                lastActivity: "Dernière Activité",
                createdAt: "Date de Création",
                unknown: "Inconnu",
            },
            contactDetail: {
                removeVIPTooltip: "Retirer VIP",
                markAsVIPTooltip: "Marquer comme VIP (Les utilisateurs marqués comme VIP seront toujours affichés en haut dans les chats).",
                customerOwnership: "Propriété du Client",
                ownershipDescription: "Lorsque la propriété du client est attribuée, seul le propriétaire et les administrateurs complets peuvent la voir",
                unowned: "Sans propriétaire",
                assignToMe: "M'assigner",
                removeOwnership: "Retirer la Propriété",
                dragPlaceholder: "Déplacer ici",
                currentConversationDepartment: "Département de Conversation Actuel",
                pastInteractionDepartments: "Départements d'Interaction Passés",
                createdAt: "Date de Création",
                updatedAt: "Date de Mise à Jour",
                zohoSync: "Synchronisation Zoho",
                zohoSyncQuestion: "Voulez-vous effectuer les opérations de modification de contact dans Zoho également?",
                basicInfo: "Informations de Contact",
                loginInfo: "Informations du Formulaire de Contact",
                profileFields: "Champs de Profil",
                systemInfo: "Informations Système",
            },
            contactDetailItem: {
                removeOwnership: "Retirer la Propriété",
                assignOwnershipToMe: "M'assigner la Propriété",
                vipCustomer: "Client VIP",
                contentCopiedSuccess: "Contenu copié avec succès!",
                invalidEmail: "Adresse e-mail invalide!",
                invalidValue: "Valeur invalide!",
            },
            filtersSection: {
                addFilter: "Ajouter un Filtre",
                all: "Tous",
                open: "Ouvert",
                closed: "Fermé",
                relevance: "Pertinence",
                lastActivityNewest: "Activité la Plus Récente",
                lastActivityOldest: "Activité la Plus Ancienne",
                noParticipant: "Aucun Participant",
                ownershipFilter: "Filtre de Propriété",
                metaReferral: "Référence Meta",
                userStatus: "Statut Utilisateur",
                unowned: "Sans propriétaire",
                fromAds: "Des Publicités",
                notFromAds: "Pas Des Publicités",
                blockedUsers: "Utilisateurs Bloqués",
                unblockedUsers: "Utilisateurs Non Bloqués",
                unread: "Non Lu",
                read: "Lu",
                yes: "Oui",
                no: "Non",
                answered: "Répondu",
                unanswered: "Sans Réponse",
                active: "Actif",
                lost: "Perdu",
                new: "Nouveau",
                chatbot: "Chatbot",
                closedStatus: "Fermé",
                platform: "Plateforme",
                channel: "Canal",
                department: "Département",
                tag: "Étiquette",
                participant: "Participant",
                ownership: "Propriété",
                lastActivityTime: "Heure de Dernière Activité",
                fullName: "Nom Complet",
                email: "Email",
                phone: "Téléphone",
                vipCustomer: "Client VIP",
                hasVIP: "A VIP",
                noVIP: "Pas de VIP",
                operatingSystem: "Système d'Exploitation",
                browser: "Navigateur",
                ipAddress: "Adresse IP",
                visitingPage: "Page Visitée",
                adInteraction: "Interaction Publicitaire",
                blockedStatus: "Statut de Blocage",
                connectionTime: "Heure de Connexion",
                createdAt: "Date de Création",
                updatedAt: "Date de Mise à Jour",
                readStatus: "Statut de Lecture",
                missedChat: "Chat Manqué",
                answerStatus: "Statut de Réponse",
                lastConversationStatus: "Statut de Dernière Conversation",
                lastTriggerState: "État du Dernier Déclencheur",
                type: "Type",
                name: "Nom",
                enterTriggerName: "Entrez le nom du déclencheur...",
                zohoInfo: "Info Zoho",
                id: "ID",
                enterContactOrLeadId: "Entrez l'ID de Contact ou Lead...",
                broadcastMessage: "Message de Diffusion",
                today: "Aujourd'hui",
                yesterday: "Hier",
                thisWeek: "Cette Semaine",
                lastWeek: "Semaine Dernière",
                last7Days: "7 Derniers Jours",
                last30Days: "30 Derniers Jours",
                thisMonth: "Ce Mois",
                lastMonth: "Mois Dernier",
            },
            filterChip: {
                operator: "Opérateur:",
                enterText: "Entrez le texte...",
                enterNumber: "Entrez le nombre...",
                type: "Type",
                value: "Valeur",
                enterValue: "Entrez la valeur...",
                addFilter: "Ajouter un Filtre",
                equals: "Égal",
                contains: "Contient",
                startsWith: "Commence Par",
                endsWith: "Se Termine Par",
                greaterThan: "Supérieur À",
                lessThan: "Inférieur À",
                greaterThanOrEqual: "Supérieur ou Égal À",
                lessThanOrEqual: "Inférieur ou Égal À",
                between: "Entre",
                custom: "Personnalisé",
                select: "Sélectionner",
            },
            filterPanel: {
                backToChat: "Retour à la Vue de Chat",
                publicFilter: "Filtre Public",
                privateFilter: "Filtre Privé",
                editFilterName: "Modifier le Nom du Filtre",
                contactsFound: " contacts trouvés",
                enterFilterName: "Entrez le nom du filtre",
                filterSuggestions: "Suggestions de Filtre",
                private: "Privé",
                public: "Public",
                createFilter: "Créer un Filtre",
                update: "Mettre à Jour",
                changeToPublic: "Changer en Public",
                changeToPrivate: "Changer en Privé",
                delete: "Supprimer",
                clearSearch: "Effacer la Recherche",
                previous: "Précédent",
                next: "Suivant",
                searchTerm: "Terme de Recherche:",
                whichFieldToSearch: "Dans quel champ souhaitez-vous rechercher?",
                contactId: "ID de Contact",
                conversationId: "ID de Conversation",
                noSearchAllFields: "Non, rechercher dans tous les champs",
                yesSearchOnlyField: "Oui, rechercher uniquement dans {field}",
                search: "Rechercher",
                allFields: "Tous les Champs",
                fullname: "Nom complet",
                email: "Email",
                whatsappNumber: "Numéro WhatsApp",
                phone: "Téléphone",
                contactIdField: "ID de Contact",
                conversationIdField: "ID de Conversation",
                searchAllFieldsPlaceholder: "Entrez ce que vous voulez rechercher dans tous les champs",
                searchFullnamePlaceholder: "Entrez ce que vous voulez rechercher par Nom Complet",
                searchEmailPlaceholder: "Entrez ce que vous voulez rechercher par Email",
                searchWhatsappPlaceholder: "Entrez ce que vous voulez rechercher par WhatsApp",
                searchPhonePlaceholder: "Entrez ce que vous voulez rechercher par Téléphone",
                searchContactIdPlaceholder: "Entrez l'ID de Contact que vous souhaitez rechercher",
                searchConversationIdPlaceholder: "Entrez l'ID de Conversation que vous souhaitez rechercher",
                searchPlaceholder: "Rechercher",
                edited: " (Modifié)",
                unnamedFilter: "Filtre Sans Nom",
                all: "Tous",
                open: "Ouvert",
                closed: "Fermé",
                unknown: "Inconnu",
                filterUpdatedSuccess: "Filtre mis à jour avec succès",
                filterUpdatedDescription: 'Le filtre "{name}" a été mis à jour.',
                filterUpdateFailed: "Le filtre n'a pas pu être mis à jour",
                filterUpdateError: "Une erreur s'est produite lors de la mise à jour du filtre.",
                filterSavedSuccess: "Filtre enregistré avec succès",
                filterSavedDescription: 'Le nom "{createName}" était déjà utilisé. Le filtre a été créé sous le nom "{filterName}".',
                filterCreatedDescription: 'Le filtre "{filterName}" a été créé.',
                filterSaveFailed: "Le filtre n'a pas pu être enregistré",
                filterSaveError: "Une erreur s'est produite lors de l'enregistrement du filtre.",
                aiFilterCreatedSuccess: "Filtre IA créé avec succès",
                aiFilterCreatedDescription: 'Le nom "{createName}" était déjà utilisé. Le filtre a été créé sous le nom "{filterName}" et appliqué.',
                aiFilterCreatedApplied: 'Le filtre "{filterName}" a été créé et appliqué.',
                aiFilterCreateFailed: "Le filtre n'a pas pu être créé",
                aiFilterCreateError: "Une erreur s'est produite lors de la création du filtre IA.",
                phoneDetected: "Numéro de Téléphone Détecté",
                emailDetected: "Adresse Email Détectée",
                idFormatDetected: "Format d'ID Détecté",
                contactIdDetected: "ID de Contact Détecté",
                conversationIdDetected: "ID de Conversation Détecté",
                searchMode: "Mode de Recherche",
                phoneDetectedMessage: "La valeur que vous avez saisie ressemble à un numéro de téléphone. Souhaitez-vous rechercher uniquement dans le champ numéro de téléphone?",
                emailDetectedMessage: "La valeur que vous avez saisie ressemble à une adresse email. Souhaitez-vous rechercher uniquement dans le champ email?",
                idFormatDetectedMessage: "La valeur que vous avez saisie ressemble à un format d'ID. Dans quel champ souhaitez-vous rechercher?",
                phoneField: "champ numéro de téléphone",
                emailField: "champ email",
                contactIdField: "champ ID de contact",
                conversationIdFieldName: "champ ID de conversation",
                idField: "champ ID",
                deleteFilter: "Supprimer le Filtre",
                deleteFilterConfirm: 'Êtes-vous sûr de vouloir supprimer le filtre "{name}"? Cette action ne peut pas être annulée.',
                delete: "Supprimer",
                cancel: "Annuler",
                filterDeletedSuccess: "Filtre supprimé avec succès",
                filterDeletedDescription: 'Le filtre "{name}" a été supprimé.',
                filterDeleteFailed: "Le filtre n'a pas pu être supprimé",
                filterDeleteError: "Une erreur s'est produite lors de la suppression du filtre.",
                visibilityUpdatedSuccess: "Visibilité mise à jour avec succès",
                visibilityUpdatedDescription: 'Le filtre a été défini comme "{visibility}".',
                visibilityUpdateFailed: "La visibilité n'a pas pu être mise à jour",
                visibilityUpdateError: "Une erreur s'est produite lors de la mise à jour du filtre.",
                publicVisibility: "public",
                privateVisibility: "privé",
            },
            contactList: {
                noContactsFound: "Aucun contact trouvé",
                unknownContact: "Contact Inconnu",
                unknown: "Inconnu",
                fullName: "Nom Complet",
                platform: "Plateforme",
                email: "Email",
                phone: "Téléphone",
                tags: "Étiquettes",
                status: "Statut",
                lastActivity: "Dernière Activité",
                answerStatus: "Statut de Réponse",
                channel: "Canal",
                owner: "Propriétaire",
                vip: "VIP",
                connectionTime: "Heure de Connexion",
                unread: "Non Lu",
                departments: "Départements",
                operatingSystem: "Système d'Exploitation",
                browser: "Navigateur",
                countryCity: "Pays - Ville",
                ipAddress: "Adresse IP",
                visitingPage: "Page Visitée",
                lastConversationDate: "Date de Dernière Conversation",
                blockedStatus: "Statut de Blocage",
                lastConversationParticipants: "Participants de la Dernière Conversation",
                preferredLanguage: "Langue Préférée",
                createdAt: "Date de Création",
                updatedAt: "Date de Mise à Jour",
                broadcastStatus: "Statut de Diffusion",
                broadcastAnswer: "Réponse de Diffusion",
                zohoContactId: "ID de Contact Zoho",
                zohoLeadId: "ID de Lead Zoho",
                profileFields: "Champs de Profil",
                closed: "Fermé",
                open: "Ouvert",
                unknownStatus: "Inconnu",
                answered: "Répondu",
                unanswered: "Sans Réponse",
                unreadStatus: "Non Lu",
                readStatus: "Lu",
                vipStatus: "VIP",
                normal: "Normal",
                blocked: "Bloqué",
                today: "Aujourd'hui",
                yesterday: "Hier",
                enqueued: "En File d'Attente",
                sent: "Envoyé",
                delivered: "Livré",
                read: "Lu",
                deleted: "Supprimé",
                failed: "Échoué",
                replied: "Répondu",
                notReplied: "Non Répondu",
                jsonProperty: "Propriété JSON",
                jsonCopiedSuccess: "Contenu JSON copié avec succès!",
            },
        },
        form: {
            title: {
                titleSettings: "Paramètres du titre",
                fullNameSettings: "Paramètres du nom complet",
                emailSettings: "Paramètres de l'email",
                addressSettings: "Paramètres de l'adresse",
                phoneSettings: "Paramètres du téléphone",
                datePickerSettings: "Paramètres du sélecteur de date",
                shortTextSettings: "Paramètres de texte court",
                longTextSettings: "Paramètres de texte long",
                dropDownListSettings: "Paramètres de la liste déroulante",
                singleChoiceSettings: "Paramètres de choix unique",
                multipleSelectionSettings: "Paramètres de sélection multiple",
                numberSettings: "Paramètres de nombre",
                hourSettings: "Paramètres de l'heure",
                spinnerSettings: "Paramètres du spinner",
                sendSettings: "Paramètres d'envoi",
                starRatingSettings: "Paramètres d'évaluation par étoiles",
                ratingScaleSettings: "Paramètres de l'échelle de notation",
                separationElementSettings: "Paramètres de l'élément de séparation",
                fileUploadSettings: "Paramètres de téléversement de fichier",
                imageSettings: "Paramètres de l'image"
            },
            lineColor: "Couleur de la ligne",
            separatorColorInfo: "Sélectionnez ou entrez la couleur du séparateur (par exemple, #RRGGBB)",
            separatorHeight: "Hauteur du séparateur",
            separatorHeightInfo: "Entrez la hauteur du séparateur",
            bottomSpace: "Espace inférieur",
            bottomSpaceInfo: "Ajoutez de l'espace sous le séparateur",
            topSpace: "Espace supérieur",
            topSpaceInfo: "Ajoutez de l'espace au-dessus du séparateur",
            sideSpace: "Espace latéral",
            sideSpaceInfo: "Ajoutez de l'espace à gauche et à droite du séparateur",
            onlyImageUpload: "Vous ne pouvez télécharger qu'une image !",
            imageSizeLimit: "La taille de votre image ne doit pas dépasser 5 Mo !",
            image: "Image",
            size: "Taille",
            width: "Largeur",
            height: "Hauteur",
            imageAlignment: "Alignement de l'image",
            wide: "Large",
            small: "Petit",
            textAlignment: "Alignement du texte",
            chooseHorizontalAlignment: "Choisissez comment aligner ce titre horizontalement.",
            headerSize: "Taille de l'en-tête",
            addSmallTextBelowHeader: "Ajoutez un texte plus petit sous l'en-tête",
            subHeaderText: "Texte du sous-titre",
            subLabel1: "Sous-étiquette(1)",
            subLabel2: "Sous-étiquette(2)",
            validPhoneNumber: "Veuillez entrer un numéro de téléphone valide",
            masked: "Masqué",
            copyField: "Copier le champ",
            copyFieldDescription: "Créez une copie de ce champ tout en conservant tous ses paramètres enregistrés",
            enterQuestion: "Posez une question",
            notRequired: "Non requis",
            addDescriptionBelowField: "Ajoutez une brève description sous le champ",
            setDefault: "Définir par défaut",
            pleaseSelect: "Veuillez sélectionner",
            placeholder: "Espace réservé",
            required: "Obligatoire",
            fieldEmptyError: "Ne pas permettre l'envoi du formulaire si ce champ est vide",
            subLabels: "Sous-étiquettes",
            addressLine1: "Adresse ligne 1",
            addressLine2: "Adresse ligne 2",
            postalCode: "Code postal",
            stateProvince: "État / Province",
            chooseLabelAlignment: "Choisissez comment aligner le texte de l'étiquette horizontalement",
            right: "DROITE",
            left: "GAUCHE",
            top: "HAUT",
            labelAlignment: "Alignement de l'étiquette",
            fieldLabel: "Étiquette de champ",
            read: "Lu",
            itemsPerPage: "éléments/page",
            downloadAllDataAsPDF: "Télécharger toutes les données au format PDF",
            downloadAllDataAsExcel: "Télécharger toutes les données au format Excel",
            downloadSelectedDataAsPDF: "Télécharger les données sélectionnées au format PDF",
            downloadSelectedDataAsExcel: "Télécharger les données sélectionnées au format Excel",
            selectItemToViewDetails: "Sélectionnez un élément pour voir les détails.",
            deleteFormConfirm:
                "Si vous supprimez ce formulaire, toutes les données associées seront définitivement supprimées. Êtes-vous sûr de vouloir continuer ?",
            redicetFormAnswer: "FORWARD FORM ANSWERS",
            redicetFormAnswerDesc:
                "Lorsque vous redirigez les réponses d'un formulaire vers le système de tickets, veillez à demander un numéro de téléphone ou une adresse électronique à l'utilisateur dans le formulaire. Ces informations sont importantes pour une communication plus rapide et plus efficace avec l'utilisateur.",
            redicetFormAnswerDesc2: "Les réponses aux formulaires sont dirigées vers le système en tant que tickets.",
            rediectAnswersToTicket: "Rediriger les réponses entrantes vers un ticket.",
            errorTicketMode: "Erreur de mise à jour du mode de ticket :",
            formView: "Voir le formulaire",
            formEdit: "Formulaire de mise à jour",
            totalResponse: "Total des réponses",
            totalUnreadResponse: "Total des réponses non lues",
            totalReadResponse: "Réponse totale à la lecture",
            totalArchivedResponse: "Total des réponses archivées",
            singleChoice: "Choix unique",
            _delete: "Supprimer",
            inbox: "Boîte de réception",
            edit: "Editer",
            forms: "Formulaires",
            formsDesc: "Vous pouvez gérer vos formulaires ici.",
            createaForm: "créer un formulaire",
            allForms: "toutes les formes",
            formPublish: {
                shareFast: "PARTAGER RAPIDEMENT",
                shareFastDesc: "Lien direct vers le formulaire et partage social",
                add: "ADD",
                addDesc: "Diverses options d'intégration de pages web",
                assignForm: "FORMULAIRE D'AFFECTATION",
                assignFormDesc: "Attribuez vos formulaires à d'autres personnes",
                emails: "E-MAILS",
                emailsDesc: "Rappels et partage instantané",
                prefill: "REMPLISSAGE PRÉALABLE",
                prefillDesc: "Pré-remplir vos formulaires",
                pdf: "PDF",
                pdfDesc: "Télécharger le PDF à remplir",
                platforms: "PLATEAUX",
                platformsDesc: "Options de publication par des tiers",
                linkToYour: "ADRESSE DU LIEN DE VOTRE FORMULAIRE",
                linkToYourDesc:
                    "Votre formulaire a été publié en toute sécurité et est prêt à être utilisé à cette adresse.",
                shareWithLink: "PARTAGER AVEC LE LIEN",
                publicForm: "Formulaire public",
                copyLink: "COPY LINK",
                openInNewTab: "OUVRIR DANS UN NOUVEL ONGLET",
                linkCopied: "Lien copié",
                codeCopied: "Code copié",
                iframe: "IFRAME",
                iframeDesc: "Ajoutez le formulaire à votre page avec iFrame",
                openWindow: "FENÊTRE OUVERTE",
                openWindowDesc: "Lien vers un formulaire contextuel",
                formAddDesc:
                    "Copiez et collez cet extrait dans votre code et placez votre formulaire sur votre site web.",
            },
            formSettings: {
                enterNameForm: "Saisir un nom pour ce formulaire",
                selectStatusForm: "Sélectionnez le statut de votre formulaire",
                disabled: "Handicapés",
                disableSpecifiedTime: "Désactivation à un moment précis",
                disableFormResponse: "Désactivation lorsque la limite de réponse du formulaire est atteinte",
                pageShownAfterForm: "La page affichée après l'envoi du formulaire",
                formNotFound: "Formulaire non trouvé.",
                errorLoadingform: "Une erreur s'est produite lors du chargement du formulaire.",
                formUpdated: "Le titre du formulaire a été mis à jour avec succès.",
                formErrorUpdated: "Une erreur s'est produite lors de la mise à jour du titre du formulaire",
                formSettings: "RÉGLAGES DU FORMULAIRE",
                changeFormStateAndProperties: "Modifier l'état et les propriétés du formulaire",
                title: "Titre",
                newFormSettings: "Paramètres du nouveau formulaire",
                formStatus: "État du formulaire",
                activateOrDeactivate: "Activer, désactiver ou activer sous condition votre formulaire",
                effective: "EFFICACE",
                yourFromIsVisible: "Votre formulaire est maintenant visible et peut recevoir des réponses.",
                emails: "E-MAILS",
                emailsDesc: "Envoyer des courriels de réponse automatique et des courriels de notification",
                conditions: "CONDITIONS",
                conditionsDesc:
                    "Section de logique conditionnelle qui déclenche des actions en fonction des entrées du formulaire",
                thankYouPage: "PAGE DE REMERCIEMENT",
                thankYouPageDesc: "La page affichée après l'envoi du formulaire",
                integretions: "INTEGRATIONS",
                integretionsDesc: "Connecter votre formulaire à d'autres applications",
            },
            clickToDeleteYourLogo: "Cliquez pour supprimer votre logo",
            create: "Créer",
            settings: "Paramètres",
            load: "Chargement",
            insertFormField: "Insérer un champ de formulaire",
            addYourLogo: "Ajouter votre logo",
            surveyElements: {
                surveyElements: "Éléments de l'enquête",
                dataTable: "Tableau des données",
                starRating: "Classement par étoiles",
                evaluationScale: "Échelle d'évaluation",
            },
            pageElements: {
                pageElements: "Éléments de la page",
                separationElement: "Élément de séparation",
                partitionCollapse: "Eff",
                pageBreak: "Fin de la page",
            },
            basicElements: {
                basicElements: "Éléments de base",
                shortText: "Texte court",
                longText: "Texte long",
                paragraph: "Paragraphe",
                dropDownList: "Liste déroulante",
                singleChoice: "Choix unique",
                multipleSelection: "Sélection multiple",
                number: "Nombre",
                image: "Image",
                fileUpload: "Téléchargement de fichiers",
                hour: "Heure",
                spinner: "Spinner",
                send: "Envoyer",
            },
            formElements: {
                formElements: "Éléments du formulaire",
                title: "Titre",
                fullName: "Nom complet",
                email: "Courriel",
                address: "Adresse",
                phone: "Téléphone",
                datePicker: "Sélecteur de date",
                appointment: "Nomination",
                signature: "Signature",
                productList: "Liste des produits",
            },
            startWithaBlankForm: "Commencer par un formulaire vierge",
            startFromScratch: "Partir de zéro",
            createOrTransferaForm: "Créer ou transférer un formulaire pour commencer la collecte de données",
            createForm: "Créer un formulaire",
        },
        automation: {
            deleteAutomationsTitle: "Supprimer les Automatisations",
            deleteAutomationsConfirmation: "Êtes-vous sûr de vouloir supprimer {count} automatisations ? Cette action ne peut pas être annulée.",
            automationsMoveError: "Erreur lors du déplacement des automatisations",
            noAutomationToMove: "Aucune automatisation trouvée à déplacer",
            deleteCategoryConfirmation: "Êtes-vous sûr de vouloir supprimer la catégorie \"{categoryName}\" ? Les automatisations de cette catégorie seront déplacées vers la catégorie \"Général\".",
            automationsMovedToCategory: "{count} automatisations déplacées vers la catégorie \"{categoryName}\"",
            automationImportedSuccessfully: "Automatisation {name} importée avec succès",
            automationPasteError: "Erreur lors du collage de l'automatisation",
            invalidAutomationExport: "Aucune exportation d'automatisation Supsis valide trouvée dans le presse-papiers",
            invalidAutomationJSON: "Aucun JSON d'automatisation valide trouvé dans le presse-papiers",
            clipboardNotSupported: "L'accès au presse-papiers n'est pas pris en charge par ce navigateur",
            automationJSONCopyError: "Erreur lors de la copie de l'automatisation",
            automationCopiedToClipboardFallback: "Automatisation copiée dans le presse-papiers en tant que JSON (méthode de secours)",
            automationCopiedToClipboard: "Automatisation copiée dans le presse-papiers en tant que JSON. Vous pouvez la coller avec Ctrl+V dans un autre panneau client.",
            automationCopyError: "Erreur lors de la copie de l'automatisation",
            automationCopied: "Automatisation copiée",
            automationMoveError: "Erreur lors du déplacement de l'automatisation",
            automationMovedToCategory: "Automatisation déplacée vers la catégorie \"{categoryName}\"",
            categoryDeletedSuccessfully: "Catégorie supprimée avec succès",
            categoryDeleteError: "Erreur lors de la suppression de la catégorie",
            automationsDeleteError: "Erreur lors de la suppression des automatisations",
            automationsDeletedSuccessfully: "{count} automatisations supprimées avec succès",
            categoryUpdatedSuccessfully: "Catégorie mise à jour",
            categoryUpdateError: "Erreur lors de la mise à jour de la catégorie",
            categorySaveError: "Erreur lors de l'enregistrement de la catégorie",
            categoryCreatedSuccessfully: "Catégorie créée. Vous pouvez faire glisser des automatisations vers cette catégorie.",
            categoryNameAlreadyExists: "Une catégorie avec ce nom existe déjà",
            categoryNameRequired: "Le nom de la catégorie ne peut pas être vide",
            moveAllAutomations: "Déplacer Toutes les Automatisations",
            deleteAutomations: "{count} automatisations supprimées",
            selectedAutomations: "{count} automatisations sélectionnées",
            pasteInfoMessage: "Automatisation copiée dans le presse-papiers détectée ! Créez immédiatement une nouvelle automatisation en la collant avec <strong>Ctrl+V</strong>.",
            categoryName: "Nom de la Catégorie",
            categoryNamePlaceholder: "Saisissez le nom de la catégorie",
            editCategory: "Modifier la Catégorie",
            deleteCategory: "Supprimer la Catégorie",
            createCategory: "Ajouter une Catégorie",
            publishAutomation: "Publié",
            unpublishAutomation: "Arrêté",
            timerAutomation: "Programmé",
            eventAutomation: "Événement",
            deleteAutomation: "Supprimer l'Automatisation",
            changeCategory: "Changer de Catégorie",
            copyAutomation: "Copier l'Automatisation",
            copyAutomationAsJSON: "Copier en tant que JSON",
            emptyCategoryMessage: "Vous pouvez ajouter des automatisations à la catégorie en les faisant glisser ici",
            whenFormSubmitted: "Lorsqu'un formulaire est soumis",
            taskCreated2: "Tâche créée",
            waitingTaskCreation: "En attente de la création de la tâche...",
            calendarEventCreated: "Événement créé dans le calendrier",
            calendarEventUpdated: "Événement mis à jour dans le calendrier",
            calendarEventDeleted: "Événement supprimé du calendrier",
            reservationCreated: "Réservation créée",
            reservationDateChanged: "Date de réservation modifiée",
            reservationDeleted: "Réservation supprimée",
            chatLost: "Lorsque le chat est perdu",
            webchatCompleted: "Lorsque le chat web est terminé",
            instagramCompleted: "Lorsque le chat du canal Instagram est terminé",
            messengerCompleted: "Lorsque le chat du canal Messenger est terminé",
            whatsappCompleted: "Lorsque le chat du canal WhatsApp est terminé",
            telegramCompleted: "Lorsque le chat du canal Telegram est terminé",
            chatAssignedToAgent: "Lorsque le chat est attribué à un agent",
            profileButtonClicked: "Lorsque le bouton d'automatisation est cliqué depuis le profil",
            operatedTask: "Tâche en cours d'exécution",
            tableSelection: "Sélection de la table",
            selectTable: "Sélection de la table",
            whichTableAutomationAddRecords:
                "Quelle table voulez-vous exécuter l'automatisation lorsqu'un enregistrement est ajouté ? Veuillez sélectionner.",
            whichTableAutomationUpdateRecords:
                "Vous souhaitez lancer l'automatisation lorsqu'un enregistrement est mis à jour dans quelle table ? Veuillez sélectionner.",
            whichTableAutomationDeletedRecords:
                "Dans quelle table voulez-vous lancer l'automatisation lorsqu'un enregistrement est supprimé ? Veuillez sélectionner",
            whichTableAutomationClickRecords:
                "Dans quelle table voulez-vous lancer l'automatisation lorsque le bouton d'automatisation d'un enregistrement est cliqué ? Veuillez sélectionner",
            planStatus: "Statut du plan",
            scheduled: "Planifié",
            completed: "Complété",
            cancelled: "Annulé",
            startTest: "Démarrer le test",
            unpublish: "Unpublish",
            whenMessagePicked: "Lorsqu'un message est sélectionné via l'interface de discussion",
            whenTaskCompleted: "Lorsqu'une tâche est terminée",
            whenTaskDeleted: "Lorsqu'une tâche est supprimée",
            whenTaskAssigneeChanged: "Lorsqu'un attributaire de tâche est modifié",
            whenTaskPriorityChanged: "Lorsque la priorité d'une tâche est modifiée",
            whenTaskDueDateChanged: "Lorsque la date d'échéance d'une tâche est modifiée",
            whenTaskStatusChanged: "Lorsque le statut d'une tâche est modifié",
            whenTaskArchived: "Lorsqu'une tâche est archivée",
            whenTagAdded: "Lorsqu'une étiquette est ajoutée à la tâche",
            whenTagRemovedTask: "Lorsqu'une balise est supprimée d'une tâche",
            whenTagChecklist: "Lorsque la liste de contrôle d'une tâche est complétée",
            whenReminderActivated: "Lorsqu'un rappel est activé",
            whenTicketCreated: "Lorsqu'un ticket est créé",
            whenTicketStageChanged: "Lorsque l'étape d'un ticket est modifiée",
            whenTicketAssigneeChanged: "Lorsqu'un assigné de ticket est modifié",
            whenTicketClosed: "Lorsqu'un ticket est clôturé",
            whenTicketUpdated: "Lorsqu'un ticket est mis à jour",
            autoPlanAndTaskHistory: "Plan d'automatisation et historique des tâches",
            automation: "Automatisation",
            botScenario: "Scénario de bot",
            nameSurname: "NomSurname",
            phone164: "*Entrez au format E164. Par exemple : 905396667744",
            whichWpChannels: "Quels canaux Whatsapp ajouter ?",
            findContact: "Trouver un contact",
            findContacts: "Trouver des contacts",
            offsetDesc:
                "Sauter les N premiers contacts. La valeur par défaut est '0'. Utilisez cette valeur pour faire défiler les contacts.",
            limitDesc:
                "Nombre maximal de contacts à retourner après le décalage. La valeur par défaut est '10'. Utilisez cette valeur pour paginer",
            contact: "Contact",
            selectAction: "Sélectionner une action",
            addMethod: "Ajouter une méthode",
            selectField: "Sélectionner un champ",
            schedulerRunningPlanEx: "Exemple de plan d'exécution du planificateur",
            schedulerPlanner: "Planificateur de l'ordonnanceur",
            taskCreated: "Tâche créée ?",
            taskStatus: "Statut des tâches",
            terminateReason: "Raison de la terminaison",
            taskDuration: "Durée de la tâche",
            taskWakeUpCount: "Nombre de réveils de la tâche",
            completedAt: "Completed",
            cancelledAt: "Annulé",
            nextRunAt: "Prochaine exécution",
            configSchedulerAuto: "Configurer la minuterie pour l'automatisation",
            saveChanges: "Enregistrer les modifications",
            catchAllWebhooks: "Attraper tous les Webhooks de cette URL",
            webhookDataExPreview:
                "Aperçu de l'échantillon de données du webhook (s'affichera après l'envoi de la demande)",
            webhookUrlCopied: "URL du webhook copiée dans le presse-papiers",
            selectAnBlock: "Sélectionner un bloc",
            dataFormats: "Formats de données",
            whenRecordCreated: "Lorsqu'un enregistrement est créé",
            whenRecordUpdated: "Lorsqu'un enregistrement est mis à jour",
            whenRecordDelete: "Lorsqu'un enregistrement est supprimé",
            whenRecordAutomation: "Lorsqu'un bouton d'automatisation d'un enregistrement est cliqué",
            whenWebhookTriggered: "Lorsqu'un webhook est déclenché",
            whenChatCreated: "Lorsqu'un chat est créé",
            whenChatClosed: "Lorsqu'un chat est fermé",
            whenChatRated: "Lorsqu'un chat est évalué",
            whenNewContactCreated: "Lorsqu'un nouveau contact est créé",
            whenContactUpdate: "Lorsqu'un contact est mis à jour",
            whenContactPropUpdate: "Mise à jour des propriétés d'un contact",
            whenNewTagAdded: "Lorsqu'une nouvelle balise est ajoutée",
            whenTagRemoved: "Lorsqu'une balise est supprimée",
            whenNewEmailReceived: "Lorsqu'un nouvel e-mail est reçu",
            whenNewTaskCreated: "Lorsqu'une nouvelle tâche est créée",
            whenNewMetaleadCreated: "Lorsqu'un nouveau méta-lead est créé",
            whenNewAgentCreated: "Lorsqu'un nouvel agent est créé",
            whenNewInvoiceCreated: "Lorsqu'une nouvelle facture est créée",
            whenNewWpReceived: "Lorsqu'un nouveau message WhatsApp est reçu",
            whenNewReservationCreated: "Lorsqu'une nouvelle réservation est créée",
            whenNewChatbotReceived: "Lorsqu'un nouveau message de chatbot est reçu",
            chatWebhookAutomation: "Attraper un Webhook et lancer une automatisation",
            automationName: "Nom de l'automatisation",
            supsisObject: "Objet Supsis",
            selectModule: "Modèle de sélection",
            bodyType: "Type de corps",
            selectBodyType: "Sélectionner le type de corps",
            selectMethod: "Sélectionner une méthode",
            trigger: "Déclencher",
            published: "Publié",
            createdAt: "Créé à",
            action: "Action",
            type: "Type",
            view: "Voir",
            createTimerAutomation: "Créer un automatisme de temporisation",
            createEventBasedAutomation: "Créer une automatisation basée sur les événements",
            createWebhookAutomation: "Créer une automatisation de type Webhook",
            automationsDeletedSuccessfully: "Automations supprimées avec succès",
            automationsCouldNotBeDeleted: "Les automatisations n'ont pas pu être supprimées",
            timerAutomationCreatedSuccessfully: "L'automatisation de l'horloge a été créée avec succès",
            eventAutomationCreatedSuccessfully: "Automatisation d'un événement créé avec succès",
            webhookAutomationCreatedSuccessfully: "Automatisation du crochet Web créée avec succès",
            automationsCouldNotBeFetched: "Les automatisations n'ont pas pu être récupérées",
            automationPublishedStateUpdatedSuccessfully: "Mise à jour réussie de l'état publié de l'automatisation",
            automations: "Automations",
            allAutomations: "Toutes les automatisations",
            scheduledAutomations: "Automations programmées",
            eventBasedAutomations: "Automatisations basées sur des événements",
            buttonAutomations: "Automations basées sur des boutons",
            webhookAutomations: "Automatisations basées sur les webhooks",
            blocks: {
                ASSIGN_OWNER: "Attribuer la Propriété",
                autoForwardToOwnerForce: "Transfert automatique au propriétaire (même avec chatbot actif)",
                SHOW_WIDGET: "Afficher le Widget",
                REPLY_TRENDYOL_QUESTION: "Répondre à la question Trendyol",
                START_POINT: "POINT DE DÉPART",
                AI_ASSISTANT: "ASSISTANT IA",
                BOT_RESPONSE: "BOT RESPONSE",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "CLASSIFICATION DE L'IA",
                AI_MENU_FLOW: "AI MENU",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATEFORME",
                DEFAULT_FALLBACK: "DEFAULT FALLBACK",
                DEFAULT_TIMEOUT: "DÉLAI D'ATTENTE PAR DÉFAUT",
                AI_FUNCTIONS: "AI FUNCTIONS",
                FILTER: "FILTRE",
                FLOW: "FLUX",
                ATTACHMENT_INPUT: "ENTRÉE DE PIÈCES JOINTES",
                USER_INPUT: "ENTRÉE UTILISATEUR",
                GO_TO_STEP: "ALLER À L'ÉTAPE",
                WEBHOOK: "WEBHOOK",
                SET_ATTRIBUTE: "DÉFINIR UN ATTRIBUT",
                QUESTION: "QUESTION",
                CLOSE_CHAT: "FERMER LE CHAT",
                CREATE_TICKET: "CRÉER UN TICKET",
                TRANSFER_CHAT: "TRANSFÉRER LE CHAT",
                TRANSFER_TO_CHATBOT: "TRANSFÉRER AU CHATBOT",
                TAG_CHAT: "AJOUTER UNE BALISE",
                REMOVE_TAG: "SUPPRIMER UN TAG",
                SET_DEPARTMENT: "SET DEPARTMENT",
                SEND_TRANSCRIPT: "ENVOYER UNE TRANSCRIPTION",
                SEND_SMS: "ENVOYER DES SMS",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "CRÉER UN ÉVÉNEMENT",
                CREATE_RESERVATION: "CRÉER UNE RÉSERVATION",
                RESERVATION_OPEN_URL: "RESERVATION OPEN URL",
                RESERVATION_SELECT_DAY: "SÉLECTIONNER LE JOUR DE LA RÉSERVATION",
                RESERVATION_EVENT_LIST: "LISTE DES VISITEURS DE LA RÉSERVATION",
                RESERVATION_SELECT_TIME: "SÉLECTIONNER L'HEURE DE LA RÉSERVATION",
                CREATE_TASK: "CRÉER UNE TÂCHE",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "DISPONIBILITÉ DES PRODUITS SHOPIFY",
                SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
                AKINON_SHOW_PRODUCTS: "AFFICHER LES PRODUITS AKINON",
                AKINON_FIND_PRODUCT: "TROUVER UN PRODUIT",
                AKINON_ORDER_STATUS: "ÉTAT DE LA COMMANDE CHEZ AKINON",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
                AKINON_FIND_NEAREST_STOCK: "AFFICHER LE STOCK DU MAGASIN",
                AKINON_FIND_NEAREST_STORES: "AFFICHER LES MAGASINS LES PLUS PROCHES",
                AKINON_SHOW_DISCOUNT_CODES: "AFFICHER LES CODES DE RÉDUCTION",
                SUPPRESSION_ADD: "BLOQUER LE CONTACT",
                SUPPRESSION_REMOVE: "DÉBLOQUER LE CONTACT",

                IDEASOFT_SELECT_ORDER: "SELECT ORDER",
                IDEASOFT_ORDER_STATUS: "OBTENIR LE STATUT DE LA COMMANDE",
                IDEASOFT_GET_MEMBER_INFO: "REMPLIR LES INFORMATIONS SUR LES MEMBRES",
                TICKET_UPDATE: "MISE À JOUR DES BILLETS",

                TSOFT_SELECT_ORDER: "SELECT ORDER",
                TSOFT_ORDER_STATUS: "OBTENIR LE STATUT DE LA COMMANDE",

                TICIMAX_V2_SELECT_ORDER: "SELECT ORDER",
                TICIMAX_V2_ORDER_STATUS: "OBTENIR LE STATUT DE LA COMMANDE",

                IKAS_GET_MEMBER_INFO: "Obtenir les détails du membre",
                IKAS_SELECT_ORDER: "Sélectionner la commande",
                IKAS_ORDER_STATUS: "Obtenir le statut de la commande",

                GET_LOCATION: "OBTENIR LA POSITION",
                FALLBACK: "OPTION DE RECHANGE",
                TIMEOUT: "DÉLAI D'ATTENTE",
                SUCCESS: "SUCCÈS",
                FAILURE: "ÉCHEC",

                PROBEL_SELECT_BRANCH: "Sélectionner la branche",
                PROBEL_SELECT_CLINIC: "Sélectionner la polyclinique",
                PROBEL_SELECT_DAY: "Sélectionner le jour du rendez-vous",
                PROBEL_SELECT_HOUR: "Sélectionner l'heure du rendez-vous",
                PROBEL_MAKE_APPOINTMENT: "Prendre un rendez-vous",
                PROBEL_CANCEL_APPOINTMENT: "Annulation de rendez-vous",
                PROBEL_GET_PATIENT_TOKEN: "Obtenir le jeton du patient",
                PROBEL_FILL_INFO: "Obtenir des informations MERNIS",
                PROBEL_SELECT_APPOINTMENT: "Sélectionner un rendez-vous",

                SEND_WP_BUSINESS_MESSAGE: "ENVOYER UN MESSAGE WHATSAPP",
                MESSENGER_SEND_MESSAGE: "ENVOYER UN MESSAGE MESSENGER",
                INSTAGRAM_SEND_MESSAGE: "ENVOYER UN MESSAGE INSTAGRAM",
                INSTAGRAM_COMMENT_REPLY: "RÉPONDRE AU COMMENTAIRE",
                INSTAGRAM_COMMENT_DELETE: "SUPPRIMER UN COMMENTAIRE",
                INSTAGRAM_COMMENT_SHOW: "AFFICHER LE COMMENTAIRE",
                INSTAGRAM_COMMENT_HIDE: "CACHER LE COMMENTAIRE",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RÉPONDRE EN PRIVÉ",
                LOOP: "Boucle",
                LOOP_NEXT: "Boucle sur l'élément suivant",
                LOOP_BREAK: "Interrompre la boucle",
                LOOP_CONTINUE: "Continuer la boucle suivante",
                LOOP_FINISH: "Terminer la boucle",
                SLEEP: "Sommeil",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Attraper le webhook",
                TERMINATE_AUTOMATION: "Terminer l'automatisation",
                CREATE_CONTACT: "Créer un contact",
                UPDATE_CONTACT: "Mettre à jour un contact",
                FIND_CONTACTS: "Trouver des contacts",
                FIND_CONTACT: "Trouver un contact",
                FIND_CHATS: "Trouver des chats",
                FIND_CHAT: "Trouver un chat",
                WAIT_FOR: "Attendre",
                STRING_FORMAT: "Formater la chaîne",
                NUMBER_FORMAT: "Formatage des nombres",
                DATE_FORMAT: "Format Date",
                RECORDS_FROM_CSV: "Enregistrements provenant d'un fichier CSV",
                MESSAGE_RECEIVED: "Message reçu",

                ASK_AI: "Intelligence Artificielle",

                TABLE_CREATE_RECORD: "Créer un enregistrement",
                TABLE_DELETE_RECORD: "Supprimer l'enregistrement",
                TABLE_UPDATE_RECORD: "Mettre à jour l'enregistrement",
                TABLE_FIND_RECORD: "Trouver un enregistrement",
                TABLE_FIND_RECORDS: "Lister les enregistrements",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Trouver un enregistrement (par téléphone)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Ajouter un fichier à l'enregistrement",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Télécharger une image dans le champ personnalisé",
                ZOHO_CREATE_RECORD: "Zoho Créer un enregistrement",

                GET_SUPSIS_RECORD_BY_ID: "Supsis Trouver un enregistrement (par ID)",
            },
        },
        modules: {
            kanbanSettings: {
                title: "Paramètres",
                column: "Paramètres de colonne",
                selectField: "Sélectionnez un champ",
                selectFieldPlaceholder: "Sélectionnez un champ",
                card: "Paramètres de carte",
                selectFields: "Sélectionnez les champs à afficher dans la carte",
                cancel: "Annuler",
                save: "Enregistrer",
                kanban: "Paramètres Kanban"
            },
            priority_lowest: "Plus Basse",
            priority_low: "Basse",
            priority_medium: "Moyenne",
            priority_high: "Haute",
            priority_highest: "Plus Haute",
            createFailed: "Échec de la création du module",
            createSuccess: "Module créé avec succès",
            moduleDeletedSuccessfully: "Module supprimé avec succès",
            deleteModuleTitle: "Supprimer le module",
            deleteModuleContent: "Êtes-vous sûr de vouloir supprimer ce module ?",
            modules: "Modules",
            modulesSettings: "Paramètres des Modules",
            displayName: "Nom d'Affichage",
            description: "Description",
            table: "Tableau",
            menuApiSettings: "Paramètres du Menu et de l'API",
            icon: "Icône",
            save: "Enregistrer",
            exampleIcon: "Ex: extension, home",
            newModule: "Nouveau Module",
            moduleName: "Nom du Module",
            apiName: "Nom de l'API",
            type: "Type",
            apiAccess: "Accès à l'API",
            actions: "Actions",
            module: "Module",
            relation: "Relation",
            moduleRelationName: "Module/Relation",
            moduleRelationTable: "Table de Module/Relation",
            showInMainMenu: "Afficher dans le Menu Principal",
            apiEnabled: "API Activée",
            settings: "Paramètres",
            createModule: "Créer un module",
            relationType: "Type de relation",
            standartModule: "Module standard",
            customTable: "Table personnalisée",
            localField: "Champ local",
            showingRemoteFieldInList: "Afficher le champ distant dans la liste",
            relationSettings: "Paramètres de relation",
            remoteField: "Champ distant",
            localFieldType: "Type de champ local",
            standart: "Standard",
            custom: "Personnalisé",
            contact: "Contact",
            viewRecord: "Voir le record",
            recordDetail: "Détails du record",
            recordNotFound: "Record ou informations de la table non trouvées",
            relatedLists: "Listes liées",
            recordViewer: "Visualisateur de records",
        },
        tables: {
            enterWidgetName: "Entrez le nom du widget",
            widgetName: "Nom du Widget",
            renameWidget: "Renommer le widget",
            assistantCapabilities: "Capacités de l'Assistant",
            addNewFieldsToTable: "Peut ajouter de nouveaux champs au tableau",
            editExistingFields: "Peut modifier les champs existants",
            deleteUnnecessaryFields: "Peut supprimer les champs inutiles",
            filterRecords: "Peut filtrer les enregistrements",
            groupRecords: "Peut regrouper les enregistrements",
            hideFieldsCapability: "Peut masquer les champs",
            createConditionalFormatting: "Peut créer une mise en forme conditionnelle",
            createCalculationFormulas: "Peut créer des formules de calcul",
            createSampleRecords: "Peut créer des enregistrements d'exemple",
            examplePrompt: "Exemple : Ajoutez les champs Nom, Prénom, E-mail et Téléphone pour les informations client dans ce tableau...",
            supsisAssistantTables: "Supsis Assistant : Tables",
            supsisAssistantWritePrompt: "Décrivez ce que vous voulez que l'Assistant Supsis fasse",
            supsisAssistantExamplePrompt: "Créez un tableau pour suivre les réunions. Incluez des champs tels que le sujet de la réunion, la date, les participants, la personne responsable, les décisions prises et les actions de suivi.",
            sendSupsisAssistant: "Envoyer à l'Assistant Supsis",
            examplePromptsTitle: "Exemples de demandes :",
            examplePrompts: {
                addCustomerInfoFields: "Ajoute les champs Prénom, Nom, E-mail et Téléphone pour les informations client dans ce tableau.",
                addOrderFields: "Ajoute les champs Nom du produit, Quantité, Prix unitaire, Montant total et Date de commande au tableau des commandes.",
                addBirthDateField: "Ajoute un champ Date de naissance à ce tableau et définis le format de date en JJ/MM/AAAA.",
                updateStatusField: "Mets à jour le champ Statut, rends-le déroulant avec les options : En attente, En cours, Terminé, Annulé.",
                replaceAddressFields: "Supprime le champ Adresse et ajoute à la place les champs Adresse ligne 1, Adresse ligne 2, Arrondissement, Ville et Code postal.",
                alignTextFields: "Aligne tous les champs de texte au centre et limite la longueur maximale du texte à 100 caractères.",
                addAutoIncrementID: "Ajoute un champ ID en auto-incrément avec le préfixe PRD- pour le produit.",
                addTotalAmountFormula: "Ajoute le champ Montant total comme formule calculant le produit de la quantité et du prix unitaire.",
                createActiveCustomersFilter: "Crée un filtre pour n'afficher que les clients actifs.",
                filterRecentUsers: "Filtre les utilisateurs inscrits au cours des 30 derniers jours.",
                groupByStatus: "Regroupe les enregistrements par colonne Statut.",
                hideAllExceptDeliveryAndOrderNo: "Masque tous les champs sauf Date de livraison et Numéro de commande.",
                colorCodeOrders: "Colore les commandes en retard en rouge, celles à livrer aujourd’hui en jaune, et celles terminées en vert.",
                highlightHighPaymentRecords: "Souligne en violet les enregistrements avec un paiement supérieur à 1000 TL.",
                groupAndHighlightUnpaidOrders: "Regroupe par date de commande et affiche en rouge les commandes non payées.",
                createSampleRecords: "Crée 10 enregistrements d’exemple dans ce tableau.",
                addSampleRecordsForAliAndAhmet: "Ajoute 5 enregistrements d’exemple avec les noms de client Ali et Ahmet.",
                createRandomSampleOrders: "Crée 20 enregistrements de commande aléatoires avec des statuts définis au hasard.",
                hrCandidateTracking: "Je veux créer un logiciel de suivi des candidats (ATS) pour nos processus RH. Incluez tout ce qu'un ATS devrait avoir. Utilisez des noms de champs en turc.",
                crmModuleCreation: "Créez tous les modules nécessaires pour la gestion de la relation client (CRM). Incluez les informations client, les enregistrements de réunions et la gestion des opportunités.",
                realEstatePortfolioManagement: "Je veux mettre en place un système de gestion de portefeuille immobilier. Il devrait gérer les détails des propriétés, les demandes des clients et le suivi des ventes.",
                schoolManagementSystem: "Je veux gérer le suivi des étudiants, des enseignants et des horaires de cours pour un système de gestion scolaire. Utilisez des noms de champs en turc.",
                projectManagementSystem: "Je veux créer un système de gestion de projet. Incluez des tâches, des membres de l'équipe, le suivi du temps et des fonctionnalités de reporting.",
                inventoryAndWarehouseManagement: "Je veux construire un système pour la gestion des stocks et des entrepôts. Il devrait gérer les entrées/sorties de produits, les niveaux de stock et le suivi des fournisseurs.",
                serviceAndMaintenanceTracking: "Je veux un système de suivi des services et de la maintenance. Il devrait gérer les appareils des clients, l'historique de maintenance et les affectations des techniciens.",
                restaurantManagementSystem: "Je veux mettre en place un système de gestion de restaurant. Incluez le suivi des tables, la gestion des commandes, l'affichage en cuisine et les opérations de facturation.",
            },
            createAppWithSupsisAssistant: "Créer une application avec Supsis Assistant",
            noWidgets: "Aucun widget ajouté",
            widgetLoadError: "Le widget ne peut pas être chargé",
            createDashboardSupsisAssistant: "Créer un tableau avec Supsis Assistant",
            youtubeDesc: "Ajoutez des vidéos YouTube à votre panneau",
            iframeDesc: "Ajoutez du contenu iframe à votre panneau",
            countdownDesc: "Ajoutez un compte à rebours pour suivre les dates importantes",
            countdown: "Compte à rebours",
            textDesc: "Ajoutez du contenu texte personnalisé à votre panneau",
            numbersDesc: "Obtenez un aperçu rapide de toutes les colonnes numériques",
            numbers: "Nombres",
            addWidget: "Ajouter un widget",
            graphDesc: "Créez un widget de graphique pour visualiser les données dans vos tableaux",
            graph: "Graphique",
            suggested: "Suggesté",
            creationDate: "Date de création",
            today: "Aujourd'hui",
            month: "Mois",
            week: "Semaine",
            day: "Jour",
            table: "Tableau",
            kanban: "Kanban",
            calendar: "Calendrier",
            calendarSettings: "Paramètres du Calendrier",
            colorBy: "Couleur Par",
            startDateField: "Champ Date de Début",
            endDateField: "Champ Date de Fin (Optionnel)",
            eventCardFields: "Champs de Carte d'Événement",
            selectColorField: "Sélectionner le Champ de Couleur",
            selectStartDateField: "Sélectionner le Champ de Date de Début",
            selectEndDateField: "Sélectionner le Champ de Date de Fin",
            cancel: "Annuler",
            save: "Enregistrer",
            kanbanNotAvailable: "Vue Kanban Non Disponible",
            needDropdownField:
                "Pour utiliser la vue Kanban, vous avez besoin d'au moins un champ déroulant statique dans votre tableau. Vous pouvez ajouter un nouveau champ ou modifier un champ existant depuis les paramètres du tableau.",
            notAvailable: "Vue Calendrier Non Disponible",
            needDateField:
                "Vous avez besoin d'au moins un champ de date dans votre tableau pour utiliser la vue calendrier. Vous pouvez ajouter un nouveau champ ou modifier un champ existant depuis les paramètres du tableau.",
            switchToTable: "Passer à la Vue Tableau",
            operator: "Opérateur",
            conditionalColor: "Couleur conditionnelle",
            groupField: "Champ de groupe",
            selectDirection: "Sélectionner la direction",
            showEmptyGroups: "Afficher les groupes vides",
            clearGrouping: "Vider le regroupement",
            applyGrouping: "Appliquer le regroupement",
            sortDirection: "Direction de tri",
            downloadSelectedRecords: "Télécharger les enregistrements sélectionnés",
            viewName: "Nom de la vue",
            enterViewName: "Entrez le nom de la vue",
            enterDesc: "Entrez la description",
            viewNameRequired: "Nom de la vue requis",
            runWebhookAutomation: "Exécuter l'automatisation du crochet Web",
            downloadAllRecords: "Télécharger tous les enregistrements",
            deleteRecords: "Supprimer les enregistrements",
            editRecords: "Mise à jour des enregistrements",
            duplicateRecords: "Duplicate Records",
            selected: "Sélectionné",
            sureDeleteRecords: "Êtes-vous sûr de vouloir supprimer des enregistrements?",
            selectedRecordSucs: "Les enregistrements sélectionnés ont été supprimés avec succès",
            errorDeletingRecords: "Une erreur s'est produite lors de la suppression des enregistrements.",
            sureCopyRecords: "Êtes-vous sûr de vouloir copier les enregistrements?",
            copyRecords: "Copier les enregistrements",
            recordsCopiedSucs: "Les enregistrements sélectionnés ont été copiés avec succès",
            recordsCopiedError: "Une erreur s'est produite lors de la copie des enregistrements sélectionnés",
            viewSucsCreated: "La vue a été créée avec succès",
            editMultipleRecords: "Modifier plusieurs enregistrements",
            importRecords: "Importer des enregistrements",
            importHasStarted:
                "L'importation a commencé. Cela peut prendre quelques minutes en fonction de la taille de vos données. Veuillez patienter...",
            anErrorImport: "Une erreur s'est produite lors de l'importation",
            recordCreated: "Créer un enregistrement",
            recordUpdated: "Mise à jour de l'enregistrement",
            recordDeleted: "Supprimer un enregistrement",
            noAutomationDefined: "Aucune automatisation n'a encore été définie",
            nameTheAutomationAdd:
                "Nomme l'automatisation qui sera exécutée lorsqu'un enregistrement est ajouté à cette table :",
            nameTheAutomationUpdate:
                "Nommez l'automatisation qui s'exécutera lorsqu'un enregistrement de cette table sera mis à jour :",
            nameTheAutomationDelete:
                "Nomme l'automatisation qui s'exécutera lorsqu'un enregistrement sera supprimé de cette table :",
            editField: "Champ d'édition",
            sort: "Tri",
            ascending: "Ascendant",
            descending: "Descendant",
            createField: "Créer un champ",
            insertBefore: "Insérer avant",
            insertAfter: "Insérer après",
            goToRelatedAuto: "Aller à l'automatisation connexe",
            permission: "Permission",
            lockField: "Champ de verrouillage",
            hideField: "Champ masqué",
            deleteField: "Supprimer un champ",
            watchVideo: "Regarder la vidéo",
            uploadError: "Erreur de téléchargement",
            updateError: "Erreur de mise à jour",
            invalidValue: "Valeur non valide. Veuillez utiliser le format correct.",
            errorUpdatingRecord: "Une erreur s'est produite lors de la mise à jour de l'enregistrement.",
            errorCreatingView: "Une erreur s'est produite lors de la création de la vue.",
            datetimeOptions: "Options de date et d'heure",
            numberOptions: "Options relatives aux nombres",
            currencyOptions: "Options de devise",
            dropdownOptions: "Options de la liste déroulante",
            automationButtonOptions: "Options du bouton d'automatisation",
            defaultLabel: "Étiquette par défaut",
            disableWhenClicked: "Désactiver en cas de clic",
            fieldSucsCreate: "Champ créé avec succès",
            fieldCreatingFailed: "Une erreur s'est produite lors de la création du champ",
            fieldSucsUpdate: "Champ mis à jour avec succès",
            fieldUpdatingFailed: "Une erreur s'est produite lors de la mise à jour du champ",
            showAll: "Afficher tout",
            hideAll: "Cacher tout",
            searchFields: "Champs de recherche",
            firstRowHeader: "La première ligne contient l'en-tête",
            seperatorCharacter: "Caractère de séparation",
            comma: "Virgule",
            semicolan: "Point-virgule",
            tableFieldOrFileColumns: "Correspondance entre les champs de la table et les colonnes du fichier",
            exampleResultPreview: "Exemple d'aperçu de résultat",
            newView: "Nouvelle vue",
            createViewaFiltering:
                "Créez des vues pour continuer à filtrer, trier et masquer des champs sans modifier la table principale",
            pleaseUpdateSelected:
                "Veuillez sélectionner le champ que vous souhaitez mettre à jour pour les enregistrements sélectionnés",
            pleaseSelectedNewValue: "Veuillez saisir la nouvelle valeur du champ sélectionné.",
            selectedMenuItem: "Élément de menu sélectionné :",
            deleteTable: "Supprimer le tableau",
            sureDeleteTable: "Êtes-vous sûr de vouloir supprimer cette table ?",
            deleteTableSucs: "La table a été supprimée avec succès.",
            deleteTableError: "Erreur lors de la suppression du tableau :",
            editTable: "Modifier le tableau",
            createNewField: "Créer un nouveau champ",
            tables: "Tables",
            tableName: "Nom de la table",
            description: "Description",
            createTable: "Créer une table",
            createNewTable: "Créer une nouvelle table",
            allTables: "Toutes les tables",
            myTables: "Mes tables",
            myFavorites: "Mes favoris",
            errorCreatingTable: "Erreur lors de la création de la table :",
            customerTable: "Table client",
            customerTableDesc: "Table client par défaut",
            leadTracking: "Suivi des prospects",
            leadTrackingDesc: "Table de suivi des prospects",
            todoList: "Liste des choses à faire",
            todoListDesc: "Liste de suivi des tâches",
            approvalReq: "Demande d'approbation",
            approvalReqDesc: "Gestion des demandes d'approbation",
            eventSchedule: "Calendrier d'événements",
            eventScheduleDesc: "Programmation des événements à venir",
            inventoryList: "Liste d'inventaire",
            inventoryListDesc: "Suivi des stocks de produits",
            bookingForm: "Formulaire de réservation",
            bookingFormDesc: "Suivi des réservations",
            bugTracker: "Suivi des bogues",
            bugTrackerDesc: "Suivi des bogues de logiciels",
            employeeDirectory: "Annuaire des employés",
            employeeDirectoryDesc: "Contient des informations sur les employés",
            errorPullTable: "Erreur lors de l'extraction des données de la table",
            newRecordSucs: "Nouvel enregistrement créé avec succès.",
            failedNewRecord: "La création d'un nouvel enregistrement a échoué :",
            newRecordCreateError: "Une erreur s'est produite lors de la création d'un nouvel enregistrement",
            recordCount: "Nombre d'enregistrements",
            increaseLimit: "Limite d'augmentation",
            newRecord: "Nouvel enregistrement",
            imports: "Importation",
            exports: "Exportation",
            download: "Téléchargement",
            automateYourData: "Automatisez vos données",
            recordUpdatedSucs: "Enregistrement mis à jour avec succès",
            failedToUpdateRecord: "Échec de la mise à jour de l'enregistrement",
            recordUpdatingError: "Erreur de mise à jour de l'enregistrement",
            mainTable: "Table principale",
            filter: "Filtre",
            hideFields: "Masquer les champs",
            saveAsView: "Enregistrer sous forme de vue",
            search: "Recherche",
            create: "Créer",
            left: "Gauche",
            center: "Moyen",
            right: "Droite",
            selectTimezone: "Sélectionner le fuseau horaire",
            createFieldSucs: "Champ créé avec succès",
            failedCreateField: "Échec de la création du champ :",
            createFieldError: "Une erreur s'est produite lors de la création du champ",
            addCondition: "Ajouter une condition",
            applyFilter: "Appliquer un filtre",
            fieldType: "Type de champ",
            alignment: "Alignement",
            blankTable: "Tableau vide",
            templates: "Modèles",
            timezone: "Fuseau horaire",
            timeFormat: "Format de l'heure",
            includeTime: "Heure incluse",
            decimalFormat: "Format décimal",
            currencySymbol: "Symbole de la monnaie",
            mode: "Mode",
            statics: "Statique",
            dynamic: "Dynamique",
            multipleSelection: "Sélection multiple",
            addOption: "Ajouter une option",
            text: "Texte",
            longText: "Texte long",
            number: "Nombre",
            currency: "Devise",
            datetime: "Date & Heure",
            dropdown: "Liste déroulante",
            checkbox: "Case à cocher",
            email: "Email",
            phone: "Téléphone",
            file: "Fichier",
            image: "Image",
            video: "Vidéo",
            audio: "Audio",
            colour: "Couleur",
            automationButton: "Bouton d'automatisation",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Semaine",
            readyContents: "Contenus prêts",
            webhookIntegration: "Intégration de webhook",
            businessChannel: "Canal professionnel WhatsApp",
            confirmationFeature: "Fonction de confirmation",
            specialReporting: "Reporting spécial",
            aiAssistant: "Assistant IA",
            flexibleBilling: "Facturation flexible",
            automaticReservation: "Réservation automatique",
            taskManagement: "Gestion des tâches",
            calendarIntegration: "Intégration du calendrier",
            activeChatbot: "Chatbot actif",
            smsIntegration: "Intégration SMS",
            mailIntegration: "Intégration e-mail",
            startChatWithVisitor: "Commencer le chat avec le visiteur",
            whatsappManaging: "Gestion de Whatsapp",
            automaticChatbotButton: "Bouton/Chatbot automatique",
            personalizedBroadcasts: "Diffusions personnalisées",
            chatWithNonContacts: "Chat avec les non contacts",
            broadcastMessaging: "Messagerie de diffusion",
            perBroadcast: "Par diffusion",
            extraPricePerMessage: "Prix supplémentaire par message",
            smartTrigger: "Déclencheur intelligent",
            telegramIntegration: "Intégration de Telegram",
            instagramIntegration: "Intégration d'Instagram",
            ticketFeature: "Fonction de ticket",
            storage: "Stockage",
            onePanelManagement: "Gestion à partir d'un seul panneau",
            isolatedDatabaseConnection: "Connexion de base de données isolée",
            removeLogo: "Supsis Logo Supprimer",
            chatBaloonCustomization: "Personnalisation du ballon de discussion",
            chatAndNotifications: "Chat et Notifications",
            unlimited: "Illimité",
            specialCustomerSupport: "Support client spécial",
            softwareSupport: "Support logiciel",
            standardSupport: "Support standard",
            teamChatIntegration: "Intégration de chat d'équipe",
            fileAndVoiceShare: "Partage de fichiers et de voix",
            instantVisitor: "Suivi instantané des visiteurs",
            detailedReporting: "Rapport détaillé",
            normalreporting: "Reporting normal",
            noExtraCosts: "Pas de frais supplémentaires",
            accessibleToAllAgents: "Accessible à tous les agents",
            dataSecurity: "Sécurité des données",
            autoTranslate: "Traduction automatique",
            chatbotVersionHistory: "Historique des versions du chatbot",
            chatbotStory: "Histoire du chatbot",
            freeAgent: "Agent gratuit",
            stableAgentCount: "Nombre d'agents stables",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Plans abordables",
            generalPlan: "Plan général",
            specialPlan: "Plan spécial",
            currentPlan: "Plan actuel",
            selected: "Sélectionné",
            popular: "Populaire",
            trialPkg: "Forfait d'essai",
            support: "Support 24/7",
            flexiblePricing: "Tarification flexible",
            rightToCancel: "Droit d'annulation à tout moment",
            unlimitedCBScenario: "Scénarios de chatbot illimités",
            freeFirstScenario: "Premier scénario gratuit",
            unlimitedLearn: "Formation illimitée au chatbot",
            allPlatformIntegration: "Intégration avec toutes les plateformes",
            detailedReports: "Rapports détaillés",
            aiSupport: "Support IA",
            creativeAI: "Assistant de chat IA rapide et réaliste",
            unlimitedSession: "Sessions illimitées simultanément",
            assistantFromWebsite: "Créer un assistant à partir du site Web",
            assistantFromDoc: "Créer un chatbot à partir du document",
            mobileApp: "Application mobile",
        },
        messenger: {
            channel: "Canal Messenger",
            manageChannel: "Gérer le canal",
            channelDetail: "Détail du canal",
            integrationTitle: "Intégration Messenger",
            deleteDesc: "Êtes-vous sûr de vouloir supprimer le canal Messenger?",
            channels: "Canaux Messenger",
            connectMessenger: "Se connecter à Messenger",
            detail: "détail",
            visibility: "Visibilité",
            settings_group: "Paramètres",
            commentsettings: "Gestion des commentaires",
            commentSettingsTitle: "Gestión de comentarios de Messenger",
            commentSettingsDesc: "Gérer vos commentaires Messenger",
        },
        instagram: {
            channel: "Chaîne Instagram",
            detail: "détail",
            visibility: "Visibilité",
            settings_group: "Paramètres",
            commentsettings: "Gestion des commentaires",
            commentSettingsTitle: "Gestion des commentaires Instagram",
            commentSettingsDesc: "Gérez vos commentaires Instagram",
            commentSettingsTicket:
                "Assure que les commentaires entrants sont enregistrés dans le système sous forme de tickets.",
            commentSettingsChatbot:
                "Sélectionnez à quel scénario de chatbot les commentaires entrants doivent être dirigés.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Afficher toutes les chaînes Instagram",
        },
        calendar: {
            calendarsDesc: "Éviter les conflits d'horaire",
            generalAvailability: "Disponibilité générale",
            generalAvailabilityDesc:
                "Indiquez les heures auxquelles vous êtes régulièrement disponible pour des rendez-vous.",
            appointDuration: "Durée du rendez-vous",
            appointDurationDesc: "Combien de temps doit durer chaque rendez-vous ?",
            customDuration: "Durée personnalisée",
            descriptionDesc:
                "Ajoutez une note décrivant votre service. La note que vous ajoutez apparaîtra sur votre page de réservation et dans les courriels de confirmation.",
            resForm: "Formulaire de réservation",
            resFormDesc: "Personnalisez le formulaire que les personnes utiliseront pour prendre un rendez-vous.",
            addField: "Ajouter un champ",
            addAnItem: "Ajouter un élément",
            saveItem: "Enregistrer un élément",
            planningTimeframe: "Période de planification",
            planningTimeframeDesc: "Limite le délai dans lequel un rendez-vous peut être pris.",
            availableAtMoment: "Disponible maintenant",
            startAndEndDate: "Dates de début et de fin",
            maxNumberAppoint: "Nombre maximal de jours après lesquels un rendez-vous peut être pris",
            howLongMinAppoint: "Délai avant lequel le rendez-vous peut être pris",
            planningIntervalStartEnd: "Dates de début et de fin de l'intervalle de planification",
            startTime: "Heure de début",
            done: "Fait",
            receivedAppointInterval: "Intervalle de rendez-vous reçu",
            receivedAppointIntervalDesc: "Gérer les rendez-vous reçus pour qu'ils apparaissent dans votre calendrier",
            interimTime: "Temps intermédiaire",
            interimTimeDesc: "Ajouter du temps entre les intervalles de rendez-vous",
            dayMaxRes: "Nombre maximal de réservations par jour",
            dayMaxResDesc: "Limite le nombre de rendez-vous pris qui peuvent être acceptés en une seule journée",
            customise: "Définir la personnalisation",
            noAvatar: "Pas d'avatar",
            organizationName: "Nom de l'organisation",
            enterFullAdress: "Saisir l'adresse complète",
            noCoverPhoto: "Pas de photo de couverture",
            enterAboutInfo: "Saisir des informations sur le sujet",
            service: "Service",
            deleteService: "Supprimer le service",
            enterGoogleMapsUrl: "Saisir l'URL de Google Maps",
            enterLatitude: "Saisir la latitude",
            enterLongitude: "Entrez la longitude",
            enterNumber: "Entrez le numéro de téléphone",
            uploadAvatar: "Télécharger un avatar",
            teamMemberDeleteError: "Erreur lors de la suppression d'un membre de l'équipe :",
            setupBookingWebsite: "Création d'un site de réservation",
            bookingLandingPageBuilder: "Constructeur de page de réservation",
            coverPhoto: "Photo de couverture",
            enterOrganisationName: "Entrez le nom de l'organisation",
            about: "A propos",
            services: "Services",
            deleteServices: "Supprimer un service",
            selectReservationPlan: "Sélectionner un plan de réservation",
            addNewService: "Ajouter un nouveau service",
            addNewMember: "Ajouter un nouveau membre",
            fullAddress: "Adresse complète",
            latitude: "Latitude",
            longitude: "Longitude",
            contactDetails: "Détails du contact",
            emailAddress: "Adresse électronique",
            enterEmail: "Saisir l'adresse électronique",
            websiteURL: "URL du site web",
            enterWebsiteURL: "Saisir l'URL du site web",
            reservationPolicy: "Politique de réservation",
            enterResPolicy: "Saisir la politique de réservation",
            workingHours: "Heures de travail",
            selectEndHour: "Sélectionner l'heure de fin",
            addNewHour: "Ajouter une nouvelle heure",
            updateMemberInfo: "Mettre à jour les informations relatives au membre",
            errorRecevingData: "Erreur lors de la récupération des données :",
            anonymService: "Service anonyme",
            unknownPlan: "Plan inconnu",
            errorCreatingMockPage: "Erreur lors de la création de la page fictive :",
            failedToCreateBookingPage: "Échec de la création de la page de réservation",
            fileSizeToolLarge: "Taille du fichier trop importante",
            errorLoadingTheLogo: "Erreur lors du chargement du logo :",
            failedToLoadLogo: "Échec du chargement du logo",
            errorUpdating: "Erreur de mise à jour :",
            failedToUpdate: "Échec de la mise à jour",
            newMember: "Nouveau membre",
            errorLoadingAvatar: "Erreur lors du chargement de l'avatar :",
            avatarFailedToLoad: "Échec du chargement de l'avatar",
            teamMemberSuccessfullyDeleted: "Membre de l'équipe supprimé avec succès",
            teamMemberNotDelete: "Échec de la suppression du membre de l'équipe",
            yesDelete: "Oui, supprimer",
            sureResDelete: "Êtes-vous sûr de vouloir supprimer cette réservation ?",
            resDetails: "Détails de la réservation",
            infoPersonMakingRes: "Informations sur la personne qui effectue la réservation",
            appointmentProgram: "Programme de rendez-vous",
            goToAppointSettings: "Aller aux paramètres du programme de rendez-vous",
            resPlanCreateSuccess: "Plan de réservation créé avec succès",
            pleaseEnterTitle: "Veuillez saisir le titre",
            sureContinueSaving: "Êtes-vous sûr de vouloir continuer sans sauvegarder ?",
            appointProgram: "PROGRAMME DE RÉSERVATION",
            everyMonth: "Chaque mois",
            firstEveryMonth: "Premier de chaque mois",
            dayOf: "Jour",
            notRepeat: "Ne se répète pas",
            daily: "Tous les jours",
            weekly: "Une fois par semaine",
            monthly: "Une fois par mois",
            annually: "Une fois par an",
            custom: "Spécial",
            eventSaved: "Enregistrement d'un événement",
            reservationWebPage: "Page web de réservation",
            reservationPrograms: "Programmes de réservation",
            addReservationProgram: "Ajouter un programme de réservation",
            resPlanError: "Erreur lors de la réception des programmes de réservation :",
            resDeleteSure: "Êtes-vous sûr de vouloir supprimer ce programme de réservation ?",
            resDeleteSuccess: "Le programme de réservation a été supprimé avec succès.",
            resDeleteError: "Erreur lors de la suppression du programme de réservation :",
            unkownUser: "Utilisateur inconnu",
            eventNotFound: "Événement non trouvé",
            reservations: "Réservations",
            events: "Evénements",
            upcoming: "à venir",
            past: "Passé",
            setting: "Paramètres",
            delete: "Supprimer",
            cancel: "Annuler",
            save: "Enregistrer",
            close: "Fermer",
            deleteRepeatEvent: "Supprimer l'événement récurrent",
            thisEvent: "Cet événement",
            thisAndOtherEvent: "Cet événement et les suivants",
            allEvent: "Tous les événements",
            ok: "OK",
            googleCalendarLink: "Ajouter au Google Agenda",
            yahooCalendarLink: "Ajouter au Yahoo Agenda",
            subject: "Sujet",
            visitor: "Visiteur",
            allDay: "Toute la journée",
            title: "Titre",
            deleteEvent: "Supprimer l'événement",
            deleteEvents: "Supprimer les événements",
            deleteEventsSure: "Êtes-vous sûr de vouloir supprimer les événements de ce calendrier?",
            deleteEventConfirm: "Êtes-vous sûr de vouloir supprimer cet événement?",
            notEmptyTitle: "Le titre ne peut pas être vide!",
            tasks: "Tâches",
            googleConnect: "Intégration Google",
            googleDisconnect: "Désactiver l'intégration Google",
            sure: "Êtes-vous sûr?",
            disconnectGoogleSure: "Êtes-vous sûr de vouloir désactiver la connexion Google?",
            yes: "Oui",
            no: "Non",
            customRepeat: "Répétition personnalisée",
            recurrenceFrequency: "Fréquence de répétition",
            repeatDays: "Répéter les jours suivants:",
            never: "Jamais",
            thisDate: "À cette date:",
            recurrenceCount: "Nombre de répétitions:",
            end: "Fin",
            event: "Événement",
            calendars: "Calendriers",
            newCalendar: "Créer un nouveau calendrier",
            changeColor: "Changer de couleur",
            addCalendar: "Ajouter un calendrier",
            nameCalendar: "Nom du calendrier",
            description: "Description",
            change: "Modifier",
            deleteCalendar: "Supprimer le calendrier",
            deleteCalendarSure: "Êtes-vous sûr de vouloir supprimer ce calendrier?",
            notEmptyCalendarName: "Le nom du calendrier ne peut pas être vide",
            myEvents: "Mes événements",
            everyoneEvents: "Tous les événements",
            haveEvent: "événements de l'agent",
            goCalendar: "Aller au calendrier",
            goReservation: "Créer une réservation",
            agents: "Agents",
            today: "Aujourd'hui",
            month: "Mois",
            week: "Semaine",
            day: "Jour",
            list: "Liste",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Groupe de paramètres",
            waitDayFromLastSend: "Jour d'attente depuis le dernier message envoyé",
            automationRuleName: "Nom de la règle d'automatisation",
            time: "Temps",
            year: "An",
            month: "Mois",
            dayOfMonth: "Jour du mois",
            day: "Jour",
            bySecond: "Par seconde",
            byMinute: "Par minute",
            byHour: "Par heure",
            byWeekNo: "Par numéro de semaine",
            byYearDay: "Par jour de l'année",
            byMonthDay: "Par jour du mois",
            byMonth: "Par mois",
            december: "Décembre",
            november: "Novembre",
            october: "Octobre",
            september: "Septembre",
            august: "Août",
            july: "Juillet",
            june: "Juin",
            may: "Mai",
            april: "Avril",
            march: "Mars",
            february: "Février",
            january: "Janvier",
            byWeekDay: "Par jour de semaine",
            interval: "Intervalle",
            seconds: "Secondes",
            minutes: "Minutes",
            hourly: "Toutes les heures",
            daily: "Quotidiennement",
            weekly: "Hebdomadaire",
            monthly: "Mensuel",
            yearly: "Annuel",
            frequency: "Fréquence",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Province",
                country: "Pays",
                phone: "Téléphone",
                email: "E-mail",
                fullname: "Nom complet",
                couponPercent: "% de réduction",
                lastOrderDate: "Dernière commande",
                firstOrderDate: "Première commande",
                county: "Comté",
                lastSource: "Dernière source",
                firstSource: "Première source",
                lastPaymentType: "Dernier mode de paiement",
                firstPaymentType: "Premier mode de paiement",
                maxOrderAmount: "Montant maximal de la commande",
                minOrderAmount: "Montant minimal de la commande",
                totalOrderAmount: "Montant total de la commande",
                totalOrderCount: "Nombre total de commandes",
                usedCouponAmount: "Montant du coupon utilisé",
                usedCouponCount: "Nombre de coupons utilisés",
                tookDayFromLastOrder: "Jours depuis la dernière commande",
                isCouponUser: "Est utilisateur de coupon",
            },
            createAutomation: "Créer une automatisation",
            previous: "Précédent",
            createAutomationDesc: "Créez et gérez l'automatisation des messages",
            newTicimaxChannel: "Nouvelle chaîne Ticimax",
            connextToTicimaxXml: "Se connecter au service XML Ticimax",
            connectTicimax: "Se connecter à Ticimax",
            examplePreview: "Aperçu de l'exemple",
            completeAutomationRule: "Règle d'automatisation complète",
            configureMessage: "Configurer le message",
            automationTimer: "Minuterie d'automatisation",
            findTargetMembers: "Trouver les membres cibles",
            createAutomationRule: "Créer une règle d'automatisation",
            action: "Action",
            status: "Statut",
            triggeredUserCount: "Nombre d'utilisateurs déclenchés",
            nextScheduled: "Prochain prévu",
            timerRule: "Règle de minuterie",
            automationRules: "Règles d'automatisation",
            apply: "Appliquer",
            searchAMember: "Rechercher un membre",
            segmentedMembersDesc: "Énumérez et automatisez les membres segmentés",
            manageVisibilityDesc: "Gérer la visibilité du canal",
            xmlOrderListURL: "URL de la liste de commandes XML",
            manageIntegrationDesc: "Gérez votre intégration Ticimax",
            detail: "Détail",
            ticimaxChannelsTitle: "Canaux Ticimax",
            ticimaxDetail: "Détail Ticimax",
            settingsGroup: "Paramètres",
            visibility: "Visibilité",
            members: "Membres",
            automation: "Automatisation",
            integrationChannel: "Canal d'intégration",
            channelUpdated: "Chaîne mise à jour avec succès",
            channelUpdateFailed: "Échec de la mise à jour du canal",
        },
        notification: {
            taskArchive: "Une notification est envoyée lorsque la tâche est archivée.",
            taskComplet: "Notification is sent when a completed task is closed.",
            adjustNow: "Régler maintenant",
            chatAssignedMe: "Lorsqu'un chat m'est attribué.",
            ticketAssignedMe: "Lorsqu'un ticket m'est attribué.",
            myChatClosed: "Lorsqu'un chat que je possède est fermé.",
            contactOwner: "Lorsque le propriétaire du chat change, lorsque la propriété est attribuée ou retirée.",
            tagActionsToVisitor: "Lorsqu'une étiquette est ajoutée ou retirée d'un visiteur.",
            ticketCreated: "Lorsqu'un visiteur ou un chatbot crée un ticket.",
            notesActions: "Lorsqu'une note est ajoutée ou retirée d'un client.",
            visitorProfileUpdated: "Lorsque le profil d'un visiteur est mis à jour.",
            chatStartedByAnyPlatform: "Lorsqu'un chat est lancé depuis n'importe quel canal.",
            userActions: "Lorsqu'un utilisateur est créé, mis à jour ou supprimé.",
            departmentActions: "Lorsqu'un département est créé, mis à jour ou supprimé.",
            settingsActions: "Lorsqu'un paramètre est créé, mis à jour ou supprimé.",
            integrationsActions: "Lorsqu'un canal d'intégration est créé, mis à jour ou supprimé.",
            loginFormActions: "Lorsque le formulaire de connexion est mis à jour ou activé.",
            bannedWordActions: "Lorsqu'un mot interdit est créé, mis à jour ou supprimé.",
            emailActions: "Lorsqu'un compte email est créé, mis à jour ou supprimé.",
            preparedContentActions: "Lorsqu'un contenu préparé est créé, mis à jour ou supprimé.",
            roleActions: "Lorsqu'un rôle est créé, mis à jour ou supprimé.",
            tagActions: "Lorsqu'une étiquette est créée, mise à jour ou supprimée.",
            welcomeMessageActions: "Lorsqu'un message de bienvenue est créé, mis à jour ou supprimé.",
            webhookActions: "Lorsqu'un webhook est créé, mis à jour ou supprimé.",
            billingEvents: "Lorsqu'une facture est créée ou que son statut est mis à jour.",
            systemStatus: "Lorsque le statut du système de support en direct est mis à jour.",
            reservationMessageCrud: "Lorsqu'une réservation est créée, mise à jour ou supprimée.",
            ipAddressWhiteListEvents: "Lorsqu'une adresse IP autorisée est ajoutée, mise à jour ou supprimée.",
            taskAssignedMe: "Lorsqu'une tâche m'est attribuée.",
            workflowCreated: "Lorsqu'un flux de travail est créé.",
            workflowDeleted: "Lorsqu'un flux de travail est supprimé.",
            createdTask: "Lorsqu'une tâche est créée.",
            deletedTask: "Lorsqu'une tâche est supprimée.",
            chatbotStoryCrud: "Lorsqu'une histoire de chatbot est créée, mise à jour ou supprimée.",
            chatbotForwardAgent: "Le chatbot transfère un chat à un agent.",
            userSegmentCrud: "Lorsqu'un segment d'utilisateur est créé, mis à jour ou supprimé.",
            chatbotCreditLow: "Lorsque le crédit du chatbot est faible.",
            wpCreditLow: "Lorsque le crédit WhatsApp tombe en dessous de 100 TL.",
            wpCustomerGroupCrud: "Lorsqu'un groupe de clients WhatsApp est créé, mis à jour ou supprimé.",
            wpBroadcastMessageStatus: "Lorsqu'un message de diffusion WhatsApp est lancé, terminé ou annulé.",
            wpTemplateMesssageCrud: "Lorsqu'un message modèle WhatsApp est créé, mis à jour ou supprimé.",
            whatsappQrChannelStatusUpdated: "Lorsque le statut de connexion du canal WhatsApp QR est mis à jour.",
            activityTypeLabels: {
                "chat-assign": "Lorsqu'un chat m'est assigné",
                "ticket-assign": "Lorsqu'un ticket m'est assigné",
                "task-assign": "Lorsqu'une tâche m'est assignée",
                "task-complet": "Lorsqu'une tâche est terminée",
                "chat-close-own": "Lorsqu'un chat dont je suis propriétaire est fermé",
                "tag-actions-to-visitor": "Tags ajoutés ou supprimés d'un contact",
                "create-ticket": "Ticket créé par un visiteur ou un chatbot. Aussi, lorsqu'un message hors ligne est envoyé depuis la fenêtre de chat",
                "note-actions-to-visitor": "Notes ajoutées ou supprimées d'un contact",
                "visitor-profile-updates": "Mises à jour du profil visiteur",
                "chat-start": "Chat démarré sur n'importe quelle plateforme par un contact ou un agent",
                "user-crud": "Utilisateur créé, mis à jour ou supprimé",
                "department-crud": "Département créé, mis à jour ou supprimé",
                "settings-crud": "Paramètres créés, mis à jour ou supprimés",
                "integration-channel-crud": "Canal d'intégration créé, mis à jour ou supprimé",
                "login-form-crud": "Formulaire de connexion mis à jour, activé ou désactivé",
                "banned-word-crud": "Mot interdit créé, mis à jour ou supprimé",
                "email-account-crud": "Compte email créé ou supprimé",
                "prepared-content-crud": "Contenu préparé créé ou supprimé",
                "role-crud": "Rôle créé, mis à jour ou supprimé",
                "tag-crud": "Tag créé, mis à jour ou supprimé",
                "welcome-message-crud": "Message de bienvenue créé, mis à jour ou supprimé",
                "webhook-crud": "Webhook créé, mis à jour ou supprimé",
                "automation-created": "Automatisation créée",
                "automation-deleted": "Automatisation supprimée",
                "automation-published": "Automatisation publiée",
                "automation-unpublished": "Automatisation non publiée",
                "automation-updated": "Automatisation mise à jour",
                "billing-events": "Événements de facturation",
                "task-workflow-crud": "Workflow de tâche créé, mis à jour ou supprimé",
                "task-crud": "Tâche créée, mise à jour ou supprimée",
                "system-status": "Changements de statut système en ligne ou hors ligne",
                "chatbot-story-crud": "Histoire de chatbot créée, mise à jour ou supprimée",
                "chatbot-forward-chat": "Chatbot transfère un chat à un agent",
                "chatbot-user-segment-crud": "Segment d'utilisateur créé, mis à jour ou supprimé",
                "chatbot-credit-low": "Lorsque le crédit du chatbot est faible",
                "whatsapp-credit-low": "Lorsque le crédit WhatsApp est faible",
                "whatsapp-customer-group-crud": "Lorsqu'un groupe de clients WhatsApp est créé, mis à jour ou supprimé",
                "whatsapp-broadcast-message-crud": "Lorsqu'un message de diffusion WhatsApp est envoyé, terminé ou annulé",
                "whatsapp-template-message-crud": "Lorsqu'un message de modèle WhatsApp est créé, mis à jour ou supprimé",
                "form-created": "Formulaire créé",
                "form-updated": "Formulaire mis à jour",
                "form-deleted": "Formulaire supprimé",
                "form-restored": "Formulaire restauré",
                "form-downloaded": "Formulaire téléchargé",
                "user-role-changed": "Rôle utilisateur modifié",
                "user-password-changed": "Mot de passe utilisateur modifié",
                "user-email-changed": "Adresse email utilisateur modifiée",
                "user-name-changed": "Nom d'utilisateur modifié",
                "user-phone-changed": "Téléphone utilisateur modifié",
                "user-disabled": "Utilisateur désactivé/activé",
                "role-updated": "Rôle mis à jour",
                "task-workflow-updated": "Workflow de tâche mis à jour",
                "task-workflow-pipeline-stage-added": "Étape de pipeline de workflow de tâche ajoutée",
                "task-workflow-pipeline-stage-updated": "Étape de pipeline de workflow de tâche mise à jour",
                "task-workflow-pipeline-stage-deleted": "Étape de pipeline de workflow de tâche supprimée",
                "drive-folder-created": "Dossier Drive créé",
                "drive-folder-deleted": "Dossier Drive supprimé",
                "drive-folder-renamed": "Dossier Drive renommé",
                "drive-file-added": "Fichier ajouté à Drive",
                "drive-file-deleted": "Fichier supprimé de Drive",
                "task-module-rules-enabled": "Règles du module de tâches activées",
                "task-module-rules-disabled": "Règles du module de tâches désactivées",
                "task-module-rules-rule-added": "Règle ajoutée au workflow de tâche",
                "task-module-rules-rule-deleted": "Règle supprimée du workflow de tâche",
                "task-module-rules-rule-updated": "Règle mise à jour dans le workflow de tâche",
                "task-module-rules-rule-enabled": "Règle activée dans le workflow de tâche",
                "task-module-rules-rule-disabled": "Règle désactivée dans le workflow de tâche",
                "contact-module-rules-enabled": "Règles du module de contacts activées",
                "contact-module-rules-disabled": "Règles du module de contacts désactivées",
                "contact-module-rules-rule-added": "Règle ajoutée au module de contacts",
                "contact-module-rules-rule-updated": "Règle mise à jour dans le module de contacts",
                "contact-module-rules-rule-deleted": "Règle supprimée du module de contacts",
                "contact-module-rules-rule-enabled": "Règle activée dans le module de contacts",
                "contact-module-rules-rule-disabled": "Règle désactivée dans le module de contacts",
                "developer-token-changed": "Token développeur mis à jour",
                "table-created": "Table créée",
                "table-field-added": "Champ ajouté à la table",
                "table-field-updated": "Champ mis à jour dans la table",
                "table-field-deleted": "Champ supprimé de la table",
                "table-view-added": "Vue ajoutée à la table",
                "table-view-updated": "Vue mise à jour dans la table",
                "table-view-deleted": "Vue supprimée de la table",
                "table-page-added": "Page ajoutée à la table",
                "table-page-updated": "Page mise à jour dans la table",
                "table-page-deleted": "Page supprimée de la table",
                "table-widget-added": "Widget ajouté à la page de table",
                "table-widget-updated": "Widget mis à jour sur la page de table",
                "table-widget-deleted": "Widget supprimé de la page de table",
                "table-privacy-changed": "Paramètres de confidentialité de la table mis à jour",
                "web-app-created": "Application web créée",
                "web-app-updated": "Application web mise à jour",
                "web-app-deleted": "Application web supprimée",
                "web-tab-created": "Onglet web créé",
                "web-tab-updated": "Onglet web mis à jour",
                "web-tab-deleted": "Onglet web supprimé",
                "module-created": "Module créé",
                "module-updated": "Module mis à jour",
                "module-deleted": "Module supprimé",
                "relation-created": "Relation créée",
                "relation-updated": "Relation mise à jour",
                "voice-agent-created": "Agent vocal créé",
                "voice-agent-updated": "Agent vocal mis à jour",
                "voice-agent-deleted": "Agent vocal supprimé",
                "voice-agent-phone-number-inbound-agent-changed": "Agent d'appel entrant du numéro de téléphone modifié",
                "voice-agent-phone-number-outbound-agent-changed": "Agent d'appel sortant du numéro de téléphone modifié",
                "voice-agent-batch-call-created": "Appel groupé créé",
                "voice-agent-knowledge-base-created": "Base de connaissances créée",
                "voice-agent-knowledge-base-deleted": "Base de connaissances supprimée",
                "table-data-downloaded": "Données de table téléchargées",
                "table-data-imported": "Données en masse importées dans la table",
                "table-data-batch-updated": "Données de table mises à jour en masse",
                "table-data-batch-deleted": "Données de table supprimées en masse",
                "contact-batch-updated": "Contacts mis à jour en masse",
                "chat-data-downloaded": "Historique de chat téléchargé"
            },
            crmActions: "Actions CRM",
            mobileApp: "Application mobile",
            webPanel: "Panneau Web",
            notifications: "Notifications",
            whatsappActions: "Actions Whatsapp",
            chatbotActions: "Actions du chatbot",
            companyActions: "Actions de l'entreprise",
            basicActions: "Actions de base",
            notificationSettingsDesc:
                "Choisissez les notifications que vous souhaitez recevoir et où vous souhaitez les recevoir.",
            noNotificationDesc2:
                "Ici, vous verrez toutes les notifications liées aux offres d'emploi, aux candidats et aux pools de talents que vous suivez. Vous pouvez personnaliser les notifications en ajustant les paramètres.",
            noNotificationTitle2: "Pas encore de notifications.",
            noNotificationTitle1: "Pas de notifications. Profitez du silence.",
            adjustSettings: "Ajuster les paramètres",
            showAll: "Afficher tout",
            showOnlyUnread: "Afficher uniquement les non lus",
            mailWasSent: "Le courriel a été envoyé.",
            mailAdressRemoved: "Adresse e-mail supprimée.",
            chatbotPublished: "La version <b>{version}</b> du chatbot a été publiée par <b>{user}</b>.",
            chatbotDeleted: "Le chatbot <b>{chatbot}</b> a été supprimé par <b>{user}</b>.",
            settingsUpdatedWoDetail: "Les paramètres ont été mis à jour par <b>{user}</b>.",
            noActivityDesc:
                "Il n'y a actuellement aucune activité dans le système. Quelques événements doivent se produire",
            noActivityTitle: "Pas encore d'activité",
            actionType: "Type d'action",
            dateBetween: "Dates entre",
            selectActor: "Sélectionner un utilisateur",
            activities: "Activités",
            chatbotCreated: "Le chatbot nommé <b>{chatbot}</b> a été créé par <b>{user}</b>.",
            taskAddedTags: "<b>{user}</b> a ajouté ces tags à la tâche (<b>{taskTitle}</b>) : <b>{tags}</b>",
            taskStageChanged:
                "L'étape de la tâche <b>{task}</b> a été changée de <b>{oldStage}</b> à <b>{newStage}</b> par <b>{user}</b>.",
            taskCreated: "La tâche <b>{task}</b> a été créée par <b>{user}</b>.",
            contactPropRemoved: "La propriété du visiteur <b>{prop}</b> a été supprimée par <b>{user}</b>.",
            contactPropAdded: "La propriété du visiteur <b>{prop}</b> a été ajoutée par <b>{user}</b>.",
            userRemoved: "L'utilisateur <b>{oldUser}</b> a été supprimé par <b>{user}</b>.",
            loginFormUpdated: "Le formulaire de connexion visiteur a été mis à jour par <b>{user}</b>.",
            loginFormDeactivated: "El formulario de inicio de sesión del usuario fue desactivado por <b>{user}</b>.",
            loginFormActivated: "Le formulaire de connexion de l'utilisateur a été activé par <b>{user}</b>.",
            invoiceRefunded: "Le processus de remboursement a été effectué par <b>{user}</b>.",
            paymentMethodAdded: "Une nouvelle méthode de paiement a été ajoutée par <b>{user}</b>.",
            invoicePaymentFailed: "Le paiement de la facture n'a pas été accepté par <b>{user}</b>.",
            invoicePaymentReceived: "Le paiement de la facture a été accepté par <b>{user}</b>.",
            planStarted: "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{details} Représentant</b>).",
            planStartedChatbot:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canaux Whatsapp</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canaux Professionnels Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{details} Représentant</b>).",
            planCanceledChatbot:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canaux Whatsapp</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canaux Professionnels Whatsapp</b>).",
            invoiceCreated: "La facture a été créée par <b>{user}</b>.",
            billingAddressUpdated: "Les informations de l'adresse ont été mises à jour par <b>{user}</b>.",
            taskWorkflowDeleted: "Le flux de travail <b>{workflow}</b> a été supprimé par <b>{user}</b>.",
            whatsappBroadcastFailed: "L'envoi du message de diffusion intitulé <b>{title}</b> a échoué.",
            whatsappBroadcastCancelled: "L'envoi du message de diffusion intitulé <b>{title}</b> a été annulé.",
            whatsappBroadcastCompleted:
                "Un message de diffusion intitulé <b>{title}</b> a été envoyé avec succès à <b>{numbers}</b> destinataires.",
            whatsappBroadcastCreated:
                "Un message de diffusion intitulé <b>{title}</b> a été envoyé à <b>{numbers}</b> destinataires par <b>{user}</b>.",
            ticketAssigned: "Un ticket a été attribué à <b>{user2}</b> par <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> s'est connecté à SUPSIS.",
            chatJoined: "<b>{agent}</b> a rejoint le chat avec <b>{visitor}</b>.",
            chatForwarded: "Le chat avec <b>{visitor}</b> a été transmis à <b>{agent}</b> par <b>{user}</b>.",
            chatAssigned: "Le chat avec <b>{visitor}</b> a été attribué à <b>{agent}</b> par le système.",
            customerGroupUpdated: "Le groupe <b>{group}</b> a été mis à jour par <b>{user}</b>.",
            customerGroupRemoved: "Le groupe <b>{group}</b> a été supprimé par <b>{user}</b>.",
            customerGroupAdded: "Le groupe <b>{group}</b> a été créé par <b>{user}</b>.",
            contentRemoved: "Le contenu prêt <b>{content}</b> a été supprimé par <b>{user}</b>.",
            contentAdded: "Le contenu prêt <b>{content}</b> a été ajouté par <b>{user}</b>.",
            channelVisibilityChanged:
                "La visibilité du canal d'intégration <b>{channel}</b> a été modifiée par <b>{user}</b>.",
            taskDeleted: "La tâche <b>{task}</b> a été supprimée par <b>{user}</b>.",
            taskCompleted: "<b>{task}</b> compito è stato completato da <b>{user}</b>.",
            taskArchived: "<b>{user}</b> a archivé la tâche <b>{task}</b>.",
            userRemovedToDepartment:
                "L'utilisateur <b>{user2}</b> a été supprimé du département <b>{department}</b> par <b>{user1}</b>.",
            userAddedToDepartment:
                "L'utilisateur <b>{user2}</b> a été ajouté au département <b>{department}</b> par <b>{user1}</b>.",
            mailAddressAdded: "Adresse e-mail <b>{email}</b> ajoutée par <b>{user}</b>",
            settingUpdate: "Mis à jour par <b>{user}</b> :",
            taskWFlowCreated: "Flux de travail des tâches <b>{Wflow}</b> créé par <b>{user}</b>.",
            bannedWordRemoved: "Le mot interdit <b>{bWord}</b> a été supprimé par <b>{user}</b>.",
            bannedWordCreated: "Le mot interdit <b>{bWord}</b> a été créé par <b>{user}</b>.",
            taskPriorityUpdated: "<b>{user}</b> a changé la priorité de la tâche <b>{taskTitle}</b> de <b>{oldPriority}</b> à <b>{newPriority}</b>",
            welcomeMessageRemoved: "Le message de bienvenue <b>{welcome}</b> a été supprimé par <b>{user}</b>.",
            welcomeMessageAdded: "Message de bienvenue <b>{welcome}</b> créé par <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> supprimé par <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> ajouté par <b>{user}</b>.",
            roleRemoved: "Rôle <b>{role}</b> supprimé par <b>{user}</b>.",
            roleAdded: "Rôle <b>{role}</b> ajouté par <b>{user}</b>.",
            departmentRemoved: "Département <b>{department}</b> supprimé par <b>{user}</b>.",
            departmentAdded: "Département <b>{department}</b> ajouté par <b>{user}</b>.",
            triggerUpdated: "Un déclencheur mis à jour par <b>{user}</b>.",
            triggerRemoved: "Un déclencheur supprimé par <b>{user}</b>.",
            triggerAdded: "Un nouveau déclencheur créé par <b>{user}</b>.",
            webhookRemoved: "Webhook de <b>{user1}</b>, supprimé par <b>{user2}</b>",
            webhookAdded: "Webhook ajouté par <b>{user1}</b>, ajouté par <b>{user2}</b>.",
            chatClosed: "Le chat avec <b>{visitor}</b> a été terminé par <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> a lancé un chat <b>{platform}</b> avec <b>{visitor}</b>.",
            chatOpenedByVisitor: "Un chat <b>{platform}</b> a été lancé par <b>{visitor}</b>.",
            channelRemoved: "Le canal <b>{channel}</b> a été supprimé par <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> a créé un représentant nommé <b>{newAgent}</b>.",
            visitorUnblocked: "Le visiteur <b>{visitor}</b> a été débloqué par l'utilisateur <b>{agent}</b>.",
            visitorBlocked: "Le visiteur <b>{visitor}</b> a été bloqué par <b>{agent}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> a réassigné <b>{visitor}</b> de <b>{oldOwner}</b> à <b>{newOwner}</b>.",
            customerOwnershipRemoved:
                "<b>{actor}</b> a supprimé la propriété de <b>{visitor}</b> de <b>{oldOwner}</b>, le laissant sans propriétaire.",
            customerOwnershipAssigned:
                "<b>{actor}</b> a attribué la propriété de <b>{visitor}</b> de sans propriétaire à <b>{newOwner}</b>.",
            customerOwnershipReassigned:
                "<b>{actor}</b> a réattribué la propriété de <b>{visitor}</b> de <b>{oldOwner}</b> à <b>{newOwner}</b>.",
            userStatusChanged:
                "L'utilisateur <b>{name}</b> a changé de statut de <b>{oldStatus}</b> à <b>{newStatus}</b>.",
            channelCreated: "Le canal <b>{channel}</b> a été créé par <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> utilisateur a planifié le rendez-vous nommé <b>{title}</b> pour le <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> utilisateur a mis à jour le rendez-vous nommé <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> usuario ha eliminado la cita llamada <b>{title}</b>.",
            reservationCreated:
                "Une réservation a été créée pour l'utilisateur <b>{name}</b> et le visiteur <b>{visitor}</b> le <b>{date}</b>.",
            reservationDeleted:
                "Le rendez-vous entre l'utilisateur <b>{name}</b> et le visiteur <b>{visitor}</b> le <b>{date}</b> a été annulé.",
            taskStatusChanged: "Lorsque l'état de la tâche change",
            taskWorkflowCrud: "Le flux de travail des tâches est créé, mis à jour ou supprimé",
            taskCrud: "Tâche est créée, mise à jour ou supprimée",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Nouveau",
                visitor: "Personne",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automation",
                table: "Tableau",
                module: "Module",
                message: "Message",
            },
            calendar: "Calendrier",
            soundSettings: "Notifications audio",
            allNotificationSettings: "Paramètres de notification",
            allAuditLogs: "Journaux d'audit",
            allNotifications: "Toutes les notifications",
            allActivities: "Toutes les activités",
            workFlow: "Flux de travail",
            editTask: "Modifier la tâche",
            tasks: "Tâches",
            todo: "Choses à faire",
            tapTo: 'Appuyez sur ⇥ pour les opérations "{prefix}"',
            newUsers: "Nouvel ⇥ utilisateur",
            newTags: "Nouveau ⇥ tag",
            newRole: "Nouveau ⇥ rôle",
            newTrigger: "Nouveau ⇥ déclencheur",
            newDepartment: "Nouveau ⇥ département",
            newTicket: "Nouveau ⇥ ticket",
            jumpSettings: "Aller ⇥ aux paramètres",
            jumpIntegrations: "Aller ⇥ aux intégrations",
            jumpTeam: "Aller ⇥ à l'équipe",
            jumpUsers: "Aller ⇥ aux utilisateurs",
            jumpReport: "Aller ⇥ au rapport",
            timingSettings: "Paramètres de temps",
            exampleVisitorMail: "visiteur@mail.com",
            languageAndRegion: "Langue et région",
            theme: "Thème",
            appearance: "Apparence - Apparence",
            color: "Couleur",
            background: "Arrière-plan",
            smart: "Intelligent",
            teamChat: "Chat d'équipe",
            chatbot: "ChatBot",
            chatbotTraining: "Formation du Chatbot",
            chatbotUserSegments: "Segments d'utilisateurs du Chatbot",
            chatbotIntegration: "Intégration du Chatbot",
            chatbotEntities: "Entités du Chatbot",
            chatbotIntegrationWebHook: "Intégration WebHook du Chatbot",
            chatbotArchive: "Archive du Chatbot",
            chatbotTemplatesAI: "Modèles d'intelligence artificielle pour le Chatbot",
            chatbotTemplates: "Modèles de chatbot",
            chatbotReportsOverall: "Rapports généraux du chatbot",
            chatbotReportsAllChats: "Rapports de tous les chats du chatbot",
            chatbotReportsRatingDistribution: "Distribution des notes des rapports du chatbot",
            chatbotReportsPaidChats: "Rapports de chats payés du chatbot",
            chatbotReportsBusiestPeriod: "Période de pointe du chatbot",
            chatbotTemplatesAllMessages: "Modèles de chatbot pour tous les messages",
            chatbotTemplatesAverage: "Moyenne des modèles de chatbot",
            chatbotTemplatesPopularity: "Popularité des modèles de chatbot",
            chatbotTemplatesAllUser: "Modèles de chatbot pour tous les utilisateurs",
            ticket: "Demandes de support",
            archives: "Archives",
            tags: "Tags",
            offlineSupportRequests: "Demandes de support hors ligne",
            roles: "Rôles",
            users: "Utilisateurs",
            departments: "Départements",
            contents: "Contenu instantané",
            welcomeMessages: "Messages de bienvenue du système",
            catalog: "Catalogue",
            bannedWords: "Mots interdits",
            bannedVisitors: "Visiteurs interdits",
            application: "Application",
            mails: "Mail",
            visitors: "Visiteurs",
            integrationsWebhook: "Intégration Webhook",
            billing: "Facturation",
            reportNew: "Nouveau rapport",
            integrations: "Intégrations",
            chatbotStory: "Histoires de chatbot",
            searchPlaceHolder: "Rechercher, aller ou ajouter...",
            searchAreaTitle: "Rechercher Supsis",
            searchAreaDesc1: "Vous pouvez rechercher n'importe quoi. Seulement",
            searchAreaDesc2: "ou",
            searchAreaDesc3: "tapez ou cherchez n'importe quoi.",
            navigateBtn: "Naviguer",
            selectBtn: "Sélectionner",
            cancelBtn: "Annuler",
            integration: {
                shouldByInstaPack:
                    "Vous devriez acheter un pack Instagram pour créer une chaîne Instagram. Vous pouvez accéder immédiatement aux packs avec des prix abordables.",
                createInstaLimitMax: "Vous avez atteint la limite de création d'une chaîne Instagram. Maximun.",
                createInstaContinue:
                    "Vous pouvez créer une chaîne Instagram. Pour continuer, mettez votre forfait à niveau ou supprimez certaines de vos chaînes Instagram.",
                privatePolicy: "Politique privée.",
                termsAndCondition: "Conditions générales.",
                readAndAgree: "J'ai lu et j'accepte.",
                shouldByMessengerPack:
                    "Vous devez acheter un pack Messenger pour créer un canal Messenger. Vous pouvez accéder aux packs à des prix abordables immédiatement.",
                createMessengerLimitMax: "Vous avez atteint la limite de création de canaux Messenger. Maximun.",
                createMessengerContinue:
                    "Vous pouvez créer un canal Messenger. Pour continuer, mettez à jour votre forfait ou supprimez certains de vos canaux Messenger.",
                selectMessengerAccount: "Sélectionnez un compte Messenger.",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "Tous les départements",
                deleteAll: "Supprimer tout",
                wpBusinessAPI: "Intégrations - Canaux de l'API Whatsapp Business",
                wpV1: "Intégrations - Canaux Whatsapp multiples",
                instagram: "Intégrations - Instagram",
                instagramContactList: "Intégrations - Liste de contacts Instagram",
                mail: "Intégrations - Mail",
                whatsapp: "Intégrations - Whatsapp",
                whatsappContactList: "Intégrations - Liste de contacts Whatsapp",
                wpBCRequests: "Intégrations - Demandes de messages en masse Whatsapp",
                wpBCCustomerGroups: "Intégrations - Groupes de clients Whatsapp",
                wpBCTemplates: "Intégrations - Modèles de messages en masse Whatsapp",
                chatbot: "Intégrations - ChatBot",
            },
            settings: {
                settings: "Paramètres",
                features: "Paramètres - Fonctionnalités",
                languageAndRegion: "Paramètres - Langue et région",
                bubbleSettings: "Paramètres - Paramètres de la bulle",
                bubbleActions: "Paramètres - Actions de la bulle",
                themeSettings: "Paramètres - Thème",
                talkSettings: "Paramètres - Paramètres de la conversation",
                visitorLoginForm: "Paramètres - Formulaire de connexion des visiteurs",
                visitorAttribute: "Paramètres - Attributs des visiteurs",
                autoAssign: "Paramètres - Attribution automatique",
                chatTimingSettings: "Paramètres - Durée du chat",
                availability: "Paramètres - Disponibilité",
                websiteIntegration: "Paramètres - Intégration du site web",
                developer: "Paramètres - Développeur",
            },
        },
        mail: {
            errorStatus: "Statut d'erreur",
            mailSendErrorTitle: "E-mails non remis",
            mailSendErrorDescription: "Nombre total d'e-mails non remis",
            fixGrammarTitle: "Correction grammaticale",
            expandTextTitle: "Extension du texte",
            summaryTitle: "Résumé",
            changeToneTitle: "Changement de ton",
            translationTitle: "Traduction",
            replyTitle: "Réponse",
            customRequestTitle: "Réponse à la demande personnalisée",
            viewMode: "Mode d'affichage",
            singleView: "Vue unique",
            splitView: "Vue partagée",
            folders: "Dossiers",
            sendError: "Une erreur s'est produite lors de l'envoi de l'email. Veuillez réessayer plus tard.",
            visitorCreationError: "Échec de la création du visiteur. Veuillez réessayer plus tard.",
            onlyImageAllowed: "Seuls les fichiers image sont autorisés.",
            imageFileTooLarge: "Le fichier image est trop volumineux. La taille maximale est de 10 Mo.",
            imageUploaded: "Image téléchargée avec succès.",
            imageUploadError: "Une erreur s'est produite lors du téléchargement de l'image.",
            mailAiAssistant: {
                aiCreateSummarized: "Créer un résumé IA",
                aiSentimentAnalysis: "Analyse de sentiment IA",
                contentRequired: "Le contenu de l'e-mail est requis pour utiliser cette fonctionnalité",
                grammarFixed: "La grammaire a été corrigée",
                aiError: "L'assistant IA a rencontré une erreur",
                contentExpanded: "Le contenu de l'e-mail a été développé",
                emailSummarized: "L'e-mail a été résumé",
                toneChanged: "Ton changé en {tone}",
                emailTranslated: "E-mail traduit en {language}",
                replyGenerated: "Réponse automatique générée",
                contentUpdated: "Le contenu a été mis à jour",
                contentRebuilt: "Le contenu a été reconstruit",
                contentRebuildFailed: "Échec de la reconstruction du contenu",
                customRequestEmpty: "Veuillez saisir une demande",
                customRequestApplied: "Le contenu de la demande personnalisée a été appliqué",
                loadingText: "IA en cours",
                loadingDescription: "Le texte est en cours d'analyse, veuillez patienter...",
                aiTitle: "Assistant IA pour e-mail",
                aiDescription: "Outils IA pour améliorer, modifier et analyser votre e-mail",
                emptyContentTitle: "Aucun contenu d'e-mail trouvé",
                emptyContentDescription: "Le contenu de l'e-mail est requis pour utiliser les fonctionnalités IA.",
                limitedAccessDescription: "Fonctionnalités limitées disponibles en l'absence de contenu d'e-mail.",
                resultEmotions: "Émotions détectées",
                analysisDescription: "Explication de l'analyse",
                recommendationsList: "Suggestions d'amélioration",
                mailSummarize: "Résumé de l'e-mail",
                aiResponse: "Généré par l'IA",
                rebuild: "Reconstruire",
                applyText: "Appliquer le texte",
                specialRequest: "Demande personnalisée",
                specialRequestPlaceholder: "Saisissez vos instructions personnalisées ici...",
                sendRequest: "Envoyer la demande",
                fixGrammarTitle: "Corriger la grammaire",
                fixGrammardescription: "Corrige automatiquement les fautes d'orthographe et de grammaire",
                expandTextTitle: "Développer le texte",
                expandTextDescription: "Rend votre texte plus complet et détaillé",
                changeToneTitle: "Changer le ton",
                changeToneDescription: "Transforme le ton et le style du texte selon vos préférences",
                changeTone_ProfessionalTitle: "Professionnel",
                changeTone_ProfessionalDescription: "Ton formel et professionnel adapté aux environnements de travail",
                changeTone_FriendlyTitle: "Amical",
                changeTone_FriendlyDescription: "Approche chaleureuse et sincère",
                changeTone_CasualTitle: "Décontracté",
                changeTone_CasualDescription: "Ton conversationnel détendu et informel",
                changeTone_FormalTitle: "Formel",
                changeTone_FormalDescription: "Style très formel et institutionnel",
                changeTone_ConfidentTitle: "Assuré",
                changeTone_ConfidentDescription: "Style d'expression fort et convaincant",
                translateTitle: "Traduire",
                translateDescription: "Traduit votre texte dans différentes langues",
                generateReplyTitle: "Générer une réponse",
                generateReplyDescription: "Génère automatiquement une réponse appropriée à l'e-mail reçu",
                customPromptTitle: "Demande personnalisée",
                customPromptDescription: "Génère un contenu d'e-mail en fonction de vos instructions personnalisées"
            },
            searchEmail: "Rechercher un e-mail...",
            emailAttachments: "Pièces jointes ({count})",
            signatureMessage: "Votre signature d'e-mail existe. Voulez-vous l'inclure dans le contenu de l'e-mail ?",
            emailSubject: "Objet de l'e-mail",
            takeItBack: "Annuler",
            fastForward: "Rétablir",
            addEmoji: "Ajouter un emoji",
            addLink: "Ajouter un lien",
            bold: "Gras",
            italic: "Italique",
            underline: "Souligné",
            fontFamily: "Police",
            textColor: "Couleur du texte",
            stringFormats: "Formats de texte",
            alignLeft: "Aligner à gauche",
            alignRight: "Aligner à droite",
            alignCenter: "Centrer",
            normalText: "Texte normal",
            participantList: "{first}, {second}, {third} +{remaining} autres",
            noMailFound: "Aucun e-mail trouvé",
            selectedMail: "{count} e-mail sélectionné",
            recipientEmailAddress: "Adresse e-mail du destinataire",
            CCreceivers: "Destinataires en copie (CC)",
            BCCreceivers: "Destinataires en copie cachée (BCC)",
            emptyStateMessage: "Sélectionnez un e-mail ou rédigez-en un nouveau",
            FromName: "Nom de l'Expéditeur",
            broadcastCreatedSuccess: "Diffusion créée avec succès",
            confirmArchive: "Êtes-vous sûr de vouloir archiver cette diffusion?",
            archive: "Archiver",
            cancel: "Annuler",
            archiveSuccess: "Diffusion archivée avec succès",
            archiveError: "Erreur lors de l'archivage de la diffusion",
            empty: "Vide",
            summerDiscounts: "Remises d'été",
            opportunities: "Opportunités",
            newMailTemplateCreated: "Créer un nouveau modèle d'e-mail",
            dateRange: "Plage de dates",
            templateName: "Nom du modèle",
            category: "Catégorie",
            templateUpdateSucs: "Le modèle a été mis à jour avec succès",
            templateUpdateError: "Une erreur s'est produite lors de la mise à jour du modèle",
            marketing: "Marketing",
            operational: "Opérationnel",
            custom: "Spécial",
            pleaseEnterTemplateName: "Veuillez saisir le nom du modèle",
            pleaseEnterTemplateSubject: "Veuillez saisir le sujet du modèle",
            pleaseSelectTemplateCategories: "Veuillez sélectionner la catégorie du modèle",
            representMails: "Courriers du représentant",
            otherRepresentMails:
                "Vous pouvez suivre les courriels entrants et sortants à destination et en provenance des adresses électroniques d'autres représentants",
            signatureAutoAdd: "L'état de l'ajout automatique de la signature a été modifié avec succès",
            autoAdd: "Ajout automatique",
            forwardEmailAddSucs: "Ajout réussi d'une adresse électronique de transfert",
            errorAddingForwardEmail:
                "Une erreur s'est produite lors de l'ajout d'une adresse électronique de transfert",
            mailAddForward: "Ajout manuel (renvoi effectué)",
            mailAddForwarding: "Ajout manuel (j'ai terminé la redirection)",
            broadcast: "Publications",
            templates: "Modèles",
            newMailArrived: "Nouveau courrier arrivé",
            mailSentSucs: "Courrier envoyé avec succès",
            representativeMails: "Courrier représentatif",
            composeNewEmail: "Composer un nouvel e-mail",
            couldNotUserMail: "Impossible d'envoyer du courrier car il n'y a pas de courrier d'utilisateur",
            mailAddressReq: "Adresse de messagerie requise",
            emailAddressInvalid: "Adresse électronique non valide",
            departmentIsNotValid: "Département non valide",
            mailSendNotValid: "Adresse électronique non valide",
            routingSteps: "Étapes de routage",
            owner: "Propriétaire",
            whereHeDirected: "Wohin er geleitet hat",
            forwardingEmailAddress: "Adresse électronique de transfert",
            deleteMailDesc: "Cette action ne peut pas être annulée.",
            deleteMailTitle: "Êtes-vous sûr de vouloir supprimer cette adresse e-mail?",
            gmailForwardMail: "Transfert de messagerie Gmail",
            senderMailAddressDesc: "Veuillez entrer l'adresse e-mail de l'expéditeur",
            verified: "Vérifié",
            notForwarded: "Non transféré",
            notVerified: "Non vérifié",
            default: "Par défaut",
            isVerified: "Vérifié",
            forwarding: "Transfert",
            mailAdress: "Adresse e-mail",
            addSenderAddress: "Ajouter une adresse d'expéditeur",
            outlookForward: "Transfert Microsoft (Outlook/Exchange)",
            gmailForward: "Transfert Google (Gmail)",
            senderMail: "Mail de l'expéditeur",
            mailDetail: "Détail du mail",
            mailNotFound: "Mail non trouvé",
            mailSelecting: "Sélection de mail",
            newMail: "Nouveau courrier électronique",
            myMails: "Mes courriels",
            inbox: "Boîte de réception",
            sent: "Envoyé",
            departmentMails: "Emails du département",
            newTemplate: "Nouveau modèle",
            unread: "Non lu",
            unreply: "Unanswered",
            reply: "Répondre",
            attachments: "Pièces jointes du courrier",
            To: "À",
            From: "De",
            placeHolders: "Espacements réservés",
            attacheFiles: "Joindre des fichiers",
            replyAll: "Répondre à tous",
            forward: "Transférer",
            deleteThread: "Supprimer la conversation",
            markAsRead: "Marquer comme lu",
            markAsAllRead: "Tout marquer comme lu",
            emailEditor: "Éditeur de courrier électronique",
            integrateYourMail: "Intégrez votre e-mail",
            connect: "Connecter",
            departmentMail: "Courrier électronique du département",
            createMailAddress: "Créer une adresse e-mail",
            createNewMail: "Créer un nouvel e-mail",
        },
        visitor: {
            ownership: "Propriété",
            visitors: "Visiteurs",
            bannedVisitors: "Visiteurs Bannis",
            tags: "Tags",
            profileFields: "Champs de Profil",
            downloadAll: "Télécharger tout",
            saveAsCustomerGroup: "Enregistrer en tant que groupe de clients",
            saveSearchFavorite: "Enregistrer la recherche en tant que favori",
            mail: "Mail",
            visitorDetail: "Détails du visiteur",
            selectedUser: "{selectedUser} parmi {totalUsers} utilisateurs sélectionnés",
            uncheck: "Décocher tout",
            checkAll: "Tout cocher",
            matchedUsers: "{checkedCount} utilisateurs correspondants",
            more: "Plus",
            exportUsers: "Exporter les utilisateurs sélectionnés",
            exportAllUsers: "Exporter tous les utilisateurs",
            addSegment: "Ajouter un segment",
            deleteCheckedUser: "Supprimer les utilisateurs sélectionnés",
            deleteAllUser: "Supprimer tous les utilisateurs",
            matchedFilter: "Correspondance de tous les filtres",
            visitor: "Visiteur",
            deleteUser: "Supprimer l'utilisateur",
            userData: "Données utilisateur",
            lastSession: "Dernière session",
            notUserData: "Aucune donnée utilisateur trouvée",
            segments: "Segments",
            addTag: "Ajouter un tag",
            userChats: "Chats utilisateur",
            seeAll: "Voir tout",
            confirm: "Confirmer",
            manageSegments: "Gérer les segments",
            search: "Recherche",
            manageTags: "Gérer les tags",
            allAttributes: "Voir toutes les attributs",
            noData: "Pas de données",
            noEmail: "Pas d'e-mail",
            noIpAddress: "Adresse IP non trouvée.",
            noWpNumber: "Numéro non trouvé.",
            filterName: "nom du filtre..",
            matchedContacts: "{chechkedCount} contacts appariés",
        },
        chatbotv2: {
            Ticket_Actions: "Actions de ticket",
            Task_Actions: "Actions de tâche",
            Contact_Actions: "Actions de contact",
            Calendar_Actions: "Actions de calendrier",
            "T-Soft_Actions": "Actions T-Soft",
            "Ticimax-V2_Actions": "Actions Ticimax",
            TSOFT_SELECT_ORDER: "SELECT ORDER",
            TSOFT_ORDER_STATUS: "OBTENIR LE STATUT DE LA COMMANDE",
            TICIMAX_V2_SELECT_ORDER: "SELECT ORDER",
            TICIMAX_V2_ORDER_STATUS: "OBTENIR LE STATUT DE LA COMMANDE",
            Ikas_Actions: "Actions Ikas",
            IKAS_GET_MEMBER_INFO: "Obtenir les détails du membre",
            IKAS_SELECT_ORDER: "Sélectionner la commande",
            IKAS_ORDER_STATUS: "Obtenir le statut de la commande",
            IDEASOFT_PRODUCT_SEARCH: "Recherche de produits",
            privateMessageDescription: "Les messages privés ne peuvent être vus que par les agents et restent cachés aux visiteurs.",
            AI_RANDOM_TEXT: "Texte aléatoire IA",
            AI_IMAGE: "Image IA",
            PRIVATE_MESSAGE: "Message Privé",
            aiPrompt: "Invite IA",
            variants: "Variantes",
            Zoho_Actions: "Actions Zoho",
            Table_Actions: "Actions de tableau",
            File_Actions: "Actions sur les fichiers",
            Data_Formatters: "Formateurs de données",
            Loop_Actions: "Actions de boucle",
            importSuccess: "Modèle importé avec succès",
            importFailed: "Erreur lors de l'importation du modèle",
            creatingBlank: "ChatBOT vide en cours de création...",
            untitledChatbot: "ChatBOT sans titre",
            errorCreating: "Erreur lors de la création du ChatBOT",
            typeAutomationTitle: "Tapez le titre de l'automatisation",
            typeStoryTitle: "Écrivez un titre de histoire",
            setUpYourChatbot: "Configurez votre chatbot",
            setUpYourChatbotDesc:
                "Formez votre chatbot avec des données, utilisez nos modèles prêts à l'emploi ou partez de zéro",
            blankBot: "Bot vierge",
            blankBotDesc: "Créez un chatbot vierge que vous pourrez former et personnaliser ultérieurement",
            websiteDesc:
                "Analysez le contenu de votre site web pour obtenir des réponses aux questions les plus fréquemment posées par les utilisateurs",
            yourNeedEnterYourOpenAi:
                "Vous devez entrer votre clé API OpenAI pour créer un chatbot automatisé en parcourant votre site web.",
            createOpenAiKey: "Créer une clé d'API",
            aiKnowledge: "Connaissances en intelligence artificielle",
            modalUsage: "Modal Usage",
            usedContentSources: "Sources de contenu utilisées",
            websites: "Sites web",
            articles: "Articles",
            faq: "FAQ",
            files: "Fichiers",
            functions: "Fonctions",
            settings: "Paramètres",
            disableAi: "Désactiver l'IA",
            enableAi: "Activer l'intelligence artificielle",
            lastEdited: "Dernière édition",
            state: "État",
            frequentlyAskedQuestions: "Questions fréquemment posées (FAQ)",
            faqIsCreated: "FAQ créée",
            selectKnowEnabled: "Activation des bases de connaissances sélectionnées...",
            selectKnowDisabled: "Les bases de connaissances sélectionnées sont désactivées...",
            selectKnowNotEnabled: "Les bases de connaissances sélectionnées ne sont pas activées...",
            selectKnowNotDisabled: "Les bases de connaissances sélectionnées ne sont pas désactivées",
            answered: "Répondu",
            answer: "Réponse",
            addFile: "Ajouter un fichier",
            fileDeleted: "Fichiers supprimés",
            fileDeletedFailed: "Un problème est survenu lors de la suppression des fichiers",
            noFileAdded: "Aucun fichier n'a été ajouté",
            aiFunctions: "Fonctions de l'IA",
            addFunction: "Ajouter une fonction",
            parameterCount: "Nombre de paramètres",
            auto: "Auto",
            usedByAI: "Utilisé par l'IA",
            usedByAi: "Utilisé par l'IA",
            notUsed: "Non utilisé",
            saveAndClose: "Enregistrer et fermer",
            contentPreview: "Aperçu du contenu",
            addContent: "Ajouter du contenu",
            populerUserQuestion:
                "Analysez le contenu de votre site web pour obtenir des réponses aux questions les plus fréquemment posées par les utilisateurs.",
            enterUrlAddress: "Entrez une adresse URL",
            sharingYourUrl:
                "En partageant votre URL, vous confirmez que vous disposez des droits nécessaires pour partager son contenu.",
            pageSelected: "Pages sélectionnées",
            trainChatbot: "Former le chatbot",
            thereAreOnePages: "Il y a 1 page à l'intérieur",
            categoryDesc: "Catégorie. Choisissez laquelle utiliser pour entraîner votre modèle d'IA.",
            scarpOrAddContent:
                "Récupérez ou ajoutez du contenu, que AI Assist peut utiliser pour répondre aux questions de vos clients.",
            noContentAdded: "Aucun contenu ajouté",
            howItWorks: "Comment ça marche",
            editEntries: "Modifier les entrées",
            newEntries: "Nouvelles entrées",
            chatbotManagement: "Gestion des chatbots",
            chatbotScenarioList: "Liste de Chatbot Schenerio",
            exportDiagramToClipboard: "Exporter le diagramme vers le presse-papiers",
            selectedStory: "{count} scénario sélectionné",
            Meta_Actions: "Meta Actions",
            suppressionRemoved: "Suppression supprimée",
            suppressionAdded: "Suppression ajoutée",
            didntSuppression: "Vous n'avez effectué aucune suppression.",
            whatsappIntegrationTitle: "Intégration WhatsApp V1 et WhatsApp V2",
            whatsappApiIntegrationTitle: "Intégration de l'API WhatsApp Business",
            ReadyTemplateBadge: "Modèle prêt",
            readyTemplates: "Modèles prêts",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Logo du ChatBot",
            chatbotName: "Nom du ChatBot",
            allSecnario: "Liste des scénarios de chatbot",
            ChatbotScenarioList: "Liste des scénarios de chatbot",
            Scenario: "Scénario",
            filters: {
                equal: "est égal à",
                not_equal: "n'est pas égal",
                contain: "contenir",
                not_contain: "contient pas de",
                starts_with: "commence avec",
                ends_with: "se termine par",
                empty: "est vide",
                non_empty: "non vide",
                longer_than: "plus long que",
                shorter_than: "plus court que",
                less_than: "moins que",
                less_or_equal: "moins ou égal",
                greater_than: "plus grand que",
                greater_or_equal: "plus grand ou égal",
            },
            planRequired: "{integratable} plan requis",
            noDefaultStoryTitle: "Histoire par défaut",
            noDefaultStory:
                "Mot interdit détecté, veuillez corriger le message et envoyer \n Voulez-vous faire de cette histoire la valeur par défaut ?",
            noMessage: "Pas de message",
            loading: "Chargement",
            loadMore: "Charger plus",
            hostname: "Nom d'hôte",
            goToStory: "aller à l'histoire",
            noResultFound: "Aucun résultat trouvé",
            checkYourFilterCombination: "Vérifiez votre combinaison de filtre",
            clearYourSearch: "Effacer votre recherche",
            andTryAgain: "et essayez à nouveau",
            allTemplates: "Tous les modèles",
            allAITemplates: "Tous les modèles d'IA",
            templatesFromTheIndustry: "Modèles de l'industrie",
            basicTemplate: "Modèle de base",
            proTemplate: "Modèle avancé",
            withBot: "& Bot",
            userWithBot: "Utilisateur et bot",
            chatDetail: "Détails du chat",
            allUserDetail: "Voir tous les détails de l'utilisateur",
            sessionData: "Données de session",
            supsisChatWidget: "Widget de chat en soupise",
            integratedWith: "Intégré avec :",
            botStory: "Histoire de bot",
            integration: "L'intégration",
            Users: "utilisateurs/utilisatrices",
            user_id: "ID de l'utilisateur",
            categories: "Catégories",
            worksWith: "Marche avec",
            importBot: "Importer un bot",
            keyFeatures: "Principales caractéristiques",
            importing: "importation",
            comingSoon: "À venir",
            pickStory: "Choisir une histoire",
            conversationId: "ID de conversation",
            integrateStoryWithSupsisWidget: "Intégrer le widget de Supsis avec Chatbot Story",
            integrateStoryWithWhatsapp: "Intégrer WhatsApp à Chatbot Story",
            integrateStoryWithInstagram: "Intégrer Instagram avec Chatbot Story",
            selectIntegratingStory: "Sélectionnez l'histoire qui sera intégrée",
            install: "Installer",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "E-mail",
                phone: "Téléphone",
                language: "Langue",
                timezone: "Fuseau horaire",
                gender: "Genre",
                country: "Pays",
                referrer: "Référent",
                department: "Département",
                url: "URL",
                ip: "IP",
                last_seen: "Dernier vu",
                name: "Nom",
                user_id: "ID de l'utilisateur",
                message: "Message",
                akinon_brand: "Marque",
                akinon_order_id: "Numéro de commande",
                akinon_product_id: "ID de produit",
                akinon_user_id: "ID de l'utilisateur",
                akinon_user_name: "Nom d'utilisateur",
                akinon_user_email: "E-mail utilisateur",
                akinon_invoice_url: "URL de facture",
                akinon_order_status: "Statut de la commande",
                akinon_order_price: "Prix ​​de commande",
                akinon_shipper_name: "Nom de l'expéditeur",
                akinon_product_size: "Taille du produit",
                akinon_sku: "Sku",
                akinon_product_url: "URL du produit",
                akinon_product_title: "Titre du produit",
                akinon_product_image: "Image du produit",
                akinon_product_stock: "Stock de produits",
                akinon_order_date: "Date de commande",
                akinon_track_number: "Numéro de piste",
                akinon_track_url: "URL de piste",
                akinon_latitude: "Latitude",
                akinon_longitude: "Longitude",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                last_meta_post_id: "Dernier ID de publication de métadonnées",
                last_meta_post_caption: "Dernière légende de publication de métadonnées",
                last_meta_post_type: "Dernier type de publication de métadonnées",
                visitor_trigger_type: "Type de déclencheur de visiteur",
                visitor_trigger_name: "Nom du déclencheur du visiteur",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Mode hors-ligne",
                available_agents: "Agents disponibles",
                platform: "Plateforme",
                probel_sube_kodu: "Code de la succursale",
                probel_brans_adi: "Nom de la branche",
                probel_brans_kodu: "Code de la branche",
                probel_doktor_adi: "Nom du médecin",
                probel_doktor_kodu: "Code du médecin",
                probel_poliklinik_adi: "Nom de la polyclinique",
                probel_poliklinik_kodu: "Code de la polyclinique",
                probel_randevu_tarihi: "Date de rendez-vous",
                probel_date: "Date de rendez-vous",
                probel_randevu_saati: "Heure de rendez-vous",
                probel_randevu_id: "ID de rendez-vous",
                probel_hasta_token: "Jeton du patient",
                probel_kimlik_tipi: "Type d'identité",
                probel_kimlik_no: "Numéro d'identité",
                probel_hasta_adi: "Nom du patient",
                probel_hasta_soyadi: "Prénom du patient",
                probel_hasta_cinsiyet: "Genre",
                probel_hasta_dogum_tarihi: "Date de naissance",
                probel_hasta_telefon: "Téléphone",
                hour: "Heure",
                segments: "Segments",
                tags: "Étiquettes",
                ticket: "Billet",
                metaReferrals: "Méta-références",
            },
            storyList: "Liste d'histoires",
            douYouWannaDeleteItem: "Voulez-vous supprimer cet élément?",
            douYouWannaDeleteWithChildren: "Voulez-vous supprimer cet article avec ses enfants?",
            stories: "Histoires",
            templates: "Modèles",
            aitemplates: "Modèles d'IA",
            integrations: "Intégrations",
            all: "Tous",
            installed: "installée",
            installationOK: "installée",
            uninstall: "Désinstaller",
            remainingMessageDesc: "Messages gratuits restants:",
            openAISiteRoutingDescStart: "Vous pouvez cliquer sur le lien",
            openAISiteRoutingDescEnd: "Pour obtenir une clé API.",
            integrationOK: "Intégré",
            chatWidget: "Widget de chat en soupise",
            artificialIntelligence: "Intelligence artificielle",
            integratePlatform: "Chatbot peut être intégré à {integretable}.",
            integrateOpenAIWithChatbot: "Intégrer le chat gpt-4 avec chatbot",
            integrateChatBotWithChatGPT3: "Intégration de chatbot avec le chat gpt-4",
            integrateStoryWithTelegram: "Intégrer l'histoire avec le télégramme",
            webhooks: "Webhooks",
            archive: "Archive",
            reports: "Rapports",
            uncheckAll: "Décocher tout",
            userSegments: "Segments d'utilisateurs",
            addSegment: "Ajouter un segment",
            addToSegment: "Ajouter au segment",
            removeFromSegment: "Supprimer du segment",
            plansVTippyContent:
                "La facturation de ce forfait sera effectuée au début de chaque mois, et en cas d'annulation, votre utilisation sera facturée jusqu'au début du mois et votre forfait expirera.<br><br>Le prix du forfait est hors TVA.<br><br>Les changements de forfait sont reflétés dans la facture le lendemain.",
            segmentName: "Nom du segment",
            sameSegment: "Il y a un segment avec le même nom!",
            usersInSegment: "Utilisateurs du segment",
            noUsersAdded: "Aucun utilisateur ajouté",
            updateSegment: "Segment de mise à jour",
            newSegment: "Nouveau segment",
            selectAll: "Tout sélectionner",
            queriesSelected: "requêtes sélectionnées",
            noBlocksFound: "Pas de blocs trouvés!",
            userQuery: "Requête utilisateur",
            date: "Date",
            unmatched: "Incomparable",
            goToChat: "Aller discuter",
            selectStory: "Sélectionner une histoire",
            selectBlock: "Sélectionner le bloc",
            training: "Entraînement",
            trainingAlert:
                "Pour mettre en œuvre les modifications que vous avez apportées à la page de formation du bot, vous devez publier la nouvelle version du scénario que vous avez modifié.",
            unmatchedPhrases: "Phrases inégalées",
            ignored: "Ignoré",
            story: "Histoire",
            timePeriod: "Période de temps",
            wholeTimeSpan: "Laps de temps entier",
            selectAStory: "Sélectionnez une histoire",
            searchUserQuery: "Recherchez la requête utilisateur",
            time: {
                today: "Aujourd'hui",
                yesterday: "Hier",
                last7: "Les 7 derniers jours",
                last30: "Les 30 derniers jours",
                "this-month": "Ce mois-ci",
                "last-month": "Le mois dernier",
                "last-3-month": "3 mois dernier",
                "this-year": "Cette année",
                "last-year": "L'année dernière",
                custom: "Choisissez une autre date",
            },
            emailProvider: "Fournisseur de messagerie électronique",
            triggerFromAnywhere: "Déclencher de n'importe où",
            allIntegrations: "Toutes les intégrations",
            integrateYourCBwithChatWidget: "Intégrez votre chatbot avec le widget de chat.",
            integrateYourCBwithChatGpt3: "Chatbot peut être intégré à GPT-4. Clé API GPT-4 requis.",
            integrateYourCBwithWebHook:
                "Passez facilement les informations de chat entre le chatbot et vos services Web.",
            integrateYourCBwithIntegratable:
                "Passez facilement les informations de chat entre chatbot et {integratable}.",
            addWebhook: "Ajouter WebHook",
            editWebhook: "Modifier webhook",
            newWebhook: "Nouveau webhook",
            webhookTitle: "Titre de webhook",
            webhookUrl: "URL de webhook",
            webhookToken: "Webhook token",
            webhookUsername: "Nom d'utilisateur webhook",
            webhookPassword: "Mot de passe webhook",
            editBlock: "Modifier",
            moveBlock: "Déplacer",
            copyBlock: "Copie",
            addFilter: "Ajouter le filtre",
            addFilterGroup: "Ajouter un groupe de filtre",
            clearFilter: "filtre transparent",
            in: "dans",
            and: "et",
            or: "ou",
            chatbot: "Chatbot",
            allStories: "Toutes les histoires",
            addBot: "Créer un bot",
            testBot: "Testez votre bot",
            publish: "Publier",
            editName: "Modifier le nom",
            search: "Recherche dans votre histoire…",
            typeMoreThan3Char: "Tapez au moins 3 caractères",
            expand: "Développer",
            expandAll: "Développer tout",
            noMatchingItem: "Aucun article correspondant",
            hint: "Indice",
            select: "Sélectionner",
            navigate: "Naviguer",
            dismiss: "Rejeter",
            choseAttribute: "Attribut choisi",
            selectReply: "Sélectionnez Répondre",
            preview: "Aperçu",
            draft: "Brouillon",
            lastUpdate: "Dernière mise à jour",
            published: "Publié",
            newStory: "Nouvelle histoire",
            updateStory: "Mettre à jour l'histoire",
            storyDescription: "Description de l'histoire",
            storyTitle: "Titre de l'histoire",
            deleteSingleBlock: "Supprimer un seul bloc",
            deleteWithChildren: "Supprimer avec les enfants",
            startTestFromHere: "Commencez le test à partir d'ici",
            copyBlockId: "Copier l'ID de blocage",
            gotoLiveLink: "Aller au lien en direct",
            copyBlockIdSuccessfull: "ID de bloc copié dans le presse-papiers",
            collapse: "Effondrement",
            collapseAll: "S'effondrer tout",
            snDelay: "{delay} SEC Delay",
            blockUpdated: "Bloc mis à jour",
            addPayload: "Ajouter la charge utile",
            previewModeCaution:
                "Vous apercevez maintenant l'une des versions de votre histoire. Vous ne pouvez pas enregistrer des modifications en mode d'aperçu!",
            enterText: "Entrez du texte...",
            trackpad: "Trackpad",
            navigation: "La navigation",
            navigationDesc:
                "Veuillez choisir votre mode de navigation. C'est à vous de décider s'il sera trackpad ou souris.",
            botSetting: "Réglage de bot",
            botSettingDesc:
                "Veuillez définir le niveau de confiance. Il s'agit d'un pourcentage entre 0 et 100. Le niveau définit l'exactitude des interprètes de chatbot qui sont liés aux entrées utilisateur.",
            languageSettingsDesc: "Veuillez vous assurer que la langue de bot qui répond est votre langue préférée.",
            mouse: "Souris",
            Interactions: "Interactions",
            Actions: "Actions",
            Supsis_Actions: "Actions du Supsis",
            Shopify_Actions: "Actions shopify",
            Akinon_Actions: "Actions à Akinon",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "POINT DE DÉPART",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Réponse du bot",
            AI_BOT_RESPONSE: "Réponse AI (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Se repliez par défaut",
            FILTER: "FILTRE",
            addNewFilter: "Ajouter un nouveau filtre",
            FLOW: "COULER",
            ATTACHMENT_INPUT: "Entrée de fixation",
            USER_INPUT: "Entrée utilisateur",
            GO_TO_STEP: "Aller au pas",
            WEBHOOK: "Webhook",
            SET_ATTRIBUTE: "Set Attribut",
            QUESTION: "QUESTION",
            CLOSE_CHAT: "Chatte",
            CREATE_TICKET: "Créer un billet",
            TRANSFER_CHAT: "Chat transféré",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "Département",
            SEND_TRANSCRIPT: "Envoyer une transcription",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SEND MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Produits Shopify Show",
            SHOPIFY_PRODUCT_AVAILABILITY: "Shopify Disponibilité du produit",
            SHOPIFY_ORDER_STATUS: "Statut de commande Shopify",
            AKINON_SHOW_PRODUCTS: "Produits Akinon Show",
            AKINON_FIND_PRODUCT: "Akinon trouve le produit",
            AKINON_ORDER_STATUS: "Statut d'ordre d'Akinon",
            AKINON_SELECT_ORDER: "Ordre de sélection à Akinon",
            AKINON_SELECT_SIZE: "Taille de sélection d'Akinon",
            AKINON_FIND_NEAREST_STOCK: "Afficher le magasin",
            AKINON_FIND_NEAREST_STORES: "Montrer les magasins les plus proches",
            AKINON_SHOW_DISCOUNT_CODES: "Afficher les codes de réduction",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            MESSENGER_SEND_MESSAGE: "ENVOYER UN MESSAGE MESSENGER",
            INSTAGRAM_SEND_MESSAGE: "ENVOYER UN MESSAGE INSTAGRAM",
            INSTAGRAM_COMMENT_REPLY: "RÉPONDRE AU COMMENTAIRE",
            INSTAGRAM_COMMENT_DELETE: "SUPPRIMER LE COMMENTAIRE",
            INSTAGRAM_COMMENT_SHOW: "AFFICHER LE COMMENTAIRE",
            INSTAGRAM_COMMENT_HIDE: "MASQUER LE COMMENTAIRE",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RÉPONDRE EN PRIVÉ",
            followingAttributesFilled: "Les attributs suivants seront remplis.",
            GET_LOCATION: "Obtenir l'emplacement",
            FALLBACK: "SE RETIRER",
            SUCCESS: "SUCCÈS",
            FAILURE: "ÉCHEC",
            message: "Message",
            condition: "Condition",
            score: "Score",
            equal: "Égal",
            not_equal: "n'est pas égal",
            contain: "Contenir",
            not_contain: "Contient pas de",
            starts_with: "commence avec",
            ends_with: "se termine par",
            empty: "vide",
            longer_than: "plus long que",
            shorter_than: "plus court que",
            less_than: "moins que",
            less_than_equal: "moins d'égal",
            greater_than: "plus grand que",
            greater_than_equal: "plus que l'égal",
            value: "Valeur",
            failures: "Les échecs",
            email: "E-mail",
            name: "Nom",
            username: "Nom d'utilisateur",
            source: "Source",
            language: "Langue",
            timezone: "Fuseau horaire",
            region: "Région",
            country: "Pays",
            referrer: "Référent",
            url: "URL",
            ip: "IP",
            city: "Ville",
            lastSeen: "Dernier vu",
            userId: "ID de l'utilisateur",
            selectStep: "Sélectionner l'étape",
            keywords: "Mots clés",
            userSays: "L'utilisateur dit",
            addKeyword: "Ajouter un mot-clé",
            addUserMessage: "Ajouter un message utilisateur",
            set: "Ensemble",
            to: "Pour",
            gender: "Genre",
            go_to_failure: "Aller à l'échec",
            go_to_success: "Aller au succès",
            untilFilled: "Jusqu'à rempli",
            time1: "Une fois",
            time2: "2 fois",
            time3: "3 fois",
            time4: "4 fois",
            time5: "5 fois",
            any: "N'importe quel",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alphanumérique",
            integer: "Entier",
            no: "Non",
            number: "Nombre",
            phone: "Téléphone",
            yes: "Oui",
            yesNo: "Oui Non",
            anyDescription: "Correspond à tout ce qui n'est pas vide.",
            alphanumericDescription: "Correspond aux lettres et aux chiffres",
            integerDescription: "Correspond à un numéro entier",
            noDescription: "Correspond à aucun synonyme",
            numberDescription: "Correspond au numéro ordinal et cardinal",
            phoneDescription: "Correspond au numéro de téléphone",
            yesDescription: "Correspond aux synonymes oui",
            yesNoDescription: "Correspond aux synonymes oui et non",
            emailDescription: "Correspond à l'e-mail",
            urlDescription: "Correspond à l'URL",
            temperature: "Température",
            askWhenInvalid: "Demandez quand invalide",
            applyFilter: "Appliquer le filtre",
            RANDOM_TEXT: "Texte aléatoire",
            QUICK_REPLY: "Réponse rapide",
            FILE: "Déposer",
            notificationMessageStartSuccess: "Le bloc",
            notificationMessageEndSuccess: "a été ajouté",
            notificationMessageStartError: "Une erreur s'est produite, le bloc",
            notificationMessageEndError: "n'a pas été ajouté",
            blockChangedWannaUpdate: "Je veux que la mise à jour changée",
            responses: "Réponses",
            TEXT: "Texte",
            IMAGE: "Image",
            GALLERY: "Galerie",
            BUTTON: "Bouton",
            flow: "Couler",
            active: "Actif",
            passive: "Passif",
            chooseAttributeType: "Choisissez le type d'attribut",
            imageAttachment: "Pièce jointe",
            audioAttachment: "Pièce jointe audio",
            videoAttachment: "Pièce jointe vidéo",
            documentAttachment: "Pièce jointe",
            anyAttachment: "Tout attachement",
            typeAttributeValue: "Tapez la valeur d'attribut",
            typeSearchValue: "Tapez la valeur de recherche",
            addAttribute: "Ajouter un attribut",
            addAttributeDescription:
                "Le nom de l'attribut ne peut contenir que des caractères alphanumériques qui sont des lettres A-Z, des numéros 0-9, du tiret ou du soulignement.",
            male: "Homme",
            USER_DATA: "Données d'utilisateur",
            CUSTOM_ATTRIBUTES: "Attributs personnalisés",
            enterBotResponseHere: "Entrez la réponse du bot ici ...",
            enterPrivateBotResponseHere: "Saisissez le message privé que le bot enverra ...",
            addCard: "Ajouter une carte",
            addButton: "Ajouter le bouton",
            typeCardTitle: "Titre de la carte de type",
            typeCardDescription: "Description de la carte de type",
            dragAndDropBrowse: "Faire glisser et dépasser",
            dragAndDropBrowseFile: "Téléverser un fichier",
            button: "Bouton",
            enterYourMessage: "Entrez votre message",
            imageView: "Vue d'image",
            imageUploading: "Téléchargement d'images",
            fileUploading: "Téléchargement de fichiers ...",
            clickToChooseNewImage: "Cliquez pour choisir une nouvelle image",
            clickToChooseNewFile: "Cliquez pour choisir un nouveau fichier",
            removeTheExistingOne: "Supprimer celui existant",
            validateResponseWithEntity: "Valider la réponse avec l'entité",
            actionOnFailureInput: "Action sur l'entrée de défaillance",
            askNextQuestion: "Posez la question suivante",
            goToSuccessBlock: "Aller au bloc de réussite",
            goToFailureBlock: "Aller au bloc d'échec",
            saveResposeToAttribute: "Enregistrer le dépendance à l'attribut",
            selectReplyType: "Sélectionnez le type de réponse",
            questionVariants: "Variants de questions",
            systemEntities: "Entités système",
            delay: "retard",
            retrySectionTextPart: "Demander",
            retrySectionText: ", si la réponse de l'utilisateur n'est pas valide",
            addNextQuestion: "Ajouter la question suivante",
            typeBlockTitle: "Type Titre du bloc",
            versionHistory: "Historique des versions",
            restore: "Restaurer",
            versionName: "Nom de version",
            restoreModalText:
                "Cette action restaurera la version sélectionnée. Êtes-vous sûr de vouloir restaurer cette version?",
            restoreVersion: "Restaurer la version",
            newVersion: "Nouvelle version",
            synonymMustBeUnique: "Le synonyme doit être unique",
            save: "Sauvegarder",
            entries: "Entrées",
            youHaveNoEntries: "Vous n'avez pas d'entrées",
            inputsCantBeEmpty: "Les entrées ne peuvent pas être vides",
            entryNamesMustBeUnique: "Les noms d'entrée doivent être uniques",
            entityNameMustBeUnique: "Le nom de l'entité doit être unique",
            synonyms: "Synonymes",
            entities: "Entités",
            title: "Titre",
            entryName: "Nom d'entrée",
            entityhasbeenUpdatedSuccessfully: "L'entité a été mise à jour avec succès",
            emptyError: "Les entrées ne peuvent pas être vides",
            entityNameCantBeEmpty: "L'entité ne peut pas être vide",
            allChats: "Tous les chats",
            paidChats: "Chats payants",
            busiestPeriod: "Période la plus fréquentée",
            ratingDistribution: "Répartition des notes",
            allMessages: "Tous les messages",
            avarageMessages: "Messages avarage",
            popularity: "Popularité",
            allUsers: "Tous les utilisateurs",
            interactionName: "Nom d'interaction",
            numberOfMessage: "Nombre de messages",
            ofAllUsersMessage: "% De tous les utilisateurs messages",
            totalData: "Total des données",
            avgData: "Données AVG",
            exportToCsv: "Exporter vers CSV",
            exportToExcel: "Exporter vers Excel",
            inMaintenance: "En maintenance",
            ADD_TO_SEGMENT: "Ajouter au segment",
            REMOVE_FROM_SEGMENT: "Supprimer du segment",
            users: "Utilisateurs",
            webhookName: "Nom de webhook",
            webHookUrl: "URL de webhook",
            webHookToken: "Webhook token",
            delete: "Supprimer",
            basicAuth: "Auth de base",
            requiredFieldsCannotBeLeftBlank: "Les champs requis ne peuvent pas être laissés vides",
            headerValue: "Valeur",
            yourVerificationToken: "Jeton",
            yourWebHookName: "Votre nom Webhook",
            yourWebHookUrl: "Votre URL de webhook",
            enterKey: "La touche Entrée",
            password: "Mot de passe",
            saveSuccessfully: "Votre transaction a été enregistrée avec succès",
            urlTypeError: "Veuillez remplir correctement le champ (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Clé API GPT-4 OpenAI GPT-4 requis.",
                apiKeyDesc:
                    "CHATBOT + CHAT L'intégration GPT-4 nécessite une clé API. Veuillez obtenir votre touche API ou utiliser la clé API ci-dessous pour l'essai. Vous ne pouvez utiliser que 20 messages pour l'essai.",
                getApiKey: "Ouvrir la touche API AI ouverte",
                typeApiKey: "Tapez la clé de l'API",
                ownApiKey: "Propre clé API Openai",
                trialApiKey: "Clé de l'API d'essai (restreint comme un message 20)",
                useOurTrial: "Utilisez notre essai gratuit",
                twentyMessages: "Vous pouvez essayer en utilisant 20 messages comme gratuit.",
                enableChatGpt3: "Activer le chat gpt-4",
            },
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "Code",
            discount: "Rabais",
            endDate: "Date de fin",
            name: "Nom",
            email: "E-mail",
            phone: "Téléphone",
            add: "Ajouter le coupon",
            coupons: "Coupons",
            couponDeleted: "Coupon supprimé",
            limit: "Limite",
            visitorBan: "Visiteur a été bloqué.",
            visitorUnBlock: "Le blocage a été levé.",
        },
        instagramTitle: "Cliquez sur le bouton ci-dessous pour activer les fonctionnalités Instagram.",
        instegramFunctionActive: "Activer la fonctionnalité Instagram",
        ChatBOT: "Chatbot",
        WhatsappContacts: "Contacts WhatsApp",
        InstagramContacts: "Contacts Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Monter le son",
        minimize: "Minimiser",
        maximize: "Maximiser",
        auditLogs: {
            auditLogsTitle: "Journaux d'audit",
            auditLogsSub:
                "Les journaux d'audit vous permettent de suivre les événements survenus dans votre entreprise au cours des 30 derniers jours.",
        },
        task: {
            taskID: "ID de la tâche",
            completeTask: "Terminer la tâche",
            closedTasks: "Tâches terminées",
            moveToArchive: "Déplacer vers l'archive",
            changeWorkflow: "Déplacer vers un Autre Flux de Travail",
            selectWorkflow: "Sélectionner le flux de travail",
            taskNumber: "Tâche #",
            workflowActions: "Actions du flux de travail",
            workflowTitle: "Titre du flux de travail",
            deleteTask: "Supprimer la tâche",
            archivingDate: "Date d'archivage",
            selectOption: "Sélectionner une option",
            notAuthorisedCreateTask: "Vous n'êtes pas autorisé à créer une tâche",
            notAuthorisedCreateTaskDesc: "Vous n'êtes pas autorisé à effectuer cette tâche",
            goToMessage: "Aller au message",
            goToChat: "Aller au chat",
            showVisitor: "Afficher le visiteur",
            closeTheTask: "Fermer la tâche",
            sureAddCompletedList: "Êtes-vous sûr de vouloir ajouter la tâche à la liste des tâches terminées ?",
            success: "Succès",
            successDesc: "Nouveau champ ajouté avec succès",
            moveAndDeleteTask: "Déplacer et supprimer des tâches",
            justDelete: "Supprimer simplement",
            selectColumnMoveTask: "Sélectionnez la colonne dans laquelle vous souhaitez déplacer les tâches",
            todos: "Choses à faire",
            inProgress: "En cours",
            approval: "Approuvé",
            addAComment: "Ajouter un commentaire...",
            deleteComment: "Êtes-vous sûr de vouloir supprimer le commentaire ?",
            edited: "Modifié",
            comments: "Commentaires",
            addComment: "Ajouter un commentaire",
            workflow: "Flux de travail",
            workflowDetail: "Détails du flux de travail",
            workflowPerm: "Permissions du flux de travail",
            perm: "Permissions",
            detail: "Détails",
            userPerm: "Permissions utilisateur",
            deleteCard: "Supprimer la carte",
            createCard: "Créer une carte",
            editCard: "Modifier la carte",
            dragCard: "Déplacer la carte",
            allWorkflow: "Tous les flux de travail",
            createworkflow: "Créer un flux de travail",
            deleteWorkflow: "Êtes-vous sûr de vouloir supprimer ce flux de travail ?",
            permEditTask: "Vous n'avez pas la permission de modifier cette tâche",
            permEditTaskDes: "Contactez votre administrateur pour obtenir les permissions de modification.",
            createTaskError: "Vous n'avez pas la permission de créer des tâches",
            createTaskErrorDesc: "Contactez votre administrateur pour obtenir les permissions de création de tâches.",
            moveTaskError: "Vous n'avez pas la permission de changer le statut de la tâche",
            moveTaskErrorDesc:
                "Contactez votre administrateur pour obtenir les permissions de changement de statut de tâche.",
            deleteTaskError: "Vous n'avez pas la permission de supprimer des tâches",
            deleteTaskErrorDesc:
                "Contactez votre administrateur pour obtenir les permissions de suppression de tâches.",
            permissionError: "Vous n'avez pas l'autorisation de créer des tâches",
            permissionErrorDesc:
                "Veuillez contacter votre administrateur pour obtenir les autorisations de création de tâches",
            whatsappContactProfileTitle: "Profil de {name} / {number}",
            createTaskVisitor: "Créer une tâche (visiteur)",
            editWorkflow: "Modifier le flux de travail",
            visitor: "Profil du visiteur",
            createTaskMessage: "Créer une tâche (Message)",
            createStage: "Créer une étape",
            stagesAndStatuses: "Étapes et statuts",
            workflowCreateDesc: "Description du flux de travail",
            subTasks: "Sous-tâches",
            followers: "Suiveurs",
            collaborators: "Collaborateurs",
            addRelations: "Ajouter des relations",
            relations: "Relations",
            main: "Principal",
            name: "Nom",
            completedOfCheck: "{completed} sur {total} tâches terminées",
            workflowUpdateMs: "Workflow mis à jour avec succès",
            taskUpdateMs: "Tâche mise à jour avec succès",
            workflowCreatedMs: "Workflow créé avec succès",
            workflowCreateError: "Le flux de travail n'a pas pu être créé",
            taskCreatedMs: "Tâche créée avec succès",
            settingsDesc3:
                "De plus, le module de tâches Supsis vous permet de créer votre propre flux de travail avec une automatisation personnalisable, vous permettant de gérer les tâches de manière plus efficace et d'améliorer la collaboration au sein de l'équipe.",
            settingsDesc4:
                "De cette manière, vous pouvez suivre chacune de vos tâches en détail, attribuer des tâches aux membres de l'équipe et gérer globalement vos processus métier de manière plus efficace. Le module de tâches Supsis vous fournit une solution complète pour la gestion des tâches et la coordination d'équipe.",
            settingsDesc2:
                "Le module de tâches Supsis ne laisse aucune tâche passée inaperçue. Vous pouvez filtrer les tâches en fonction de n'importe quel paramètre, suivre les charges de travail pour chaque étape du flux de travail et organiser votre calendrier pour vous aligner sur vos horaires.",
            settingsDesc1:
                "Le module Tâches vous permet d'organiser le travail collaboratif, de déléguer des tâches et de suivre la progression de votre équipe. Vous pouvez personnaliser vos tâches selon vos besoins en sélectionnant n'importe quelle vue et créer vos propres flux de travail personnalisés avec des automatisations.",
            taskModuleSettingsTitle: "Paramètres du module de tâches",
            high: "Élevée",
            medium: "Moyenne",
            low: "Faible",
            priority: "Priorité",
            addExistsSubtask: "Ajouter une sous-tâche existante",
            addSubtask: "Ajouter une sous-tâche",
            add: "Ajouter",
            newCheckList: "Nouvelle liste de contrôle",
            subtaskTitle: "Titre de la sous-tâche",
            view: "Vue",
            attachFiles: "Joindre des fichiers",
            createTaskDesc: "Description de la tâche",
            title: "Titre",
            createWorkflow: "Créer un flux de travail",
            editTask: "Modifier la tâche",
            createTask: "Créer une tâche",
            deleteColumnCont: "Êtes-vous sûr de vouloir supprimer cette colonne?",
            changeStage: "Changer d'étape",
            assignees: "Assignés",
            owner: "Propriétaire",
            stage: "Étape",
            writeSomething: "Écrivez quelque chose",
            selectAssginee: "Sélectionner le destinataire",
            assignee: "Bénéficiaire",
            enterNewTaskDesc: "Entrez la description de la nouvelle tâche",
            enterNewTaskTitle: "Entrez le titre de la nouvelle tâche",
            task: "Tâche",
            deleteTaskCont: "Êtes-vous sûr de vouloir supprimer ces tâches?",
            deleteWorkFlowCont: "Êtes-vous sûr de vouloir supprimer ce workflow ?",
            completed: "Terminé",
            todo: "À faire",
            kanbanBoard: "Tableau Kanban",
            listView: "Vue Liste",
        },
        permissionErrors: {
            userCreate:
                "Vous n'avez pas la permission d'ajouter des utilisateurs. Veuillez consulter votre administrateur.",
            userRead:
                "Vous n'avez pas la permission de voir les utilisateurs. Veuillez consulter votre administrateur.",
            userUpdate:
                "Vous n'avez pas la permission de mettre à jour les utilisateurs. Veuillez consulter votre administrateur.",
            userDelete:
                "Vous n'avez pas la permission de supprimer les utilisateurs. Veuillez consulter votre administrateur.",
            visitorBlock:
                "Vous n'avez pas la permission de bloquer les visiteurs. Veuillez consulter votre administrateur.",
            visitorUnblock:
                "Vous n'avez pas la permission de débloquer les visiteurs. Veuillez consulter votre administrateur.",
            visitorDetailRead:
                "Vous n'avez pas la permission de voir les détails des visiteurs. Veuillez consulter votre administrateur.",
            visitorListRead:
                "Vous n'avez pas la permission de voir la liste des visiteurs. Veuillez consulter votre administrateur.",
            visitorDelete:
                "Vous n'avez pas la permission de supprimer les visiteurs. Veuillez consulter votre administrateur.",
            visitorExcel:
                "Vous n'avez pas la permission d'obtenir une sortie Excel. Veuillez consulter votre administrateur.",
            visitorUpdate:
                "Vous n'avez pas la permission de mettre à jour les visiteurs. Veuillez consulter votre administrateur.",
            bannedVisitorRead:
                "Vous n'avez pas la permission de voir la liste des visiteurs interdits. Veuillez consulter votre administrateur.",
            bannedWordCreate:
                "Vous n'avez pas la permission d'ajouter des mots interdits. Veuillez consulter votre administrateur.",
            bannedWordRead:
                "Vous n'avez pas la permission de voir les mots interdits. Veuillez consulter votre administrateur.",
            bannedWordDelete:
                "Vous n'avez pas la permission de supprimer les mots interdits. Veuillez consulter votre administrateur.",
            chatRead: "Vous n'avez pas la permission de voir les chats. Veuillez consulter votre administrateur.",
            chatUpdate:
                "Vous n'avez pas la permission de modifier les discussions. Veuillez consulter votre administrateur.",
            archiveRead:
                "Vous n'avez pas la permission de consulter les archives. Veuillez consulter votre administrateur.",
            roleCreate: "Vous n'avez pas la permission d'ajouter des rôles. Veuillez consulter votre administrateur.",
            roleRead: "Vous n'avez pas la permission de consulter les rôles. Veuillez consulter votre administrateur.",
            roleUpdate:
                "Vous n'avez pas la permission de mettre à jour les rôles. Veuillez consulter votre administrateur.",
            roleDelete:
                "Vous n'avez pas la permission de supprimer les rôles. Veuillez consulter votre administrateur.",
            departmentCreate:
                "Vous n'avez pas la permission d'ajouter des départements. Veuillez consulter votre administrateur.",
            departmentRead:
                "Vous n'avez pas la permission de consulter les départements. Veuillez consulter votre administrateur.",
            departmentUpdate:
                "Vous n'avez pas la permission de mettre à jour les départements. Veuillez consulter votre administrateur.",
            departmentDelete:
                "Vous n'avez pas la permission de supprimer les départements. Veuillez consulter votre administrateur.",
            preparedContentCreate:
                "Vous n'avez pas la permission de créer du contenu préparé. Veuillez consulter votre administrateur.",
            preparedContentRead:
                "Vous n'avez pas la permission de consulter le contenu préparé. Veuillez consulter votre administrateur.",
            preparedContentUpdate:
                "Vous n'avez pas la permission de mettre à jour le contenu préparé. Veuillez consulter votre administrateur.",
            preparedContentDelete:
                "Vous n'avez pas la permission de supprimer le contenu préparé. Veuillez consulter votre administrateur.",
            welcomeCreate:
                "Vous n'avez pas la permission de créer des messages de bienvenue. Veuillez consulter votre administrateur.",
            welcomeRead:
                "Vous n'avez pas la permission de consulter les messages de bienvenue. Veuillez consulter votre administrateur.",
            welcomeUpdate:
                "Vous n'avez pas la permission de mettre à jour les messages de bienvenue. Veuillez consulter votre administrateur.",
            welcomeDelete:
                "Vous n'avez pas la permission de supprimer les messages de bienvenue. Veuillez consulter votre administrateur.",
            settingCreate:
                "Vous n'avez pas l'autorisation de créer des paramètres. Veuillez consulter votre administrateur.",
            settingRead:
                "Vous n'avez pas l'autorisation de consulter les paramètres. Veuillez consulter votre administrateur.",
            settingUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les paramètres. Veuillez consulter votre administrateur.",
            settingDelete:
                "Vous n'avez pas l'autorisation de supprimer les paramètres. Veuillez consulter votre administrateur.",
            reportCreate:
                "Vous n'avez pas l'autorisation de créer des rapports. Veuillez consulter votre administrateur.",
            reportRead:
                "Vous n'avez pas l'autorisation de consulter les rapports. Veuillez consulter votre administrateur.",
            reportUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les rapports. Veuillez consulter votre administrateur.",
            reportDelete:
                "Vous n'avez pas l'autorisation de supprimer les rapports. Veuillez consulter votre administrateur.",
            offlineSupportRequestCreate:
                "Vous n'avez pas l'autorisation de créer des demandes de support hors ligne. Veuillez consulter votre administrateur.",
            offlineSupportRequestRead:
                "Vous n'avez pas l'autorisation de consulter les demandes de support hors ligne. Veuillez consulter votre administrateur.",
            offlineSupportRequestUpdate:
                "Vous n'avez pas l'autorisation de répondre aux demandes de support hors ligne. Veuillez consulter votre administrateur.",
            offlineSupportRequestDelete:
                "Vous n'avez pas l'autorisation de supprimer les demandes de support hors ligne. Veuillez consulter votre administrateur.",
            catalogCreate:
                "Vous n'avez pas l'autorisation de créer des catalogues. Veuillez consulter votre administrateur.",
            catalogRead:
                "Vous n'avez pas l'autorisation de consulter les catalogues. Veuillez consulter votre administrateur.",
            catalogUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les catalogues. Veuillez consulter votre administrateur.",
            catalogDelete:
                "Vous n'avez pas l'autorisation de supprimer les catalogues. Veuillez consulter votre administrateur.",
            chatbotStoryCreate:
                "Vous n'avez pas l'autorisation de créer des histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotStoryRead:
                "Vous n'avez pas l'autorisation de consulter les histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotStoryUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotStoryDelete:
                "Vous n'avez pas l'autorisation de supprimer les histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotTemplateRead:
                "Vous n'avez pas l'autorisation de consulter les modèles de chatbot. Veuillez consulter votre administrateur.",
            chatbotTemplateAiRead:
                "Vous n'avez pas l'autorisation de consulter les modèles de chatbot IA. Veuillez consulter votre administrateur.",
            chatbotIntegrationsRead:
                "Vous n'avez pas l'autorisation de consulter les intégrations de chatbot. Veuillez consulter votre administrateur.",
            chatbotArchiveRead:
                "Vous n'avez pas l'autorisation de consulter les archives de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesRead:
                "Vous n'avez pas l'autorisation de consulter les entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesCreate:
                "Vous n'avez pas l'autorisation de créer des entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesDelete:
                "Vous n'avez pas l'autorisation de supprimer les entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotReportRead:
                "Vous n'avez pas la permission de consulter les rapports du chatbot. Veuillez contacter votre administrateur.",
            chatbotTrainRead:
                "Vous n'avez pas la permission de consulter la formation du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentCreate:
                "Vous n'avez pas la permission de créer des segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentRead:
                "Vous n'avez pas la permission de consulter les segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentUpdate:
                "Vous n'avez pas la permission de mettre à jour les segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentDelete:
                "Vous n'avez pas la permission de supprimer les segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            integrationsRead:
                "Vous n'avez pas la permission de consulter la page des intégrations. Veuillez contacter votre administrateur.",
            whatsappIntegrationRead:
                "Vous n'avez pas la permission de consulter la page d'intégration WhatsApp. Veuillez contacter votre administrateur.",
            instagramIntegrationRead:
                "Vous n'avez pas la permission de consulter la page d'intégration Instagram. Veuillez contacter votre administrateur.",
            telegramIntegrationRead:
                "Vous n'avez pas la permission de consulter la page d'intégration Telegram. Veuillez contacter votre administrateur.",
            integrationCreate:
                "Vous n'avez pas la permission d'activer les intégrations. Veuillez contacter votre administrateur.",
            triggerCreate:
                "Vous n'avez pas la permission de créer des déclencheurs. Veuillez contacter votre administrateur.",
            triggerRead:
                "Vous n'avez pas la permission de consulter les déclencheurs. Veuillez contacter votre administrateur.",
            triggerUpdate:
                "Vous n'avez pas la permission de mettre à jour les déclencheurs. Veuillez contacter votre administrateur.",
            triggerDelete:
                "Vous n'avez pas la permission de supprimer les déclencheurs. Veuillez contacter votre administrateur.",
            billingRead:
                "Vous n'avez pas l'autorisation de consulter les factures. Veuillez contacter votre administrateur.",
            taskCreate: "Vous n'avez pas l'autorisation de créer des tâches. Veuillez contacter votre administrateur.",
            taskRead:
                "Vous n'avez pas l'autorisation de consulter les tâches. Veuillez contacter votre administrateur.",
            taskUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les tâches. Veuillez contacter votre administrateur.",
            taskDelete:
                "Vous n'avez pas l'autorisation de supprimer les tâches. Veuillez contacter votre administrateur.",
            calendarCreate:
                "Vous n'avez pas l'autorisation de créer un calendrier/une réservation. Veuillez contacter votre administrateur.",
            calendarRead:
                "Vous n'avez pas l'autorisation de consulter un calendrier/une réservation. Veuillez contacter votre administrateur.",
            calendarUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour un calendrier/une réservation. Veuillez contacter votre administrateur.",
            calendarDelete:
                "Vous n'avez pas l'autorisation de supprimer un calendrier/une réservation. Veuillez contacter votre administrateur.",
            mailCreate: "Vous n'avez pas l'autorisation de créer des e-mails. Veuillez contacter votre administrateur.",
            mailRead:
                "Vous n'avez pas l'autorisation de consulter des e-mails. Veuillez contacter votre administrateur.",
            mailUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour des e-mails. Veuillez contacter votre administrateur.",
            mailDelete:
                "Vous n'avez pas l'autorisation de supprimer des e-mails. Veuillez contacter votre administrateur.",
        },
        message: {
            confirmDeleteRedStationIntegration: "Êtes-vous sûr de vouloir supprimer ce canal Kırmızı Santral ?",
            enterRedStationIntegration: "Entrez vos identifiants API Kırmızı Santral",
            redStationIntegration: "Intégration Kırmızı Santral",
            copyChannelID: "Copier l'ID du Canal",
            redStationChannels: "Canaux Kırmızı Santral",
            bannedUserError: "Une erreur s'est produite lors de l'ajout du bannissement.",
            bannedUserSuccess: "Bannissement ajouté avec succès.",
            selectAtLeastOneOption: "Veuillez sélectionner au moins une option.",
            enterValidValue: "Veuillez entrer une valeur valide.",
            enterValidIpAddress: "Veuillez entrer une adresse IP valide.",
            enterValidVisitorId: "Veuillez entrer un ID de visiteur valide.",
            enterValidWhatsappNumber: "Veuillez entrer un numéro WhatsApp valide.",
            invalidEmailAddress: "Veuillez entrer une adresse e-mail valide.",
            bannedUser: "Banni",
            unbannedUser: "Non Banni",
            banModalDescription: "Entrez la plateforme et la valeur pour bannir l'utilisateur.",
            exampleNumber: "Numéro d'exemple : 905551111111",
            clearSelectedFiltersTooltip: "Efface les valeurs de filtres sélectionnées sur la page",
            minutesText: "{count} minutes",
            secondsText: "{count} secondes",
            downloadCooldownWarning: "Veuillez attendre {time} pour créer une nouvelle demande de téléchargement.",
            excelExportReceiveQuestion: "Comment souhaitez-vous recevoir le fichier Excel ?",
            sendToMe: "M'envoyer",
            sendToSomeoneElse: "Envoyer à Quelqu'un d'Autre",
            enterEmailAddress: "Entrez l'adresse e-mail",
            exportRequestSuccess: "Votre demande a été créée, nous vous l'enverrons par e-mail dès que possible",
            maxDateRangeWarning: "La plage de dates sélectionnée peut être de 45 jours maximum",
            ticketOnlyMail: "Cette demande ne peut être répondue que par e-mail. Les messages envoyés via WhatsApp ne peuvent pas être transférés.",
            cardInfoUpdateError: "Une erreur s'est produite lors de la mise à jour des informations de la carte",
            billingInfoSavedSuccessfully: "Vos informations de facturation ont été enregistrées avec succès",
            billingInfoSaveError: "Erreur lors de l'enregistrement des informations de facturation :",
            paymentInfoSavedSuccessfully: "Vos informations de paiement ont été enregistrées avec succès",
            annualDiscount: "Obtenez 20% de réduction sur les achats annuels",
            annualDiscountDescription: "Vous pouvez réaliser des économies importantes en choisissant un abonnement annuel.",
            payOnlyForUsedFeatures: "Payez uniquement ce que vous utilisez",
            payOnlyForUsedFeaturesDescription: "Payez uniquement pour les fonctionnalités que vous utilisez, ne payez pas pour plus.",
            cancelAnytime: "Annulez à tout moment",
            cancelAnytimeDescription: "Pas besoin de contrats à long terme, vous pouvez annuler quand vous le souhaitez.",
            noPermissionDescription: "Vous <strong>n'avez pas la permission</strong> d'effectuer cette opération. Veuillez contacter votre administrateur.",
            creditCardRequired: "Informations de Carte de Crédit Requises",
            creditCardRequiredDescription: "Vous avez des abonnements payants. Vous pouvez continuer en saisissant vos informations de carte de crédit ou en annulant vos abonnements.",
            creditCardRequiredDescription2: "Vous devez saisir les informations de carte de crédit car vous avez des abonnements payants dans votre compte.",
            subscriptionManagement: "Gestion des Abonnements",
            addCreditCard: "Ajouter des Informations de Carte de Crédit",
            transferOwnership: "Transférer la Propriété et Rediriger",
            errorLoadingAgents: "Une erreur s'est produite lors du chargement des agents",
            pleaseFillRequiredFields: "Veuillez remplir les champs requis",
            callStartedSuccessfully: "Appel démarré avec succès",
            errorStartingCall: "Une erreur s'est produite lors du démarrage de l'appel",
            errorLoadingData: "Une erreur s'est produite lors du chargement des données",
            errorLoadingDataPhoneNumbers: "Une erreur s'est produite lors du chargement des numéros de téléphone",
            noVariablesFound: "Aucune variable trouvée dans le prompt. Les variables doivent être au format <code v-pre>{{ nom_variable }}</code>.",
            aiVoiceAgentSpecialVariables: "Valeurs de Variables Spéciales",
            addAiVoiceAgentChannel: "Ajouter un Canal",
            multiLanguageSupport: "Support multilingue",
            customerService247: "Service client 24h/24 et 7j/7",
            autoCallAnswer: "Réponse automatique aux appels",
            aiVoiceAgentChannelRequired: "Canal d'Agent Vocal IA Requis",
            aiVoiceAgentChannelRequiredDescription: "Vous devez ajouter un canal d'Agent Vocal IA pour utiliser cette fonctionnalité.",
            aiVoiceAgentChannelRequiredDescription2: "L'Agent Vocal IA est un assistant alimenté par l'intelligence artificielle qui peut passer des appels téléphoniques avec vos clients.",
            startCall: "Démarrer l'Appel",
            selectContactFieldPlaceholder: "Sélectionner les informations de contact",
            aiVoiceAgentVariableValuePlaceholder: "Saisir la valeur",
            aiVoiceAgentVariables: "Informations sur les Variables de l'Agent",
            aiVoiceAgentVariableManual: "Manuel",
            aiVoiceAgentVariableContact: "Informations de Contact",
            toNumberHelpText: "Doit être au format E.164. Exemple : +905321234567",
            toNumber: "Numéro à Appeler",
            selectAiVoiceAgentHelpText: "Si non sélectionné, l'agent sortant par défaut du numéro sera utilisé",
            selectAiVoiceAgent: "Sélectionner un agent (optionnel)",
            aiVoiceAgent: "Agent",
            selectFromNumber: "Sélectionner le numéro appelant",
            fromNumber: "Numéro Appelant",
            startAiCall: "Démarrer l'Appel avec l'Agent Vocal IA",
            aiCall: "Passer un Appel avec l'Agent Vocal IA",
            groupByNone: "Aucun regroupement appliqué",
            groupByAgent: "Regrouper les contacts par les agents de leur dernière session",
            groupByDepartment: "Regrouper les contacts par le département sélectionné dans leur dernière session",
            groupByChannel: "Regrouper les contacts par le canal d'où ils viennent",
            groupByPlatform: "Regrouper les contacts par la plateforme d'où ils viennent",
            groupByWebsite: "Regrouper les contacts par le site web d'où ils viennent",
            groupByTag: "Regrouper les contacts par leurs étiquettes",
            groupByAnswerStatus: "Regrouper les contacts par leur statut de réponse de leur dernière session",
            groupByOwner: "Regrouper les contacts par leurs propriétaires",
            changeGroupBy: "Changer le Mode de Regroupement",
            changeSortMode: "Changer le Mode de Tri",
            selectIcon: "Sélectionner une Icône",
            iconPickerTitle: "Sélecteur d'Icônes",
            searchIconPlaceholder: "Rechercher une icône...",
            profileFieldsDescriptionChat: "Cliquez pour personnaliser vos champs de profil",
            createCommentSuccess: "Commentaire créé avec succès",
            createCommentError: "Une erreur est survenue lors de la création du commentaire",
            updateCommentSuccess: "Commentaire mis à jour avec succès",
            updateCommentError: "Une erreur est survenue lors de la mise à jour du commentaire",
            deleteCommentSuccess: "Commentaire supprimé avec succès",
            deleteCommentError: "Une erreur est survenue lors de la suppression du commentaire",
            formSubmission: "Soumission du formulaire",
            selectForm: "Sélectionner le formulaire",
            updateOwnerUsers: "Mettre à jour les propriétaires",
            updateOwnerUsersDesc: "Voulez-vous mettre à jour les propriétaires de cet utilisateur ? Vous pouvez les transférer à un autre utilisateur ou les laisser sans propriétaire.",
            deposit: "Dépôt",
            creditUsage: "Utilisation du crédit",
            businessMarketing: "Marketing",
            businessUtility: "Utilité",
            businessAuthentication: "Authentification",
            businessService: "Service",
            incomingSessionMessage: "Message entrant",
            outgoingSessionMessage: "Message sortant",
            freeTierConversation: "Conversation gratuite (FTC)",
            chatStart: "Démarrer le chat",
            wpMessage: "Message en masse Whatsapp QR",
            pin: "Épingler",
            rename: "Renommer",
            browserSpeechRecognitionNotSupported: "Votre navigateur ne prend pas en charge la reconnaissance vocale. Nous recommandons d'utiliser le navigateur Chrome.",
            spaceKeyReleaseToSave: "Il sera enregistré lorsque vous relâcherez la touche espace",
            spaceKeyHint: "Vous pouvez parler en maintenant la touche espace enfoncée",
            listeningInProgress: "Écoute en cours...",
            speakNow: "Parlez maintenant...",
            toggleAllPermissions: "Activer/Désactiver toutes les permissions du rôle",
            rolePermissions: "Permissions du rôle",
            roleSaved: "Rôle enregistré avec succès",
            creatingRole: "Création du rôle...",
            savingRole: "Enregistrement du rôle...",
            editRole: "Modifier le rôle",
            newRoleCreate: "Créer un nouveau rôle",
            descriptionEmail: "Ajoute automatiquement l'adresse e-mail du visiteur dans le chat à la boîte de message et vous permet de l'envoyer",
            exampleEmail: "Exemple: @email bonjour",
            nameDescription: "Ajoute automatiquement le nom du visiteur dans le chat à la boîte de message et vous permet de l'envoyer",
            exampleName: "Exemple: @name bonjour",
            pmDescription: "Vous permet d'envoyer un message privé. Seuls les autres représentants du service client peuvent voir ces messages, pas les visiteurs.",
            examplePm: "Exemple: pm: Ce message est privé",
            chatShortcuts: "Raccourcis de chat",
            showSystemStatus: "Afficher l'état du système",
            endChatWizard: "Assistant de fin de session",
            terminationError: "Une erreur s'est produite",
            profileFieldsUpdateError: "Une erreur est survenue lors de la mise à jour des champs de profil",
            profileFieldsUpdated: "Champs de profil mis à jour",
            aiSuggestionError: "Les suggestions IA ne peuvent pas être récupérées",
            profileFieldsDescription: "Vous pouvez remplir les champs de profil personnalisés pour cette personne pour fournir plus d'informations à votre équipe.",
            categoryTags: "Vous pouvez ajouter des tags à cette personne pour la classer rapidement.",
            manageTags: "Gérer les tags",
            enterNote: "Entrer une note",
            noteDescription: "Vous pouvez ajouter des notes sur cette personne. Ces notes seront également visibles après la conversation.",
            suggestedProfileFields: "Champs de profil suggérés:",
            suggestedTags: "Tags suggérés",
            suggestedNote: "Note suggérée:",
            applyAll: "Tout appliquer",
            aiSuggestionTitle: "Suggestions d'IA",
            aiSuggestion: "Supsis Asistan Suggestions",
            searchItem: "Rechercher un élément",
            makeSelection: "Faire une Sélection",
            channel: "Canal",
            taskClosingDate: "Date de Clôture de la Tâche",
            deleteOperation: "Opération de Suppression",
            confirmDeleteTask: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
            taskDeletedSuccess: "Tâche supprimée avec succès",
            taskDeleteError: "Erreur lors de la suppression de la tâche",
            selectColumns: "Sélectionnez les Colonnes que Vous Souhaitez Voir dans le Tableau",
            linkedinChannels: "Chaînes LinkedIn",
            updateLinkedinChannelDesc: "Mettre à jour votre chaîne LinkedIn",
            deleteLinkedinChannel: "Supprimer la Chaîne LinkedIn",
            confirmDeleteLinkedinChannel: "Êtes-vous sûr de vouloir supprimer cette chaîne LinkedIn ?",
            contactIdPlaceholder: "ID du contact",
            contactId: "ID du contact",
            enterOwnerId: "Entrer l'ID du propriétaire",
            selectOwner: "Sélectionner le propriétaire",
            dynamic: "Dynamique",
            addCollaborator: "Ajouter un collaborateur",
            dynamicValue: "Valeur dynamique",
            selectCollaborator: "Sélectionner un collaborateur",
            collaborator: "Collaborateur",
            collaborators: "Collaborateurs",
            addFollower: "Ajouter un suiveur",
            selectFollower: "Sélectionner un suiveur",
            followers: "Suiveurs",
            follower: "Suiveur",
            addAssignee: "Ajouter un assigné",
            selectUser: "Sélectionner un utilisateur",
            assignees: "Assignés",
            assignee: "Assigné",
            pipelineStage: "Étape du pipeline",
            selectPipelineStage: "Sélectionner l'étape du pipeline",
            title: "Titre",
            taskTitle: "Titre de la tâche",
            description: "Description",
            taskDescription: "Description de la tâche",
            priority: "Priorité",
            selectPriority: "Sélectionner la priorité",
            selectWorkflow: "Sélectionner le flux de travail",
            packagePurchase: "Achat de package",
            upcomingInvoice: "Facture à venir",
            invoiceUpdated: "Facture mise à jour",
            invoiceMarkedInvalid: "Facture marquée comme invalide.",
            invoiceUpdateError: "Erreur de mise à jour de la facture",
            invoiceMarkInvalidError: "Une erreur est survenue lors du marquage de la facture comme invalide.",
            refunded: "Remboursé",
            paid: "Payé",
            pending: "En attente",
            unpaid: "Non payé",
            paymentFailed: "Paiement échoué",
            paymentProcessError: "Une erreur est survenue lors du processus de paiement.",
            paymentSuccessful: "Paiement réussi",
            paymentProcessSuccessful: "Le processus de paiement a été effectué avec succès.",
            invoiceRefund: "Remboursement de facture",
            invoiceRefundedSuccessfully: "La facture a été remboursée avec succès.",
            invoicePaymentError: "Erreur de paiement de facture",
            invoicePaymentProcessError: "Une erreur est survenue lors du processus de paiement de la facture.",
            invoicePaid: "Facture payée",
            invoiceMarkedAsPaid: "La facture a été marquée comme payée avec succès.",
            invoicePriceUpdateError: "Une erreur est survenue lors de la mise à jour du prix de la facture.",
            invoicePriceUpdatedSuccessfully: "Le prix de la facture a été mis à jour avec succès.",
            invoicePdf: "Facture PDF",
            viewInvoice: "Voir la facture",
            makePayment: "Effectuer le paiement",
            autoForwardToOwnerForceDescription: "Dans tous les cas, les contacts possédés sont automatiquement transférés à leur propriétaire. Ils ne sont ni maintenus en file d'attente ni transférés au chatbot. Même si ce paramètre est désactivé, si le chatbot n'est pas actif dans le système, ils seront quand même transférés à leur propriétaire.",
            autoForwardToOwnerForce: "Transfert automatique au propriétaire (même avec chatbot actif)",
            socialMedia: "Réseaux Sociaux",
            web: "Web",
            email: "E-mail",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-commerce",
            utilities: "Utilitaires",
            advertising: "Publicité",
            cancelPlanTitle:"Annulation du plan",
            cancelPlanDescription:"Après l'annulation du plan, le paquet pourra être utilisé jusqu'à la fin de la période de validité.",
            voteSuccess: "Vote enregistré avec succès",
            voteSuccessDescription: "Votre demande d'ajout de l'intégration {integrationName} à Supsis a bien été reçue.",
            companyName: "Nom de l'entreprise",
            company: "Entreprise",
            languageTitle1: "Langue par défaut du panneau",
            languageTitle2: "Langue par défaut des messages",
            languageTitle3: "Région & Fuseau horaire",
            languageTitle4: "Paramètre automatique de la langue du client",
            languageTitle5: "Sélection de la langue de messagerie du client dans WebChat",
            languageDesc1: "Définit la langue du panneau Supsis AI",
            languageDesc2: "Vous pouvez changer la langue de messagerie par défaut ici.",
            languageDesc3: "Définit la région et le fuseau horaire",
            languageDesc4: "Permet la détection automatique de la langue de messagerie du client avec le support de l'IA.",
            languageDesc5: "Active la fonctionnalité permettant au client de sélectionner sa langue parlée dans le canal WebChat.",
            featuresTitle1: "Sélection du département",
            featuresTitle2: "Afficher le nombre de clients en attente",
            featuresTitle3: "Restriction des mots interdits",
            featuresTitle4: "Autoriser les clients à créer des tickets",
            featuresTitle5: "Appel vocal",
            featuresTitle6: "Appel vidéo",
            featuresTitle7: "Envoi de messages vocaux (agent)",
            featuresTitle8: "Envoi de messages vocaux (client)",
            featuresTitle9: "Transfert automatique d'appels",
            featuresTitle10: "Afficher le chat entre représentants",
            featuresTitle11: "Envoi de fichiers (agent)",
            featuresTitle12: "Envoi de fichiers dans WebChat (client)",
            featuresTitle13: "Autoriser l'envoi de messages avant la connexion de l'agent",
            featuresTitle14: "Masquer les messages système des représentants",
            featuresTitle15: "Autoriser le client à supprimer ses informations personnelles",
            featuresTitle16: "Notification de présence en ligne du client",
            featuresTitle17: "Traduction automatique",
            featuresTitle18: "Connexion automatique du visiteur",
            featuresTitle19: "Partage de localisation dans WebChat (client)",
            featuresTitle20: "Partage de localisation (représentant)",
            featuresTitle21: "Copilote AI de chat",
            featuresTitle22: "Mise en attente des conversations sans propriétaire",
            featuresTitle23: "Masquer les informations de contact",
            featuresDesc1: "Routage obligatoire vers les départements en fonction des sujets sélectionnés par le client.",
            featuresDesc2: "Montre aux clients leur position dans la file d'attente lorsque les représentants sont occupés.",
            featuresDesc3: "Empêche les représentants d'envoyer des mots interdits définis dans le système aux clients lorsque la restriction des mots interdits est active.",
            featuresDesc4: "Active l'option de créer un ticket dans la bulle WebChat.",
            featuresDesc5: "Active la fonction d'appel vocal dans la bulle WebChat.",
            featuresDesc6: "Active la fonction d'appel vidéo dans la bulle WebChat.",
            featuresDesc7: "Permet aux représentants d'envoyer des messages vocaux.",
            featuresDesc8: "Permet aux clients d'envoyer des messages vocaux dans le canal WebChat.",
            featuresDesc9: "Attribue automatiquement les appels en attente aux représentants disponibles.",
            featuresDesc10: "Affiche le panneau de conversation entre représentants.",
            featuresDesc11: "Permet aux représentants d'envoyer des fichiers.",
            featuresDesc12: "Permet aux clients d'envoyer des fichiers dans le canal WebChat.",
            featuresDesc13: "Permet aux clients d'envoyer des messages avant qu'un représentant ne se connecte.",
            featuresDesc14: "Masque les messages système des représentants, empêchant les clients de les voir.",
            featuresDesc15: "Active la possibilité pour les clients de supprimer leurs informations personnelles d'un simple clic dans la bulle WebChat.",
            featuresDesc16: "Informe les représentants par un message système lorsque le client quitte ou revient dans le canal WebChat.",
            featuresDesc17: "Traduit automatiquement les messages des clients dans la langue du représentant.",
            featuresDesc18: "Commence la conversation dès que le visiteur clique sur la bulle.",
            featuresDesc19: "Active la possibilité pour les clients de partager leur localisation dans le canal WebChat.",
            featuresDesc20: "Active la possibilité pour les représentants de partager leur localisation.",
            featuresDesc21: "Active l'utilisation de l'assistance AI pour les représentants pour corriger les fautes de frappe, changer le ton des messages et générer des réponses assistées par AI.",
            featuresDesc22: "Active cette fonction pour garder les personnes sans propriétaire dans la file d'attente.",
            featuresDesc23: "Empêche les représentants de voir les numéros de téléphone et les adresses e-mail des clients.",
            groupBy: "Grouper",
            privacyPolicyAndTerms: "Politique de confidentialité / Conditions d'utilisation",
            privacyPolicyTitle: "Politique de confidentialité pour les systèmes de support et de chatbot Supsis",
            privacyPolicyDescription: "Cette politique de confidentialité décrit comment Softcand Yazılım Hizmetleri A.S. (« Softcand », « nous », « notre » ou « nos ») collecte, utilise et divulgue des informations sur les utilisateurs (« vous » ou « votre ») de l'application web Supsis (« Supsis »). Cette politique de confidentialité s'applique aux informations que nous collectons lorsque vous utilisez Supsis ; ces informations sont valables lorsqu'elles sont consultées via notre site web, nos applications mobiles ou d'autres plateformes où la politique de confidentialité est publiée.",
            informationWeCollect: "Informations que nous collectons",
            weCollectFollowingInformation: "Nous collectons les informations suivantes",
            customerAccountInformation: "Informations sur le compte client",
            customerAccountData: "Lors de la création d'un compte Supsis, nous collectons les données suivantes : prénom, nom, numéro de téléphone et adresse e-mail.",
            userInformation: "Informations sur l'utilisateur",
            userProvidedInformation: "Informations fournies par les utilisateurs de l'application, y compris le prénom, le nom et l'adresse e-mail.",
            dataDeletionProcess: "Processus de suppression des données",
            dataDeletionProcedures: "Nous suivons ces procédures pour la suppression des données",
            automaticDeletion: "Suppression automatique",
            automaticDeletionInfo: "Les comptes clients sont automatiquement supprimés lorsqu'ils sont fermés ou après six mois d'inactivité.",
            directRequest: "Demande directe",
            directRequestInfo: "Les clients peuvent demander la suppression de toutes leurs données en nous contactant directement.",
            websiteVisitorDataDeletion: "Suppression des données des visiteurs du site web",
            websiteVisitorDataDeletionInfo: "Les visiteurs du site web peuvent supprimer leurs données, y compris l'historique des discussions, les messages et les fichiers, directement via l'interface de chat web.",
            howToContactUs: "Comment nous contacter",
            contactChannels: "Vous pouvez nous contacter par les canaux suivants",
            dataProcessingAndSharing: "Traitement et partage des données",
            handleCustomerData: "Nous traitons les données des clients comme suit",
            noThirdPartySharing: "Pas de partage avec des tiers",
            noThirdPartySharingInfo: "Supsis ne partage pas les données des clients avec des tiers, des organisations ou des individus.",
            promotionalEmails: "E-mails promotionnels",
            promotionalEmailsInfo: "Nous pouvons envoyer des e-mails promotionnels aux clients ; ils peuvent choisir de se désinscrire de ces e-mails.",
            visitorAndConversationData: "Données des visiteurs et des conversations",
            noSharingVisitorData: "Nous ne partageons ni n'utilisons les informations sur les visiteurs et les discussions des clients.",
            thirdPartyServices: "Services tiers",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Agenda",
            googleCalendarInfo: "Supsis utilise Google Agenda pour activer des fonctionnalités liées au calendrier dans l'application. Les données synchronisées à partir des calendriers ne sont partagées avec personne et ne sont visibles que par l'utilisateur. Lorsque Google OAuth expire, tous les événements synchronisés de Supsis et de Google Agenda sont automatiquement supprimés.",
            googleAccountPublicProfile: "Profil public du compte Google",
            googleAccountPublicProfileInfo: "Supsis collecte des informations sur le nom et l'adresse e-mail pour vérifier et authentifier les utilisateurs lors de la connexion. Ces informations ne sont pas conservées après vérification.",
            changesToPrivacyPolicy: "Modifications de cette politique de confidentialité",
            privacyPolicyUpdateInfo: "Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Si nous apportons des modifications importantes, nous vous informerons par le biais de notre site web ou d'autres canaux de communication.",
            privacyPolicyContactInfo: "Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter à l'adresse m@softcand.com.",
            termsOfServiceTitle: "Conditions d'utilisation pour les systèmes de support et de chatbot Supsis",
            lastUpdated: "Dernière mise à jour",
            inEffect: "En vigueur",
            importantTerms: "Important : Ces conditions d'utilisation, qui incluent également notre politique de confidentialité, constituent un contrat contraignant entre la personne désignée lors du processus d'inscription comme utilisateur du service (« vous ») et Softcand Yazılım Hizmetleri Anonim Şirketi (exerçant sous le nom de Supsis ou Supsis Live Support ou Supsis Live Support et systèmes de chatbot) (« nous ») et régissent votre utilisation de nos sites web situés sur supsis.com (page de destination du produit), softcand.com (site web de l'entreprise) ou supsis.live (application produit) ou beta.supsis.live (version bêta de l'application produit). Pour cette raison, ces conditions sont importantes et vous devez vous assurer de les lire attentivement et de nous contacter pour toute question avant d'utiliser le service.",
            termsDescription: "Ces conditions d'utilisation régissent votre utilisation de nos sites web situés sur supsis.com (page de destination du produit), softcand.com (site web de l'entreprise) ou supsis.live (application produit) ou beta.supsis.live (version bêta de l'application produit).",
            applicationOfTerms: "Application des conditions",
            termsApplyToAllUsers: "Ces conditions s'appliquent à tous les utilisateurs du service, que vous utilisiez le service en votre propre nom ou au nom d'une autre personne ou organisation.",
            termsUpdateNotice: "Nous pouvons mettre à jour ou modifier les conditions à tout moment à notre discrétion. Si nous modifions les conditions, nous vous informerons en vous alertant via notre plateforme web et par e-mail.",
            termsDisagreementNotice: "Vous devez accepter d'être lié par les conditions mises à jour en cliquant sur votre acceptation dans l'avis qui vous est présenté avant de continuer à utiliser le service.",
            consumerRightsNotice: "Si vous êtes classé comme 'consommateur' en vertu de la législation applicable, vous pouvez avoir des droits légaux en vertu de cette législation locale qui interdisent l'application de tout ou partie de certaines des limitations et exclusions énoncées dans ces conditions à votre égard, et dans ce cas, ces parties ne s'appliqueront pas à vous.",
            theService: "Le service",
            serviceGrant: "Nous vous accordons un droit non exclusif, mondial, non transférable et révocable d'utiliser le service conformément à ces conditions.",
            serviceAccess: "Vous pouvez accéder et utiliser le service (y compris toute copie accidentelle qui se produit dans le cadre de cette utilisation) conformément à ces conditions.",
            serviceAgentAppointment: "Lorsque vous vous connectez au service et connectez un compte de réseau social au service, vous nous nommez comme votre agent en ce qui concerne ce compte pour effectuer des actions en votre nom, à votre direction (par exemple, répondre à un message direct sur Instagram ou une autre plateforme) lors de la fourniture du service.",
            additionalAccountsAppointment: "Lorsque vous connectez des comptes supplémentaires au service, vous nous nommez également comme votre agent en ce qui concerne ces comptes pour entreprendre les activités dans le cadre de l'agence.",
            accountControl: "Vous garantissez que vous contrôlez chaque compte et que vous êtes autorisé à nous nommer comme votre agent avec l'autorité d'entreprendre les activités dans le cadre de l'agence en votre nom pour chaque compte.",
            serviceAffiliation: "Vous reconnaissez et acceptez que le service n'est pas affilié à ou autorisé par Instagram, Facebook, Twitter ou tout autre service de réseau social pour lequel nous fournissons le service et que tout accès à chaque plateforme (y compris via le service) est régi par les conditions d'utilisation de la plateforme applicable.",
            serviceLinks: "Le service contient des liens vers d'autres sites web ainsi que du contenu ajouté par des personnes autres que nous. Nous n'approuvons, ne sponsorisons ni ne validons aucun contenu généré par les utilisateurs ou tout contenu disponible sur un site web lié.",
            contentMonitoring: "Nous n'avons aucune obligation de surveiller, d'éditer ou de supprimer le contenu téléchargé ou partagé par nos utilisateurs sur le service et ensuite publié sur un compte sur l'une des plateformes.",
            serviceControl: "Vous reconnaissez et acceptez que : (1) nous conservons le contrôle sur le service et pouvons modifier, compléter ou cesser le fonctionnement du service à tout moment à notre seule discrétion (nous vous informerons raisonnablement de toute modification qui affecte de manière significative la fonctionnalité du service) ; (2) le service peut être indisponible de temps à autre (y compris pour des raisons de maintenance) et, dans la mesure du possible, nous vous informerons de toute période d'arrêt planifiée ; et (3) nous pouvons refuser de publier le contenu que vous ajoutez au service que nous considérons, en agissant raisonnablement, comme ne respectant pas la section 3 de ces conditions.",
            yourRightsAndObligations: "Vos droits et obligations",
            contentAdditionRestriction: "Vous ne devez pas ajouter de contenu au service : (1) à moins que vous ne déteniez tous les droits, licences et consentements nécessaires pour le faire ; (2) qui pourrait amener vous ou nous à enfreindre une loi ou un règlement ou toute autre règle, code ou obligation légalement contraignante ; (3) qui est ou que nous, agissant raisonnablement, considérons comme du spam, obscène, inapproprié, diffamatoire, dénigrant, indécent, subversif, offensant, pornographique, menaçant, abusif, susceptible d'inciter à la haine raciale, illégal, discriminatoire, blasphématoire, en violation de la confiance ou en violation de toute loi sur la confidentialité ; (4) qui pourrait nous discréditer ou discréditer le service ; ou (5) qui enfreint les droits de propriété intellectuelle ou d'autres droits de quiconque.",
            restrictionsOnServiceUse: "Vous ne devez pas : (1) tenter de dupliquer ou de reproduire, ou de modifier, de changer ou de préparer des œuvres dérivées du service, du contenu que nous publions en relation avec le service ou de tout autre matériel que vous ne possédez pas ou pour lequel vous n'avez pas de licence pertinente ; (2) distribuer des virus ou d'autres codes malveillants ; (3) utiliser le service pour publier des informations trompeuses ou trompeuses ; (4) accéder au compte d'une autre personne sur notre service sans sa permission ; (5) modifier, désactiver, interférer ou contourner tout aspect du service ou tester ou rétroconcevoir le service pour trouver des limitations, des vulnérabilités ou contourner les capacités de filtrage ; ou (6) faire quoi que ce soit qui pourrait affecter l'accès ou l'intégrité du service.",
            payments: "Paiements",
            paymentAcknowledgment: "Vous reconnaissez et acceptez que :",
            paymentMethodDebit: "Nous débiterons votre méthode de paiement désignée à la date de facturation spécifiée (le jour où votre période d'essai se termine) chaque mois, année ou autre période de facturation (le cas échéant) pour la période de facturation suivante à l'avance, sauf si vous annulez le service avant cette date ; et",
            cancellationPolicy: "Si vous annulez le service, vous continuerez à avoir accès au service jusqu'à votre prochaine date de facturation, et tout remboursement de toute somme payée pour la période de facturation actuelle est à notre discrétion (c'est-à-dire que les paiements ne sont pas remboursables, sauf à notre discrétion).",
            intellectualProperty: "Propriété intellectuelle",
            contentDefinition: "Dans ces conditions, 'Contenu' inclut des matériaux sous forme de texte, audio, graphique, pictural et vidéo, ou toute combinaison de matériaux, sous toute forme.",
            intellectualPropertyRightsTransfer: "Rien dans ces conditions ne constitue un transfert de droits de propriété intellectuelle. Vous reconnaissez et acceptez qu'entre vous et nous, nous possédons tous les droits de propriété intellectuelle dans le service (c'est-à-dire que nous possédons les droits sur les applications que nous mettons à votre disposition – nous ne possédons pas de droits de propriété intellectuelle sur votre contenu – voir ci-dessous au 5(3)).",
            userContentRights: "Nous reconnaissons qu'entre vous et nous, vous possédez ou avez une licence sur tous les droits de propriété intellectuelle dans le contenu que vous fournissez au service ou que vous nous fournissez autrement dans le but de fournir le service.",
            grantLicense: "Vous nous accordez un droit et une licence perpétuels, non exclusifs, sans redevance, irrévocables, mondiaux et transférables d'utiliser, de toute manière (y compris en publiant sur un compte sur une plateforme comme vous l'avez demandé) : (a) le contenu que vous ajoutez au service ; et (b) le contenu de profil sur les plateformes de médias sociaux associées à votre compte (y compris, sans limitation, en reproduisant, en modifiant ou en adaptant, et en communiquant ce contenu au public) aux fins de vous fournir le service.",
            subLicense: "Nous pouvons sous-licencier la licence au paragraphe 5(4) à des prestataires de services tiers qui nous aident à fournir le service.",
            moralRights: "Dans certains pays où le service est exploité, la législation locale reconnaît que les auteurs de contenu peuvent avoir des 'droits moraux' concernant le contenu. Les exemples de droits moraux peuvent inclure le droit d'être attribué en tant qu'auteur de contenu, le droit de s'opposer à une fausse attribution de la paternité du contenu et le droit de s'opposer à un traitement dégradant du contenu dans certaines circonstances.",
            licenseSurvival: "La licence au paragraphe 5(4) survivra à toute résiliation de ces conditions.",
            rightsRepresentation: "Vous déclarez et garantissez que vous avez tous les droits nécessaires pour accorder les licences et autres engagements énoncés dans cet article 5.",
            warranties: "Garanties",
            warrantiesAcknowledgment: "Vous déclarez et garantissez que :",
            accountOwnership: "Tous les comptes, sur toute plateforme, ajoutés au service sont détenus ou contrôlés par vous ;",
            serviceUsageAgreement: "Vous utiliserez le service conformément à ces conditions ; et",
            legalCapacity: "Vous avez la capacité légale et l'autorité de conclure ces conditions.",
            liability: "Responsabilité",
            liabilityForLoss: "Vous êtes responsable de toute perte ou dommage causé si vous enfreignez vos obligations en vertu de ces conditions ou si vous ne faites pas preuve de diligence raisonnable dans votre utilisation du service. Votre responsabilité sera réduite dans la mesure où nous causons ou contribuons à cette perte ou ce dommage par notre propre violation de ces conditions ou notre propre négligence dans la fourniture du service.",
            indemnification: "Vous nous indemnisez pour toute perte ou dommage que nous subissons en raison de votre violation de ces conditions (y compris les garanties que vous nous donnez en vertu de ces conditions), ou de tout comportement intentionnel, acte illégal ou négligence dans votre utilisation ou abus du service.",
            exclusionOfLiability: "Dans toute la mesure permise par la loi, et sous réserve des dispositions 7(5) et 7(6) de ces conditions, nous excluons toute responsabilité pour toutes les réclamations, dépenses, pertes, dommages et coûts engagés contre vous ou encourus par vous directement ou indirectement résultant de ou en relation avec votre utilisation du service ou votre incapacité à utiliser le service, y compris en ce qui concerne les pertes économiques, la perte de données, l'interruption des activités ou tout dommage consécutif ou accessoire.",
            totalLiabilityLimit: "Dans toute la mesure permise par la loi, et sous réserve des dispositions 7(5) et 7(6) de ces conditions, notre responsabilité totale envers vous pour violation de contrat en vertu de ces conditions, pour délit (y compris négligence) ou pour toute autre cause est limitée à un montant égal au total des frais payés ou à payer par vous pour le service pour la période d'un mois précédant immédiatement le jour où notre responsabilité est née.",
            exclusionOfTerms: "Dans toute la mesure permise par la loi, et sous réserve des dispositions 7(6) et 7(7) de ces conditions, nous excluons toutes les conditions, déclarations, garanties, conditions, assurances ou obligations (qu'elles soient explicites ou implicites) autres que celles expressément énoncées dans ces conditions.",
            statutoryObligations: "Dans certaines juridictions, la législation peut exiger que certaines garanties, conditions, assurances ou obligations relatives au service soient implicites dans ces conditions ou imposées à notre fourniture du service ('obligations statutaires'). De plus, la législation peut interdire ou rendre nulles d'autres conditions qui ont pour effet d'exclure, de limiter ou de modifier les conditions imposées, ou l'exercice des droits et recours, ou la récupération de compensations, autrement disponibles pour vous lorsque nous violons une condition imposée ('interdiction statutaire').",
            statuteProhibition: "Si la législation mentionnée au paragraphe 7(6) s'applique à ces conditions telles qu'acceptées par vous, ou au service tel qu'il vous est fourni, rien dans ces conditions n'est destiné à être ou à agir comme une interdiction statutaire. En particulier, aucune partie de ces conditions n'est destinée à limiter notre responsabilité là où cette partie constituerait une interdiction statutaire.",
            termination: "Résiliation",
            terminationAutomatic: "Ces conditions prennent fin automatiquement si, pour une raison quelconque, nous cessons d'exploiter le service.",
            terminationNotice: "Nous pouvons également résilier ou suspendre immédiatement votre accès au service, en vous en informant, si nous pensons raisonnablement que vous avez violé ces conditions de quelque manière que ce soit.",
            cancelService: "Vous pouvez annuler le service à tout moment en nous en informant, et vous pouvez continuer à accéder au service jusqu'à la fin de votre période de facturation actuelle.",
            terminationRights: "Tous les droits qui vous sont accordés dans ces conditions prennent fin en cas de résiliation.",
            assignmentRestriction: "Vous ne devez pas céder, sous-licencier ou traiter de toute autre manière vos droits en vertu de ces conditions.",
            invalidProvision: "Si une disposition de ces conditions est invalide ou inapplicable, elle doit être interprétée ou séparée dans la mesure nécessaire sans affecter la validité ou l'applicabilité des dispositions restantes.",
            expenseResponsibility: "Chaque partie doit à ses propres frais faire tout ce qui est raisonnablement nécessaire pour donner plein effet à cet accord et aux événements envisagés par celui-ci.",
            governingLaw: "Ces conditions sont régies par les lois de la Turquie et chaque partie se soumet à la juridiction des tribunaux de Turquie.",
            privacyPolicyTab: "Politique de confidentialité",
            termsAndConditionsTab: "Conditions d'utilisation",
            placeholders: "Espaces réservés",
            deleteConfirmationMessage: "Êtes-vous sûr de vouloir supprimer ce filtre ?",
            deleteSuccess: "Filtre supprimé avec succès",
            filterSavedSuccessfully: "Le filtre a été enregistré avec succès",
            filterCreatedMessage: "Le filtre que vous venez de créer, {filterName}, est maintenant disponible ici et peut être utilisé à tout moment.",
            copyImage: "Copier l'image",
            copyText: "Copier le texte",
            translateVisitorMessage: "Traduire le message",
            replyMessage: "Répondre",
            filterName: "Nom du filtre",
            enterFilterName: "Entrez le nom du filtre",
            selectVisibility: "Sélectionnez la visibilité",
            public: "Public",
            private: "Privé",
            includeExistingFilters: "Inclure les filtres existants",
            includeSearchTerm: "Inclure le terme de recherche",
            includeSortOrder: "Inclure l'ordre de tri",
            includeGroupingSelection: "Inclure la sélection de regroupement",
            saveFilter: "Enregistrer le filtre",
            ban: "Bannir",
            forwardToDepartmentAndAssign: "Transférer au département et attribuer",
            storageSpace: "Espace de stockage",
            completed: "Terminé",
            failed: "Échoué",
            cancelled: "Annulé",
            running: "En cours",
            paused: "En pause",
            queued: "En attente",
            scheduled: "Prévu",
            metaLead: "Meta Lead",
            agent: "Agent",
            invoice: "Facture",
            whatsapp: "WhatsApp",
            reservation: "Réservation",
            chatbot: "Chatbot",
            webhook: "Webhook",
            table: "Table",
            ticket: "Billet",
            calendar: "Calendrier",
            tag: "Étiquette",
            low: "Bas",
            lowest: "Le plus bas",
            medium: "Moyen",
            high: "Élevé",
            highest: "Le plus élevé",
            createDepartment: "Créer un département",
            goToLink: "Aller au Lien",
            emailAddressYouProvide: "Un compte existe déjà avec l’adresse e-mail fournie.",
            channelPrivacyPolicyNotMet: "La politique de confidentialité du canal n'est pas respectée",
            userIsNotInDepartment: "L'utilisateur n'est pas dans le département",
            currentDepartment:"Département actuel",
            validDepartment:"Département valide",
            youCanForwardToThisDepartment:"Vous pouvez rediriger la conversation vers ce département",
            goToSettings:"Aller aux paramètres",
            changeDepartmentAndForward:"Changer de département et rediriger",
            selectDepartmentToForwardAgent:"Veuillez sélectionner le service par lequel vous souhaitez acheminer la conversation pour l'agent nommé {selectAgentName}.",
            selectDepartmentToForward: "Veuillez sélectionner le département auquel vous souhaitez rediriger",
            packageConfirmationMessage: "Êtes-vous sûr de vouloir acheter le forfait ? Le forfait que vous achetez est soumis à des frais en temps réel. Vous pouvez continuer à l'utiliser pendant un an après l'annulation. Le prix de ce produit est hors TVA de 20 %.",
            packagePurchaseConfirmation: "Êtes-vous sûr de vouloir acheter le forfait ? Les forfaits mensuels seront facturés au début de chaque mois. L'utilisation du forfait prendra fin après la date d'annulation. Le prix de ce produit est hors TVA de 20%.",
            annualPurchaseDiscount: "Profitez de l'offre de réduction de 30 % sur les achats annuels !",
            customerTables: "Tableaux de clients",
            formIntegration: "Intégration de formulaire",
            automationIntegration: "Intégration d'automatisation",
            remainingAutomationTask: "Tâches d'automatisation restantes",
            createUserError: "Une erreur s'est produite lors de la création de l'utilisateur",
            sendTemplateMessage: "Envoyer un message modèle",
            startChatWithDifferentChannel: "Démarrer une conversation avec un autre canal",
            whatsappChatStarter: "Démarreur de chat WhatsApp",
            pressEnterToJoin: "Appuyez sur Entrée pour rejoindre le chat",
            pressEnterToStartChat: "Appuyez sur Entrée pour démarrer le chat",
            cannotSendMessage: "Vous ne pouvez pas envoyer de message à cette personne",
            cannotSendSessionMessage: "Vous ne pouvez pas envoyer de message de session à cette personne",
            conversationNotInYourDepartments: "Cette conversation n'appartient à aucun de vos départements",
            customizeImage: "Si vous souhaitez personnaliser l'image",
            clickToUpload: "Cliquez ici pour télécharger une image",
            uploadNote: "Voici les formats de fichiers et leurs tailles respectives acceptés pour le téléchargement",
            imageSize: "L'image n'a pas pu être téléchargée car elle dépasse 2 Mo",
            videoSize: "La vidéo n'a pas pu être téléchargée car elle dépasse 20 Mo",
            documentSize: "Le document n'a pas pu être téléchargé car il dépasse 2 Mo",
            uploading: "Téléchargement de l'image, veuillez patienter...",
            uploadSuccess: "Image téléchargée avec succès",
            note: "Note",
            gridView: "Vue de tableau",
            completedTasks: "Tâches terminées",
            system: "Système",
            destroyedBy: "Destruido par",
            brand: "Marque",
            questions: "Fragen",
            channelCreatedSuccess: "Canal créé avec succès",
            channelCreatedError: "Échec de la création du canal",
            plans: {
                types: {
                    supsis: "Forfaits Représentants",
                    chatbot: "Chatbot",
                    automation: "Automatisation",
                    customer_tables: "Tableau des Clients",
                    mail: "E-mail",
                    tasks: "Tâches",
                    form: "Formulaire",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    "artificial_intelligence": "Intelligence Artificielle",
                    "webhook": "Webhook",
                    "telegram": "Telegram",
                    webphone: "Web Phone",
                },
            },
            vipCustomerDescription:
                "Marquer cette personne comme client VIP la place en tête de la file d'attente et garantit qu'elle reçoit un service prioritaire.",
            switchOn: "Activé",
            switchOff: "Désactivé",
            ownerDescription:
                "Cette fonctionnalité indique le propriétaire d'un chat. Quel que soit le statut du propriétaire (en ligne ou hors ligne), les chats sont toujours attribués au propriétaire. Les chats appartenant à un propriétaire ne peuvent être vus que par ce dernier et ne peuvent pas être répondus par le chatbot.",
            permissionError: "Vous n'avez pas la permission d'effectuer cette action!",
            copySuccess: "Contenu copié avec succès!",
            unowned: "Sans propriétaire",
            jsonPreview: "APERÇU JSON",
            enterNewValue: "Entrez une nouvelle valeur",
            updatePreferredLanguage: "Mettre à jour la langue préférée",
            updateTags: "Mettre à jour les tags",
            updateEmail: "Mettre à jour l'e-mail",
            enterNewEmail: "Entrez un nouvel e-mail",
            deleteConfirmation: "Confirmation de suppression",
            confirmDelete: "Êtes-vous sûr de vouloir supprimer cette fonctionnalité?",
            yesDelete: "Oui, supprimer",
            vipCustomer: "★ Client VIP",
            joinChat: "Rejoindre la conversation",
            takeControlFromChatbot: "Prendre le contrôle depuis le chatbot",
            enterJoin: "Vous pouvez rejoindre la conversation en appuyant sur la touche Entrée",
            watchChat: "Voir la conversation",
            untitledAutomation: "👉 Automatisation de clic sur le profil sans titre",
            event: "Événement",
            chatbotSettings: "Paramètres de routage du chatbot",
            chatbotScenarioNotFound: "Scénario de chatbot introuvable",
            noChatbotScenario: "Aucun scénario de chatbot trouvé dans le système.",
            scenarioNotFound: "Scénario introuvable",
            descNotAvailable: "Description non disponible",
            lastRegulation: "Dernière réglementation",
            taskCreator: "Créateur de tâche",
            noPermission: "Vous n'avez pas la permission de créer des tâches.",
            noPermissionDescription: "Vous n'avez pas la permission d'effectuer cette action.",
            notAppointed: "Non nommé",
            changeStage: "Changer d'étape",
            selectedCandidates: "1 candidat sélectionné",
            coverPhotoRemove: "Supprimer la photo de couverture",
            coverPhotoSet: "Définir comme photo de couverture",
            autoTransfer: "Transférer automatiquement vos contacts vers Zoho",
            autoTransferDescription:
                "Les contacts arrivant sur ce canal sont automatiquement transférés vers le module de contact Zoho CRM. Ceux transférés vers Zoho activent les widgets Zoho.",
            zohoChannelRequiredTitle: "Canal Zoho CRM requis",
            zohoChannelRequiredContent:
                "Vous n'avez pas de canal Zoho CRM. Cliquez ici pour en ajouter un immédiatement.",
            okText: "Ajouter un canal Zoho CRM",
            cancelText: "Annuler",
            forceQueueForNoOwnerContacts: "Forcer les contacts sans propriétaire à attendre dans la file d'attente",
            forceQueueDescription:
                "Seuls les contacts possédés sont automatiquement attribués, forçant les contacts sans propriétaire à attendre dans la file d'attente.",
            showNoOwnerContactsToAdmins: "Afficher les contacts sans propriétaire uniquement aux administrateurs",
            showNoOwnerContactsDescription:
                "Les contacts sans propriétaire ne sont visibles que par les administrateurs.",
            autoAssignOwner: "Attribution automatique de la propriété du contact",
            autoAssignOwnerDescription:
                "Lorsque le chat est automatiquement attribué à un représentant, il est également attribué en tant que propriétaire.",
            creator: "Créateur",
            hideShow: "Masquer / Afficher",
            url: "URL",
            cannedMessages: "Messages prédéfinis",
            templateMessages: "Messages de modèle",
            chatbots: "Chatbots",
            noCannedMessages: "Aucun message prédéfini trouvé",
            filterToFindMore: "Vous pouvez trouver plus de messages prédéfinis en modifiant vos filtres.",
            runPrompt: "Exécuter le Prompt",
            noLeadsFound: "Aucun lead trouvé pour cette personne",
            deals: "Offres",
            noDealsFound: "Aucune offre trouvée pour cette personne",
            loadingDeals: "Chargement des offres",
            zohoCRM: "Zoho CRM",
            viewContact: "Voir le contact",
            noNotesAdded: "Aucune note ajoutée pour le moment",
            attachments: "Pièces jointes",
            addNewNote: "Ajouter une nouvelle note",
            savingg: "Enregistrement...",
            warningFillFields: "Veuillez remplir les champs titre et contenu.",
            successNoteAdded: "Note ajoutée avec succès.",
            errorAddingNote: "Une erreur s'est produite lors de l'ajout de la note.",
            noteTitle: "Titre de la note",
            noteContent: "Contenu de la note",
            selectPreferredAgent: "Sélectionnez l'agent préféré que vous souhaitez attribuer au visiteur.",
            postOperations: "Opérations de publication",
            loadingPostOperations: "Chargement des opérations de publication",
            noPostOperations: "Aucune opération de publication trouvée pour cette personne",
            postOperationDetails: "Détails des opérations de publication",
            noMediaDocuments: "Aucun média ou document disponible pour cette personne.",
            selectionLimitError: "Vous pouvez sélectionner un maximum de 30 éléments.",
            showNote: "Afficher la note à tout le monde",
            hideNote: "Cacher la note",
            updateNote: "Mettre à jour la note",
            addUserNote: "Ajouter une note sur l'utilisateur",
            privateNote: "Note privée",
            metaReferrals: "Références Meta",
            noMetaReferrals: "Aucune interaction publicitaire Meta trouvée.",
            searchPrompt: "Recherchez quelque chose.",
            noRecentResults: "Aucun résultat récent trouvé.",
            contactInfo: "Informations de contact",
            noPropertiesAdded: "Aucune propriété ajoutée pour le moment.",
            propertyAddedUpdated: "Propriété ajoutée/mise à jour avec succès.",
            propertyError: "Une erreur s'est produite lors de l'ajout/de la mise à jour de la propriété.",
            propertyDeleted: "Propriété supprimée avec succès.",
            propertyDeleteError: "Une erreur s'est produite lors de la suppression de la propriété.",
            zohoSynchronization: "Synchronisation Zoho",
            zohoSyncConfirmation: "Voulez-vous apporter des modifications à la personne dans Zoho?",
            hideOtherInfo: "Masquer d'autres informations",
            showOtherInfo: "Afficher d'autres informations",
            whatsappChatStart: "Démarrer le chat WhatsApp",
            ownership: "Propriété du client",
            countryAndLanguage: "Pays, Langue",
            calendarEvent: "Événement du calendrier",
            contact: "Contact",
            user: "Utilisateur",
            customerOwnership: "Propriété du client",
            ownerless: "Sans propriétaire",
            preferredDepartment: "Département préféré",
            flowluTransfer: "Transférer à Flowlu",
            mergeSuccess: "L'opération de fusion a été réalisée avec succès.",
            visitorOwnershipWarning: "Ce visiteur est la propriété d'un autre utilisateur.",
            newAutomation: "Nouvelle automatisation",
            automations: "Automatisations",
            createProfileAutomation: "Créer une automatisation de profil",
            profileButtonClicked: "Bouton de profil cliqué",
            profileButtonDescription: "Cette automatisation sera déclenchée lorsqu'un bouton de profil est cliqué.",
            automationName: "Nom de l'automatisation",
            create: "Créer",
            dayRange: "Plage de jours",
            hourRange: "Plage d'heures",
            last24Hours: "Dernières 24 heures",
            today: "Aujourd'hui",
            yesterday: "Hier",
            thisWeek: "Cette semaine",
            lastWeek: "La semaine dernière",
            last7Days: "Derniers 7 jours",
            last30Days: "Derniers 30 jours",
            thisMonth: "Ce mois-ci",
            lastMonth: "Le mois dernier",
            startDateTime: "Date et heure de début",
            endDateTime: "Date et heure de fin",
            complaint: "Plainte",
            opens: "Ouvertures",
            clicks: "Clics",
            mockData: "(Données fictives)",
            preferredRepresentative: "Sélectionner un agent préféré",
            forwardToDepartment: "Reenvoyer à l'équipe",
            toMobileAgents: "A l'agent mobile",
            noMediaAndDocuments: "Ce utilisateur n'a pas de médias ou de documents",
            reportBug: "Signaler un bug",
            waitingForReply: "En attente de réponse",
            memorySize: "Taille de la mémoire",
            usedMemory: "Mémoire utilisée",
            availableMemory: "Mémoire disponible",
            memoryLimit: "Limite de mémoire",
            memoryLimitPrice: "Prix pour la mémoire supplémentaire",
            telegramBotIsReachable: "Le service de robots de Telegram est bogué",
            telegramBotIsHealthy: "Le service de robots de Telegram est en bonne santé",
            telegramBotIsUnhealthy: "Le Telegram Bot Service a une erreur",
            pieView: "Vue circulaire",
            chartView: "Vue graphique",
            tableView: "Vue tableau",
            lastUpdate: "dernière mise à jour",
            workflow: "workflow",
            task: "tâche",
            filterBy: "Par filtre",
            watchAllLive: "Regarder tout en direct",
            sessionsUnique: "Sessions (utilisateurs uniques)",
            sessionsAll: "Sessions (tous les utilisateurs)",
            moreFeaturesDesc:
                "Plus de fonctionnalités, plus d'intégrations, plus d'agents ! Passez à l'action dès maintenant pour mieux gérer votre équipe et développer votre entreprise au maximum de son potentiel !",
            metaLeadForms: "Meta Lead Forms",
            metaLeadsConnectedSucs: "Meta Leads connecté avec succès",
            failedToConnectMetaLeads: "Échec de la connexion aux Meta Leads",
            forbiddenChannel: "Canal interdit",
            forbiddenChannelDesc: "Vous n'êtes pas autorisé à voir ce canal",
            firstContact: "Premier contact",
            needsAnalysis: "Analyse des besoins",
            offerSent: "Offre envoyée",
            offerReview: "Examen de l'offre",
            decisionPhase: "Phase de décision",
            personDeleted: "Personne supprimée",
            metaLeadsIntegration: "Intégration de Meta Leads",
            phoneNumberIsInvalid: "Numéro de téléphone non valide",
            owner: "Propriétaire",
            addAnItem: "Ajouter un élément",
            saveItem: "Enregistrer un élément",
            customItem: "Élément personnalisé",
            backgroundPhoto: "Image d'arrière-plan",
            whenYouActivateFeature:
                "Lorsque vous activez cette fonctionnalité, elle n'apparaîtra pas sur la page de réservation",
            logo: "Logo",
            noLogo: "Pas de logo",
            addTeamMember: "Ajouter un membre de l'équipe",
            timezone: "Fuseau horaire",
            selectDayys: "Sélectionner le(s) jour(s)",
            selectStartHour: "Sélectionner l'heure de début",
            selectEndHour: "Sélectionner l'heure de fin",
            moveLeft: "Déplacer vers la droite",
            moveRight: "Déplacer vers la gauche",
            reply: "Réponse",
            replyToAll: "Répondre à tous",
            deleteThreadMessage: "Supprimer le message du fil de discussion",
            totalEmailsBounced: "Nombre total d'e-mails rejetés",
            totalEmailsComplained: "Nombre total d'e-mails ayant fait l'objet d'une réclamation",
            untilNowTotalEmailOpens: "Nombre total d'e-mails ouverts jusqu'à présent",
            untilNowTotalEmailLinkClicks: "Nombre total de clics sur les liens des courriels jusqu'à présent",
            uniqueClicks: "Nombre de clics uniques",
            untilNowTotalUniqueEmail:
                "Nombre total de clics uniques sur le lien de l'e-mail jusqu'à présent (par destinataire)",
            emailCampaignTimeline: "Chronologie de la campagne d'emailing",
            receivedBroadcasts: "Diffusions reçues",
            groupDeletedSuccessfully: "Groupe supprimé avec succès",
            verify: "Vérifier",
            done: "Fait",
            pleaseSelectAnEmailAddress: "Veuillez sélectionner une adresse électronique",
            goBack: "Retourner",
            show: "Afficher",
            vueEmailEditor: "Vue Email Editor (Demo)",
            saveDesign: "Enregistrer le design",
            exportHTML: "Exporter HTML",
            saveAsEmailCustomerGroup: "Enregistrer en tant que groupe de clients e-mail",
            saveAsWhatsappCustomerGroup: "Enregistrer en tant que groupe de clients Whatsapp",
            deleteModalFormDesc:
                "Si vous supprimez ce formulaire, toutes les données du formulaire seront définitivement supprimées. Êtes-vous sûr de vouloir continuer ?",
            todo: "Choses à faire",
            inProgress: "En cours ",
            approval: "Approbation",
            transactionType: "Type de transaction",
            previousBalance: "Solde précédent",
            nextBalance: "Prochain solde",
            amount: "Montant",
            wpIntegrationChannelRequired: "Canal d'intégration Web Whatsapp requis",
            wpIntegrationChannelRequiredDesc:
                "L'intégration Chatbot + Whatsapp Web nécessite un canal Whatsapp Web. Veuillez créer un nouveau canal.",
            wabaIntegrationChannelRequired: "Canal d'intégration commerciale Whatsapp requis",
            wabaIntegrationChannelRequiredDesc:
                "L'intégration Chatbot + API Whatsapp Business nécessite le canal Web Whatsapp. Veuillez créer un nouveau canal.",
            instaIntegrationChannelRequired: "Canal d'intégration Instagram requis.",
            instaIntegrationChannelRequiredDesc:
                "L'intégration Chatbot + Instagram nécessite un canal Instagram. Veuillez créer un nouveau canal.",
            createWpChannel: "Créer un canal web Whatsapp",
            createWabaChannel: "Créer un canal API d'entreprise Whatsapp",
            createInstaChannel: "Créer un canal Instagram ",
            failedToDeleteGroup: "Échec de la suppression d'un groupe",
            failedToDeleteGroups: "Échec de la suppression des groupes",
            failedToFetchGroupContacts: "Échec de la récupération des contacts du groupe",
            mailAddressDeletedSuccessfully: "Adresse électronique supprimée avec succès",
            defaultMailAddressChangedSuccessfully: "L'adresse de messagerie par défaut a été modifiée avec succès",
            mailAddressAlreadyRegistered: "L'adresse électronique ne peut pas être déjà enregistrée ou vide",
            pleaseVerifyByClicking: "Veuillez vérifier en cliquant sur le lien envoyé à votre adresse électronique",
            signSucsRegistered: "Signature enregistrée avec succès",
            myContacts: "Mes contacts",
            unanswered: "Manqué",
            emailBroadcasts: "Diffusion d'e-mails",
            monthlyLimit: "Limite mensuelle",
            totalShipments: "Total des expéditions",
            shippingStatus: "État de l'expédition",
            lastAction: "Dernière action",
            receiver: "Récepteur",
            delivered: "Livré",
            opened: "Ouvert",
            clicked: "Cliqué",
            bounced: "Il est de retour",
            clickedLinks: "Liens cliqués",
            reason: "Raison",
            timer: "Timer",
            implemented: "Implémenté ?",
            module: "Module",
            excelDownload: "Téléchargement d'Excel",
            serviceFeatures: "Caractéristiques du service",
            mailAddressDeletedSucs: "Adresse électronique supprimée avec succès",
            inputSearchText: "Saisir le texte de la recherche",
            createRecord: "Créer un enregistrement",
            separatorCharacter: "Caractère de séparation",
            exampleResultPreview: "Exemple d'aperçu de résultat",
            importRecords: "Importer des enregistrements",
            equals: "Egal",
            notEquals: "Non égal",
            startsWith: "Commence par",
            endsWith: "Se termine par",
            greaterThan: "Plus",
            lessThan: "Moins que",
            before: "Avant",
            after: "Après",
            is: "O",
            isNot: "Non",
            empty: "Vide",
            notEmpty: "Pas vide",
            isOneOff: "Une fois",
            field: "Champ",
            records: "Enregistrement",
            addIntegration: "Ajouter une intégration",
            chatbotScenarioReleased: "Scénario de chatbot publié",
            chatbotScenarioHasBeenCancelled: "Le scénario du chatbot a été annulé",
            titleAndDesc: "Titre et description",
            templateAndMailSelection: "Modèle et sélection de courrier",
            peopleToSend: "Personnes à qui envoyer",
            submissionPlans: "Plan de soumission",
            summary: "Résumé",
            broadcastTitle: "Titre de la diffusion",
            sentByEmail: "Email envoyé",
            emailTemplate: "Modèle d'e-mail",
            onlyPeopleWithEmail: "Seules les personnes disposant d'une adresse électronique peuvent être envoyées",
            sendNow: "Envoyer maintenant",
            plan: "Plan",
            senderEmail: "Email de l'expéditeur",
            totalBuyer: "Acheteur total",
            estimatedDuration: "Durée estimée",
            person: "Personne",
            shippingIsNowComplete: "L'expédition est terminée !",
            back: "Retour",
            customerName: "Nom du client",
            customerEmail: "Email du client",
            customValue: "Valeur personnalisée",
            selectMailTemplate: "Vous devez sélectionner un modèle de courrier.",
            youMustSelectSendingMailAddress: "Vous devez sélectionner l'adresse électronique d'envoi.",
            youMustSelectCustomerGroupSend: "Vous devez sélectionner le groupe de clients à qui envoyer le message",
            createBroadcast: "Créer une diffusion",
            broadcastDetails: "Détails de la diffusion",
            youCanCheckYourEmailStatus:
                "Vous pouvez vérifier le statut de votre e-mail en mettant à jour votre plan. Vous pouvez vérifier l'état de votre messagerie en passant à un plan supérieur.",
            sentDetails: "Détails de l'envoi",
            total: "Total",
            totalEmailsProcessed: "Nombre total d'emails traités",
            totalEmailsDelivered: "Nombre total d'emails envoyés",
            toAvailableAgents: "Pour les agents disponibles",
            toAvailableDepartments: "Pour les départements disponibles",
            toWithAgentAndDepartment: "Avec l'agent et le service",
            toMobilAgents: "Pour les agents mobiles",
            toPreferredAgents: "Aux agents préférés",
            searchAgent: "Agent de recherche",
            searchDepartment: "Département de recherche",
            searchMobileAgent: "Agent mobile de recherche",
            searchAgentOrDepartment: "Agent de recherche ou département",
            searchPreferredAgent: "Recherche de l'agent préféré",
            noAgentsAvailableToForward: "Aucun agent disponible pour la transmission",
            noDepartmentsAvailableToForward: "Aucun service disponible pour la transmission",
            noMobileAgentsAvailableToForward: "Aucun agent mobile disponible pour la transmission",
            noPreferredAgentsAvailableToForward: "Aucun agent privilégié disponible pour la transmission",
            ifYouSendThisConversationToTheQueue:
                "Si vous envoyez cette conversation dans la file d'attente, vous serez retiré du chat et la conversation sera placée dans la file d'attente. Si l'attribution automatique du chat est activée, la conversation sera attribuée à un agent approprié et pourra vous être retransférée.",
            ifAutomaticChatAssignmentIsDisabled:
                "Si l'attribution automatique du chat est désactivée, l'appel restera dans la file d'attente. Le personnel autorisé peut prendre l'appel depuis la file d'attente.",
            sendQueue: "Envoyer à la file d'attente",
            agentName: "Nom de l'agent",
            departmentName: "Nom du service",
            toQueue: "File d'attente",
            mobile: "Mobile",
            noGrouping: "Pas de regroupement",
            groupByThis: "Regrouper par ceci",
            selectGroupingCriteria: "Sélectionner les critères de regroupement",
            activeUsers: "Utilisateurs actifs",
            passiveUsers: "Utilisateurs passifs",
            noPlatform: "Aucune plate-forme spécifiée",
            noRole: "Rôle non spécifié",
            noDepartment: "Aucun département spécifié",
            noLanguage: "Aucune langue spécifiée",
            group2: "Groupe",
            groupedByStatus: "Grouped by Status",
            grouping: "Groupement",
            activeSubjects: "Sujets actifs",
            passiveSubjects: "Sujets passifs",
            groupSubjects: "Sujets de groupe",
            showAll: "Afficher tout",
            onlyActive: "Seulement actif",
            onlyPassive: "Seulement les passifs",
            selectTimezone: "Sélectionner le fuseau horaire",
            userFilter: "Filtre utilisateur",
            confidenceScore: "Score de confiance",
            chatbotLanguage: "Langue du chatbot",
            botScenerio: "Scénario du bot",
            selectTemplate: "Sélectionner un modèle",
            importFromReadyTemplates: "Importer des modèles prêts",
            classification: "Classification",
            addClassification: "Ajouter une classification",
            expressionClassified: "Expression à classer",
            zohoModuleName: "Nom du module Zoho",
            selectModule: "Sélectionner un module",
            standardFields: "Champs standard",
            selectStandardField: "Sélectionner un champ standard",
            customFields: "Champs personnalisés",
            selectCustomFields: "Sélectionner un champ personnalisé",
            aiFunction: "Fonction d'intelligence artificielle",
            aiFunctionDesc:
                "Gérer une fonction d'intelligence artificielle pour effectuer des actions basées sur les entrées de l'utilisateur",
            functionName: "Nom de la fonction",
            functionDesc: "Description de la fonction",
            addParameter: "Ajouter un paramètre",
            chooseAiStory: "Choisir une histoire d'intelligence artificielle",
            chatbotAiPromptDesc:
                "L'intelligence artificielle apprend et détermine comment elle doit se comporter en recevant des instructions sur une tâche ou un problème spécifique à l'aide de la fonction 'prompt'",
            enterPrompt: "Entrez l'invite",
            aiParameterTunings: "Réglages des paramètres de l'IA",
            aiParameterTuningsDesc:
                "Vous pouvez régler les paramètres de l'IA pour la rendre plus réactive et plus précise. Ces paramètres sont utilisés pour contrôler le comportement de l'IA et la façon dont elle réagit aux entrées de l'utilisateur.",
            temperature: "Température",
            temperatureDesc:
                "Température d'échantillonnage à utiliser, entre 0 et 2. Des valeurs élevées telles que 0,8 rendront la sortie plus aléatoire, tandis que des valeurs plus faibles telles que 0,2 la rendront plus ciblée et déterministe.",
            topDesc:
                "Comme alternative à l'échantillonnage par température, appelé échantillonnage par noyau, le modèle considère les résultats des tokens avec la masse de probabilité top_p. Ainsi, 0,1 signifie que seuls les tokens ayant la masse de probabilité la plus élevée (10 %) sont pris en compte. Nous recommandons généralement de modifier ce paramètre ou la température, mais pas les deux.",
            toolChoices: "Options de l'outil",
            noneDesc: "None signifie que le modèle n'invoquera aucun outil et générera à la place un message.",
            autoDesc:
                "Le mode automatique est la valeur par défaut et signifie que le modèle peut choisir entre générer un message ou invoquer un ou plusieurs agents.",
            requiredDesc:
                "Le mode requis signifie que le modèle doit appeler un ou plusieurs agents avant de répondre à l'utilisateur.",
            createArticles: "Créer un article",
            createArticlesDesc:
                "Créez des articles pour aider vos utilisateurs à trouver des réponses à leurs questions",
            articlesTitle: "Titre de l'article",
            articlesContent: "Contenu de l'article",
            createFaq: "Créer une foire aux questions (FAQ)",
            createFaqDesc:
                "Créez une nouvelle FAQ pour votre chatbot. Cela aidera votre chatbot à répondre aux questions de l'utilisateur.",
            question: "Question",
            saveAndClose: "Enregistrer et fermer",
            contentPreview: "Aperçu du contenu",
            upgradePackageTitle: "Améliorez votre forfait et évitez les limites",
            upgradePackageDescription:
                "Plus de fonctionnalités, plus d'intégrations, plus d'agents ! Passez à l'action dès maintenant pour mieux gérer votre équipe et maximiser le potentiel de votre entreprise !",
            upgradePackage: "Mise à niveau",
            deleteSelected: "Supprimer les fichiers sélectionnés",
            newFolder: "Nouveau dossier",
            newFile: "Nouveau fichier",
            noFilesFound: "Aucun fichier n'a été trouvé dans ce dossier",
            uploadFile: "Télécharger un fichier",
            enterFolderName: "Veuillez saisir le nom du dossier",
            folderName: "Nom du dossier",
            dropFileHere: "Déposer des fichiers ici",
            createFolder: "Créer un dossier",
            fileUploadingError: "Une erreur s'est produite lors du téléchargement d'un fichier",
            fileUploadingSucs: "Dossier créé avec succès",
            folderNameNotEmpty: "Le nom du dossier ne peut pas être vide",
            deleteFolder: "Supprimer le dossier",
            sureDeleteFolder: "Êtes-vous sûr de vouloir supprimer ce dossier et tous les fichiers qu'il contient ?",
            deletionSucs: "Suppression réussie",
            deleteFile: "Supprimer le fichier",
            sureDeleteFile: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
            deletionError: "Une erreur s'est produite pendant le processus de suppression",
            selectFile: "Sélectionner un fichier",
            moreThanOneSelect: "Vous pouvez sélectionner plusieurs fichiers",
            selectAnFile: "Sélectionner un fichier",
            supprimerZohoLinkbulkSms: "Bulk SMS",
            sendBulkSmsCustomers: "Envoyez des SMS en masse à vos clients",
            writeYourMessage: "Écrivez votre message ici",
            sendSms: "Envoyer un SMS",
            sendSmsYourCustomers: "Envoyez des SMS à vos clients",
            manageChannelDetail: "Gérer les informations relatives au canal",
            details: "Détails",
            teamGramChannels: "Canaux TeamGram",
            newTeamGramIntegration: "Nouvelle intégration TeamGram",
            teamGramIntegration: "Intégration du TeamGram",
            notMoreThanOneTeamGramChannels: "Vous ne pouvez pas créer plus d'un canal TeamGram",
            teamGramDetail: "Détail du TeamGram",
            manageYourTeamGramIntegration: "Gérer votre intégration TeamGram",
            trendyolChannels: "Canaux Trendyol",
            trendyolStoreIntegration: "Intégration de la boutique Trendyol",
            trenyolStoreConnection: "Connectez votre magasin Trendyol",
            deleteTrendyolIntegration: "Supprimer l'intégration Trendyol",
            sureDeleteTrendyolIntegration:
                "Êtes-vous sûr de vouloir supprimer l'intégration Trendyol ? Cette action est irréversible",
            trendyolStoreChannel: "Canal du magasin Trendyol",
            deleteTrendyolChannel: "Supprimer le canal Trendyol",
            channelUpdatedSucs: "Canal mis à jour avec succès",
            failedUpdateChannel: "Échec de la mise à jour du canal",
            trendyolStoreIntegrationDetail: "Détail de l'intégration de la boutique Trendyol",
            configureTrendyolStoreIntegrationDetail: "Configurez votre intégration dans la boutique Trendyol",
            trenyolStoreProductQuestManage: "Boutique Trendyol - Gestion de la quête de produit",
            trendyolStoreDesc:
                "Vous pouvez utiliser les paramètres suivants pour gérer les demandes de renseignements sur les produits de la boutique Trendyol",
            zohoCrmChannels: "Canaux Zoho CRM",
            zohoPersonalChannel: "Canaux Zoho Personal",
            connectZoho: "Se connecter à Zoho CRM",
            updateChannelDesc5: "Mise à jour du canal Zoho CRM",
            zohoCrmIntegration: "Intégration Zoho CRM",
            sureDeleteZohoChannel: "Êtes-vous sûr de vouloir supprimer le canal Zoho CRM ?",
            createNotMoreThanOneZohoChannels: "Vous ne pouvez pas créer plus d'un canal Zoho",
            removeZohoLink: "Supprimer le lien Zoho",
            connectToZoho: "Se connecter à Zoho",
            chatClosed: "Chat fermé",
            scoreChat: "Chat marqué",
            createdTicket: "Ticket créé",
            updatedTicket: "Ticket mis à jour",
            newUserCreated: "Nouvel utilisateur créé",
            updateUser: "Utilisateur mis à jour",
            deleteUsers: "Utilisateur supprimé",
            changeStatusRepresent: "Le statut du représentant a changé",
            incomingMessage: "Message entrant",
            outgoingMessage: "Message sortant",
            createdNewTicket: "Nouveau ticket créé",
            bitrix24Channels: "Canaux Bitrix24",
            sureDeleteBitrixChannel: "Êtes-vous sûr de vouloir supprimer le canal Bitrix24 ?",
            bitrix24Integrations: "Intégration Bitrix24",
            notCreateMoreThenOneChannel: "Vous ne pouvez pas créer plus d'un canal Ideasoft",
            connectToBitrix24: "Se connecter à Bitrix24",
            connectToBitrix24Api: "Se connecter à l'Api Bitrix24",
            updateChannel: "Canal de mise à jour",
            updateChannelDesc: "Mettre à jour le canal de l'Api Bitrix24",
            yourBitrix24Domain: "Votre nom de domaine Bitrix24",
            bitrix24ConnectedSucs: "Bitrix24 s'est connecté avec succès",
            failedToConnectBitrix24: "Échec de la connexion à Bitrix24",
            channelCreatedSuccessfully: "Canal créé avec succès",
            failedToCreateChannel: "Échec de la création d'un canal",
            holidayPlusChannels: "Canaux vacances+",
            newHolidayPlusIntegration: "Nouvelle intégration Holiday+",
            holidayPlusIntegrations: "Intégration Holiday+",
            notCreateMoreThanOneHolidayChannel: "Vous ne pouvez pas créer plus d'un canal Holiday+",
            holidayPlusDetail: "Détail vacances+",
            manageHolidayPlusIntegration: "Gérer votre intégration Holiday+",
            ideasoftChannels: "Canaux Ideasoft",
            connectToIdeasoft: "Se connecter à Ideasoft",
            connectToIdeasoftApi: "Se connecter à l'api Ideasoft",
            updateChannelDesc2: "Mettre à jour le canal Whatsapp business api",
            ideasoftIntegration: "Intégration Ideasoft",
            sureDeleteIdeasoftChannel: "Êtes-vous sûr de vouloir supprimer le canal Ideasoft ?",
            moreThanOneChannelError: "Vous ne pouvez pas créer plus d'un canal Ideasoft",
            websiteAddress: "Adresse du site web",
            ideasoftConnectedSucs: "Ideasoft s'est connecté avec succès",
            failedToConnectIdeasoft: "Échec de la connexion à Ideasoft",
            redirectURLcopiedToClipboard: "URL de redirection copiée dans le presse-papiers",
            openAIChannels: "Ouvrir des canaux d'IA",
            newOpenAiChannel: "Nouveau canal OpenAI",
            createNewChannelOpenAi: "Créer un nouveau canal pour OpenAI",
            updateChannelDesc3: "Mettre à jour le canal Whatsapp business api",
            openAiIntegration: "Intégration de l'OpenAI",
            sureDeleteOpenAiChannel: "Êtes-vous sûr de vouloir supprimer le canal OpenAI ?",
            createMoreThenOneOpenAiChannel: "Vous ne pouvez pas créer plus d'un canal OpenAI",
            postaCellChannels: "Canaux PostaCell",
            newPostaCellChannel: "Nouveaux canaux PostaCell",
            createNewPostaCellChannel: "Créer un nouveau canal pour le fournisseur de sms PostaCell",
            updateChannelDesc4: "Mettre à jour le canal Whatsapp business api",

            accessControl: "Contrôle d'accès",
            leads: "Pistes",
            ensureFacebookAccount: "S'assurer d'avoir un compte et une page Facebook",
            ensureAdAccount: "S'assurer d'avoir un compte publicitaire",
            page: "Page",
            leadCount: "Nombre de prospects",
            showLeads: "Afficher les pistes",
            syncLeeds: "Synchroniser Leeds",
            wpStartChat: "Lanceur de chat Whatsapp",
            archivedIn: "Archivé ?",
            makeSelect: "Effectuer une sélection",
            newLead: "Nouveau Leed",
            initalContact: "Premier contact",
            needsAssessnment: "Analyse des besoins",
            proposalSent: "Offre envoyée",
            proposalReview: "Examen de la proposition",
            negotiation: "Négociation",
            decisionStage: "Phase de décision",
            closure: "Kanapnış",
            followUp: "Suivre",
            campagin: "Campagne",
            adSet: "Ensemble d'annonces",
            ad: "Annonce",
            inArchived: "Archivé",
            deletedSelectedPerson: "Supprimer les personnes sélectionnées",
            sureDelSelectedPerson: "Êtes-vous sûr de vouloir supprimer les personnes sélectionnées ?",
            deletePerson: "Supprimer la personne",
            sureDeletePerson: "Êtes-vous sûr de vouloir supprimer la personne ?",
            phoneNumberNotAvailable: "Numéro de téléphone non disponible",
            statusSucsUpdated: "Statut mis à jour avec succès",
            statusUpdatedFailed: "Une erreur s'est produite lors de la mise à jour du statut",
            archivedContact: "Contact archivé",
            sureWantArchivePerson: "Êtes-vous sûr de vouloir archiver cette personne ?",
            personArchived: "Personne archivée",
            personArchivedHead: "L'opération d'archivage a échoué",
            metaLeadChannels: "Meta Lead Channels",
            wpStartSpeech: "Démarrage du discours Whatsapp",
            pleaseSelectStartChat: "Veuillez sélectionner le canal sur lequel vous souhaitez démarrer la discussion :",
            phoneNumber: "Numéro de téléphone",
            phoneNumberDesc: "Code pays avec uniquement des chiffres sans espaces",
            channelDesc: "Sur quel canal voulez-vous commencer le chat ?",
            pleaseSelectStartChatOn: "Veuillez sélectionner le canal sur lequel vous souhaitez démarrer le chat",
            notAuthorisedChannel: "Vous n'êtes pas autorisé à accéder à ce canal",
            phoneNumberError: "Numéro de téléphone incorrect",
            chatStartError: "Une erreur s'est produite lors du démarrage du chat. Veuillez réessayer",
            noRecordFailed: "Aucun enregistrement n'a été trouvé",
            metaLeadsChannel: "Canal Meta Leads",
            mlChannelDetails: "Détails du canal Meta Leads",
            manageMlChannel: "Gérer vos Meta Leads",
            deleteMetaLeadsChannelInfo: "Êtes-vous sûr de vouloir supprimer le canal Meta Leads?",
            contactPage: "Page de Contact",
            addRouted: "Ajouter l'acheminement",
            otherEmailProviders: "Autres fournisseurs de courrier électronique",
            visitorScreenNaming: "Nommage de l'écran du visiteur",
            enterCatalogTitle: "Entrez le titre du catalogue...",
            passwordUpdate: "Mise à jour du mot de passe",
            showCenterScreen: "Affichage au centre de l'écran",
            skipNow: "Sauter maintenant",
            confirm: "Confirmer",
            newTable: "Nouvelle table",
            actions: "Transaktionen",
            integrationsTrendyol:
                "Connectez votre boutique Trendyol et répondez automatiquement aux questions de vos clients.",
            integrationsHoliday: "Intégrez Holiday+ pour fournir des hôtels et des chambres via chatbot !",
            integrationsTeamgram:
                "Transférez vos clients de Supsis vers Teamgram pour simplifier la gestion de vos clients !",
            integrationsTicimax: "Envoyez un message automatisé aux membres segmentés de Ticimax.",
            integrationsBitrix24: "Activez l'API Bitrix24 pour une expérience chatbot améliorée pour vos clients.",
            integrationsIdeasoft: "Activez l'API Ideasoft pour une expérience chatbot améliorée pour vos clients.",
            integrationsOpenAI:
                "Activer les services OpenAI, Réponse d'IA Chatbot, Assistant IA CoPilot, Base de connaissances IA Chatbot.",
            integrationsSMSPostacell: "Activez l'envoi de SMS via le fournisseur de SMS PostaCELL.",
            integrationsMetaLeads:
                "Gérez vos prospects Meta via Supsis. Connectez les leads aux tickets, au chatbot ou au support en direct.",
            integrationsZoho: "Intégrez vos processus d'affaires dans Zoho CRM avec Supsis.",

            forward: "avant",
            packUpRequired: "Mise à niveau du paquet nécessaire",
            upgradePack: "Paquet de mise à niveau",
            supsisMobilApp: "SUPSIS MOBIL APP",
            supsisMobilAppDesc: "Application IOS et Android sur le marché !",
            sendEmail: "Envoyer un courriel",
            jumpToMessage: "Cliquez pour accéder au message",
            doesntMatter: "Peu importe",
            events: "Calendrier des événements",
            reservations: "Réservations",
            designer: "Designer",
            targetContacts: "Contacts cibles",
            scheduler: "Planificateur",
            planAndTask: "Planification et tâches",
            insights: "Aperçus",
            createRole: "Créer un rôle",
            createSubject: "Créer un sujet",
            createUser: "Créer un utilisateur",
            blockManuel: "Bloc Manuel",
            showHide: "afficher/masquer",
            contactSearch: "Recherche de contact",
            favorites: "favoris",
            downloadAllData: "télécharger toutes les données",
            downloadThePage: "Télécharger la page",
            choosePoints: "choisissez des points",
            createdAt: "Créé À",
            action: "Actions",
            searchChannel: "Canaux de Recherche",
            activeChannels: "Canaux Actifs",
            deleteChannels: "Chaînes Supprimées",
            selectChannel: "Sélectionnez le Canal",
            channelFilter: "Filtre de Canal",
            noConversationDesc: "Ici, vous pouvez voir les chats actifs et les chats qui vous sont attribués.",
            forMe: "Pour moi",
            unAssigned: "Non attribué",
            agentDetails: "Détails de l'agent",
            contactProperties: "Propriétés de contact",
            goToProfile: "Aller au profil",
            addNote: "Ajouter une note",
            noPreferredAgent: "Pas encore d'agent préféré",
            toPrefer: "Préférer",
            inChat: "Dans la discussion",
            watching: "Regarde",
            chatsTitle: "Discussions",
            dealyTimeMaxValueError: "Le temps de retard peut être de 15 au maximum",
            dealyTimeTypeError: "La valeur du temps de retard doit être un nombre",
            passedTimeHm: "{hour} Heures {min} Minutes",
            passedTimeMs: "{min} Minutes {sec} secondes",
            passedTimeSc: "{sec} Secondes",
            translateMessage: "Votre message a été traduit par l'intelligence artificielle.",
            toneChanged: "Le ton du message a été changé en {tone}",
            aiResponseAdded: "Réponse de l'IA ajoutée au message",
            messageLonger: "Message rendu plus long",
            grammarFixed: "Grammaire corrigée",
            aiTranslate: "Traduction",
            other: "Autre",
            yourLanguage: "Votre langue",
            contactLanguage: "langue du client",
            myLanguage: "Ma langue",
            forwardToChatbot: "Transférer au Chatbot",
            friendly: "Amical",
            confident: "Confiant",
            straightForward: "Direct",
            casual: "Décontracté",
            professional: "Professionnel",
            longSentence: "Longue Phrase",
            changeTone: "Changer de Ton",
            fixGrammar: "Corriger la Grammaire",
            aiResponse: "Réponse de l'IA",
            templateButtonNote:
                "Pour interdire le contact, utilisez les textes suivants sur le bouton de bannissement. Indépendamment des lettres majuscules ou minuscules",
            templateButtonTags: "#Envoyer un message# | #Se désabonner# | #Bannir# | #Bloquer#",
            dashboard: "Tableau de bord",
            calendarModule: "Module de calendrier",
            taskModule: "Module de gestion des tâches",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "Aucun département préféré",
            searchForDepartment: "Rechercher un département",
            departmentAssignedToTheVisitor: "Sélectionnez le département que vous souhaitez attribuer au visiteur.",
            assignPreferredDepartment: "Attribuer un département préféré",
            smsChannel: "Canal SMS: ",
            whatsappv2Channel: "Canal Whatsapp V2: ",
            whatsappv1Channel: "Canal Whatsapp V1: ",
            wBChannel: "Canal Whatsapp Business: ",
            messengerChannel: "Canal Messenger: ",
            instagramChannel: "Canal Instagram: ",
            allPlatforms: "Toutes les plateformes",
            cbStartMessage: "Message de démarrage du chatbot",
            cbStartMessageDesc:
                "Le premier message saisi par l'utilisateur est automatiquement traité par le chatbot et dirigé vers l'adresse correspondante.",
            messengerUserProfile: "Profil utilisateur Messenger",
            instagramUserProfile: "Profil utilisateur Instagram",
            noEventFound: "Aucun événement trouvé",
            visitorMails: "Mails des visiteurs",
            visitorActions: "Actions des visiteurs",
            notVerified: "Non vérifié",
            visitorEvents: "Événements des visiteurs",
            assignedTasks: "Tâches assignées",
            mails: "Courriels",
            prefferedAgents: "Agents préférés",
            createEvent: "Créer un événement",
            blockManagement: "Gestion des blocs",
            deleteUser: "Supprimer l'utilisateur",
            blocked: "Bloqué",
            profiles: "Profils",
            similiarProfiles: "Profils similaires trouvés",
            ReplyAsAPm: "Répondre en tant que message privé et fermer",
            replyAsAComment: "Répondre en tant que commentaire et fermer",
            messengerAddDesc:
                "Cliquez sur le bouton Se connecter ci-dessous et connectez-vous à votre compte Facebook.",
            instaAddPrivacyCheckDesc: "J'ai lu et j'accepte la {Privacy} et les {Terms and Conditions}",
            instaAddDesc5: "Cliquez sur le bouton Se connecter ci-dessous et connectez-vous à votre compte Facebook.",
            instaAddDesc4: "Inscrivez-vous en tant que développeur Facebook",
            instaAddDesc3: "Assurez-vous que le commutateur <b>'Autoriser l'accès aux messages'</b> est activé",
            instaAddDesc2: "Assurez-vous que votre compte professionnel Instagram est connecté à votre page Facebook",
            instaAddDesc1:
                "Assurez-vous que votre compte Instagram est un compte Instagram professionnel (compte professionnel).",
            selectedDepartment: "Département sélectionné",
            departmentForwardEnable: "Règle de transfert de département activée",
            departmentForwardRule: "Règle de transfert de département",
            departmentForwardDesc:
                "Sélectionnez vers quel département les chats entrants seront redirigés dans le canal.",
            channelName: "Nom de la chaîne",
            forwardToLiveAgents: "👉 Transférer aux agents en direct",
            manageIgChannel: "Gérez votre chaîne Instagram",
            igDetail: "Détail Instagram",
            manageVisibilityDesc: "Gérer qui peut voir ce canal",
            selectAnIgAccount: "Sélectionnez un compte Instagram",
            connectToInsta: "Se connecter à Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Êtes-vous sûr de vouloir supprimer le canal Instagram?",
            instagramChannels: "Chaînes Instagram",
            suspendedDescription: "Votre compte a été suspendu en raison de factures impayées",
            onlyChatbot: "Uniquement le chatbot",
            onlyAgents: "Uniquement les agents",
            checkboxWarning: "Ce champ doit être obligatoirement coché",
            sendingAllow: "Envoi",
            receiving: "Réception",
            platform: "Plateforme",
            banModalTitle: "Fenêtre modale d'interdiction de visiteur",
            selectDepartmentDesc: "Sélectionnez les départements dont vous souhaitez modifier la visibilité",
            selectAgentDesc: "Sélectionnez les agents dont vous souhaitez modifier la visibilité",
            selectDepartment: "Sélectionner le département",
            selectAgent: "Sélectionner l'agent",
            visibleDepartments: "Départements visibles",
            visibleAgents: "Agents visibles",
            visibilityInfoCont: "Tous les agents et départements peuvent voir ce canal",
            editDepartmentVisibility: "Modifier les permissions du département",
            editAgentVisibility: "Modifier les permissions de l'agent",
            typeSTToSearch: "Tapez quelque chose pour rechercher des utilisateurs",
            exportToCSV: "Exporter vers CSV",
            clear: "Effacer",
            usedSessionCount: "Nombre de sessions utilisées",
            maxSessionCount: "Nombre maximum de sessions",
            leftSessionCount: "Nombre de sessions restantes",
            planManagement: "Gestion des plans",
            maxAutomationTask: "Nombre maximum de tâches d'automatisation",
            teamChat: "Chat d'équipe",
            templateNameIsNotValid: "Le nom du modèle n'est pas valide",
            relatedAdvertisement: "Publicité connexe",
            whatsappNumber: "Numéro WhatsApp",
            integrationsWhatsappV1:
                "Un plan WhatsApp est nécessaire pour une communication sans problème entre Supsis et WhatsApp.",
            integrationsWhatsappV2:
                "Vous pouvez facilement partager des informations de chat entre Supsis et WhatsApp.",
            integrationsWhatsappBusiness:
                "Vous pouvez transmettre rapidement et facilement des informations de chat entre Supsis et WhatsApp.",
            selectDays: "Sélectionner les jours",
            addTime: "Ajouter du temps",
            instagramContactList: "Liste de contacts Instagram",
            archiveAllRated: "Récupérer toutes les conversations avec des évaluations.",
            allChannels: "toutes les chaînes",
            comment: "commentaire",
            news: "Quoi de neuf ?",
            conversation: "conversation d'équipe",
            speechTermination: "mettre fin à la conversation",
            noSystemMessage: "Il n'y a pas encore de messages dans le système!",
            supsisCustomerService: "Services à la clientèle fournis par Supsis,",
            supsisClickExperience: "Vous pouvez tenter l'expérience en cliquant.",
            customerPage: "Aller à la page client",
            buttonTitle: "Titre du bouton",
            buttonType: "Type de bouton",
            buttonSendMessage: "envoyer le message",
            buttonGoToBlock: "aller sur le blog",
            buttonOpenUrl: "Ouvrir le lien",
            buttonPhoneCall: "Appel téléphonique",
            buttonOpenMoment: "Moment ouvert",
            buttonCloseChat: "Fermer la discussion",
            buttonTransferChat: "Transférer la conversation",
            buttonCreateTicket: "Créer un billet",
            deleteVisitor: "Voulez-vous vraiment supprimer l'utilisateur ? Cette action ne peut pas être annulée.",
            userProfile: "Profil",
            addCalendarEvent: "Événement +",
            you: "Toi",
            and: "et",
            apiIntegration: "Développeur",
            generateToken: "Générer le jeton",
            copyToken: "Copier le jeton",
            dndBlocked: "Fichier d'envoi des paramètres désactivés.",
            labels: "Étiquettes",
            noData: "Pas de données",
            color: "Couleur",
            titleColor: "Couleur du titre",
            secondTitleColor: "Couleur du deuxième titre",
            tag_name_indicator: "Nom de l'étiquette",
            sendMessage: "Envoyer message",
            removeFromG: "Retirer du groupe",
            delChannel: "Êtes-vous sûr de vouloir supprimer ce canal ?",
            new_name: "Nouveau nom",
            set_group_info: "Éditer les informations de groupe",
            shortcut_desc_num: "Passez d'une conversation active à l'autre avec des chiffres numériques",
            copilot_desc_num: "Vous permet d'ouvrir Copilot sur l'écran de discussion",
            typing_w_chat: "il écrit...",
            edit_group_info: "Modifier les informations du groupe",
            notif_sound: "Activer les sons de notification",
            notif_mute: "Mettre les notifications en mode silencieux",
            leave: "Quitter",
            group: "Groupe",
            updateTag: "Mettre à jour l'étiquette",
            ordered_desc: "Attribue les chats aux représentants dans l'ordre.",
            random_desc: "Attribue les chats aux représentants de manière aléatoire.",
            Rrobin_desc:
                "Attribue les chats aux représentants de manière circulaire. (Priorité aux représentants moins occupés)",
            RrobinRev_desc:
                "Attribue les chats aux représentants de manière circulaire inversée. (Priorité aux représentants les plus occupés)",
            algo_desc: "Sélectionnez l'algorithme pour l'attribution automatique des chats",
            algorithm: "Algorithme",
            os_browser: "Système d'exploitation et navigateur",
            CHAT: "Discuter",
            addTag: "Ajouter une étiquette",
            tags: "Mots clés",
            searchRepresentative: "Rechercher un représentant",
            voting: "Vote",
            chatWidget: "Widget de chat en soupise",
            webhooks: "Webhooks",
            selectHooks: "Sélectionnez des crochets Web",
            planRequired: "{intégraable} plan requis",
            allIntegrations: "Toutes les intégrations",
            disableAgentSystemMessages: "Masquer les messages du système d'agent",
            disableAgentSystemMessagesDesc: "Masquer les messages du système de l'agent.",
            disableAutoTranslate: "Traduction automatique",
            disableAutoTranslateDesc:
                "Traduit automatiquement les messages de différentes langues. Vous pouvez ainsi communiquer plus facilement avec vos clients.",
            shouldAddMethod:
                "Vous devez remplir le champ Mode de paiement et adresse de facturation !\n Aucun argent ne sera retiré de votre compte. \n" +
                "À la fin du mois, une facture sera créée en fonction de votre consommation.",
            approveSelection: "Approuver la sélection",
            trialDaysEndSelectPlan: "Confirmer la sélection du plan",
            trialDaysEndSelectPlanDesc:
                "Votre version d'essai est terminée. Vous devez confirmer en sélectionnant le plan ci-dessous.",
            infoAboutAnnouncement: "Brèves informations sur l'annonce",
            announcement: "Annonce",
            newAnnouncementForm: "Nouveau formulaire d'annonce",
            newAnnouncement: "Nouvelle annonce",
            announcements: "Annonces",
            newTicketSound: "Nouveau billet",
            vtippyDepartmentNotification:
                "Paramètres de notification pour les messages de la conversation du département",
            vtippyGroupNotification: "Paramètres de notification pour les messages des groupes créés",
            vtippyTicketNotification: "Paramètres de notification pour chaque nouveau ticket que vous recevez",
            vtippyAnnouncemenNotification: "Paramètres de notification pour les nouvelles annonces",
            languageSelection: "Sélection de la langue",
            announcementTitle: "Titre d'annonce",
            infinitePlay: "Jouer en continu",
            hideBubbleOnMobile: "Cacher sur mobile",
            vtippyHideBubbleOnMobile: "Chat Bubble est caché aux utilisateurs mobiles.",
            deleteSystemLanguage: "Supprimer la langue {code} du système",
            assignedChat: "Chat assigné",
            check: "Cocher",
            systemStatus: "État du système",
            chatAssignedToUser: "Nouveau chat attribué",
            inactiveThresholdTime: "Temps de chat inactif (minute)",
            tippyInactiveThresholdTime:
                "Si aucun message n'est envoyé dans le délai donné, la conversation est considérée comme inactive. Entrez la valeur (minutes). Doit être de plage en 1 min - 120 minutes.",
            inactiveTerminateTime: "Durée du chat inactif (minute)",
            tippyInactiveTerminateTime:
                "Le chat inactif sera terminé s'il ne passe pas en mode actif dans un certain temps. Entrez la valeur (minutes). Doit être de plage en 1 min - 120 minutes.",
            removePendingMessage: "Annuler l'envoi du message",
            disconnected: "Débranché",
            visitorWriteEmptyChatTippy: "Le client peut écrire dans la conversation avant que l'agent ne se connecte.",
            visitorWriteEmptyChat: "Le client peut écrire sans l'agent connecté.",
            visitorConnectionEventSystemMessageEnabled:
                "Les messages du système d'état de connexion du visiteur activent",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Les messages du système de retour du visiteur et du visiteur permettent",
            openBubble: "Bulle ouverte",
            showHeaderImage: "Afficher l'image d'en-tête",
            askQuestion: "poser une question",
            locationPermsNeeded:
                "Des autorisations de localisation sont nécessaires pour utiliser cette fonctionnalité",
            useMyLocation: "Utilise ma location",
            acceptingChat: "Accepter les chats",
            notAcceptingChat: "Ne pas accepter les chats",
            blockBy: "Interdit par",
            languageRemovalQuestion: "Vous êtes sur le point de supprimer la langue {code} du système!",
            loggedOut: "Déconnecté",
            vtippyNewVisitorNotification: "Notification audible pour chaque nouveau visiteur sur votre site Web",
            vtippySelectnotification: "Vous pouvez choisir le son de notification.",
            vtippyVoiceLevel: "vous pouvez ajuster le volume",
            vtippyStartVoice: "Écouter",
            vtippyInfiniteNotification:
                "Si vous n'êtes pas actif dans le nouveau panneau Chats, il continuera de jouer. Vous pouvez modifier actif-passif en cliquant.",
            vtippyTranslateButton: "Traduit la langue sélectionnée vers d'autres langues",
            vtippyTranslateClearButton: "Nettoie le contenu dans d'autres langues.",
            vtippyNewChatNotification:
                "Vous pouvez sélectionner une notification sonore pour les nouvelles conversations à venir dans le système et ajuster le volume.",
            vtippyNewConversationNotification:
                "Vous pouvez choisir une notification sonore et ajuster le volume lorsque de nouvelles conversations entrantes vous sont attribuées.",
            vtippyNewMessageNotification:
                "Vous pouvez sélectionner des notifications pour les messages entrants à vos conversations et ajuster le volume.",
            vtippyPrivateMessageNotification:
                "Vous pouvez sélectionner une notification pour le message entrant à l'équipe.",
            hideInactiveAgents: "Masquer les agents inactifs",
            hideMinorValues: "Masquer les valeurs mineures",
            hashHintMessage: "Vous pouvez rapidement entrer des raccourcis hashtag avec #hash",
            pmHintMessage: "Saviez-vous que vous pouvez envoyer un message clé privé ?. par exemple PM: salut",
            shortcutHintMessage:
                "Saviez-vous que vous pouvez envoyer des messages plus rapidement avec des messages de raccourci?",
            switchBetweenConversations:
                "Saviez-vous que vous pouvez rapidement basculer entre les conversations avec les raccourcis ABC?",
            atNameHintMessage: "Saviez-vous que vous pouvez rapidement saisir le nom du visiteur avec @name?",
            dndHintMessage: "Vous pouvez télécharger des fichiers avec glisser-déposer.",
            pasteFile: "vous pouvez envoyer des fichiers.",
            atEmailHintMessage: "Saviez-vous que vous pouvez rapidement saisir le courrier des visiteurs avec @mail?",
            pastePlainText: "Coller du presse-papiers comme texte brut",
            pressAndTalk: "Press and talk",
            agentActivities: "Activités d'agent",
            listStatuses: "Statuts",
            newHASHContent: "#Add Hash",
            hash: "Hashtag",
            hashText: "Texte de hachage",
            exampleHash: "suivi de commande",
            notValidHash: "Ne doit pas contenir d'espaces.",
            websiteChatWidgetIntegration: "Intégration du widget de chat de site Web",
            videoCallEnabledDesc: "Activez pour activer la fonction d'appel vidéo.",
            videoCallEnabled: "Fonction d'appel vidéo",
            audioCallDesc: "Activez pour activer la fonction de recherche vocale.",
            audioCallEnabled: "Fonctionnalité de recherche vocale",
            assignPreferredAgent: "Agent préféré",
            representativeAssignedToTheVisitor:
                "Sélectionnez l'agent préféré que vous souhaitez attribuer au visiteur.",
            agentFileSendEnabledDesc: "Permet la possibilité d'envoyer des fichiers aux délégués",
            agentFileSendEnabled: "Les représentants peuvent soumettre des fichiers",
            visitorFileSendEnabledDesc:
                "Vous permet de tourner la fonction d'envoi de fichiers visiteurs activé ou désactivé",
            visitorFileSendEnabled: "Les visiteurs peuvent soumettre des fichiers",
            visitorAutoLogin: "Connexion automatique des visiteurs",
            visitorAutoLoginDesc: "Conversation de démarrage automatique lorsque le visiteur clique sur Bubble de chat",
            agentVoiceRecordEnabledDesc: "Permet aux agents d'enregistrer l'audio",
            agentVoiceRecordEnabled: "Les agents peuvent enregistrer l'audio",
            visitorVoiceRecordEnabledDesc: "Permet aux visiteurs d'enregistrer l'audio",
            visitorVoiceRecordEnabled: "Les visiteurs peuvent enregistrer l'audio",
            startVideoCall: "Appel vidéo",
            startAudioCall: "Appel vocal",
            visitorGDPRDeleteEnabledDesc:
                "Vous permet de basculer la possibilité de supprimer toutes les informations des visiteurs",
            visitorGDPRDeleteEnabled: "Les visiteurs peuvent supprimer toutes leurs informations",
            visitorLocationEnabled: "Les visiteurs peuvent partager l'emplacement",
            visitorLocationEnabledDesc: "Permet aux visiteurs de tourner ou désactiver le partage de l'emplacement",
            customerLocationEnabled: "Les représentants peuvent partager l'emplacement",
            customerAutoMergeEnabled: "Fusionne automatiquement les mêmes personnes",
            customerAutoMergeEnabledDesc:
                "Cette fonctionnalité effectue une fusion automatique pour regrouper de manière efficace les données liées aux mêmes personnes. Cela garantit une représentation plus cohérente et ordonnée des utilisateurs ayant des profils similaires dans les ensembles de données.",
            chatAiCopilot: "Copilote de discussion IA",
            chatAiCopilotDesc:
                "Répondez automatiquement aux questions de vos clients en utilisant le Copilote de discussion IA",
            customerLocationEnabledDesc:
                "Permet aux représentants de tourner ou désactiver le partage de l'emplacement",
            thoesNotOwners: "Maintenir les personnes qui ne sont pas propriétaires dans la file d'attente",
            thoesNotOwnersDesc:
                "Vous activez cette fonction pour maintenir dans la file d'attente les personnes qui ne sont pas propriétaires de la conversation",
            hideContactInfo: "Cacher les informations de contact",
            hideContactInfoDesc:
                "Lorsque vous activez cette fonctionnalité, les numéros et les courriels de vos clients sont cachés aux agents",
            triggerAlreadyExists: "Le déclencheur existe déjà",
            ticketStatusForm: "Formulaire de statut de ticket",
            statusFormTitle: "Titre de l'état du billet",
            allStatus: "Tous les statuts",
            triggers: "Déclencheurs",
            trigger: "Déclencher",
            noTrigger: "Vous n'avez pas encore ajouté de déclencheurs",
            triggerSkipLoginForm: "Formulaire de connexion",
            triggerSkipLoginFormTrue: "Afficher le formulaire de connexion",
            triggerSkipLoginFormFalse: "Passer le formulaire de connexion et aller directement au message",
            noContent: "Pas de contenu",
            toCreate: "Créer",
            clickTheButton: "cliquez sur le bouton",
            triggerContent:
                "Tapez la description que vous souhaitez apparaître dans le modal qui s'ouvre. Il vous suffit d'écrire dans une seule langue et la traduction dans d'autres langues est effectuée automatiquement.",
            triggerDrag: "Vous pouvez ajuster la durée du message en faisant glisser ou en cliquant sur la barre.",
            triggerNewCondition: "Vous pouvez ajouter une nouvelle condition avec le bouton.",
            triggerNoConditionDescription1:
                "Vous pouvez créer les conditions que vous souhaitez à partir des options. Si vous ne créez aucune condition pour un déclencheur, le premier déclencheur sera actif.",
            triggerNoConditionDescription2:
                "Un seul des déclencheurs avec les mêmes conditions apparaît sur la page des visiteurs.",
            triggerShowAndHide: "Vous pouvez afficher ou masquer des déclencheurs quand vous le souhaitez.",
            countryLanguage: "Pays/Langue",
            addTrigger: "Ajouter la déclencheur",
            yesPlease: "Oui s'il te plaît!",
            noThanks: "Non merci.",
            firstAnswer: "Question Dialogue Confirmer Réponse",
            secondAnswer: "Question Dialogue Rejet Réponse",
            noTitle: "Pas de title",
            sumChat_MediaFile: "Médias et documents",
            importantWarning: "AVERTISSEMENT IMPORTANT!",
            images: "Images",
            URLS: "Liens",
            files: "Dossiers",
            noCondition: "Aucune condition! Vous pouvez ajouter des conditions en cliquant sur l'icône Plus.",
            showTriggers: "Cliquez pour afficher les déclencheurs",
            showThisTrigger: "Cliquez pour afficher ce déclencheur",
            hideTriggers: "Cliquez pour masquer les déclencheurs",
            hideThisTrigger: "Cliquez pour masquer ce déclencheur",
            updateTrigger: "Mettre à jour le déclencheur",
            conditions: "Conditions",
            messageDurationPerRow: "Durée du message par ligne",
            updateCompleted: "Mise à jour terminée",
            CatalogUpdatedSuccessfully: "Catalogue mis à jour avec succès",
            integrateSupsiswithIntegratable:
                "Passez facilement les informations de chat entre le Supsis et {integratable}.",
            installationOK: "installée",
            dayTime: "Heure",
            weekDay: "Jour de la semaine",
            spendTimePage: "Passé du temps sur la page",
            spendTimeSite: "Passé du temps sur place",
            pageUrl: "L'URL de la page",
            pageTitle: "Titre de la page",
            equal: "Égal",
            not_equal: "Inégal",
            less_than: "Moins que",
            greater_than: "Plus grand que",
            less_than_or_equal: "Moins ou égal",
            greater_than_or_equal: "Meilleur que ou égal",
            visitorName: "Nom du visiteur",
            seconds10: "10 secondes",
            seconds30: "30 secondes",
            minute1: "1 minute",
            minutes5: "5 minutes",
            minutes10: "10 minutes",
            minutes30: "30 minutes",
            hour1: "1 heure",
            hours2: "2 heures",
            hours4: "4 heures",
            hours8: "8 heures",
            hours12: "12 heures",
            hours24: "24 heures",
            maxCondition: "Condition maximale",
            doYouWishToDeleteTrigger: "Souhaitez-vous supprimer le déclencheur",
            contains: "Contient",
            not_contains: "Ne contient pas",
            chatLanguage: "Langue de chat",
            translating: "Traduction en cours",
            buyWhatsapp: "Acheter l'intégration WhatsApp",
            liveSupportStartingWait: "Commencer le soutien en direct, veuillez patienter",
            noConnection: "Pas de connection!",
            integrations: "Intégrations",
            refundInvoiceSure: "Êtes-vous sûr de vouloir retourner la facture?",
            invoiceMarkedAsPaidSuccess: "La facture a marqué comme payé avec succès",
            invoiceMarkedAsPaidError: "Erreur, la facture n'a pas marqué",
            deleteConfirm: "Voulez-vous supprimer ce {object}?",
            markPaidConfirm: "Êtes-vous sûr de Mark comme payé cette facture?",
            addLink: "Lien",
            startChatDesc: "Commencer la conversation",
            selectStep: "Sélectionnez une étape:",
            addGOTO: "Aller à",
            sendFastLink: "Envoyer un lien rapide",
            or: "Ou",
            allTags: "Toutes les balises",
            showDetail: "Montrer les détails",
            hideDetail: "Masquer les détails",
            weLlSendPhone: "Nous enverrons à votre téléphone",
            weLlSendEmail: "Nous enverrons à votre e-mail",
            linkSentToPhone: "Lien envoyé comme SMS",
            offerlinkSendToPhone: "Nous vous enverrons le lien de téléchargement de notre application via SMS.",
            offerlinkSendToMail: "Nous vous enverrons le lien de téléchargement de notre application par e-mail.",
            theEmail: "Mon e-mail enregistré",
            differentEmail: "Un autre e-mail différent",
            linkSentToMailBox: "Le lien a été envoyé à votre adresse de courrier",
            errorOccurred: "Erreur est survenue !",
            clickStoreIcon:
                "Vous pouvez accéder à l'application mobile en cliquant sur l'icône adaptée à votre téléphone.",
            meetWithSupsis: "Souhaitez-vous rencontrer notre application mobile en Supsis?",
            downloadMobileApps: "Télécharger l'application mobile",
            getApps: "Obtenir des applications",
            info: "Information",
            conversationHistory: "Historique des conversations",
            planInfoHeader: "Planifier des informations",
            planInformation: "Votre plan est {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} agent libre)",
            creditAvailable: "Votre crédit d'agent disponible dans votre plan:",
            upDownGradePlan: "Si vous souhaitez mettre à niveau / rétrograder votre plan, veuillez",
            click: "Cliquez sur",
            autoStartChat: "Démarrage du chat automatique",
            bubbleColor: "Couleur de bulle de chat",
            openFolder: "Dossier ouvert",
            preDefined: "Thèmes",
            customIcon: "Installer à partir de votre ordinateur",
            theme: "Thème",
            themeSettings: "Réglage des thèmes",
            chatThemeSettings: "Paramètres du thème de discussion",
            bubbleSettings: "Paramètres de bulle de chat",
            inputHeightOfBubble: "Taille de bulle",
            inputPixelsOfChatBubble: "Cliquez pour modifier les distances de la bulle de chat sur les bords",
            modalTitleIsMarginAsPixelInfo: "Distances de la bulle de chat sur les bords:",
            inputPxOfXaxis: "Position horizontale",
            inputPxOfYaxis: "Position verticale",
            inputPxOfMobileXaxis: "(Mobil) position horizontale",
            inputPxOfMobileYaxis: "(Mobil) position verticale",
            animations: "Animations",
            preferredAnimation: "Animation préférée",
            selectAnAnimation: "Sélectionnez une animation",
            inputOfBubbleMessage: "Ajoutez du contenu à d'énormes bulles de discussion. \n {contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Il s'agit du paramètre pour masquer la bulle de chat en fonction de l'état de connexion.",
            showChatBubbleOnlyLoggedUser: "Afficher la bulle pour uniquement connectée à l'utilisateur. (Ideasoft)",
            helloDoUNeedHelp: "Salut, avez-vous besoin d'aide?",
            bubbleIcon: "Image de bulle de chat",
            overrideMargins: "Personnaliser les marges",
            autoHideBubble: "Hide Chat Bubble",
            vtippyAutoHideBubble: "Cache la bulle de chat lorsque les agents sont hors ligne",
            hideBubble: "Chat-Blase deaktivieren",
            vtippyHideBubble: "Deaktiviert die Chat-Blase.",
            overrideMobileMargin: "Personnaliser les marges pour mobile",
            vtippyMobileMargin: "Personnaliser les marges pour mobile",
            isFabsActive: "Afficher le bouton d'action flottante",
            isAlwaysActive: "Le menu est toujours ouvert",
            isAlwaysActiveDesc:
                "Souhaitez-vous que le menu de la bulle de discussion reste toujours ouvert dans la vue web ?",
            bubbleOpenableMenu: "Dropdown de Chat Bubble",
            vtippyIsFabsActive: "Réglage du bouton Afficher / masquer l'action flottante",
            vtippyIsFabsAsIcon:
                "C'est le réglage de la question de savoir si les icônes apparaîtront dans le menu déroulant.",
            isFabsAsIcon: "Afficher les icônes de menu.",
            setMarginAsPixel: "Définir en pixel",
            returnDefaultMargins: "Paramètres de marge par défaut",
            deleteSite: 'Voulez-vous supprimer le site "{siteName}"?',
            deleteThisSite: "Supprimer le site",
            assetOversizeWithExt: "La taille du fichier doit être inférieure à 10 Mo et en PNG, format JPG.",
            closeChat: "Messagerie finale",
            formStep: "Étape de forme",
            menuStep: "Étape du menu",
            contentStep: "Étape de contenu",
            menuTitle: "Titre de menu",
            messageContent: "Contenu du message",
            goToLive: "Transfert vers le représentant",
            prevStep: "Revenir à l'étape précédente",
            button: "Bouton",
            addImage: "Image",
            addText: "Texte",
            stepTitle: "Titre de pas",
            addTicket: "Billet",
            formDescription: "Question",
            addInput: "Question",
            addRandomText: "Texte aléatoire",
            calendarPassedTimeMinSec: "{min} minute {sec} seconde {nom}",
            calendarPassedTimeSec: "{hour} heure {min} minute {sec} seconde {name}",
            updateUserName: "Mettre à jour le nom d'utilisateur",
            forgotPassword: "Mot de passe oublié",
            osrFromMessageSaved: "Message hors ligne enregistré.",
            requiredField: "Ce champ est obligatoire.",
            nightModeOn: "Mode nocturne sur",
            catalogMenu: "Menu",
            catalogContent: "Contenu",
            all: "Tous",
            allDepartments: "Tous les départements",
            preferredLanguage: "langue préférée",
            kmkAutoDepartmentBind: "KMK Auto Depariment Find",
            kmkAutoDepartmentBindDesc:
                "Rechercher le vendeur sur les sites des clients KMK et réglé sur la page de connexion en tant que département",
            visitorEmailUpdated: "Courriel du visiteur mis à jour",
            visitorEmailIsNotValid: "Le courrier électronique des visiteurs n'est pas valide",
            visitorNameUpdated: "Nom du visiteur mis à jour",
            clickToEdit: "Cliquez pour modifier",
            addEmail: "+ Ajouter un e-mail",
            addFullname: "+ Ajouter FullName",
            partner: "Ref?",
            isIntegrated: "L'intégration?",
            agentCount: "Compte d'agent",
            closePreviewColors: "Fermer un aperçu du thème",
            previewColors: "Aperçu du thème ouvert",
            videoCalls: "Appels vidéo",
            filterLost: "Chats perdus",
            vtipyCustomLogin:
                "Vous pouvez personnaliser les informations qui seront demandées dans le formulaire de connexion lorsque vos visiteurs se connectent au système.",
            vtipyLoginlessChat:
                "Le formulaire de connexion des visiteurs sera caché. Le visiteur peut se connecter directement à discuter.",
            loginlessChat: "Formulaire de connexion",
            imageUrl: "URL de l'image",
            replied: "Répondu",
            solved: "Résolu",
            openImage: "Image ouverte",
            writeFeedback: "Vous pouvez rédiger vos commentaires sur le Supsis ici.",
            feedbackFailed: "Une erreur s'est produite lors de l'envoi de commentaires.",
            feedbackSuccessful: "Soumission de rétroaction réussie.",
            sendFeedback: "Envoyer des commentaires",
            errorReport: "Vous pouvez nous donner des commentaires sur les problèmes que vous avez sur le Supsis.",
            sendErrorFeedBack: "Donnez-nous des commentaires sur le problème que vous rencontrez.",
            successImgUpload: "Votre image a été téléchargée avec succès.",
            successImgDelete: "L'image a été supprimée avec succès.",
            errorImgUpload: "Une erreur s'est produite lors du téléchargement de votre image.",
            errorImgDelete: "Une erreur s'est produite lors de la suppression de l'image",
            chatBotEndStatics: "Taux de réussite de la conversation du chatbot",
            videoCallDist: "Distribution des appels vidéo",
            departmentInfo: "Informations sur le département",
            infoAboutDepartment: "Donnez de brèves informations sur le département",
            deleteDepartmentQuestion: "Voulez-vous vraiment supprimer ce département?",
            departmentDeleted: "Département supprimé",
            departmentTitle: "Titre du département",
            updateDepartmentForm: "Formulaire de mise à jour du département",
            newDepartmentForm: "Nouveau formulaire de département",
            department: "Département",
            newDepartment: "Nouveau département",
            departmentSaved: "Département sauvé",
            sameDepartment: "Il y a un département avec le même nom",
            sameValue: "Il y a une valeur avec le même nom!",
            sameTag: "Il y a une balise avec ce nom!",
            departments: "Départements",
            chatTimingSettings: "Paramètres de synchronisation de chat",
            assetOversize: "La taille du fichier que vous souhaitez envoyer ne doit pas dépasser 2 Mo.",
            assetOversizeMB: "La taille du fichier que vous souhaitez envoyer ne doit pas dépasser {mb} Mo.",
            messageDeleted: "Ce message est supprimé",
            filterLostChat: "Filtrer les chats perdus",
            filterClosedByAgent: "Filtre fermé par agent",
            filterVideoCall: "Filtre d'appel vidéo",
            notificationText: "Le soupsis a besoin de l'autorisation de",
            notificationTitle: "Notifications désactivées",
            deniedText:
                "Vos notifications sont fermées, vous devez activer vos notifications afin de ne pas manquer vos clients.",
            deniedTitle: "Cliquez pour ouvrir vos notifications!",
            deniedHeader: "Pour ne pas manquer vos clients, vous devez activer vos notifications !",
            showNotificationGuide: "Cliquer pour les détails",
            howToEnableNotification: "Comment puis-je activer les notifications",
            notificationOK: "D'accord",
            notificationUnderstood: "Compris!",
            notificationCancel: "Annuler",
            howToEnableNotificationInstruction1:
                "Cliquez sur l'icône de verrouillage dans la barre d'adresse du navigateur",
            howToEnableNotificationInstruction2:
                "Si les «notifications» sont désactivées dans la section des autorisations, activez-la",
            howToEnableNotificationInstruction3:
                'Si "Notifications" n\'apparaît pas dans la section des autorisations, cliquez sur "Paramètres du site',
            howToEnableNotificationInstruction4:
                'Activez l\'autorisation "Notifications" de la section "Autorisations" de la page Paramètres du site',
            checkPaymentMethod: "Veuillez vérifier votre mode de paiement",
            pushNotificationEnabled: "Super, notification push activée",
            pushNotificationDenied: "Vous avez nié l'autorisation de notification",
            suspendedMessage: "votre compte a été suspendu",
            enableNotification: "Activer les notifications de bureau.",
            languageSettings: "Langue sélectionnée",
            problemsSound:
                "Si vous avez des problèmes avec les notifications, vous pouvez cliquer sur l'image de verrouillage de verrouiller dans votre zone de recherche de navigateur (affiché sur l'image), cliquez sur «Paramètres du site» et modifier le «son» pour autoriser",
            betweenRepresentative: "Il y a un nouveau message d'un représentant",
            desktopNotifications: "Notifications de bureau",
            notificationEnabled: "Les notifications de bureau de Supsis sont activées.",
            newMessageAlert: "Vous avez un nouveau message.",
            notificationDisable: "Vous pouvez désactiver la notification à partir de paramètres représentatifs",
            newConversationAlert: "Vous avez un nouveau visiteur.",
            chatBot: "Chatbot",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "archive",
            chatbotChatCount: "Chatbot",
            changeTitle: "Titre de changement",
            changeVisitorTitle: "Cambiar título de visitante",
            catalog: "Titre de catalogue",
            openTheCatalog: "Catalogue ouvert",
            catalogNotOpen:
                "La fonction de catalogue est désactivée. Vous pouvez activer la fonction de catalogue pour prendre en charge vos clients avec du contenu préparé.",
            showCatalogCategories: "Définissez si le menu du catalogue apparaîtra sur la bulle de chat",
            showChatBot: "Définissez si le chatbot apparaîtra sur la bulle de chat",
            openCatalog: "Visibilité du catalogue",
            unreadMessages: "Messages non lus",
            personalFirstMsg: "Moyenne de temps de réponse de l'agent (SEC)",
            personalRating: "Score du personnel AVG",
            soundSettings: "Paramètres de notification",
            newPrivateMessage: "Message privé",
            addNewGroup: "Créer un nouveau groupe",
            newMessage: "Nouveau message",
            newConversation: "Nouveau chat",
            newVisitor: "Nouveau visiteur",
            chatPosition: "Position de chat",
            bottomLeftCorner: "Coin inférieur gauche",
            leftDocked: "gauche Amarré",
            bottomRightCorner: "Coin inférieur droit",
            rightDocked: "à droiteAmarré",
            chatPositionSelect: "Choisir la position",
            teamChatGroup: "Messages de groupe",
            teamChatDepartment: "Messages de département",
            teamChatTeam: "Messages d'équipe",
            teamChatDm: "Messages privés",
            bottomLeft: "En bas à gauche",
            left: "Gauche",
            bottomRight: "En bas à droite",
            right: "Droite",
            mailorname: "E-mail ou nom",
            fieldName: "Nom de clé",
            value: "Valeur",
            addSetting: "Ajouter un paramètres",
            globalSettings: "Paramètres globaux",
            breaksByTime: "Couler de rupture par le temps",
            clPlaceholder: "Nom qui apparaîtra sur le formulaire client",
            target: "Adresse de test de chargement",
            duration: "Durée du test de chargement (SEC)",
            arrivalCount: "Nombre de discussions",
            bootMaxLife: "Chat Max Life Time (SEC)",
            startLoadTest: "Démarrer le test de chargement",
            noClusterInstanceFound: "Il n'y a pas de serveur",
            stopLoadTest: "Test de chargement d'arrêt",
            integrationDesc: "Ajoutez simplement le code en ligne ci-dessous à votre site.",
            integrationDemoCode: "Code de démonstration d'intégration simple",
            integrationWindow: "Comment puis-je m'intégrer à mon site?",
            notIntegrated: "L'intégration",
            help: "Aider",
            notIntegratedDesc:
                "Nous avons remarqué que vous n'aviez pas ajouté le système de chat à votre site. Lorsque vous l'intégrez dans votre site et commencez le premier chat, vous terminerez l'intégration. Cliquez pour le script d'intégration",
            backToLogin: "Revenir à l'écran de connexion",
            passwordlessLoginUnsuccessful: "La connexion n'est pas réussie.Url pourrait être expiré ou utilisé avant",
            passwordlessLogin: "Connexion sans mot de passe",
            loginWithEmail: "Connectez-vous avec e-mail",
            loginWithPassword: "Connectez-vous avec le mot de passe",
            enteringPasswordless: "Connexion sans mot de passe ...",
            toMainPath: "Rediriger vers la page principale",
            userRoleChanged: "Vos autorisations ont changé. Vous serez redirigé vers la page principale.",
            passwordChangeSuccess: "Votre mot de passe a changé avec succès",
            feedback: "Montrer des commentaires",
            showFeedbackHistory: "Afficher les messages qui ont été envoyés des commentaires",
            newSelfServiceSite: "Nouveau site de libre service",
            subdomain: "Sous-domaine",
            rootUserEmail: "E-mail",
            rootUserName: "Nom",
            newVersion: "Nouvelle version disponible",
            closeLiveSupport: "Fermer le soutien en direct",
            newVersionShort: "Nouvelle version",
            bannedWordRestrict: "Blocking des mots interdits",
            ticketShow: "Autoriser les clients à créer des tickets",
            ticketShowDesc: "Activer l'option de création de ticket dans le menu de discussion",
            autoLoadIframe: "Circulation en direct",
            autoLoadIframeDesc: "Iframe de chargement automatique, transmettez tout le trafic des visiteurs",
            bannedWordRestrictDesc:
                "Lorsque le blocage des mots interdits est activé, les représentants sont empêchés de taper les mots interdits définis dans le système aux visiteurs.",
            agentDown: "Agent",
            delayChat: "Chat retardé",
            tableSettingTippy: "Vous pouvez modifier les informations qui apparaîtront dans le tableau.",
            tableSettings: "Paramètres de la table",
            tableSettingsInfo:
                "Vous pouvez modifier les informations qui apparaîtront dans le tableau. Vous pouvez sélectionner 7 colonnes au plus",
            privateParametry: "Paramètres utilisateur personnalisés",
            systemOperetor: "Informations système",
            cityAndDistrict: "District de la ville",
            general: "Général",
            availability: "Disponibilité",
            home: "Maison",
            successful: "Réussite",
            forgetPasswordSent:
                "Réinitialiser le lien de mot de passe e-mail a été envoyé, cochez votre boîte de réception",
            saturday: "Samedi",
            friday: "Vendredi",
            thursday: "Jeudi",
            wednesday: "Mercredi",
            tuesday: "Mardi",
            monday: "Lundi",
            sunday: "Dimanche",
            download: "Télécharger un fichier",
            calendarPassedTimeHour: "{hour} pendant {name} heure",
            calendarPassedTime: "{name} pour {hour} heure {min} min",
            calendarPassedTimeMin: "{name} pour {value} min",
            workScheduleOneDay: "Horaire de travail de {name} sur {sDate}",
            workSchedule: "{name} est le calendrier de travail entre {sDate} - {eDate}",
            noRating: "Il n'y a pas de note à montrer",
            rateDist: "Distribution des taux",
            distConversation: "Distribution des discours par les représentants",
            distributionConversa: "Répartition des scores",
            distChatbotAgent: "Canaux de communication",
            distAgent: "Chatbot & Agent",
            distFugitive: "Discours manqué et discours reçu",
            distLive: "Chat en direct",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Chat en direct",
            distHandled: "Chat répondu",
            distMissed: "chat sans réponse",
            distWeb: "Site Internet",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Nombre de chat WhatsApp",
            statsByTime: "Nombre de discussions par temps",
            selectRep: "Sélectionnez un représentant",
            allRepresentatives: "Tous les représentants",
            avgRating: "Score de notation ({point}) ({count} note)",
            avgFirstMessageTime: "Temps de réponse moyen",
            totalBreakTime: "Temps de pause du système",
            totalBreakNum: "Dénombrement",
            averageConTime: "Temps de conversation moyen",
            multiWpReportTitle: "Nombre de conversations multi-Whatsapp",
            multiWpReport: "Nombre de discussions WhatsApp multiples",
            multiWpReportExplanation: "Vous pouvez voir le montant des discussions de vos chaînes  Whatsapp.",
            longestConTime: "Temps de conversation le plus long",
            shortestConTime: "Temps de conversation le plus court",
            refresh: "Rafraîchir",
            waitingReply: "Messages en attente",
            organizationName: "nom de l'organisation",
            companySlogan: "Nom long de l'organisation",
            messageSentErr: "Message non envoyez, réessayez.",
            messageSent: "Message envoyé.",
            openPrivateChat: "Chat représentatif ouvert",
            escKey: "Cache une conversation active",
            archiveChatKey: "Vous permet de rejoindre le chat en bas de la page d'archivage.",
            chatCopilot: "Active Chat CoPilot",
            privateChat: "Panneau de conversation inter-agents",
            multiModeAlertDesc:
                'Le Supsis est ouvert dans une autre fenêtre. Cliquez sur "Utiliser ici" pour utiliser le Supsis dans cette fenêtre.',
            useHereText: "Utiliser ici",
            brandVisibility: "La marque de marque de Supsis apparaît sur la bulle de chat",
            focusInput: "Focus Cursor Active Chat Cntary Field",
            send: "Envoyer",
            notYet: "Pas encore",
            sending: "Envoi en cours",
            onlyRepresentative: "Votre message ne peut voir que par des représentants",
            yourMessage: "Votre message",
            liveFabListDescription: "Support en direct",
            messengerIntegrationDesc:
                "Discutez avec vos clients via la page Facebook, envoyez des messages automatisés avec le chatbot.",
            checkDepartmentToAgent: "Vérifier le département pour l'agent en ligne",
            ifAllOfflineStory: "Histoire à diriger si tous hors ligne",
            AssignMessagesToAgents: "Attribuer tous les messages aux agents",
            firstChatbotAndAssign: "D'abord, le Chatbot répond, puis il est assigné à un agent",
            hybridAssign:
                "Le système vérifie le département pour voir s'il y a un agent en ligne, et s'il n'y a pas d'agent en ligne, il l'assigne au chatbot.",
            ticketFabListDescription: "Billet",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Téléphone",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "Youtube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Tapez votre lien de canal {channelLink} dans ce champ.",
            typeYourAccountLink: "Tapez votre lien de compte {accountLink} dans ce champ.",
            typeYourMessage: "tapez votre message ici",
            typeYourMessageMail:
                "Le message entré dans ce champ sera envoyé par le client à l'adresse courante ci-dessus comme premier message.",
            typeYourMessageDesc:
                "Le message entré dans ce champ sera envoyé par le client au numéro de téléphone ci-dessus comme premier message.",
            sendNumber: "Numéro de téléphone pour envoyer le message à: {path}",
            callNumber: "Numéro de téléphone que votre client peut appeler: {phoneNumber}",
            numberIsNotCorrect: "Numéro manquant entré !!",
            emailIsNotCorrect: "Le courriel n'est pas correct!",
            selectFab: "Sélectionnez un fabuleux",
            notValid:
                "Vous ne pouvez entrer que des lettres. (Caractère unique) .e, d, f, z, a, x, c, v, w, t, n les lettres ne sont pas valides",
            forMacUsers: "Les utilisateurs de Mac peuvent utiliser le raccourci de contrôle (⌃)",
            basePriceValue: "Prix ​​de base",
            basePriceDiscount: "Rabais",
            basePriceCurrency: "Monnaie",
            customerDBEnabled: "Sélection de la base de données: utilisez le serveur de base de données client",
            customerDBDisabled: "Sélection de la base de données: Utilisez le serveur de base de données Supsis",
            mongoConnectionString: "Connexion Mongo",
            whatsappBasePriceValue: "Prix ​​de base WhatsApp",
            whatsappPlusBasePriceValue: "Prix ​​de base WhatsApp Plus",
            instagramBasePriceValue: "Prix ​​de base Instagram",
            instagramPlusBasePriceValue: "Instagram plus prix de base",
            clientAddress: "Adresse du client",
            customerClientAddress: "Adresse client client",
            apiAddress: "Adresse API",
            socketAddress: "Adresse à la douille",
            backendAddress: "adresse backend",
            panelLogoUrl: "URL du logo du panneau",
            panelCustomCssUrl: "URL CSS personnalisée du panneau personnalisé",
            customerLogoUrl: "URL du logo client",
            customerCssUrl: "URL du client CSS",
            siteAlias: "Alias ​​du site",
            language: "Langue",
            features: "Caractéristiques",
            interactionPopularity: "Popularité des interactions",
            interactionCount: "Nombre d'interactions",
            uniqueUserCount: "Nombre d'utilisateurs uniques",
            allUserPercentage: "(%) Pourcentage de tous les utilisateurs",
            represantativeSettings: "Paramètres représentatifs",
            documentTitle: "Formulaire de document Supsis",
            supsisDocument: "Document Supsis",
            ApiDoc: "Documentation de l'API",
            chatBalloonTehemeSettings: "Ballon de chat et paramètres de thème",
            customLoginFormSettingsTitle: "Personnaliser le formulaire de connexion des visiteurs",
            addNewField: "Ajouter un nouveau champ",
            editField: "Champ de modification",
            typeHere: "Tapez le contenu ici!",
            pco: "Cur",
            perPage: "/page",
            perPageInFilter: "Morceau",
            noUserInfoFound: "Aucune information sur l'utilisateur n'a été trouvée",
            startFilter: "Démarrer le filtre",
            showMyChats: "Montrez mes chats",
            showOnlineAgents: "Afficher uniquement les agents en ligne",
            showWaitingChats: "Afficher les chats d'attente",
            addNewStatus: "ajouter un statut",
            newTitleContent: "Nouveau titre",
            newCTRLContent: "Nouveau contenu CTRL",
            newALTContent: "Nouveau contenu alt",
            newTABContent: "Nouveau contenu d'onglet",
            roleName: "Nom de rôle",
            error: "Erreur",
            contentTitle: "Titre de contenu",
            contentType: "Type de contenu",
            cannotMoveFullParent: "Impossible de déplacer cet élément",
            newSiteForm: "Nouveau formulaire de registre de site",
            updateSiteForm: "Formulaire de mise à jour du site",
            newBannedWordForm: "Nouveau formulaire de registre de mots interdits",
            updateBannedWordForm: "Formulaire de mise à jour des mots interdits",
            newWelcomeMessageForm: "Nouveau formulaire de registre de messages de bienvenue",
            updateWelcomeMessageForm: "Formulaire de mise à jour du message système",
            newDefaultContentForm: "Nouveau formulaire de registre de contenu par défaut",
            updateDefaultContentForm: "Formulaire de mise à jour de contenu par défaut",
            newSubjectForm: "Nouveau formulaire de registre des sujets",
            updateSubjectForm: "Formulaire de mise à jour du sujet",
            showChatColorMeaning: "Couleurs de chat",
            showIntro: "Montrer l'intro",
            options: "Options",
            resetPassword: "réinitialiser le mot de passe",
            audioLevel: "Volume d'alerte audio",
            privateChatNotificationSound: "Son de notification",
            continue: "Continuer",
            newRoleForm: "Nouveau formulaire de registre des rôles",
            updateRoleForm: "Formulaire de mise à jour des rôles",
            newRolePlaceHolder: "Cliquez sur un nouveau rôle",
            newUserForm: "Nouveau formulaire de registre d'utilisateurs",
            updateUserForm: "Formulaire de mise à jour de l'utilisateur",
            changeOSRForm: "Message de changement hors ligne",
            tooltipOSRForm: "Vous pouvez modifier le message hors ligne.",
            newOSRForm: "Formulaire de support hors ligne",
            newOSRMessages: "Ajouter un message hors ligne",
            updateOSRForm: "Formulaire de mise à jour hors ligne",
            osrTitle: "Titre",
            osrTitleDescription: "Vous pouvez ajouter le titre de formulaire de support hors ligne",
            osrContent: "Contenu",
            osrContentDescription: "Vous pouvez ajouter du contenu de formulaire de support hors ligne",
            hello: "Bonjour le monde",
            date: "Date",
            startDate: "Date de début",
            finish: "Finir",
            start: "Commencer",
            search: "Commencer la recherche",
            endDate: "Date de fin",
            representative: "Représentants",
            representative_: "Représentant",
            star: "Étoile",
            filter: "FILTRE",
            reset: "RÉINITIALISER",
            dailyChatList: "Liste de discussion quotidienne",
            dailyChatDuration: "Durée quotidienne du chat",
            chatDuration: "Durée du chat",
            dailyChatGraph: "graphique de chat quotidien",
            ok: "D'ACCORD",
            cancel: "Annuler",
            chatCount: "Nombre de discussions",
            shortest: "Le plus court",
            longest: "Le plus long",
            average: "Moyenne",
            count: "Compter",
            averagePoint: "Point moyen",
            pointDist: "Répartition des points",
            point: "Indiquer",
            filters: "Filtres",
            totalCustomer: "Client total",
            avResponseTime: "Temps de réponse moyen",
            breakDuration: "Durée de rupture",
            breakCount: "Dénombrement",
            lastLoginPlatform: "Plateforme",
            active: "Actif",
            passive: "Passif",
            userForm: "Formulaire utilisateur",
            sender: "Expéditeur",
            profile: "Profil",
            name: "Nom",
            number: "Nombre",
            username: "Nom d'utilisateur",
            password: "Mot de passe",
            oldPassword: "ancien mot de passe",
            newPassword: "nouveau mot de passe",
            passwordAtLeast: "Mot de passe (au moins {num} caractères)",
            passwordRepeat: "Répéter le mot de passe",
            changePassword: "Changer le mot de passe",
            status: "Statut",
            enableState: "Actif?",
            douYouWishToDeleteUser: "DOU Vous souhaitez supprimer cet utilisateur?",
            userDeleted: "Supprimé par l'utilisateur",
            userSaved: "Utilisateur enregistré.",
            oldPasswordError: "L'ancien mot de passe est incorrect, veuillez vérifier.",
            chooseAnOption: "Veuillez sélectionner un son de notification.",
            userVolumeUpdated: "Paramètres de volume mis à jour.",
            save: "Sauvegarder",
            update: "Mise à jour",
            addNewMenu: "Ajouter un nouveau menu",
            addNewContent: "Ajouter un nouveau contenu",
            pleaseTitleEnter: "S'il vous plaît titre entrez",
            like: "Comme",
            disLike: "Ne pas aimer",
            users: "Utilisateurs",
            visitor: "Visiteurs",
            allContacts: "Tous les contacts",
            allUsers: "Tous les représentants",
            allSites: "Tous les domaines",
            newUser: "Nouvel utilisateur",
            noNewUser: "Il n'y a pas encore d'utilisateur.",
            noNewAdminUser: "Il n'y a pas encore d'utilisateur administrateur.",
            noRoleFound: "Il n'y a pas encore de rôle.",
            noBannedWordFound: "Il n'y a pas encore de mot interdit.",
            noWelcomeMessageFound: "Il n'y a pas encore de message système.",
            noSubjectFound: "Il n'y a pas encore de sujet.",
            noVisitorFound: "Il n'y a pas de visiteur.",
            noContactFound: "Il n'y a pas de contact.",
            sendResponse: "Écrire une réponse",
            delete: "Supprimer",
            noLiveSupportFound: "Il n'y a pas de visiteur connecté au support en direct",
            noLiveSupportFoundWithDepartment: "Il n'y a pas de discours appartenant au département",
            duplicate: "Dupliquer",
            makeDefault: "Faire défaut",
            checkMore: "Vérifiez plus",
            useReadyTemplates: "Utilisez des modèles prêts",
            noRePresentativeFound: "Il n'y a pas de représentant",
            noBannedVisitorFound: "Il n'y a pas encore de visiteur interdit.",
            removeBanDescription: "Supprimer l'interdiction",
            editThisItem: "Mettre à jour cet article",
            removeThisItem: "enlever cet article",
            role: "Rôle",
            autoChatAssignLimit: "Limite d'attribution de chat automatique",
            chatAssignInfo: "-1 = par défaut du système, 0 = pas d'attribution,> 0 = Assignez la valeur donnée.",
            relatedDepartments: "Départements connexes",
            subjectInfo: "S'il n'y a pas de sujet sélectionné, tous les sujets sont autorisés.",
            archive: "Archive",
            offlineSupportRequests: "Supports hors ligne",
            first: "D'abord",
            last: "Dernier",
            query: "Commencez à rechercher",
            clean: "Faire le ménage",
            loading: "Chargement",
            loadMore: "Charger plus",
            noMessage: "N'est aucun message",
            selectChat: "Choisir une conversation",
            noMessageInChat: "Il n'y a pas de message dans ce chat",
            noMediaToShow: "Pas de médias à montrer",
            firstSeen: "Première apparition",
            userInfo: "informations utilisateur",
            chatId: "Identifiant de chat",
            visitorId: "ID du visiteur",
            visitingPage: "Page de visite",
            osAndBrowser: "Système d'exploitation et navigateur",
            customerClientVersion: "Version client client",
            visitorFeedback: "Rétroaction des visiteurs",
            notes: "Notes",
            nameSurname: "Prénom / nom de famille",
            chats: "Chats",
            bannedVisitors: "Visiteurs interdits",
            country: "Pays",
            city: "Ville",
            cityDistrict: "District de la ville",
            browser: "Navigateur",
            os: "Système opérateur",
            ipAddress: "Adresse IP",
            connectionDate: "Date de connexion",
            transaction: "Transaction",
            banRemoved: "Interdiction supprimée.",
            bannedWords: "Mots interdits",
            newBannedWord: "Nouveau mot interdit",
            noBannedWord: "Pas encore de mot interdit.",
            bannedWordForm: "Formulaire de travail interdit",
            word: "Mot",
            bannedWordAndWordGroup: "Groupe de mots / travail interdits",
            doYouWishToDeleteBannedWord: "Dou Vous souhaitez vraiment supprimer ce mot interdit?",
            doYouWishToOfflineSupportRequest: "DOU, vous souhaitez vraiment supprimer ce message?",
            bannedWordSaved: "Mot interdit enregistré",
            deletedSuccessfully: "Supprimé avec succès",
            deleteErrorMsg: "Erreur: ce n'est pas supprimé, réessayez",
            socketError: "Erreur de connexion à socket. Veuillez actualiser la page et réessayer.",
            socketConnecting: "Connexion au serveur",
            offlineModeDescription: "Système Down, les clients ne pourront pas accéder à l'assistance en direct.",
            offlineModeSettingsDescription: "Vérifiez la fonction de mode hors ligne dans le menu Paramètres.",
            offlineModeUser: "Il doit y avoir au moins un représentant en ligne dans le système.",
            offlineModeMessage: "Message hors ligne",
            offlineMode: "Mode hors-ligne",
            adminCannotConnectSocket: "L'administrateur ne peut pas se connecter à la prise.",
            liveSupport: "Support en direct",
            siteVisitors: "Visiteurs du site",
            visitors: "Visiteurs",
            thoseConnectedToLiveSupport: "Ceux qui se sont connectés au soutien en direct",
            visitorHistory: "Histoire des visiteurs",
            visitorHistoryDescription:
                "Vous pouvez afficher et télécharger l'historique des discussions des visiteurs.",
            privateMessage: "Message privé",
            addRepresentative: "Ajouter un représentant",
            forwardRepresentative: "Représentant à terme",
            keyboardShortcuts: "Raccourcis clavier",
            chatColorMeanings: "Significations de couleur de chat",
            connLostCheckInternet: "Connexion perdue, veuillez vérifier votre connexion Internet.",
            wishToEndThisChat: "Dou Vous souhaitez terminer ce chat?",
            defaultContents: "Contenu par défaut",
            contents: "Contenu",
            newDefaultContent: "Nouveau contenu par défaut",
            shortcutChar: "Caractère de raccourci",
            pickOne: "En choisir un",
            writeSomething: "Écrivez un personnage (A-Z | 0-9)",
            letterSequence: "Séquence de lettres",
            exampleText: "Exemple: SOC -> Soccer",
            anyChar: "N'importe quel caractère",
            shorcutKey: "Touche de raccourci",
            content: "Contenu",
            shortcutName: "Nom de raccourci",
            type: "Taper",
            shortcut: "Raccourci",
            defaultContentForm: "Formulaire de contenu par défaut",
            titleContentForm: "Contenu prêt En-tête",
            deleteContentQuestion: "Souhaitez-vous vraiment supprimer ce contenu par défaut?",
            defaultContentDeleted: "Contenu par défaut supprimé",
            defaultContentSaved: "Contenu par défaut enregistré.",
            contentMoved: "Le contenu déplacé.",
            yourEmail: "Adresse e-mail",
            yourName: "Votre nom et prénom",
            login: "Connexion",
            lostPassword: "Mot de passe oublié",
            multipleSession: "Vous êtes signé ailleurs.",
            notAuthorizedToDisplayPage: "Vous n'êtes pas autorisé à voir cette page!",
            permissions: "Autorisation",
            newPermission: "Nouvelle autorisation",
            permissionForm: "Formulaire d'autorisation",
            displayTitle: "Titre d'affichage",
            key: "Clé",
            keyToUseInSystem: "Valeur clé à utiliser dans le système",
            deletePermissionQuestion: "Souhaitez-vous vraiment supprimer cette autorisation?",
            permissionDeleted: "Autorisation supprimée.",
            permissionSaved: "Autorisation enregistrée.",
            newRole: "Nouveau rôle",
            selectARole: "Sélectionnez un rôle",
            yes: "Oui",
            no: "Non",
            fullAuth: "Autorisation complète",
            roleDeleted: "Rôle supprimé.",
            roleSaved: "Rôle sauvé.",
            roleForm: "Formulaire de rôle",
            roles: "Les rôles",
            settings: "Paramètres",
            selectTopic: "Département de sélection",
            autoCallTransfer: "Transfert d'appel automatique",
            customerTyping: "Typage client",
            typing: "Dactylographie",
            agentTyping: "Typage représentatif",
            disconnectTime: "Temps de reconnexion maximum (SEC)",
            tippyDissconnectTime: "Lorsqu'un chat inactif après le nombre de secondes de la conversation se terminera.",
            queueNumberVisibleFeature: "Afficher le numéro d'attente au visiteur",
            privateChatEnabled: "Montrez le chat entre les représentants",
            delayedTalkTime: "Temps de retard (SEC)",
            employeeAverageChatCount: "Numéro de chat moyen pour le taux de chat des employés",
            customerDownTimeWhenRepExit: "Temps d'arrêt du client lorsque le représentant part (Sn.)",
            autoAssignLimit: "Limite d'attribution automatique",
            wasted: "Conversation Lost Time (SEC)",
            settingFormWrong: "Les données du formulaire sont erronées, réessayez après la vérification",
            settingsSaved: "Paramètres sauvegardés.",
            settingsCannotSaved: "Les paramètres ne peuvent pas être enregistrés",
            noAuthorization: "Pas d'autorisation",
            warningBadInput: "Il est recommandé d'entrer un nombre entre 0 et 70.",
            warning: "AVERTISSEMENT!",
            warningBadInputMarginY: "AVERTISSEMENT DES ENTRÉE DE LA MARGIE VERTIQUE ⚠️",
            warningBadInputMarginX: "AVERTISSEMENT de l'entrée de la marge horizontale ⚠️",
            warningBadInputBubbleSize: "AVERTISSEMENT D'ENTRÉE DE BUBLE DE CHAT ⚠️",
            delayTime: "Temps de retard (SEC)",
            sites: "Des sites",
            newSite: "Nouveau site",
            noSiteYet: "Il n'y a pas encore de site.",
            siteAddress: "Adresse du site",
            turnBack: "Retourner",
            customerRepLimit: "Limite de représentant client",
            siteSaved: "Site enregistré.",
            siteSaveError: "Une erreur s'est produite lors de la création du site",
            subjects: "Sujets",
            newSubject: "Nouveau sujet",
            noSubject: "Aucun sujet encore.",
            subject: "Sujet",
            subjectTitle: "Titre du sujet",
            infoAboutSubject: "Informations sur le sujet",
            deleteSubjectQuestion: "Souhaitez-vous vraiment supprimer ce sujet?",
            subjectDeleted: "Sujet supprimé.",
            subjectSaved: "Sujet sauvé.",
            welcomeMessages: "Messages système",
            newWelcomeMessages: "Nouveau message de bienvenue",
            noWelcomeMessage: "Pas de message système.",
            welcomeMessageContent: "Contenu du message système",
            makeChoice: "Fais un choix...",
            welcomeMessage: "Message de bienvenue",
            repLoggedIn: "Représentant connecté",
            loginMessage: "Se connecter",
            message: "Message",
            deleteWelcomeMessageQuestion: "Souhaitez-vous vraiment supprimer ce message système?",
            welcomeMessageDeleted: "Message système supprimé",
            welcomeMessageSaved: "Message système enregistré.",
            welcomeMessageForm: "Formulaire de message système",
            noRep: "Il n'y a pas encore de représentant.",
            addChat: "Ajouter le chat",
            forwardChat: "Chat avant",
            ago: "il y a",
            repName: "Nom représentatif",
            lastOnline: "Dernière connexion / heure en ligne",
            lastStatusChange: "Dernier changement de statut",
            activeChat: "Chat actif",
            userMaxCapacity: "Capacité de chat maximale",
            noActiveChat: "Pas de chat actif",
            watch: "MONTRE",
            join: "REJOINDRE",
            open: "Conversation ouverte",
            directMessage: "MESSAGE PRIVÉ",
            block: "BLOC",
            transactions: "Transactions",
            informations: "Informations",
            visitStart: "Visiter Start",
            fullName: "Nom et prénom",
            waitChatTime: "Temps d'attente / chat",
            blockUserConfirm: "Voulez-vous bloquer cet utilisateur?",
            messaging: "Messagerie",
            hideChat: "Cacher le chat",
            block_: "Bloc",
            privateMessage_: "Message privé",
            assignRep: "Affecter un représentant",
            forwardRep: "Avant",
            leaveChat: "Laisser la discussion",
            endChat: "Chat fin",
            translatedTextDescription: "Amazon a traduit ce message {from} -> {to}.",
            autoTranslate: "Traduire automatiquement",
            translateThisMessage: "Traduire ce message",
            autoTranslateDetectedDesc:
                "La langue des visiteurs est {visitorLanguage}. Cliquez ici pour activer la traduction automatique",
            on: "sur",
            off: "désactivé",
            copy: "Copie",
            prevChats: "Chats précédents",
            noShortCut: "Pas de raccourci",
            leaveChartConfirm: "Dou, vous souhaitez vraiment quitter le chat?",
            endChatConfirm: "Dou Vous souhaitez terminer le chat?",
            endConversation: "Conversation de fin",
            onlyOneRep: "Vous êtes le seul représentant de cette conversation!",
            chatList: "Liste de discussion",
            chatBar: "Barre de discussion",
            unreadTitle: "Non lu",
            visitorLeftTitle: "Visiteur à gauche",
            activeChatTitle: "Chat actif",
            autoAssignedTitle: "Chat attribué automatiquement",
            watchModeTitle: "Mode de surveillance",
            lostChat: "Connexion représentative perdue",
            chatWidthDelay: "Discuter avec retard",
            repChatWidthDelay:
                "Lorsqu'il n'y a pas de représentant actif dans le système ou tous nos représentants en raison du trafic élevé, les antécédents de chat seront verts",
            repLostConn: "Si le représentant du client a perdu la connexion, le fond de chat sera rose.",
            unreadMsg: "S'il y a des messages non lus, l'arrière-plan sera bleu clair.",
            visitorLeftChat: "Si le visiteur a quitté la conversation, le fond devient gris foncé.",
            activeChatMsg: "Le fond est vert si le chat est actif",
            autoAssignMsg:
                "L'arrière-plan devient de la moutarde s'il est attribué par affectation automatique et la conversation n'est pas examinée plus loin",
            watchModeMsg: "S'il est allumé en mode de lecture, l'arrière-plan devient rouge",
            online: "En ligne",
            beRightBack: "Loin",
            away: "Loin",
            busy: "Occupé",
            offline: "Hors ligne",
            logout: "Se déconnecter",
            forWindows: "Pour les fenêtres",
            forMac: "Pour Mac",
            nextChatFromActive: "Passer de la conversation active à la prochaine conversation",
            previousChatFromActive: "Passer de l'actif à la précédente",
            hideActiveChat: "Cacher une conversation active",
            closeActiveChat: "Fermer une conversation active",
            firsthiddenChat: "Rejoignez la plupart du chat des clients attendu",
            firstChatWaiting: "Passer à la conversation en attente",
            previousOpenedChat: "Quelle que soit l'ordre, passez à la conversation précédemment ouverte",
            historyDetails: "Détails de l'histoire",
            chat: "Discuter",
            chatNotFound: "Aucun discours trouvé.",
            dataNotFound: "Données introuvables.",
            visitorInfo: "Informations sur les visiteurs",
            timeSpent: "Temps passé",
            noActiveVisitors: "Pas de visiteurs actifs",
            totalConnected: "Nombre de conversations",
            missedChat: "Compte de chat manqué",
            workTime: "Temps de travail",
            closedChatCount: "Chat fermé",
            activeConvo: "Conversation active",
            notAnswered: "Pas encore répondu",
            delayedConvo: "Retardé",
            leavingRep: "Quitter le représentant",
            staffRate: "Taux de travail du personnel",
            select: "Menu déroulant",
            fullname: "Nom et prénom",
            text: "Texte",
            numeric: "Nombre",
            phone: "Téléphone",
            optionsPlaceholder: "Valeur d'option",
            selectField: "Cliquez si vous souhaitez ajouter un menu déroulant",
            fullnameField: "Cliquez si vous souhaitez ajouter un champ de nom complet.",
            textField: "Cliquez si vous souhaitez ajouter un champ de texte.",
            labelField: "Cliquez si vous souhaitez ajouter un champ de description.",
            numericField: "Cliquez si vous souhaitez ajouter un champ numérique.",
            phoneField: "Cliquez si vous souhaitez ajouter un champ téléphonique.",
            departmentField: "Cliquez si vous souhaitez ajouter un champ de département.",
            emailField: "Cliquez si vous souhaitez ajouter un champ de messagerie.",
            visible: "Visible",
            required: "Requis",
            label: "Commentaire",
            customLoginAlert: "Votre formulaire de connexion doit contenir le moins d'un champ visible.",
            atLeastOneLanguage: "Vous devez ressentir au moins une langue",
            requiredFieldField: "Ce champ est obligatoire",
            notRequiredField: "Ce champ n'est pas requis",
            visibleField: "Ce champ est visible",
            notVisibleField: "Ce champ n'apparaît pas sous la forme.",
            connectServer: "Vous êtes connecté au serveur",
            disconnectServer: "Vous n'êtes pas connecté au serveur",
            liveChatOff: "Le chat en direct est désactivé",
            visitorScreen: "Écran de visiteur",
            viewOnTheSite: "Afficher sur la page",
            viewOnTheSiteTippy: "Cliquez ici pour voir comment vos modifications restent.",
            showHint: "Dévoiler un indice",
            dontShowHint: "Ne montrez pas indice",
            liveChatOn: "Le chat en direct est sur",
            nightModeOff: "Mode nocturne éteint",
            doubleClickEdit: "Double-cliquez ou appuyez sur le bouton Modifier pour modifier.",
            edit: "Modifier",
            deleteField: "Supprimer",
            arrow_upward: "Flèche vers le haut",
            arrow_downward: "Flèche vers le bas",
            newCatalogCategory: "Nouvelle catégorie de catalogue",
            childCreate: "Double-cliquez pour créer un nouvel enfant",
            updateCatalogCategoryFrom: "Mettre à jour le formulaire de catégorie de catalogue",
            newCatalogCategoryFrom: "Nouveau formulaire de catégorie de catalogue",
            catalogCategoryMenu: "Ajouter le menu de catégorie de catalogue",
            catalogCategoryLeaf: "Ajouter un sous-menu de catégorie de catalogue",
            catalogCategoryName: "Nom de la catégorie de catalogue",
            newCatalogContentFrom: "Nouveau formulaire de contenu de catalogue",
            catalogContentName: "Nom du contenu du catalogue",
            catalogCategorySaved: "Catégorie de catalogue enregistré",
            catalogCategoryDeleted: "Catégorie de catalogue supprimé",
            catalogCategoryRate: "Taux de contenu",
            catalogContentFeature: "Fonction de contenu de catalogue",
            vtipyAudioLevel: "Utilisé pour les sons de notification muets ou réactiles.",
            vtipyOrganizationName: "Vous pouvez modifier le nom de l'organisation et le mettre à jour.",
            vtipyBrandVisibility: "Le Supsis est le paramètre si la balise peut être affichée dans la bulle de chat.",
            vtipyBrandVisibilityForced: "Seuls les utilisateurs de Proplan peuvent changer !!",
            vtipyClientDefault: "Vous pouvez modifier la langue de la page de l'agent ici.",
            vtipyCustomerClientDefault: "Vous pouvez modifier ici la langue de la page Client (CHAT).",
            vtipyVisitorPreferredLang: "Le client peut sélectionner la langue parlée sur la page (CHAT).",
            vtipyCustomerClientLanguageDetect: "Vous pouvez modifier ici la langue de la page Client (CHAT).",
            vtipySelectTopic:
                "Des affectations automatiques aux représentants existants du département sélectionné se produisent.",
            vtipyAutoCallTransfer: "Attribue automatiquement les appels en attente aux agents disponibles.",
            vtipyCustomerTyping:
                "Il vous permet de voir ce que le client a écrit sur l'écran de chat sur l'écran de chat représentatif.",
            vtipyAgentTyping:
                "Il donne des informations lorsque vous êtes représentatif tapant au client dans le chat buble",
            vtipyQueueNumberVisibleFeature:
                "Lorsque les représentants sont occupés, cela montre aux clients qui souhaitent se connecter, dans quel ordre ils sont.",
            vtipyPrivateChatEnabled: "Montre le panneau de conversation inter-agent.",
            vtipyDelayedTalkTime:
                "Si aucun délégué n'est connecté à la conversation pendant cette période, il sera étiqueté \\ \"Chat retardé \\",
            vtipyOfflineMode: "Vous permet de mettre le système en mode hors ligne.",
            vtipyAutoAssignLimit:
                "Il détermine le nombre de clients (CHAT) sera affecté automatiquement au représentant.",
            vtipyCustomerDownTimeWhenRepExit: "Temps de ralenti du client lorsque le représentant sort (Sec.)",
            tippyDisconnectTime: "Le temps de fermeture du chat après avoir déconnecté le client (SEC).",
            changeSettings: "Modifier les paramètres globaux",
            totalBg: "discussions totales",
            activeBg: "discussions actives",
            watchBg: "MONTRE",
            waitingBg: "Discussions En Attente",
            lateBg: "Conversations Passagères",
            freeBg: "GRATUIT",
            maxCapacityBg: "CAPACITÉ MAXIMALE",
            addNewSettings: "Ajouter un nouveau paramètre global",
            darkMode: "Mode sombre",
            clientDefault: "Langue par défaut du panneau",
            customerClientDefault: "Client la langue par défaut du client",
            customerClientLanguageDetect: "Détection automatique de la langue du client client",
            visitorPreferredLang: "Laissez le client choisir la langue parlée",
            preferredThemeColor: "Couleur du thème préféré pour l'écran de chat client",
            detail: "Détail",
            supportUs: "Contactez-nous (support en direct)",
            langSetting: "Paramètres de langue",
            changeLang: "Changer de langue",
            fontSizeSetting: "Paramètre de zoom d'écran",
            changeLangDesc: "Modifie le langage de l'application en {code}",
            trLang: "turc",
            enLang: "Anglais",
            fieldRequired: "{field} champ est requis",
            selectALanguage: "Sélectionnez une langue",
            selectATheme: "Sélectionnez un thème",
            responseForm: "Formulaire de réponse",
            clientRequestInfo: "Informations sur la demande du client",
            createdDate: "Date de création",
            descMessage: "messages",
            new: "Nouveau",
            selectAllPermission: "Tout sélectionner",
            catalogCategories: "Catalogue",
            copiedClipboard: "Copié dans le presse-papier",
            changeLogo: "Changer le logo",
            changePhoto: "Changer de photo",
            addPhoto: "Ajouter une photo",
            seePhoto: "Voir la photo",
            deletePhoto: "Supprimer la photo",
            organizationLogo: "Logo de l'organisation",
            changePlan: "Plan de changement",
            close: "Fermer",
            vtipyUploadLogo:
                "En téléchargeant le logo de votre entreprise de ce domaine, vous pouvez utiliser votre propre logo dans les e-mails clients et les pages clients.",
            tagName: "Nom de la balise",
            tagDescription: "Libellé Description",
            tagColor: "Couleur de l'étiquette",
            userInformations: "informations de l'utilisateur",
            incomingChat: "Chat entrant",
            support: "Soutien",
            team: "Ensemble",
            groups: "Groupes",
            newConversationStarted: "Une nouvelle conversation a commencé",
            allHistoryLoaded: "Tout l'historique téléchargé",
            chatCreator: "Créateur de chat",
            enterGroupTitle: "Entrez le titre du groupe",
            requiredTitle: "Vous ne pouvez pas laisser le champ de titre vide",
            requiredChannel: "Le nom du canal ne peut pas être vide",
            next: "Confirmer",
            selectPeople: "Sélectionnez les personnes",
            textLimitAlertMessage:
                "La limite de caractères dans WhatsApp est de 19 caractères et au-delà de cette limite, il ne sera pas affiché. Or, sur le web, les textes dépassant la limite de 19 caractères sont automatiquement déplacés vers la ligne suivante et affichés.",
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!",
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!",
        },
        "{contentOfChatBubble}": "#VALUE!",
        telegram: {
            typeInTelegramToken: "Tapez en jeton de télégramme",
            token: "Jeton",
            telegramTokenTitle: "Intégration de Telegram Supsis",
            telegramAlertForm: "Vous pouvez obtenir le jeton de bot Telegram à partir de",
            telegramAlertTitle: "Voulez-vous vraiment supprimer le jeton?",
            telegramAlertText: "Le jeton sera définitivement perdu!",
        },
        wp: {
            sendingStatus: "En cours d'envoi",
            sent: "Envoyé",
            allErrors: "Toutes les erreurs",
            inProcess: "En traitement",
            sendingStatuses: "Statuts d'envoi",
            downloadCSV: "Télécharger CSV",
            errorMessage: "Message d'erreur",
            noNumbersAdded: "Aucun numéro ajouté",
            sendAgain: "Envoyer à nouveau",
            shippingDetails: "Détails d'expédition",
            importContactsFromFile: "Importer Des Contacts À Partir D'Un Fichier",
            chatStarted: "Le chat a commencé",
            chatNotStarted: "Le chat n'est pas commencé",
            contactSelected: "Contact sélectionné",
            startChatWithAnyNo: "Commencez à discuter avec n'importe quel numéro",
            toLittleChar: "Numéro manquant !",
            typeInANumberDesc: "Tapez le nombre pour commencer à discuter avec:",
            wpPlusAndLicenceRequired: "Plan WhatsApp Plus et licence requise.",
            wpPlusAndLicenceRequiredDesc:
                "Avant de pouvoir commencer des chats avec des numéros qui ne sont pas enregistrés dans vos contacts, vous devez mettre à niveau votre plan WhatsApp et obtenir une licence.",
            chatStartingWait: "Conversation commençant, veuillez attendre",
            whatsapp: "Whatsapp",
            agreement: "Accord",
            purchase: "Achat",
            activating: "Activation du service WhatsApp",
            authenticating: "Authentification du code QR",
            ready: "Prêt",
            enableFeature: "Activer la fonction WhatsApp",
            readAndAgree: "J'ai lu et accepté",
            subscribe: "S'abonner",
            subscribed: "Souscrit",
            toEnableWpDescription: "Pour activer les fonctionnalités WhatsApp, cliquez sur le bouton ci-dessous.",
            waitForWpActivationDescription:
                "Votre service de compte WhatsApp s'active. S'il te plaît attend un moment. Il faut environ 10 à 30 secondes.",
            greatWpActivatedDescription: "Super, votre service de compte WhatsApp est activé!",
            unsubscribe: "Se désabonner",
            planDetails: "Caractéristiques",
            sendReceiveMessage: "Envoyer et recevoir des SMS",
            sendReceiveImage: "Envoyer et recevoir des fichiers d'image",
            sendReceiveAudio: "Envoyer et recevoir des fichiers audio",
            sendReceiveGif: "Envoyer et recevoir des fichiers GIF",
            startChat: "Commencez à discuter sur le Supsis",
            supsisFunctionality: "Fonctionnalité de chat en supsis utile",
            onePhoneMultiAgent: "Un téléphone et plusieurs agents",
            basicIntegration: "Intégration de base et configuration zéro",
            activationTitle: "Pour activer l'intégration WhatsApp sur le Supsis:",
            wpIntegrationInstruction1: "Ouvrez WhatsApp sur votre téléphone",
            wpIntegrationInstruction2: "Appuyez sur le menu ou paramètres. Cliquez sur les appareils liés",
            wpIntegrationInstruction3: "Pointez votre téléphone vers cet écran pour capturer le code",
            qrGeneratingWait: "Code QR Génération Veuillez vous attendre ...",
            pleaseContinueToWaitUntilCompleted:
                "Une fois le code QR vérifié, il passera automatiquement au champ terminé. S'il vous plaît, attendez...",
            authenticatingWait: "Authentification, veuillez attendre ...",
            unsubscribeWpInetgration: "Intégration de WhatsApp de désabonnement",
            unsubscribeIGIntegration: "Intégration Instagram de désabonnement",
            wpBack: "Dos",
            terminatelWpInetgration:
                "Lorsque vous cliquez sur le bouton «désinscrire», votre intégration WhatsApp se terminera",
            cancelWpInetgration: "Voulez-vous annuler l'intégration WhatsApp?",
            terminatelIGIntegration:
                "Lorsque vous cliquez sur le bouton «désinscrire», votre intégration Instagram se terminera",
            cancelIGIntegration: "Voulez-vous annuler l'intégration Instagram?",
            startChatWp: "Démarrer la discussion",
            purchaseHeader: "Achat d'intégration Supsis-WhatsApp",
            wpServices: "Service WhatsApp",
            wpServicesIntegrationCompleted:
                "Votre intégration WhatsApp est terminée. Vous pouvez maintenant utiliser le service.",
            purchasePaymentDescription:
                "Fonction de WhatsApp facturée de mois en mois. Votre service WhatsApp sera activé après avoir accepté l'abonnement.",
            wpIntegrationFeatures: "Fonctionnalités d'intégration WhatsApp",
            saveChanges: "Sauvegarder les modifications",
            contactList: "Liste de contacts",
            broadcast: {
                broadcast: "Diffuser",
                detail: "Détail de diffusion",
                customer: "Client",
                phoneNumbers: "Numéro de contact",
                showMore: "Montre plus",
                groupName: "Nom de groupe",
                messages: "messages",
                status: "Statut",
                usageCost: "Coût d'utilisation",
                sendingTime: "Temps d'envoi",
                progress: "Progrès",
                groupDetail: "Détails du groupe",
                messagesPerContact: "Messages par contact",
                successRatio: "Ratio de réussite",
            },
            messages: "messages",
            broadcastRequests: "Demandes de diffusion",
            customerGroups: "Groupes de clients",
            messageTemplates: "Modèles de messages",
            plans: "Des plans",
            wpIntegrationRequired: "L'intégration WhatsApp requise",
            wpRequiredIntegrationDescription:
                "Désolé, la page que vous avez visité sera activée lors de l'intégration de votre WhatsApp.",
            integrateWp: "Allons-y, intégrons WhatsApp",
            active: "Actif",
            archived: "Archivé",
            createBroadcastMessage: "Créer un message de diffusion",
            title: "Titre",
            description: "Description",
            createdAt: "Créé à",
            numbers: "Nombres",
            actions: "Actions",
            action: "Action",
            createCustomerGroup: "Créer un groupe de clients personnalisé",
            search: "Recherche",
            name: "NOM",
            contacts: "Contacts",
            noContactFound: "Aucun contact trouvé",
            broadcastTitle: "Donnez un titre à votre diffusion.",
            recipients: "Destinataire",
            selectRecipients: "Sélectionner les destinataires",
            writeYourMessage: "Écrivez votre message.",
            schedule: "Calendrier",
            scheduleNowOrLater: "Horaire maintenant ou plus tard",
            summary: "Résumé",
            cancel: "Annuler",
            send: "Envoyer",
            sending: "Envoi en cours",
            deleteCustomerGroup: "Êtes-vous sûr de supprimer ce groupe de clients? {name}",
            customerGroupDeleting: "Suppression du groupe de clients ...",
            customerGroupDeletingSuccess: "Groupe de clients supprimé avec succès",
            customerGroupDeletingError: "Erreur lors de la suppression du groupe de clients",
            wpPlusRequired: "Plan WhatsApp plus requis.",
            broadcastMessageArchived: "Message de diffusion comme archivé",
            broadcastMessageNotArchived: "Le message de diffusion n'est pas archivé",
            groupNameSearch: "Tapez le nom du groupe de clients",
            groupNameDesc: "Nom du groupe de clients Identifiez vos groupes de clients",
            save: "Sauvegarder",
            number: "NOMBRE",
            addColumn: "Ajouter la colonne",
            addColumnDesc: "Ajouter une colonne à la table",
            addNewContact: "Ajouter un nouveau contact",
            addNewContactDesc: "Ajouter un contact à la table",
            importFile: "Importer depuis le fichier",
            importFileDesc: "Importer des contacts à partir du fichier Excel ou CSV",
            contactAdded: "Contact ajouté",
            updateCustomerGroup: "Mise à jour du groupe de clients ...",
            updateCustomerGroupSuccess: "Groupe de clients mis à jour avec succès",
            sendBroadcastMessage: "Envoyer un message de diffusion",
            columnName: "Nom de colonne",
            columnType: "Type de colonne",
            defaultValue: "Valeur par défaut",
            setDefaultValue: "Définissez la valeur par défaut sur les contacts",
            age: "Âge",
            location: "Emplacement",
            gender: "Genre",
            selectContactFile: "Sélectionnez le fichier de contact",
            selectContactCsvOrExcel: "Sélectionnez un fichier CSV ou Excel.",
            importConfiguration: "Configuration d'importation",
            customizeFile: "Personnalisez votre configuration d'importation.",
            sendMessageTo: "À qui voulez-vous envoyer le message?",
            allContact: "Tous les contacts",
            messageTypes: "Types de messages",
            whenSendMessage: "Quand voulez-vous envoyer le message?",
            instantlyRightNow: "Instantanément maintenant",
            completed: "Complété",
            scheduleFuture: "Planification pour une date future",
            messageDesc: "Votre message sera envoyé instantanément à tous les destinataires",
            messageSendAt: "Votre message sera envoyé à tous les destinataires à",
            estimatedPrice: "Prix ​​estimé",
            estimatedTime: "Temps estimé",
            now: "Maintenant",
            tenMinute: "10 minutes",
            cancelled: "Annulé",
            failed: "Échoué",
            running: "En cours",
            queued: "En queue",
            scheduled: "Programmé",
            noNumberAdded: "Aucun chiffre ajouté",
            csvOrExcelFile: "Fichier CSV ou Excel",
            broadcastMessagesToContactFile: "Diffuser les messages à la liste des contacts",
            broadcastMessageTemplates: "Modèles de messagerie",
            messageFlow: "Flux de messages",
            textMessageSupport: "Prise en charge du SMS",
            imageMessageSupport: "Prise en charge du message d'image",
            spamPreventions: "Prévention de spam",
            includesAllBasicPlans: "Comprend tout le plan de base",
            chatbotIntegration: "Intégration de chatbot",
            messageToNewNumbers: "Message à de nouveaux nombres",
            broadcastMessageToEveryone: "Diffuser des messages à tout le monde",
            personalizedBroadcastMessage: "Messages de diffusion personnalisés",
            customerGroupSegmentation: "Segmentation du groupe de clients",
            scheduleBroadcastMessage: "Planifier le message de diffusion",
            locationMessageSupport: "Prise en charge du message de localisation",
            advancedSpamPreventions: "Préventions de spam avancées",
            whatsappPlans: "Plans WhatsApp",
            selectBestPlan: "Choisissez le plan qui vous convient",
            comingSoon: "À venir...",
            selectFile: "Sélectionner un fichier",
            created: "Créé",
            message: "Message",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            trendyolQandA: "Questions et Réponses Trendyol",
            instagramComments: "Commentaires Instagram",
            messengerComments: "Commentaires Messenger",
            trendyolComments: "Commentaires Trendyol",
            facebookComments: "Commentaires Facebook",
            offlineTickets: "Tickets Hors Ligne",
            chatbotTickets: "Billets du Chatbot",
            ticketSettings: "Paramètres des Billets",
            ticketSelection: "Ticket Sélectionné",
            bulkClose: "Fermeture en Masse",
            igComment: "Commentaire Instagram",
            igMentioned: "Mentions Instagram",
            incomingReqChatbot: "Demandes entrantes avec Chatbot",
            incomingReqWebForm: "Demandes provenant d'un formulaire Web",
            incomingReqAutomation: "Demandes provenant de l'automatisation",
            thisPersonEmailAnswered: "Cette personne souhaite recevoir une réponse par courrier électronique",
            thisPersonWpAnswered: "Cette personne attend une réponse par WhatsApp",
            clickStartWpChat: "Cliquez pour démarrer le chat WhatsApp",
            requestProgress: "Progression de la demande",
            requestMessage: "Message de demande",
            clickAddMailAddress: "Cliquez pour ajouter une adresse e-mail",
            sendReplyCloseTicket: "Envoyer une réponse et fermer le ticket",
            closeTicket: "Fermer le ticket",
            selectEmailSender: "Sélectionner l'expéditeur du courrier électronique",
            withEmailWillNotRecievice:
                "Vous ne pourrez pas recevoir de réponses au courrier lorsque vous l'envoyez avec cette adresse électronique!",
            deleteCommentAndClose: "Supprimer et fermer le commentaire",
            sendReplyAndClose: "Envoyer une réponse et fermer",
            startChatWp: "Démarrer une discussion WhatsApp",
            sureWantToDeleteTicket: "Êtes-vous sûr de vouloir supprimer un ticket ?",
            bulkDeleteConfirmation: "Confirmation de suppression en bloc",
            selectedTicketSucsDelete: "Les billets sélectionnés ont été supprimés avec succès",
            thereErrorDeletingTicket: "Une erreur s'est produite lors de la suppression des tickets.",
            deleteConfirm: "Confirmer la suppression",
            sureDeleteTicket: "Êtes-vous sûr de vouloir supprimer ce ticket ?",
            ticketSucsDelete: "Ticket supprimé avec succès",
            represantiveSucsAppoint: "L'agent a été nommé avec succès",
            ticketClosedSucs: "Le ticket a été clôturé avec succès",
            ticketCloureFailed: "La clôture du ticket a échoué.",
            unprocessed: "Non traité",
            pleaseSelectValidStatus: "Veuillez sélectionner un statut valide",
            ticketStatusBeenUpdatd: "Le statut du ticket a été mis à jour.",
            doYouWantCloseTicket: "Voulez-vous fermer le ticket ?",
            ticketWillMarkedClosed: "Le ticket sera marqué comme clos et archivé",
            errorUpdatingTicketFailed: "Une erreur s'est produite lors de la mise à jour du statut du ticket",
            igCommentDeleteIgPost: "Le commentaire Instagram a été supprimé de votre publication IG.",
            igCommentHideChange: "Le statut de masquage des commentaires Instagram a été modifié",
            pleaseChooseRepresent: "Veuillez sélectionner un représentant.",
            selectedTicketSucsDelegated: "Les billets sélectionnés ont été délégués avec succès.",
            errorOccuredDuringDelegation: "Une erreur s'est produite pendant le processus de délégation.",
            bulkTicketClosing: "Fermeture d'un ticket en bloc",
            sureWantCloseTicket: "Êtes-vous sûr de vouloir fermer le ticket ?",
            selectedTicketSucsClosed: "Les tickets sélectionnés ont été clôturés avec succès.",
            thereErrorClosingTicket: "Une erreur s'est produite lors de la fermeture des tickets",
            changeFilterTicketPage: "Modifier les filtres sur la page Tickets",
            nameOfFilter: "Nom du filtre.",
            filterValue: "Valeur du filtre",
            deletesSelectedTickets: "Supprime les billets sélectionnés",
            idTicketBeDelete:
                "Les identifiants des billets à supprimer (identifiants des billets sélectionnés ou tous les identifiants des billets listés)",
            assignsAgentSelectedTickets: "Assigne un représentant aux tickets sélectionnés",
            idTicketBeAssigned:
                "IDs des tickets à assigner (IDs des tickets sélectionnés ou IDs de tous les tickets listés)",
            idAgentAssigned: "ID du représentant à assigner",
            changesStatusSelectedTicket: "Change le statut des tickets sélectionnés",
            idTicketWhoseStatus:
                "IDs des tickets dont le statut sera changé (IDs des tickets sélectionnés ou IDs de tous les tickets listés)",
            newStatus: "Nouveau statut",
            selectedTicketsSucsUpdated: "Le statut des tickets sélectionnés a été mis à jour avec succès.",
            errorWhileChangingStatus: "Une erreur s'est produite lors du changement de statut des tickets.",
            thisPageVoiceAssistant: "Cette page dispose d'un assistant vocal",
            hello: "Bonjour !",
            voiceAssistantContent: `Savais-tu qu'il y a un <strong>Assistant IA</strong> pour vous aider sur cette page ?
                Vous pouvez essayer les méthodes suivantes pour utiliser l'assistant :`,
            commandHoldingDownTheKey:
                "Vous pouvez donner des commandes en maintenant enfoncée une combinaison de touches et en parlant.",
            topRightContent: "Dans le coin supérieur droit",
            clickOnTheIcon: "vous pouvez démarrer l'assistant en cliquant sur l'icône.",
            sampleVoiceCommands: "Exemples de commandes vocales :",
            showMyTickets: "Montrer mes billets",
            showMeZeynepsOpenTicket: "Afficher les billets ouverts de Zeynep aujourd'hui",
            deleteTicketsScreen: "Supprimer les billets à l'écran",
            assigntLastTicketAli: "Attribuer le dernier ticket à Ali",
            changeStatusAllTicket: "Modifier le statut de tous les tickets pour qu'ils soient terminés",
            setStatusTicketsScreen: "Définit le statut des tickets à l'écran sur .......",
            assigntUserTicketScreen: "Attribuer les tickets à l'écran à l'utilisateur .....",
            assigntFirstTicket: "Attribuer le premier ticket à l'utilisateur",
            showIgTickets: "Affiche les tickets Instagram du mois dernier",
            makeChoice: "Effectuer une sélection",
            makeAssignment: "Assigner",
            tickets: "Tickets",
            instagramTickets: "Billets Instagram",
            facebookTickets: "Billets Facebook",
            trendyolTickets: "Billets Trendyol",
            automationTickets: "Tickets d'automatisation",
            supsisFormTickets: "Billets Supsis Form",
            columnSettings: "Paramètres des colonnes",
            ticketField: "Zone des billets",
            contactPropertyFields: "Zones de propriété de Reach",
            ticketFilterList: {
                archivedRequests: "Besondere Liste",
                comingFromFacebook: "En provenance de Facebook",
                comingFromInstagram: "En provenance de Instagram",
                unassignedOpenRequests: "Demandes ouvertes non affectées",
                openRequests: "Demandes ouvertes",
                requestsOpenedThisWeek: "Demandes ouvertes cette semaine",
                specialList: "Liste spéciale",
                creationDate: "Date de création",
                supsisFromTheForm: "Supsis From The Form",
                fromTrendyol: "De Trendyol",
                comesWithAutomation: "Vient de l'automatisation",
                label: "Étiquette",
                status: "Statut",
                subject: "Sujet",
                email: "Courriel",
                name: "Nom",
                phone: "Téléphone",
                type: "Type",
                assignedUser: "Utilisateur assigné",
            },
            appointingRepresentative: "Nommer un représentant",
            ticketTagFilter: "Étiquette de filtre de billets",
            ticketEmails: "Liste des e-mails de transfert de billets",
            save: "Sauvegarder",
            delete: "Supprimer",
            transactions: "Options",
            noEmailTicketNotifications: "Il n'y a pas de données",
            emailIsNotValid: "L'email n'est pas valide",
            emailNotificationDeleted: "Article supprimé avec succès",
            emailNotificationDeleteError: "Une erreur s'est produite",
            tagFilterRequired: "Tag de filtre de billets requis, utilisez * (wildcard) Tag pour tous les billets",
            emailsRequired: "Le transfert des e-mails ne doit pas être nul",
            emailNotificationCreated: "Règle de forwading de billets créé",
            emailNotificationCreateError: "Une erreur s'est produite",
            ticketForwarding: "Transfert d'e-mail de billet",
            ticketTagFilterDesc:
                "Il utilise les sujets de billets que vous avez utilisés dans la conception du chatbot pour filtrer les billets. Vous pouvez écrire une balise différente et appuyer sur Entrée pour l'ajouter. Si vous sélectionnez la balise '*', il sélectionnera tous les billets",
            ticketEmailsDesc:
                "Liste de messagerie vers laquelle les billets seront transmis. Vous pouvez ajouter les adresses des représentants du système en les sélectionnant. Vous pouvez également ajouter des e-mails sans système.",
            ticketList: "Règles de transfert de billets",
            ticketTagFilterPlaceHolder: "Filtre de billets, sélectionnez '*' pour tous",
            ticketEmailsPlaceHolder: "Transfert de la liste des e-mails",
        },
        theme: {
            opacity: "Opacité",
            headerColor1: "Couleur de section hader 1",
            headerColor1A: "Hader Section Opacité 1",
            headerColor2: "Couleur de section d'en-tête 2",
            headerColor2A: "Section d'en-tête Opacité 2",
            backgroundColor: "Couleur d'arrière-plan 1",
            backgroundColorA: "Opacité d'arrière-plan 1",
            backgroundColor2: "Couleur d'arrière-plan 2",
            backgroundColor2A: "Opacité arrière 2",
            textColor: "Couleur de texte",
            errorTheme: "Couleur d'erreur",
            bubbleBackground: "Couleur bulle représentative",
            bubbleVisitorBackground: "Couleur de bulle du client",
            bubbleBackgroundA: "Opacité de bulle représentative",
            bubbleVisitorBackgroundA: "Opacité de bulle du client",
            bubbleText: "Couleur de texte représentatif",
            bubbleVisitorText: "Couleur du texte du client",
            textFormColor: "Forme de couleur",
            selectCustom: "Sélectionnez le thème personnalisé",
            headerColorSecond: "Couleur du haut de l'en-tête",
            headerColorFirst: "Couleur du bas du titre",
            backgroundColorFirst: "Couleur de fond supérieure",
            formColor: "Couleur du texte du formulaire",
            buttonColor: "Couleur du bouton",
            backgroundColorSecond: "Couleur de fond de fond",
            chatBotButtonText: "Couleur du bouton du chatbot",
            chatBotButtonColor: "Couleur du bouton du chatbot",
        },
        billing: {
            paymentId: "ID de paiement",
            billType: "Type de facture",
            invoiceAmount: "Montant de la facture",
            invoiceDate: "Date de la facture",
            invoiceStatus: "Statut de la facture",
            invalidBill: "Facture non valide",
            invalidBillNotPossible: "Cette facture n'a pas été créée, elle ne peut donc pas être marquée comme non valide.",
            myInvoices: "Mes factures",
            allInvoices: "Toutes les factures",
            manualInvoices: "Factures manuelles",
            endOfPeriodInvoices: "Factures de période",
            purchaseInvoices: "Factures d'achat",
            paidInvoices: "Factures payées",
            unpaidInvoices: "Factures non payées",
            walletDeposit: "Dépôt de portefeuille",
            updateBillingInfo: "Mettre à jour les informations de facturation",
            notFoundSavedBillingAddress: "Aucune adresse de facturation enregistrée",
            notFoundSavedCard: "Aucune carte de crédit ajoutée",
            cardInfoIsStoredSecurelyByIyzico: "Les informations de la carte sont stockées en toute sécurité par Iyzico",
            paymentMethodAndInvoiceAddress: "Méthode de paiement et adresse de facturation",
            unpaidInvoiceBannerMessage: "Vous avez une facture impayée. Veuillez payer votre facture pour éviter une interruption de service.",
            unpaidInvoiceBannerMessageWithDate: "Vous avez une facture impayée. Si vous ne payez pas avant le {date}, votre compte sera suspendu.",
            clickToPay: "Aller à la page de paiement",
            packageDescriptions: {
                whatsapp: "Intégrez votre compte WhatsApp classique pour répondre aux clients sur tous les canaux.",
                whatsappBusiness: "Intégrez votre compte WhatsApp Business pour répondre aux clients sur tous les canaux.",
                supsis: "Avec plus de représentants, vous pouvez répondre à vos clients plus rapidement et efficacement.",
                chatbot: "L'intégration d'un chatbot vous permet de servir vos clients 24h/24 et 7j/7.",
                instagram: "Intégrez votre compte Instagram pour répondre aux clients sur tous les canaux.",
                telegram: "Intégrez votre compte Telegram pour répondre aux clients sur tous les canaux.",
                custom: "Choisissez l'un de nos plans personnalisés pour obtenir des solutions adaptées à votre entreprise.",
                messenger: "Intégrez votre compte Messenger pour répondre aux clients sur tous les canaux.",
                trendyol: "Intégrez votre compte Trendyol pour répondre rapidement aux questions de vos clients.",
                metaLead: "Intégrez votre compte Meta Lead pour gérer vos leads directement depuis le tableau de bord.",
                customerTables: "Créez des tableaux dynamiques pour gérer les informations clients, les commandes et bien plus encore.",
                form: "Créez des formulaires pour collecter des informations auprès de vos clients et analyser les données.",
                automation: "Configurez des automatisations pour optimiser vos processus et améliorer votre service.",
                mail: "L'intégration des emails vous permet d'envoyer et de recevoir des messages de vos clients.",
                tasks: "Créez des tâches pour planifier et gérer vos processus de travail.",
                artificialIntelligence: "L'intégration de l'intelligence artificielle vous aide à répondre aux clients plus rapidement et efficacement.",
                webhook: "Intégrez vos applications avec Supsis grâce aux webhooks.",
                default: "Explorez nos offres pour plus de détails.",
            },
            autoRenew: "Renouvellement automatique",
            purchased: "Acheté",
            currentPlans:"Mes plans",
            individual: "Individu",
            expirationDate: "EXP",
            yourNameSurname: "Il tuo nome e cognome",
            editCardInformation: "Modifier les informations de la carte",
            billingContactInfo: "Mise à jour réussie des coordonnées de facturation",
            defaultRootEmail: "Défaut : Courriel de base",
            invoiceEmailAddress: "Adresse électronique de la facture",
            invoiceSettings: "Paramètres de la facture",
            updateChannelDesc6: "Update Whatsapp business api channel",
            newWabaChannel: "Nouveau canal professionnel Whatsapp",
            newWabaChannelDesc: "Créer un nouveau canal pour l'api Whatsapp business",
            popular: "Populaire",
            selectedPlan: "Plan sélectionné",
            editPlan: "Modifier le plan",
            removePlan: "Supprimer le plan",
            showPlan: "Afficher le plan",
            hiddenPlan: "Plan caché",
            contactSales: "Contact Sales",
            showLess: "Afficher moins",
            more: "Plus",
            selectTransactionType: "Type de transaction",
            walletLogs: "Enregistrements du portefeuille",
            addBalance: "Ajouter du crédit",
            availableBalance: "Solde disponible",
            appsumoPack: "Appsumo Pack",
            updatePlan: "Mettre à jour le plan",
            createPlan: "Créer un plan",
            freePack: "Pack gratuit",
            instantFee: "Des frais instantanés seront facturés",
            planSequence: "Séquence du plan",
            requiredCodes: "Nombre de codes requis",
            subHeading: "Sous-titre",
            featureKey: "Clé de la caractéristique",
            customerKey: "Clé du client",
            monthlyPrice: "Prix mensuel",
            monthlyNonDiscounted: "Prix mensuel non actualisé (affichage non fonctionnel)",
            twoYearDiscount: "Remise sur 2 ans",
            yearDisccount: "Remise annuelle",
            sixMonthDiscount: "Remise de 6 mois",
            threeMonthDiscount: "Remise de 3 mois",
            features: "Propriétés",
            sessionCount: "Nombre de sessions",
            subType: "Type d'abonnement",
            skipTrialVersion: "Sauter la version d'essai",
            skipTrialVersionDesc:
                "Vous pouvez ignorer la version d'évaluation et continuer en sélectionnant le paquet approprié pour votre entreprise. Si vous sautez la version d'essai, cette action ne peut pas être annulée.",
            skipStep: "Sauter cette étape",
            switchToPay: "Passer au paiement",
            forward: "Avancer",
            pleaseFillInCard: "Veuillez remplir les détails de la carte !",
            fillInTheBillingAddress: "Veuillez remplir les informations relatives à l'adresse de facturation !",
            cardNumberWrong: "Le numéro de carte est erroné !",
            pleaseConfirmTheUser: "Veuillez confirmer le contrat d'utilisation.",
            pleaseCheckYourCard: "Veuillez vérifier votre carte et vos coordonnées.",
            site: "Site",
            period: "Période",
            billStatus: "Statut de la facture",
            totalPrice: "Prix total + TVA",
            depotMoneyWallet: "Dépôt dans le portefeuille",
            threeMonthly: "Tous les 3 mois",
            sixMonthly: "Tous les 6 mois",
            twoYearly: "2 ans",
            forever: "Pour toujours",
            extraPackage: "Paquet supplémentaire",
            teamPackage: "Paquet d'équipe",
            adventPackage: "Paquet avantageux",
            cupponError: "Le code du bon est incorrect ou expiré.",
            enterYourCard: "Veuillez saisir votre carte de crédit.",
            invalidCard: "Carte de crédit non valide, paiement non reçu.",
            calculateThis: "Calculer pour :",
            adventageousPackage: "Remises avantageuses sur les forfaits !",
            cupponApplied: "Coupon appliqué avec succès",
            subStart: "Abonnement initié",
            subSuccessStart: "Votre abonnement a démarré avec succès",
            success: "Succès",
            succesDesc: "Abonnement créé avec succès",
            successDesc: "Votre fonction a été activée avec succès.",
            maxNumber: "Nombre maximal de représentants qui prendront la parole",
            currentAmountDetails: "Détails du montant actuel",
            endOfMonthForecastDetails: "Détails des prévisions de fin de mois",
            totalAmount: "Montant total",
            vatAmount: "Montant de la TVA (20 %)",
            totalAmountIncludingVAT: "Montant total incluant la TVA",
            hideDetails: "Cacher les détails",
            createInvoice: "Créer une facture",
            reimbursementMade: "Remboursement effectué",
            invalidInvoice: "Facture non valide",
            balanceTopUp: "Rechargement du solde WhatsApp",
            paidSuccesfully: "La facture a été payée avec succès",
            paymentFailed: "Le processus de paiement de la facture a échoué",
            areYouSurePaid: "Êtes-vous sûr de vouloir que cette facture soit marquée comme payée ?",
            invoiceMarkedPaid: "La facture a été marquée comme payée",
            invoiceMarkedFailed: "Une erreur s'est produite et la facture n'a pas pu être marquée comme payée",
            areYouSoreRefundInvoice: "Êtes-vous sûr de vouloir effectuer un remboursement pour cette facture ?",
            youMustFillInEmpty: "Vous devez remplir tous les espaces vides.",
            createdNewInvoice: "La nouvelle facture a été créée avec succès",
            createdNewInvoiceFailed: "Une erreur s'est produite lors de la création de la facture",
            invoiceUpdated: "Le montant de la facture a été mis à jour avec succès...",
            invoiceUpdatedFailed: "Un problème a été rencontré lors de la mise à jour de la facture",
            plans: "Plans",
            companyName: "Nom de l'entreprise",
            compony: "Entreprise",
            person: "Personne",
            invoiceAddressInfo: "Informations sur l'adresse de la facture",
            idNo: "Identifiant turc",
            taxOffice: "Bureau des impôts",
            taxNumber: "Numéro d'identification fiscale",
            packageCanotDownSupsis:
                "Votre paquet ne peut pas être déclassé. Veuillez supprimer ou désactiver plusieurs de vos agents pour rétrograder votre paquet.",
            packageCanotDownWp:
                "Votre forfait ne peut pas être déclassé. Veuillez supprimer plusieurs de vos canaux Whatsapp pour rétrograder votre forfait.",
            packageCanotDownWPBussiness:
                "Votre forfait ne peut pas être déclassé. Veuillez supprimer plusieurs de vos canaux professionnels Whatsapp pour rétrograder le statut de votre forfait.",
            chooseYourPlan: "Choisissez votre plan.",
            numberOfRepresentatives: "Nombre de représentants",
            numberOfChannels: "Nombre de canaux",
            wpNumberOfChannels: "Nombre de canaux Whatsapp",
            igNumberOfChannels: "Nombre de canaux Instagram",
            msNumberOfChannels: "Nombre de canaux Messenger",
            cancelIt: "Annuler",
            activePlan: "Plan actif",
            activate: "Activer",
            noTransition: "Pas de transition",
            daysLater: "jours plus tard",
            payBack: "Remboursement",
            paid: "Payé",
            unPaid: "Non payé",
            editPrice: "Modifier le prix",
            payNow: "payer maintenant",
            youAreCurrentlyOnTrial:
                "Vous êtes actuellement en procès. Vous pouvez passer la période d'essai maintenant pour voir les forfaits exclusifs.",
            youAreCurrentlyLimited:
                "Vous êtes actuellement limité par le système car vos forfaits ne remplissent pas les conditions.",
            youHaveOneRepresentative: "Vous avez un représentant.",
            deactivateOrDeleteYourPiece: "Désactivez ou supprimez votre représentant ou achetez un représentant.",
            youHaveOneWhatsappQRChannel: "Vous avez un canal QR Whatsapp.",
            deleteYourWhatsAppQR: "Supprimez votre canal QR Whatsapp ou achetez un canal.",
            youHaveAWhatsappBusiness: "Vous avez un canal Whatsapp Business.",
            deleteYourWhatsapp: "Supprimez votre chaîne Whatsapp Business ou achetez une chaîne.",
            youHaveAnInstagram: "Vous avez une chaîne Instagram.",
            deleteYourInstagram: "Supprimez votre chaîne Instagram ou achetez une chaîne.",
            youHaveAMessenger: "Vous avez une chaîne Messenger.",
            deleteYourMessenger: "Supprimez votre chaîne Messenger ou achetez une chaîne.",
            additionalPackages: "Packages supplémentaires",
            availablePackages: "Forfaits disponibles",
            buyNow: "Acheter maintenant",
            invoiceInformation: "Informations de facturation",
            invoiceAddress: "Adresse de facturation",
            invoiceType: "Type de facture",
            review: "Revue",
            viewDetails: "Voir les détails",
            addNewAddress: "Ajouter une nouvelle adresse",
            enterYourBillingAddress: "Entrez votre adresse de facturation",
            selectPlan: "Sélectionner un forfait",
            paymentStatus: "Statut de paiement",
            amount: "Montant",
            invoiceID: "ID de facture",
            expected: "Attendu...",
            currentAmount: "Montant actuel",
            monthlyEstimatedAmount: "Montant estimé mensuel",
            creationDate: "Date de création",
            invoicePeriod: "Période de facturation",
            newPaymentMethod: "Nouvelle méthode de paiement",
            channelCount: "Nombre de canaux",
            remainingTime: "Temps restant",
            chatbotLimit: "Limite de chatbot",
            free: "Gratuit",
            maxChatbotSession: "Sessions maximum de chatbot",
            buyIt: "Acheter",
            renewalDate: "Date de renouvellement",
            monthly: "Mensuel",
            yearly: "Annuel",
            packagePeriod: "Période du package",
            packageType: "Type de package",
            packageManagement: "Gestion des packages",
            invoiceManagement: "Gestion des factures",
            futureInvoice: "Facture future",
            pastInvoices: "Factures passées",
            creditCard: "Carte de crédit",
            invoice: "Facture",
            mustBeUpgradePlanForChatBot: "Pour activer la fonction de chatbot, vous devez passer au plan Pro!",
            cardInfo: "Informations sur la carte",
            billingDetails: "Détails de la facturation",
            addCardIyzico:
                "Vous n'avez pas de carte enregistrée. Afin de payer vos frais d'utilisation mensuels, vous devez ajouter une carte. Le système de paiement est fourni par Iyzico.",
            billingPlanSettings: "Facture",
            startWith: "{cardFamily} La carte commence par {binNumber}",
            paymentMethod: "Mode de paiement",
            billingDate: "Date de facturation",
            isPaid: "Est payé?",
            markPaid: "Marquez comme payé",
            paymentDate: "Date de paiement",
            pay: "Payer",
            newInvoice: "Créer une facture",
            updateBilling: "Mettre à jour les détails de facturation",
            updateCard: "Changer la carte de crédit",
            paymentBilling: "Méthode de paiement et détails de facturation",
            price: "Prix",
            billingAddress: "adresse de facturation",
            billingCity: "Ville",
            billingCountry: "Pays",
            contactName: "Nom de contact de facturation",
            expireMonth: "Expirer le mois",
            expireYear: "Expirer l'année",
            expireDate: "Date d'expiration",
            cardNumber: "Numéro de carte",
            cardHolderName: "Nom du titulaire",
            cardAlias: "Alias ​​de la carte",
            identityNumber: "Numéro d'identité",
            name: "Nom",
            surname: "Nom de famille",
            email: "E-mail",
            addCard: "Ajouter une carte",
            update: "Mise à jour",
            cancel: "Annuler",
            save: "Sauvegarder",
            saving: "Économie",
            noInvoiceFound: "Il n'y a pas de facture",
            year: "Année",
            updating: "Mise à jour ...",
            newInvoiceForm: "Nouvelle facture Créer une forme",
            error: "Erreur",
            transactions: "Options",
            paymentMethodAdded: "Le mode de paiement a ajouté avec succès",
            paymentMethodAddError: "Le mode de paiement n'a pas ajouté, une erreur s'est produite",
            creditCardChanged: "La carte de crédit a changé avec succès",
            errorOccurred: "Une erreur s'est produite, réessayez",
            billingDetailUpdated: "Les détails de facturation ont réussi à mettre à jour",
            invoiceCreated: "La facture a créé avec succès",
            paymentSuccess: "Paiement avec succès, merci",
            paymentFail: "Paiement échoué, réessayez",
            billingAddressChanged: "L'adresse de facturation a changé avec succès",
            hidePlan: "Plan de cachette",
            informationShopping:
                "Vos informations de paiement, les informations de facturation, les informations sur la carte de crédit sont contrôlées par Shopify.",
            trialTimeInformation:
                "Le procès se termine {dayCount} jours après. Si vous n'entrez pas de mode de paiement avant l'expiration de cette période, vous serez automatiquement passé au plan libre par le système.",
            trialTimeInformationShort: "Essai: dernier {dayCount} jour",
            currentPlanLabel: "Plan actuel: {planName} ({agentCount} Agent)",
            changeCancelPlan: "Plan de modification / annulation",
            oneAgent: "Agent",
            agent: "Agent",
            yourCurrentPlan: "Plan actuel",
            month: "Mois",
            billedMonthToMonth: "(facturé de mois en mois)",
            selectAgentCount: "Sélectionner le nombre d'agents",
            selectFreePlan: "Sélectionnez le plan gratuit",
            planDetails: "Détails du plan",
            multiAgent: "(Multi agent)",
            selectProPlan: "Sélectionner le plan Pro",
            foreverFree: "Libre pour toujours",
            websiteIntegration: "Intégration du site Web",
            websiteIntegrationUnlimited: "Intégration du site Web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Appel vidéo",
            multiAgentUpTo: "Multi agent (jusqu'à {agentCount} Agent)",
            audioCallUnlimited: "Appel audio",
            screenSharingUnlimited: "Partage d'écran",
            fileTransferUnlimited: "Transfert de fichier",
            autoChatAssignerUnlimited: "Assistant de chat automatique",
            multiLanguageTranslationUnlimited: "Traduire automatiquement",
            detailedReporting: "Déclaration",
            days30TrialsAvailable: "Essais de 30 jours disponibles",
            limitedArchiveLookupLastMo: "Lookup d'archives limité (dernier {monthCount}-mo)",
            fullCustomizationUnlimited: "Personnalisation",
            planUpdated: "Super, votre plan est mis à jour.",
            planUpdating: "Votre plan est de mise à jour ...",
            planUpdatingDescription: "Veuillez patienter pendant la mise à jour de votre plan",
            done: "Fait",
            freePlanUpdated: "Votre plan est mis à jour en tant que plan gratuit. (MAX Agent Credit: 1)",
            proPlanUpdated:
                "Votre plan est mis à jour en tant que plan professionnel. (MAX Agent Credit: {proPlanUpdated})",
            canNotDwnGrade:
                "Impossible de rétrograder votre plan de Pro {agentCountFirst} Agent (s) vers {valNewPlnToUppr} {agentCountSecond}. Votre agent crédits utilisés.",
            deleteWarning: "Vous devez supprimer ou désactiver {valDif} agent (s)",
            warnMessage: "Le plan sélectionné doit être différent du plan actuel",
            add: "Ajouter",
            cancelYourPlan: "Annuler votre plan",
            upgradeYourPlan: "Améliorez votre plan",
            downgradeYourPlan: "Rétrograder votre plan",
            agree: "ACCEPTER",
            disagree: "ÊTRE EN DÉSACCORD",
            invoices: "Facture",
            priceIntervals: "Intervalle de prix",
            selectSiteAlias: "Sélectionnez ou entrez le nom du site",
            selectPriceInterval: "Sélectionnez ou entrez l'intervalle de prix",
            isRefunded: "Est remboursé?",
            invoiceId: "Facture non",
            siteId: "Site no",
            createdDate: "Date de création",
            failCount: "Nombre de tentatives de récupération de paiement échouées",
            failDate: "Date de paiement échoué",
            Dashboard: "Tableau de bord",
            Agents: "Agents",
            Integration: "L'intégration",
            Settings: "Paramètres",
            Contacts: "Contacts",
            Domain: "Domaine",
            lastActivity: "Dernière Activité",
            basePrice: "Prix ​​de base",
            packagePrice: "Prix ​​du coffret",
            whatsappPrice: "Prix ​​WhatsApp",
            realtimeVisitorCount: "Visiteur en temps réel",
            suspend: "Suspendre",
            partner: "Partenaire",
            plan: "Plan",
            trialDay: "Jours d'essai",
            mobile: "Mobile",
            webSite: "Site Internet",
            websiteOrigins: "Origine du site Web",
            ownerName: "Le nom du propriétaire",
            ownerEmailAddress: "Courriel du propriétaire",
            discount: "Rabais",
            daysLeft: "Jours restants",
            newTrialPopUp: "Combien de jours la nouvelle période d'essai devrait-elle être?",
            newWpPricePopUp: "Combien coûtent les nouveaux frais WhatsApp?",
            newIGPricePopUp: "Combien coûtent les nouvelles frais Instagram?",
            newBasePricePopUp: "Combien coûte le nouveau prix de base?",
            siteInfoUpdated: "Informations sur le site Mises à jour",
            siteInfoNotUpdated: "Informations sur le site non mises à jour",
            siteInfoNotUpdatedErr: "Erreur est survenue! Informations sur le site non mises à jour.",
        },
        tour: {
            closeChat: "Chatte",
            ticket: "Billet",
            formStep: "Étape de forme",
            menuStep: "Étape du menu",
            contentStep: "Étape de contenu",
            menuTitle: "Titre de menu",
            messageContent: "Contenu du message",
            goToLive: "Représentant Connect",
            stats: "Groupe de statistiques",
            settings: "PARAMÈTRES",
            status: "STATUT",
            prevStep: "Étape précédente",
            nextStep: "L'étape suivante",
            finish: "Finir",
            skip: "Sauter",
            skip2: "Sauter, je sais que le système",
            startTour: "Tour initial",
            firstTimeIntro:
                "Vous entrez dans le système pour la première fois, je souhaite présenter l'application si vous autorisez",
            hi: "Salut",
            welcomeTo: "Bienvenue au soutien en direct du Supsis",
            statsPanel:
                "Il s'agit de la barre d'état indiquant les numéros de chat totaux et actifs qui attendent instantanément avec le système.",
            sidebarMenu: "MENU",
            sidebarMenuContent: "Vous pouvez basculer entre les pages ici.",
            representativePrivateMessage: "Panneau de conversation inter-représentatif",
            representativePrivateMessageContent: "Vous pouvez voir des conversations privées entre les agents ici.",
            helpMenu: "Menu d'aide",
            helpMenuContent: "Vous pouvez trouver des informations d'aide sur le système ici.",
            settingsMenu: "Menu des paramètres",
            settingsMenuContent:
                "Vous pouvez faire ici la langue, le mode nocturne et les étapes d'agrandissement d'écran.",
            startChat: "Démarrer la discussion",
            profileMenu: "Menu de profil",
            profileMenuContent:
                "Vous pouvez modifier votre disponibilité et définir les paramètres de votre agent ici.",
            visitorsTab: "Visiteurs",
            visitorsTabContent: "Vous pouvez voir les visiteurs ici.",
            visitorTabHistory: "Histoire des visiteurs",
            visitorTabHistoryContent: "Vous pouvez voir l'histoire des visiteurs ici.",
            representativeTab: "Représentants",
            representativeTabContent: "Vous pouvez voir les représentants ici.",
            liveSupport: "Support en direct",
            liveSupportContent: "Vous pouvez voir le nombre de clients recevoir un support en direct ici.",
            siteVisitors: "Visiteurs du site",
            siteVisitorsContent: "Vous pouvez voir le nombre de visiteurs du site ici.",
            tableSettings: "Paramètres de la table",
            tableSettingsContent: "Vous pouvez afficher ou masquer des colonnes dans le tableau ici.",
            watchModeButton: "Bouton de la visionneuse",
            watchModeContent: "Vous pouvez vous joindre ici en mode Viewer et vous ne pouvez voir ce qui est publié.",
            popoverInfo: "Détails du visiteur",
            popoverInfoContent: "Il donne des informations sur le visiteur.",
            popoverButton: "Paramètres de chat avancés",
            popoverButtonContent:
                "Vous pouvez ouvrir la conversation, envoyer un message directement au représentant ou bloquer le visiteur.",
            openChat: "Rejoignez le bouton de conversation",
            openChatContent: "Vous pouvez ouvrir la conversation ici",
            pagination: "Menu de pagination.",
            paginationContent: "Vous pouvez augmenter le nombre de pages ici.",
            changeLang: "Peut changer la langue du système",
            changeTheme: "Peut changer le thème sombre et clair",
            changeStatus: "Peut modifier votre statut de disponibilité",
            logout: "Peut déconnecter le système d'ici",
            chatwindow: {
                chatWindowActionButtons: "Boutons d'action de fenêtre de chat",
                chatPanelActions: "Actions du panneau de chat",
                otherPanels: "Autres panneaux",
                chatColorButton: "Montrez un sens des couleurs de barre de chat",
                keyboardShortcutButton: "Afficher les fonctions de raccourcis KeyBpard",
                hideButton: "Minimiser le chat actuel sans sortir",
                closeButton: "Forcer la fermeture et sortir du chat actuel",
                ellipsisButton:
                    "Plus d'actions de chat. Minimiser, fermer, interdire le visiteur, envoyer un message privé, affecter un représentant",
                userInfoWidget: "Afficher le détail du visiteur du propriétaire de l'utilisateur actuel du chat",
                preparedContentWidget:
                    "Widget de modèles de messages préparés, peut sélectionner rapidement un modèle de message sur le chat actuel",
                chatHistoryWidget: "S'il y a des antécédents de chat du visiteur actuel, peut les voir",
                chatWindowSettingsButtons: "Bouton Paramètres de la fenêtre de parler",
                settingsButton:
                    "Vous pouvez bloquer la conversation, transmettre, un message confidentiel et attribuer des délégués.",
                chatBarButton:
                    "Ici, vous pouvez bloquer la conversation active, envoyer un message privé à l'agent et laisser la conversation.",
            },
        },
        adminUser: {
            newAdminUserForm: "Nouveau formulaire de registre d'utilisateurs d'administration",
            updateAdminUserForm: "Formulaire de mise à jour de l'utilisateur de l'administrateur",
            adminUsers: "Utilisateurs administratifs",
            newAdminUser: "Nouvel utilisateur administrateur",
            noAdminUser: "Aucun utilisateur d'administration encore",
            adminUserName: "Nom d'utilisateur admin",
        },
        report: {
            channel: "Canal",
            channelType: "Type de canal",
            contactCount: "Nombre de contacts",
            tag: "Étiquette",
            owner: "Propriétaire",
            email: "Email",
            language: "Langue",
            approvalCount: "Nombre d'approbations",
            adTitle: "Titre de l'annonce",
            sourceType: "Type de source",
            contactDistributions: "Distributions des contacts",
            mostUsedTag: "Tag le plus utilisé",
            leastUsedTag: "Tag le moins utilisé",
            timeDistribution: "Distribution des contacts par temps",
            channelDistribution: "Distribution des contacts par canal",
            tagDistribution: "Distribution des contacts par tags",
            platformDistribution: "Distribution des contacts par plateforme",
            ownerDistribution: "Distribution des contacts par propriétaire",
            languageDistribution: "Distribution des contacts par langue",
            adsDistribution: "Distribution des contacts par publicité",
            contactPropertyDistribution: "Distribution des contacts par propriétés de contact",
            totalPersonCount: "Nombre total de contacts",
            averagePersonCount: "Nombre moyen de contacts",
            personCount: "Nombre de contacts",
            person: "Contact",
            mostEffectiveAd: "Publicité la plus efficace",
            leastEffectiveAd: "Publicité la moins efficace",
            mostUsedChannel: "Canal le plus utilisé",
            leastUsedChannel: "Canal le moins utilisé",
            columnChart: "Graphique en colonnes",
            pieChart: "Graphique circulaire",
            mostUsed: "Le plus utilisé",
            leastUsed: "Le moins utilisé",
            mostUsedLanguage: "Langue la plus utilisée",
            leastUsedLanguage: "Langue la moins utilisée",
            mostAssigned: "Le plus assigné",
            leastAssigned: "Le moins assigné",
            mostUsedPlatform: "Plateforme la plus utilisée",
            leastUsedPlatform: "Plateforme la moins utilisée",
            commentAnalysis: "Analyse des commentaires",
            whatsappChannelDistribution: "Distribution des chats par canaux WhatsApp",
            instagramChannelDistribution: "Distribution des chats par canaux Instagram",
            messengerChannelDistribution: "Distribution des chats par canaux Messenger",
            trendyolChannelDistribution: "Distribution des chats par canaux Trendyol",
            metaLeadsChannelDistribution: "Distribution des chats par canaux Meta Leads",
            chatDistributionByTelegramChannels: "Distribution de chat par canaux Telegram",
            chatDistributionByLinkedinChannels: "Distribution de chat par canaux Linkedin",
            channelTimeseries: "Chronologie des canaux",
            channelPies2: "Distribution des canaux",
            date: "Date",
            incomingMessages: "Messages entrants",
            outgoingMessages: "Messages sortants",
            customerCount: "Nombre de clients",
            mailCount: "Nombre de courriers",
            answered: "Répondu",
            unanswered: "Sans réponse",
            selectaChannel: "sélectionner un canal",
            sentMails: "Courriers envoyés",
            sentMailCount: "Nombre de courriers envoyés",
            eventCount: "Nombre d'événements",
            ticketDistribution: "Distribution des billets",
            selectWorkflow: "Sélectionnez votre flux de travail ",
            distributionOfTasks: "Distribution des tâches",
            mostMissioned: "Missionné le plus",
            leastTask: "Moins de tâches",
            totalNumberTasks: "Nombre total de tâches",
            errorFetchingTask: "Erreur de réception des données de la tâche :",
            pipelinePhase: "Phase du pipeline",
            status: "Statut",
            numberOfTasks: "Nombre de tâches",
            insufficientData: "Données insuffisantes",
            hourly: "(Horaire)",
            hourlyAverage: "Moyenne horaire",
            hourlyMax: "Maximum horaire",
            hourlyMin: "Minimum horaire",
            totalAmount: "Montant total",
            averageAmount: "Montant moyen",
            minAmount: "Montant minimum",
            maxAmount: "Montant maximum",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Séries chronologiques des canaux",
            channelPies: "Tartes de canal",
            pieView: "Diagramme circulaire",
            topVisitorCountry: "Pays le plus visité",
            websiteTrafficByCountry: "Trafic du site web par pays",
            visitorCount: "Nombre de visiteurs",
            websiteVisitorTraffic: "Trafic des visiteurs du site web",
            websiteTraffic: "Trafic du site web",
            author: "Auteur",
            topWorstComments: "Pires commentaires",
            topBestComments: "Meilleurs commentaires",
            topComments: "Meilleurs commentaires",
            noComment: "Pas encore de commentaires",
            minWaitingTime: "Temps d'attente minimum",
            maxWaitingTime: "Temps d'attente maximum",
            averageWaitTime: "Temps d'attente moyen",
            waitTime: "Temps d'attente (secondes)",
            agentWaitDurationTitle: "Graphique de la durée d'attente de l'agent",
            incomingMessage: "Message(s) entrant(s)",
            outgoingMessage: "Message(s) sortant(s)",
            totalSpent: "Dépense totale",
            avgSpent: "Dépense moyenne",
            totalPayment: "Paiement total",
            walletStatus: "Statut du portefeuille",
            walletBalanceStatus: "Statut du solde du portefeuille",
            messageTraffic: "Trafic de messages",
            breakCount: "Nombre de pauses",
            agentBreakTime: "Nombre de pauses des agents ☕",
            agentStatusHour: "Heure de statut de l'agent",
            agentWorkTimeCalendar: "Calendrier du temps de travail de l'agent",
            agentActivity: "Activité de l'agent",
            noEnoughtData: "Pas assez de données",
            averageFirstResponse: "Temps moyen de première réponse",
            slowestResponser: "Le plus lent à répondre",
            fastestResponder: "Le plus rapide à répondre",
            firstAnswerTimeSec: "Temps de la première réponse (en secondes)",
            firstAnswerByAgent: "Temps de la première réponse par l'agent",
            averageSolutionTime: "Temps de résolution moyen",
            slowestSolver: "Résolveur le plus lent",
            fastestSolver: "Résolveur le plus rapide",
            averageChat: "Chat moyen",
            leastChatReceiver: "Récepteur de chat le moins actif",
            mostChatRecipients: "Le plus grand nombre de destinataires de chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Temps de résolution (min)",
            resolveTimeByUser: "Temps de résolution du chat par l'utilisateur (en minutes)",
            chatResolveTimeByAgent: "Temps de résolution du chat par les agents",
            chatDistByHandleType: "Répartition des chats par gestionnaire",
            chatDistByHandDesc: "Combien de chats ont été gérés par des agents, des chatbots et des hybrides?",
            chatCountsByHandleType: "Nombre de chats par type de traitement",
            missed: "Manqué",
            chatDistByAnsDesc: "Combien de discussions ont été répondues ou manquées?",
            chatCountsByAns: "Nombre de discussions par réponse",
            chatCountByPlatform: "Nombre de discussions par plateforme",
            chatDistByPDesc: "Combien de discussions sont venues sur quelle plateforme ?",
            chatDistByPlatform: "Distribution des discussions par plateforme",
            ticketCountByUser: "Nombre de billets par agent",
            ticketCountByStatus: "Nombre de billets par statut de réponse",
            user: "Utilisateur",
            saveAsImage: "Enregistrer en tant qu'image",
            fullScreen: "Plein écran",
            download: "Télécharger",
            tableView: "Vue tableau",
            chartView: "Vue graphique",
            chatDistByUsers: "Répartition des discussions par utilisateurs",
            chatCountsByUsers: "Nombre de discussions par utilisateurs",
            minDuration: "Durée minimale",
            maxDuration: "Durée maximale",
            totalDurationByAgent: "Durée totale de la session par agent",
            averageDurationByAgent: "Durée moyenne de la session par agent",
            totalDurationByCB: "Durée totale de la session par chatbot",
            averageDurationByCB: "Durée moyenne de la session par chatbot",
            viewUnitAs: "Afficher l'unité comme",
            hybrid: "Hybride",
            handledBy: "Traité par",
            sessionDurationOverall: "Durée totale de la session",
            allChannels: "Tous les canaux",
            sessionsDurationOverall: "Durée totale des sessions",
            sessionsOverall: "Sessions globales",
            calendarEvents: "Événements de calendrier",
            reservationEvents: "Événements de réservation",
            incomingMails: "Mails entrants",
            incomingMailCount: "Nombre de mails entrants",
            reservation: "Réservation",
            event: "Événement",
            reservationEventCount: "Nombre d'événements de réservation",
            channelBreakdown: "Répartition des canaux",
            websiteAnalysis: "Analyse du site Web",
            customerSatisfaction: "Satisfaction client",
            teamBreakAnalysis: "Analyse des pauses d'équipe",
            dailyAgentActivity: "Activité quotidienne de l'agent",
            agentPerformance: "Performance de l'agent",
            chatDistributions: "Répartition des chats",
            users: "Utilisateurs",
            segmentTimeseries: "Série temporelle du segment",
            segmentsOverall: "Segments Globaux",
            unmatchRatio: "Taux de non-correspondance",
            totalMatchCount: "Nombre total de correspondances",
            totalUnmatchCount: "Nombre total de non-correspondances",
            matchRatio: "Taux de correspondance",
            matched: "Correspondant",
            trainingOverall: "Formation globale",
            trainingStatusTimeseries: "Série temporelle de l'état de formation",
            duration: "Durée",
            totalSessionDuration: "Durée totale de la session",
            averageSessionDuration: "Durée moyenne de la session",
            second: "seconde",
            minute: "minute",
            hour: "heure",
            aggregateAs: "Agréger comme",
            chatbotSessionDurationOverall: "Durée totale de la session du chatbot",
            ratingTimeSeries: "Série temporelle des évaluations",
            chatCountTimeseries: "Série temporelle du nombre de chats",
            notRated: "Non évalué",
            totalRatingCount: "Nombre total d'évaluations",
            averageRating: "Évaluation moyenne",
            weightedAverageRating: "Évaluation moyenne pondérée",
            rate: "Évaluer",
            ratingOverall: "Notation des clients dans l'ensemble",
            session: "Session",
            total: "Total",
            average: "Moyenne",
            max: "Maximum",
            min: "Minimum",
            sessionCount: "Nombre de sessions",
            uniqueUsers: "Utilisateurs Uniques",
            viewAs: "Afficher en tant que:",
            overall: "Global",
            detailReport: "Rapport détaillé",
            dailyReports: "Rapports quotidiens",
            pointBasedReports: "Rapports de points",
            personDateBasedPointReport: "Rapport de points de la personne et de la date",
            personDateBasedReport: "Rapport de personne et de date",
            personBasedReport: "Rapports basés sur la personne",
            personAndDateBasedGraph: "Graphique de personne et de date",
            noReport: "Aucun rapport",
            reports: "Rapports",
            totalBar: "Total",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "Nombre de tous les chats ouverts",
            active: "Nombre de chats actifs attribués à vous",
            waiting: "Nombre de visiteurs attendant qu'un représentant entre",
            late: "Nombre de visiteurs attendant plus d'une certaine période",
            free: "Nombre de visiteurs gratuits en attendant que le nouveau représentant entre",
            pco: "[Taux d'utilisation de la capacité] Taux de travail Charge de capacité de chat représentative active",
            maxCapacity: "Nombre maximum de chat que le système peut attribuer des représentants sans attendre",
            chatbot: "Nombre de discussions actives avec chatbot",
        },
        time: {
            lastYear: "L'Année Dernière",
            thisYear: "Cette Année",
            last3Months: "3 Derniers Mois",
            last7: "7 Derniers Jours",
            today: "Aujourd'hui",
            yesterday: "Hier",
            lastWeek: "La semaine dernière",
            currentWeek: "Cette semaine",
            currentMonth: "Ce mois-ci",
            lastMonth: "Le mois dernier",
            last30Day: "30 derniers jours",
            allTime: "Chaque fois",
            custom: "Date de personnalité",
        },
        fastWizard: {
            generalColors: "Couleurs générales",
            tellUsMore: "Dites-nous plus, afin que nous puissions personnaliser votre expérience",
            moreInfo: "Plus d'informations",
            display: "Afficher",
            availability: "Disponibilité",
            preview: "Aperçu",
            installCode: "Installer le code",
            previous: "Précédent",
            setupSupsisLiveChat: "Configurer le chat en direct du Supsis",
            continue: "L'étape suivante",
            completeInitialize: "Configuration complète",
            completedMessage: "La configuration de chat en direct en direct a terminé avec succès.",
            websiteIntegration: "L'adresse de votre site Web pour intégrer le chat en direct Supsis",
            customizeLiveChat: "Personnalisez votre chat en direct",
            createBrandedExperience: "Créez une expérience de chat de marque pour vos visiteurs.",
            chatColor: "Couleur de chat",
            chooseChatColor: "Choisissez une couleur d'accent.",
            chatBubble: "Bulle de chat",
            selectBubble: "Sélectionnez une bulle de chat",
            chatBubbleColor: "Couleur de bulle de chat",
            selectChatBubbleColor: "Sélectionnez une couleur de bulle de chat",
            customSelection: "Sélection personnalisée:",
            chatAvailability: "Disponibilité du chat",
            onlineSupportVisitorTime: "Quand êtes-vous en ligne pour soutenir vos visiteurs?",
            channelAvailability: "Disponibilité du canal",
            availability724: "Le chat est disponible 7/24",
            basedOnTeam: "Basé sur le statut des membres de l'équipe",
            basedOnTeamExplanation: "Le chat apparaîtra en ligne quand au moins 1 membre est réglé sur",
            customHours: "Heures d'ouverture personnalisées",
            customHoursExplanation: "Configurez vos heures d'ouverture",
            customHoursTimezone: "Fuseau horaire:",
            customHoursFrom: "Depuis:",
            customHoursTo: "Pour:",
            customHoursAddHours: "+ Ajouter des heures",
            previewDesktop: "Bureau",
            previewIpad: "IPad",
            installationAndInstructions: "Instructions d'installation",
            installationTrackingCode: "Installez le code de suivi sur votre site Web",
            installationTrackingCodePlease:
                "Veuillez coller le code conformément aux instructions ci-dessous, juste avant la fin de la balise {bodyTag} sur n'importe quelle page où vous souhaitez activer le chat en direct du Supsis.",
            installationInstructionsJavascript:
                "Collez le code d'intégration indiqué ci-dessus dans la balise {bodyTag} juste avant la fermeture.",
            installationInstructionsCopy: "Copie",
            installationInstructionsCoppyMessage: "Script d'intégration copié dans le presse-papiers",
            installationInstructionsShopify1: "1. Connectez-vous à votre panneau Shopify",
            installationInstructionsShopify2:
                "2. Accédez à la boutique en ligne> Thèmes> Menu déroulant Actions sous le thème actuel> Modifier le code> thème.liquid",
            installationInstructionsShopify3:
                "3. Placez Coller le code d'intégration indiqué ci-dessus juste avant la balise {bodyTag} à la fin du thème.liquid Script.",
            installationInstructionsIdeaSoft1: "1. Connectez-vous à votre panneau de concessionnaire.",
            installationInstructionsIdeaSoft2: "2. Accédez aux paramètres -> SEO -> Services de moteur de recherche.",
            installationInstructionsIdeaSoft3:
                '3. Sélectionnez "Vérification du site avec Meta Tag" dans la section Code de suivi.',
            installationInstructionsIdeaSoft4:
                "4. Copiez et collez le code d'intégration ci-dessus dans la case ouverte et enregistrez.",
            installationInstructionsIdeaSoft5:
                "5. Paramètres à l'intérieur -> Optimisations Cliquez sur le bouton \"effacer le cache\". Ainsi, l'intégration est terminée.",
            installationInstructionsWordPress1: "1. Connectez-vous à votre panneau d'administration WordPress",
            installationInstructionsWordPress2: "2. Allez à l'apparence> Éditeur de thème",
            installationInstructionsWordPress3:
                "3. Sous les fichiers de thème (à l'extrême droite), trouvez le pied de page du thème (pied.php) et sélectionnez-le",
            installationInstructionsWordPress4:
                "4.Paste le code d'intégration ci-dessus avant la balise {bodyTag} en bas.",
            installationInstructionsWordPress5:
                "5. Cliquez sur Mettre à jour le fichier pour enregistrer les modifications",
            installationInstructionsOpenCart1: "1. Connectez-vous à votre panneau d'administration OpenCart",
            installationInstructionsOpenCart2: "2. Allez dans Conception> Éditeur de thème",
            installationInstructionsOpenCart3:
                "3. Sélectionnez le dossier «commun» et ouvrez le fichier en-tête.twig ».",
            installationInstructionsOpenCart4:
                "4.Paste le code d'intégration ci-dessus avant la balise {headTag} en bas.",
            installationInstructionsOpenCart5: "5. Cliquez sur le bouton Enregistrer.",
            installationInstructionsTicimax1: "1. Connectez-vous à votre panneau d'administration TICIMAX",
            installationInstructionsTicimax2:
                "2. Open Design> Design> Paramètres de conception de pied de page d'en-tête",
            installationInstructionsTicimax3:
                "3. Cliquez sur le bouton «Source» dans la section de conception du logo.",
            installationInstructionsTicimax4: "4. Collez le code d'intégration ci-dessous sous le code HTML.",
            installationInstructionsEticaretteyim1:
                "1. Connectez-vous à votre panneau d'administration de commerce électronique",
            installationInstructionsEticaretteyim2:
                "2. Nommez simplement SUPSIS à partir de Plugins> Générer HTML> et copiez le code.",
            installationInstructions: "Instructions",
            installationVerify: "Vérifiez l'installation de votre site Web de Supsis",
            installationVerifyChecking: "Vérification",
            installationVerifyCheck: "Vérifier",
            installationVerifyCheckingStatus: "Vérification de l'état d'intégration du Supsis sur {website}",
            installationCheckingStatusMessageYes: "Super, le Supsis est intégré au site Web {website} !!",
            installationCheckingStatusMessageNo:
                "SUPSIS n'est actuellement pas intégré au site {website}. Vous pouvez terminer votre processus d'intégration maintenant ou plus tard.",
            vtippyPreferredLanguage: "langue préférée",
        },
        akinon: {
            typeOrSelectSKU: "Tapez ou sélectionnez SKU",
            akinonUserId: "ID utilisateur d'Akinon",
            userEmail: "E-mail utilisateur",
            userEmailDesc: "Tapez ou sélectionnez un e-mail utilisateur ...",
            send: "Envoyer",
            selectCity: "Sélectionnez une ville",
            city: "Ville",
            selectState: "Sélectionnez l'état",
            state: "État",
            useMap: "Utiliser la carte",
            chooseAddress: "Choisir l'adresse",
            selectCountry: "Choisissez le pays",
            country: "Pays",
            productIdDesc: "Tapez ou sélectionnez Produit ...",
            productId: "ID de produit",
            userIdDesc: "Tapez l'ID utilisateur Akinon ...",
            productSKU: "SKU de produit",
            latitudeDesc: "Tapez ou sélectionnez la latitude de l'emplacement cible ...",
            longitudeDesc: "Tapez ou sélectionnez Longitude de l'emplacement cible ...",
            orderNumber: "Votre numéro de commande",
            orderDesc: "Tapez le numéro de commande ...",
            longitude: "Longitude",
            latitude: "Latitude",
        },
        headBar: {
            source: "Source",
            label: "Étiquette",
            completed: "Terminé?",
            email: "E-mail",
            phone: "Téléphone",
            name: "Nom",
            date: "Histoire",
            subject: "Sujet",
            situation: "Situation",
            representative: "Représentant",
            transactions: "Transactions",
            channel: "Canal de contact",
        },
        login: {
            loginTitle1: "Bienvenue à",
            loginTitle2: "Supsis AI",
            email: "Votre adresse email",
            emailPlaceholder: "Veuillez saisir votre adresse e-mail.",
            emailError: "Veuillez saisir une adresse e-mail valide",
            password: "Votre mot de passe",
            passwordLogin: "Connexion sans mot de passe",
            passwordAndLogin: "Connexion avec mot de passe",
            passwordNew: "Réinitialiser mon mot de passe",
            loginAnd: "Ou",
            passwordPlaceholder: "S'il vous plait entrez votre mot de passe.",
            loginMemory: "Rappelez-vous cet appareil",
            passwordForget: "j'ai oublié mon mot de passe",
            passwordNewAgain: "Nouveau mot de passe",
            passwordNewAgainTwo: "Répétition du nouveau mot de passe",
            passwordNewAgainPlaceholder: "Veuillez entrer votre nouveau mot de passe.",
            passwordNewAgainPlaceholderTwo: "Veuillez ressaisir votre nouveau mot de passe.",
            login: "Connexion",
            loginFooter: "Ou connectez-vous avec un e-mail",
            emailLogin: "Connectez-vous avec un e-mail",
            welcomeTitle: "Bienvenue",
            welcomeMorning: "Bonjour",
            welcomeAfternoon: "Bon après-midi",
            welcomeEvening: "Bonsoir",
            welcomeNight: "Bonne nuit",
        },
        settings: {
            loadMore: "Charger plus...",
            detectIpAddress: "Détecter Mon Adresse IP",
            addWighteListAddress: "Ajouter une adresse IP à la liste blanche",
            accessControlSubTitles: "Gérez les adresses IP et modifiez la liste blanche pour un accès sécurisé",
            companyInformation: "Informations sur l'entreprise",
            ipAddress: "Mon adresse IP",
            whiteList: "Liste d'adresses IP sécurisées",
            whiteListAdd: "Ajouter une IP sécurisée",
            whiteListDeletedSuccessfully: "Liste blanche supprimée avec succès",
            whiteListDeletedFailed: "Liste blanche non supprimée",
            whiteListAddedSuccessfully: "Liste blanche ajoutée avec succès",
            whiteListAddedFailed: "Liste blanche non ajoutée",
            deleteWhiteListTitle: "Êtes-vous sûr de vouloir supprimer cette liste blanche ?",
            talkSettings: "Paramètres de la parole",
            talkSubtitles: "Gérer vos paramètres vocaux",
            changeSettings: "Modifier les paramètres de l'attribution automatique des chats",
            dateAndTime: "Date et heure",
            actor: "Acteur",
            event: "Événement",
            accessControl: "Contrôle d'accès",
            organizationLongName: "Nom long de l'organisation",
            visitorNewDesc: "Vous pouvez utiliser la nouvelle version du thème visiteur",
            transactionType: "Type de transaction",
            priorBalance: "Solde précédent",
            nextBalance: "Prochain solde",
            amount: "Montant",
            phoneNumber: "Numéro de téléphone",
            profileInfoRemoved: "Informations sur le profil supprimées",
            newValueUpdated: "Nouvelle valeur mise à jour",
            ballanceToTransfer: "Solde à transférer",
            availableBalance: "Solde disponible",
            balanceReceived: "Solde reçu",
            totalBalance: "Solde total",
            paymentCard: "Carte de paiement",
            wpPhoneNumber: "Numéro de téléphone Whatsapp",
            wpSendingMessage: "Premier message Whatsapp envoyé",
            auditlogs: "Journaux d'audit",
            myaccount: "Mon compte",
            notifications: "Notifications",
            company: "Entreprise",
            features: "Caractéristiques",
            general: "Général",
            chat: "Bavarder",
            timings: "Timing",
            wallet: "porte-monnaie",
            language: "Langue",
            "bubble-settings": "Paramètres de la bulle",
            "bubble-actions": "Actions de la bulle",
            "theme-settings": "Paramètres de thème",
            visitorLoginForm: "Formulaire de connexion des visiteurs",
            visitorAttribute: "Informations sur le profil du visiteur",
            timing_settings: "Paramètres de synchronisation",
            auto_assign: "Auto Assign",
            availability: "Disponibilité",
            "website-integration": "Intégration de site Web",
            General: "Général",
            Chat: "Bavarder",
            Timings: "Timing",
            Integration: "Intégration",
            developer: "Développeur",
            visitorNew: "Nouveau visiteur",
            companySubtitles: "Gérer les paramètres de votre entreprise.",
            featuresSubtitles: "Gérer les fonctionnalités de votre entreprise.",
            languageSubtitles: "Définissez la langue et le fuseau horaire préférés de votre entreprise.",
            bubbleSettings: "Paramètres de la bulle",
            bubbleSettingsSubtitles: "Gérer les paramètres de la bulle de votre entreprise.",
            bubbleActionsSubtitles: "Gérer les actions de la bulle de votre entreprise.",
            chatThemeSettingsSubtitles: "Gérer les paramètres de thème de chat de votre entreprise.",
            visitorLoginFormSubtitles:
                "Gérer les paramètres de formulaire de connexion des visiteurs de votre entreprise.",
            chatTimingSettingsSubtitles: "Gérer les paramètres de synchronisation de chat de votre entreprise.",
            webSiteIntegrationSubtitles: "Gérer les paramètres d'intégration de site Web de votre entreprise.",
            apiAccessTitle: "Accès API",
            apiAccessSubtitles: "Gérer les paramètres d'accès API de votre entreprise.",
            youTubeActionForm: "Ajoutez votre chaîne YouTube",
            linkedinActionForm: "Ajouter votre compte Linkedin",
            telegramActionForm: "Ajouter un compte Telegram",
            facebookActionForm: "Ajoutez votre page Facebook",
            tiwitterActionForm: "Ajoutez votre page Twitter",
            instagramActionForm: "Ajoutez votre page Instagram",
            liveSupportDescription: "Ouvrez un chat en direct avec vos clients",
            ticketDescription: "Gérez les demandes de vos clients",
            whatsappDescription: "Laissez vos clients vous contacter via Whatsapp",
            phoneDescription: "Laissez vos clients vous contacter par téléphone",
            emailDescription: "Laissez vos clients vous contacter par e-mail",
            facebookDescription: "Laissez vos clients vous contacter via Facebook",
            twitterDescription: "Laissez vos clients vous contacter via Twitter",
            instagramDescription: "Laissez vos clients vous contacter via Instagram",
            youtubeDescription: "Laissez vos clients vous contacter via Youtube",
            linkedinDescription: "Laissez vos clients vous joindre avec LinkedIn",
            telegramDescription: "Laissez vos clients atteindre la taille avec Telegram",
            whatsappModalTitle: "Formulaire de traitement Whatsapp",
            whatsappModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Whatsapp.",
            phoneModalTitle: "Formulaire de traitement téléphonique",
            phoneModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte téléphonique.",
            emailModalTitle: "Formulaire de traitement des e-mails",
            emailModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte e-mail.",
            facebookModalTitle: "Formulaire de traitement Facebook",
            facebookModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Facebook.",
            twitterModalTitle: "Formulaire de traitement Twitter",
            twitterModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Twitter.",
            instagramModalTitle: "Formulaire de traitement Instagram",
            instagramModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Instagram.",
            youtubeModalTitle: "Formulaire de traitement Youtube",
            youtubeModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Youtube.",
            linkedinModalTitle: "Formulaire de transaction LinkeIn",
            linkedinModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte LinkedIn.",
            telegramModalTitle: "Formulaire de transaction par télégramme",
            telegramModalDescription:
                "Entrez votre lien de profil Telegram dans le formulaire ci-dessous pour lier votre compte Telegram",
            instagramAlertTitle: "Intégration Instagram requise",
            instagramAlertDesc:
                "Désolé, la page que vous avez visitée sera activée lorsque vous intégrerez votre Instagram.",
            instagramActivateText: "Allons-y, intégrons Instagram",
            remove: "Retirer",
            edit: "Éditer",
            connected: "Connecté",
            add: "Ajouter",
            themeDescription: "Choisissez le thème de votre entreprise.",
            fontDescription: "Choisissez la police de votre entreprise.",
            isFabsAsIcon: "Afficher les textes des icônes de menu.",
            chatBubbleTextSetting: "Réglage du texte de la bulle de chat",
            textOnChatBubble:
                "Vous pouvez ajuster les paramètres de texte qui apparaîtront sur la bulle de discussion.",
            textToAppearOnChatBubble: "Texte à apparaître sur la bulle de chat",
            newVisitorProfileInformation: "Nouvelles informations de profil de visiteur",
            newVisitorProfileInformationDescription: "Nouvelles informations de profil de visiteur",
            create: "Créer",
            newAdd: "Ajouter nouveau",
            toInform: "Informer",
            toInformDescription:
                "Vous pouvez faire correspondre les valeurs que vous ajoutez sur cette page avec le formulaire de connexion des visiteurs.",
            showVisitor: "Afficher le visiteur",
            label: "Billet",
            text: "En écrivant",
            email: "E-mail",
            phone: "Téléphone",
            number: "Nombre",
            url: "URL",
            date: "Temps",
            dropdown: "sélectionnable",
            languageTimeZone: "Langue et région",
            timeZoneTitle: "Région et fuseau horaire",
            timeZoneDescription: "Paramètres de région et de fuseau horaire",
        },
        userInfoWidget: {
            zohoInfo: "Informations Zoho",
            messageSearch: "Rechercher un message",
            userInformation: "Informations de l'utilisateur",
            fullName: "Nom et surnom",
            newValue: "Nouvelle valeur",
            newProfileInfo: "Nouvelles informations de profil",
            affiliatedRepresentatives: "Représentants",
            preferredAgents: "Agent(s) préféré(s)",
            labels: "Étiquettes",
            agentNotes: "Remarques sur les agents",
            newNote: "Nouvelle note",
            note: "Note",
            available: "Des notes sont disponibles.",
            systemInformation: "Informations système",
            speechID: "ID de la parole",
            customerVersion: "Version client",
            IPAddress: "Adresse IP",
            pageVisited: "Page visitée",
            systemAndBrowser: "Système d'exploitation et navigateur",
            countryAndLanguage: "Pays et langue",
            clickToEdit: "Modifier Cliquez à l'intérieur du message",
            adsYouAreInterestedIn: "Publicités qui vous intéressent",
            detail: "Détail",
            adsTitle: "Titre",
            adUrl: "URL de l'annonce",
            sourceID: "Identifiant de la source",
            resourceType: "Type de ressource",
            adsBody: "Contenu",
            adsCreateDate: "Date de création",
            adsUpdateDate: "Date de mise à jour",
        },
        newWizartV2: {
            generalSettings: "réglages généraux",
            themeSettings: "réglages généraux",
            representativeWorkingHours: "Heures de travail représentatives",
            preview: "Aperçu",
            setup: "Installation",
            formStepTitle: "Donnez-nous plus d'informations afin que nous puissions personnaliser votre expérience",
            supsisEntergation: "Où utiliserez-vous Supsis sur votre site web ? :",
            goToNextStep: "Passez à l'étape suivante",
            readytemplate: "Utiliser le modèle de couleur prêt",
            customSettings: "Paramètres personnalisés",
            customerMessageView: "Message client Voir",
            backcgroundColor: "Couleur de l'arrière plan",
            textColor: "Couleur de la police",
            agentMessageView: "Affichage des messages de l'agent",
            workingHours: "À quels intervalles de temps fournissez-vous des services à vos visiteurs?",
            continuousService: "Service continu",
            continuousServiceDescription:
                "La bulle de discussion est toujours active. Même si vous n'êtes pas dans le système.",
            vote: "Fais ton choix",
            representativeWorking: "Heures de travail représentatives",
            representativeWorkingDescription:
                "Le chat apparaît en ligne lorsqu'au moins 1 agent est en ligne. S'il n'y a pas de représentant en ligne, il apparaîtra hors ligne.",
            computer: "Ordinateur",
            tablet: "Tablette",
            uploadTrackingCodeToYourWebsite: "Télécharger le code de suivi sur votre site Web",
            password: "Definir un nouveau mot de passe",
        },
        whatsappChannel: {
            whatsappTitleV1: "Canaux Whatsapp V1 (QR)",
            whatsappTitleV2: "Canaux Whatsapp V2 (QR)",
            channelName: "Nom du Canal",
            phoneNumber: "Numéro de Téléphone",
            forwardToChatbot: "Transférer au Chatbot",
            forwardingChatbotOrLiveAgent: "Transfert (Chatbot ou Agent en Direct)",
            addChannel: "Ajouter un Canal",
            newWhatsappChannel: "Nouveau Canal WhatsApp",
            newWhatsappChannelDescription: "Créez un nouveau canal WhatsApp en scannant le code QR",
            editWhatsappChannel: "Modifier le Canal WhatsApp",
            editWhatsappChannelDescription: "Modifier le canal WhatsApp",
            whatsappChannel: "Canal WhatsApp",
            deleteWhatsappChannelDescription: "Êtes-vous sûr de vouloir supprimer ce canal ?",
            whatsappIntegration: "Intégration WhatsApp",
            deleteChannel: "Supprimer le Canal",
            restartChannel: "Redémarrer le Canal",
            wantRestartChannel: "Voulez-vous redémarrer le canal ?",
            deleteSMSChannelDescription: "Êtes-vous sûr de vouloir supprimer le canal SMS ?",
            smsChannel: "Canal SMS",
            maxChannelCount: "Vous ne pouvez pas créer plus d’un canal SMS !",
            smsModalText:
                "Notre intégration avec des solutions de communication modernes vous donne la possibilité d'envoyer des SMS facilement et efficacement. Supprimez les frontières de la communication, connectez-vous directement avec vos clients !",
            smsModalBtn: "Cliquez pour ouvrir le canal SMS...",
            postaCellDetail: "Détails du canal PostaCell",
        },
        noPermission: "Vous n'avez pas la permission d'effectuer cette opération.",
        mail_integration_detail: {
            title: "Détail du courrier",
            integration: "Intégration",
            sender: "Expéditeur",
            signature: "Signature",
            inbox: "Boîte de réception",
            medias: "Médias",
            visibility: "Visibilité",
            settings_group: "Paramètres",
            contacts: "Contacts",
        },
        whatsapp_business_api: {
            userVisibility: "Visibilité de l'utilisateur",
            userVisibilityDesc:
                "Les canaux auxquels les utilisateurs peuvent accéder dépendent de leur rôle et des paramètres de visibilité du canal. Les utilisateurs ayant le rôle d'administrateur complet ou de racine peuvent voir tous les canaux. Si les paramètres de visibilité d'un canal sont vides, le canal est public. Cependant, si le canal est défini pour des utilisateurs ou des départements spécifiques, seuls ces utilisateurs ou ces membres du département peuvent voir le canal.",
            searchTemplate: "Modèle de recherche...",
            forwardToChatbot: "Transférer au Chatbot",
            forwarding: "Transférer (Chatbot ou agent en direct)",
            forwardLiveAgents: "👉 Transférer à l'assistance en direct",
            forwardingToDepartment: "Transférer au département",
            selectDepartment: "Sélectionner un département",
            createWbChannel:
                "Pour créer un canal Whatsapp Business, vous devez acheter un package Whatsapp Business. Vous pouvez accéder à des forfaits abordables immédiatement.",
            wbCreateChannelMax: "Vous avez atteint la limite de création de canaux Whatsapp Business. Maximum",
            wbContinue:
                "Vous pouvez créer un canal Whatsapp Business. Pour continuer, mettez votre forfait à niveau ou supprimez certains de vos canaux Whatsapp Business.",
            chatInitiatorTemplate: "Modèle d'initiateur de chat",
            selectChatInitiatorTemplate: "Sélectionnez votre modèle d'initiateur de chat.",
            dailyUsageReport: "Rapport d'utilisation quotidien",
            freeChat: "Chat gratuit",
            paidChat: "Chat payant",
            templateMessage: "Message du modèle",
            outgoingSession: "Session sortante",
            incomingSession: "Session à venir",
            totalCost: "Coût total",
            allOptNumbers: "Tous les numéros opt-in",
            startChat: "Démarrer le chat",
            lastMessageDate: "Date du dernier message",
            sureDeleteTemplate: "Êtes-vous sûr de vouloir supprimer ce modèle ?",
            manageWhoChannelChat: "Gérer qui peut voir les chats de ce canal",
            profileImageDesc: "Il s'agit d'une capture d'écran WhatsApp de votre entreprise.",
            bussinesDesciption: "Description de votre entreprise.",
            descOfWork: "Description de votre entreprise en quelques mots (512 caractères maximum).",
            accountStatus: "Statut du compte.",
            dockerStatus: "Statut du docker.",
            phoneQuality: "Qualité du téléphone.",
            customersOrDay: "Customers/Day.",
            messagingLimit: "Limite de messagerie.",
            canSendMessage: "Le message peut être envoyé.",
            officialDetails: "Détails officiels.",
            officialDetailsDesc:
                "Ces adresses seront toujours affichées dans la section du profil pour les utilisateurs qui discutent avec vous sur WhatsApp. Après l'avoir modifiée, nous l'enverrons à WhatsApp pour approbation.",
            addressLine: "Ligne d'adresse.",
            stateIfApplic: "État (le cas échéant).",
            zipCodeOrPostCode: "Code postal.",
            selectCountry: "Sélectionner le pays.",
            selectBussVertical: "Sélectionner le secteur d'activité.",
            saveInfo: "Enregistrer les informations.",
            active: "Active.",
            banned: "Interdit.",
            low: "Bas.",
            medium: "Moyen.",
            high: "Haut.",
            connected: "Connecté.",
            disConnected: "Déconnecté.",
            flagged: "Flagged.",
            pending: "En attente.",
            restricted: "Restreint.",
            unknown: "Inconnu.",
            available: "Disponible.",
            limited: "Limité.",
            blocked: "Bloqué.",
            success: "Success.",
            successDesc: "Les informations de votre profil ont été mises à jour avec succès.",
            wabaOverview: "Vue d'ensemble de la santé WABA",
            manageChannelDetail: "Gérer les informations relatives à votre canal",
            wpBussChannelDetail: "Détail du canal commercial WhatsApp",
            manageWpBussChannel: "Gérer votre canal professionnel WhatsApp",
            channelName: "Nom du canal",
            phoneNumberE164: "Numéro de téléphone",
            phoneNumberE164Place: "Numéro de téléphone. par exemple 908501234455",
            channelUpdatedSucs: "Mise à jour réussie du canal",
            failedUpdateChannel: "Échec de la mise à jour du canal",
            title: "Canaux Whatsapp Business API",
            integration: "Intégration",
            detail: "Détail",
            visibility: "Visibilité",
            templates: "Tous les modèles de messages",
            settings_group: "Paramètres",
            template_message_group: "Messages modèles",
            chat_initiator_template: "Modèle d'initiation de chat",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "Tous les contacts",
            new_template: "Créer un nouveau modèle",
            broadcast_group: "Diffusion",
            broadcast_requests: "Demandes de diffusion",
            customer_groups: "Groupes de clients",
            businessChannelDetail: "Détails du canal Whatsapp Business",
            wallet: "Wallet",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            postacellAllMessage: "Envoyer des SMS en masse",
            message_group: "Message",
            createNewTemplate: "Créer un nouveau message modèle",
            templateName: "Nom du modèle",
            templateNameDesc: "Donnez un nom à votre modèle de message.",
            templateInfo: "Informations sur les modèles",
            viewTemplates: "Voir les modèles",
            templateNameRules:
                "Le nom du modèle ne peut inclure que des lettres minuscules, des chiffres et des traits de soulignement.",
            category: "Catégorie",
            categoryDesc: "Sélectionnez le type de modèle que vous souhaitez créer",
            categoryUtility: "Utilitaire",
            categoryUtilityDesc:
                "Envoyez des informations utilitaires telles que les mises à jour de compte, les mises à jour de commande, les alertes, et plus encore.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Envoyez des offres promotionnelles, des offres de produits et plus encore pour augmenter la notoriété et l'engagement.",
            categoryAuth: "Authentification",
            categoryAuthDesc: "Envoyez des codes pour que vos clients puissent accéder à leurs comptes.",
            optional: "Optionnel",
            languageDesc: "Sélectionnez la langue dans laquelle votre message modèle sera envoyé",
            header: "En-tête",
            headerRules:
                "Ajoutez un en-tête de 60 caractères à votre message. Seule une variable est prise en charge dans l'en-tête.",
            headerOptionMedia: "Média",
            headerOptionText: "Texte",
            none: "Aucun",
            headerType: "Type d'en-tête",
            headerText: "Texte de l'en-tête",
            body: "Corps",
            bodyRules: "Saisissez le texte dans la langue que vous avez choisie pour votre message",
            addVariable: "Ajouter une variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Nom de variable par défaut",
            defaultVariableToolTip:
                "Votre variable apparaît dans le modèle avec ce nom. <br><br> De plus, cette valeur est envoyée par défaut en cas d'autres situations.",
            selectATemplate: "Sélectionnez un modèle de message",
            variableSettings: "Paramètres de variable",
            example: "Exemple",
            footer: "Pied de page",
            footerDesc:
                "Ajoutez un pied de page de 60 caractères à votre message. Les variables ne sont pas prises en charge dans le pied de page.",
            buttons: "Boutons",
            buttonType: "Type de bouton",
            buttonTypeReply: "Répondre",
            submit: "Enregistrer",
            submitting: "Soumission en cours",
            addButton: "Ajouter un bouton",
            rejectWhatsapp: "Rejeté par Whatsapp.",
            approvedWhatsapp: "Approuvé par Whatsapp.",
            pendingWhatsapp: "En attente d'approbation",
            daily_usages: "Daily Usages",
        },
        multi_whatsapp_api: {
            profile: "Profil",
            integration: "Intégration",
            detail: "Détail",
            visibility: "Visibilité",
            templates: "Tous les modèles de messages",
            settings_group: "Setting",
            template_message_group: "Messages du modèle",
            new_template: "Créer un nouveau modèle",
            broadcast_group: "Bulk Message",
            broadcast_requests: "Envoi de messages en masse",
            customer_groups: "Groupes de clients",
            chat_initiator_template: "Chat Initiator Template",
            contacts: "Contacts",
            numbers: "Numéros",
            all_contacts: "Tous les contacts",
        },
        archive: {
            destroyedBy: {
                agent: "Agent",
                visitor: "Visiteur",
                system: "Système",
                chatbot: "Chatbot",
            },
        },
        upgradeMessages: {
            ticket: "Même si vous êtes hors ligne, vos demandes sont enregistrées instantanément avec l'intelligence artificielle et le chatbot ! Gardez toujours vos clients satisfaits !",
            tasks: "Gérez facilement vos tâches et projets. Collaborez avec votre équipe et livrez les projets à temps !",
            calendar:
                "Planifiez facilement vos rendez-vous et réunions. Restez synchronisé avec votre équipe et gérez votre temps plus efficacement !",
            mail_integration:
                "Gérez facilement vos e-mails. Renforcez la communication avec vos clients et améliorez la collaboration.",
            team_integration:
                "Communiquez plus rapidement et efficacement avec votre équipe. Améliorez la collaboration et assurez-vous de livrer les projets à temps !",
            webhook_integration:
                "Connectez vos applications avec l'intégration Webhook et simplifiez l'échange de données !",
            whatsapp_v2:
                "Améliorez la communication avec vos clients grâce à l'intégration WhatsApp pour une communication plus rapide et plus efficace !",
            whatsapp:
                "Améliorez la communication avec vos clients en utilisant l'intégration WhatsApp pour une communication plus rapide et plus efficace !",
            whatsapp_business_api:
                "Profitez de l'API WhatsApp Business pour communiquer plus efficacement et efficacement avec vos clients !",
            instagram: "Interagissez plus efficacement avec vos clients en utilisant l'intégration Instagram !",
            messenger: "Communiquez facilement avec vos clients via l'intégration Messenger !",
            sms_postacell: "Communiquez rapidement et efficacement avec vos clients grâce à l'intégration SMS !",
            ready_contents:
                "Les contenus prêts vous aident à communiquer plus rapidement et plus efficacement avec vos clients.",
            automation: "Automatisez vos flux de travail pour gagner du temps et gérer vos tâches plus efficacement !",
            form: "Utilisez le créateur de formulaires pour rationaliser les interactions avec les clients, collecter des informations précieuses et améliorer la collaboration !",
            customer_tables:
                "Créez des tableaux personnalisés et gérez les informations des clients de manière efficace !",
            trendyol:
                "Améliorez la communication avec vos clients grâce à l'intégration Trendyol pour une interaction fluide !",
            access_control:
                "Protégez vos données et empêchez l'accès non autorisé avec les fonctionnalités de contrôle d'accès !",
            upgrade: "Mettre à jour mon abonnement",
            upgradeFeature: "Acheter un forfait supplémentaire",
            featureNotAvailable: "La fonctionnalité n'est pas disponible.",
            usageLimitExceeded: "Limite d'utilisation dépassée.",
            maxAgentCount: "Mettez à niveau votre forfait pour servir plus de clients en ajoutant plus d'agents.",
            maxTriggerCount:
                "Mettez à niveau votre forfait pour générer plus d'interactions en ajoutant plus de déclencheurs.",
            visitorStartChat:
                "Mettez à niveau votre forfait pour démarrer une discussion avec des visiteurs n'ayant pas encore interagi.",
            voiceCalling:
                "Mettez à niveau votre forfait pour communiquer plus efficacement avec vos clients via des appels vocaux.",
            videoCalling:
                "Mettez à niveau votre forfait pour communiquer plus efficacement avec vos clients via des appels vidéo.",
            fileAndVoiceMessage:
                "Mettez à niveau votre forfait pour envoyer des fichiers et des messages vocaux à vos clients.",
            autoTranslation:
                "Mettez à niveau votre forfait pour servir plus de clients grâce à la traduction automatique des messages.",
            telegramEntegration: "Mettez à niveau votre forfait pour activer l'intégration avec Telegram.",
            chatCopilot:
                "Mettez à niveau votre forfait pour offrir un meilleur service grâce à l'assistant de chat alimenté par l'IA.",
            calenderEntegration:
                "Mettez à niveau votre forfait pour synchroniser votre calendrier avec d'autres applications.",
            mailEntegration:
                "Mettez à niveau votre forfait pour mieux gérer les e-mails et améliorer la communication avec vos clients.",
            smsEntegration:
                "Mettez à niveau votre forfait pour atteindre vos clients plus rapidement via l'intégration SMS.",
            ticketSystem:
                "Mettez à niveau votre forfait pour mieux gérer les demandes clients avec le système de tickets.",
            taskManagementEntegration:
                "Mettez à niveau votre forfait pour optimiser le flux de travail grâce à l'intégration de gestion des tâches.",
            webhookEntegration:
                "Mettez à niveau votre forfait pour synchroniser vos autres applications avec les webhooks.",
            readyContents:
                "Mettez à niveau votre forfait pour améliorer la communication client avec des contenus prédéfinis.",
            automationEntegration: "Mettez à niveau votre forfait pour automatiser davantage votre flux de travail.",
            customerTablesEntegration:
                "Mettez à niveau votre forfait pour mieux gérer les informations clients grâce aux tableaux clients.",
            formEntegration:
                "Mettez à niveau votre forfait pour mieux gérer les demandes clients avec des formulaires.",
            maxFormLimit:
                "Mettez à niveau votre forfait pour créer plus de formulaires et mieux gérer les demandes clients.",
            maxFormFieldLimit:
                "Mettez à niveau votre forfait pour ajouter plus de champs aux formulaires et améliorer la gestion des demandes.",
            maxCustomerTableCount: "Mettez à niveau votre forfait pour ajouter plus de tableaux clients.",
            maxCustomerTableFieldCount:
                "Mettez à niveau votre forfait pour ajouter plus de champs aux tableaux clients.",
            maxCustomerTableViewCount:
                "Mettez à niveau votre forfait pour sauvegarder plus de vues de tableaux clients.",
            maxCustomerTableRecordCount:
                "Mettez à niveau votre forfait pour ajouter plus d'enregistrements aux tableaux clients.",
            maxAutomationButton: "Mettez à niveau votre forfait pour ajouter plus de blocs d'automatisation.",
            automationTimerBase: "Mettez à niveau votre forfait pour utiliser des minuteries d'automatisation.",
            automationEventBase: "Mettez à niveau votre forfait pour utiliser des événements d'automatisation.",
            automationWebhookBase: "Mettez à niveau votre forfait pour utiliser des webhooks d'automatisation.",
            automationButtonBase: "Mettez à niveau votre forfait pour utiliser des boutons d'automatisation.",
            liveScore: "Mettez à niveau votre forfait pour activer la fonction de suivi en temps réel.",
            multipleChatWindow: "Mettez à niveau votre forfait pour ouvrir plusieurs fenêtres de chat simultanément.",
            maxTaskWorkflowLimit: "Mettez à niveau votre forfait pour ajouter plus de flux de tâches.",
            maxTaskColumnLimit: "Mettez à niveau votre forfait pour ajouter plus de colonnes dans les tâches.",
            maxTaskRowLimit: "Mettez à niveau votre forfait pour ajouter plus de lignes dans les tâches.",
            maxDepartmentLimit: "Mettez à niveau votre forfait pour ajouter plus de départements.",
            maxRoleLimit: "Mettez à niveau votre forfait pour ajouter plus de rôles.",
            maxReadyContentsLimit: "Mettez à niveau votre forfait pour ajouter plus de contenus prédéfinis.",
            excelDownload: "Mettez à niveau votre forfait pour activer le téléchargement de fichiers Excel.",
            customerGroup: "Mettez à niveau votre forfait pour utiliser la fonctionnalité des groupes de clients.",
            maxMailCount: "Mettez à niveau votre forfait pour envoyer plus d'e-mails.",
            maxWhatsappChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux WhatsApp.",
            maxBusinessWhatsappChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux WhatsApp Business.",
            maxInstagramChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux Instagram.",
            maxMessengerChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux Messenger.",
            maxTelegramChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux Telegram.",
            maxTrendyolChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux Trendyol.",
            maxMetaLeadChannel: "Mettez à niveau votre forfait pour ajouter plus de canaux Meta Lead.",
        },
        setupWizard: {
            finishModalVideos: "Vidéos de formation",
            finishModalDoc: "Documentation",
            finsihModalLiveSupport: "Assistance en direct",
            completed: "D'accord, j'ai compris",
            supsisSetupGuide: "Guide de configuration Supsis",
            completedWarning: "Cliquez sur le bouton pour terminer la configuration et finaliser le guide",
            supsisSetupGuideDescription: "Veuillez compléter ces étapes pour utiliser pleinement Supsis.",
            goToSetup: "Aller à la configuration",
            completionPercentageDescription: "Vous n'utilisez que % {percentage} des fonctionnalités offertes par Supsis.",
            aiChatbot: {
                title: "Chatbot IA",
                content: "Répondez aux messages entrants automatiquement, instantanément et intelligemment avec le Chatbot IA de Supsis.",
                steps: {
                    step1: {
                        title: "Créer un Chatbot",
                        content: "Utilisez ce bouton pour créer un nouveau <b>scénario de chatbot</b>. Vous pouvez soit commencer rapidement en sélectionnant l'un des modèles spécialement préparés pour vous, soit concevoir un scénario entièrement original à partir de zéro pour créer un chatbot qui répond pleinement aux besoins de votre entreprise."
                    },
                    step2: {
                        title: "Scénarios Prêts à l'Emploi",
                        content: "Comprenez facilement la logique de fonctionnement de base du chatbot avec les <b>modèles prêts à l'emploi</b> ici. Gagnez du temps en personnalisant ces modèles selon vos besoins et développez des solutions sur mesure. Vous pouvez commencer par choisir l'un des modèles ci-dessous, adaptés à différents cas d'utilisation."
                    },
                    step3: {
                        title: "Intégrations Chatbot",
                        content: "Intégrez votre chatbot préparé avec les <b>plateformes de médias sociaux populaires telles que WhatsApp, Instagram et Facebook</b>. De cette façon, vous pouvez activer votre chatbot directement sur les canaux utilisés par vos clients, augmentant ainsi votre accessibilité et vos taux d'engagement."
                    },
                    step4: {
                        title: "Analytique Chatbot",
                        content: "Visualisez et analysez les <b>performances de votre chatbot avec des graphiques et des statistiques détaillés</b>. En filtrant selon des périodes spécifiques ou les plateformes que vous avez intégrées, vous pouvez mesurer l'efficacité de votre chatbot, identifier les domaines à améliorer et optimiser vos stratégies."
                    }
                }
            },
            aiAssistant: {
                title: "Assistant IA",
                content: "Activez l'assistant numérique pour aider votre équipe de support.",
                steps: {
                    step1: {
                        title: "Intégration OpenAI",
                        content: "<p>Établissez une <b>intégration transparente</b> entre OpenAI et Supsis AI pour augmenter l'efficacité de votre entreprise. Ainsi, votre puissant assistant IA sera activé et commencera à optimiser vos processus. Pour compléter l'intégration, il vous suffit d'entrer votre clé API OpenAI. <br> <br> <b>Pour obtenir votre clé API OpenAI, <a href='https://platform.openai.com/account/api-keys' target='_blank'>cliquez ici</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "Support en Direct IA",
                content: "Activez le système de chat en direct alimenté par l'IA.",
                steps: {
                    step1: {
                        title: "Filtrer les Conversations",
                        content: "Gérez facilement <b>toutes les conversations clients</b> depuis cette zone. Vous pouvez prioriser les conversations en les filtrant dans différentes catégories telles que non lues, en attente ou celles en cours avec le chatbot, garantissant qu'aucune demande n'est négligée."
                    },
                    step2: {
                        title: "Vue plus détaillée",
                        content: "Utilisez ces options pour examiner les conversations clients plus en profondeur. Vous pouvez appliquer des <b>filtres plus détaillés</b> tels que les conversations sans réponse d'hier ou les clients spécifiques qui vous ont contacté, ou créer vos propres filtres personnalisés pour personnaliser votre flux de travail."
                    },
                    step3: {
                        title: "Écran de Support en Direct",
                        content: "Passez à cette vue pour <b>gérer efficacement toutes vos conversations de support en direct à partir d'un écran centralisé</b>. Affichez tous les messages, les réponses des agents, les statuts actuels et les informations de date pour chaque conversation en un seul endroit, vous permettant de prendre des décisions rapides et précises."
                    },
                    step4: {
                        title: "Page de Test",
                        content: "Accédez à cette section pour tester les performances et le fonctionnement de votre chatbot créé en temps réel. En envoyant des messages en tant que visiteur, vous pouvez <b>observer de près les réponses et les comportements de votre chatbot</b>, ce qui vous permet d'apporter toutes les améliorations nécessaires avant de le présenter aux utilisateurs finaux."
                    }
                }
            },
            aiAutomation: {
                title: "Automatisation IA",
                content: "Automatisez vos processus de support et gagnez du temps.",
                steps: {
                    step1: {
                        title: "Créer une nouvelle automatisation",
                        content: "Utilisez ce bouton pour créer une nouvelle automatisation afin de rationaliser vos processus métier. Vous pouvez concevoir des automatisations basées sur des événements (par exemple, lorsqu'un nouveau message arrive), basées sur le temps (par exemple, à une heure spécifique chaque matin), ou <b>basées sur des Webhooks</b> pour rendre vos flux de travail plus intelligents."
                    },
                    step2: {
                        title: "Catégories d'automatisation",
                        content: "Lorsque vous avez de nombreuses automatisations, créez des <b>catégories d'automatisation</b> à partir de cette section pour faciliter la gestion. La catégorisation vous aide à organiser vos automatisations et à les trouver rapidement lorsque vous en avez besoin. Utilisez ce bouton pour créer une nouvelle catégorie."
                    },
                    step3: {
                        title: "Tâches exécutées",
                        content: "Après avoir créé et publié vos automatisations, vous pouvez <b>suivre instantanément le nombre de tâches exécutées par vos automatisations</b> à partir de cette section. Cela vous permet d'observer l'activité de vos automatisations et les processus qu'elles affectent."
                    },
                    step4: {
                        title: "Statistiques d'automatisation",
                        content: "Consultez les <b>statistiques de performance complètes</b> de vos automatisations dans cette section. Voyez la fréquence d'exécution de chaque automatisation, le nombre de tâches réussies, le taux de réussite et les taux d'erreur pour optimiser vos stratégies d'automatisation."
                    }
                }
            },
            aiDynamicCrm: {
                title: "CRM IA",
                content: "Analysez et gérez vos interactions client avec l'intelligence artificielle.",
                steps: {
                    step1: {
                        title: "Filtrer les visiteurs",
                        content: "Filtrez facilement les <b>visiteurs</b> dans votre base de données clients. Vous pouvez rechercher des visiteurs par nom, adresse e-mail, numéro de téléphone, balise ou champs de profil personnalisés. Vous pouvez également accéder à cette section pour une visualisation et une analyse plus détaillées."
                    },
                    step2: {
                        title: "Afficher les visiteurs",
                        content: "Tous vos visiteurs sont listés dans ce tableau. <b>Double-cliquez sur la ligne pertinente pour accéder à plus d'informations et agir sur un visiteur</b>. Dans la fenêtre ouverte, vous pouvez accéder à l'historique de communication, aux notes et à d'autres informations détaillées du visiteur."
                    },
                    step3: {
                        title: "Blocage manuel",
                        content: "Vous pouvez <b>bloquer manuellement les visiteurs</b> qui présentent un comportement indésirable ou inapproprié. Les visiteurs bloqués sont affichés dans une liste séparée, et vous pouvez lever le blocage depuis cette section si nécessaire."
                    },
                    step4: {
                        title: "Balises",
                        content: "Rendez votre CRM plus organisé et gérable en <b>catégorisant vos visiteurs avec des balises</b>. Pour attribuer des balises aux visiteurs, vous devez d'abord créer vos propres balises. Utilisez ce bouton pour créer une nouvelle balise."
                    },
                    step5: {
                        title: "Champs de profil",
                        content: "Les <b>champs de profil</b> vous permettent de collecter des informations supplémentaires sur vos visiteurs et de gérer ces informations de manière organisée. De cette façon, vous pouvez approfondir votre segmentation client, offrir un service personnalisé et rendre vos relations client plus efficaces."
                    }
                }
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Gérez vos messages de support en connectant votre compte WhatsApp Business.",
                steps: {
                    step1: {
                        title: "Intégration WhatsApp Business",
                        content: "<p><b>Connectez votre compte WhatsApp Business à Supsis</b> et gérez tous vos messages de support client depuis un seul panneau central. Grâce à cette intégration, vous pouvez envoyer des messages instantanés via WhatsApp, faire des annonces en masse, configurer des réponses automatisées et suivre de manière exhaustive vos interactions client.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Gérez les messages reçus via WhatsApp Web avec Supsis AI.",
                steps: {
                    step1: {
                        title: "Intégration WhatsApp Web",
                        content: "<p><b>Gérez sans effort tous les messages reçus via WhatsApp Web avec Supsis AI.</b> Grâce à cette intégration, vous pouvez envoyer des messages instantanés via WhatsApp, créer des messages groupés, configurer des réponses automatisées et suivre facilement vos interactions client. De cette façon, vous rendez votre communication client plus efficace.</p>"
                    }
                }
            },
            instagram: {
                title: "Instagram",
                content: "Répondez aux messages directs Instagram via Supsis AI.",
                steps: {
                    step1: {
                        title: "Intégration Instagram",
                        content: "<p><b>Centralisez votre communication client en répondant directement aux messages directs Instagram via Supsis AI.</b> Grâce à cette intégration, vous pouvez envoyer des messages instantanés via Instagram, faire des annonces groupées, configurer des réponses automatisées et suivre de manière exhaustive vos interactions client.</p>"
                    }
                }
            },
            facebook: {
                title: "Facebook",
                content: "Gérez les messages de votre page Facebook dans un seul panneau.",
                steps: {
                    step1: {
                        title: "Intégration Facebook",
                        content: "<p><b>Gérez efficacement tous les messages de votre page Facebook avec Supsis AI.</b> Grâce à cette intégration, vous pouvez envoyer des messages instantanés via Facebook Messenger, créer des messages groupés, configurer des réponses automatisées et suivre vos interactions client.</p>"
                    }
                }
            },
            telegram: {
                title: "Telegram",
                content: "Intégrez les messages Telegram avec Supsis AI.",
                steps: {
                    step1: {
                        title: "Intégration Telegram",
                        content: "<p><b>Intégrez les messages Telegram avec Supsis AI</b> et gérez votre communication client depuis un seul panneau. Grâce à cette intégration, vous pouvez envoyer des messages instantanés via Telegram, créer des messages groupés, configurer des réponses automatisées et suivre sans effort toutes vos interactions client.</p>"
                    }
                }
            },
            mail: {
                title: "Mail",
                content: "Intégrez vos e-mails de support dans le système Supsis AI.",
                steps: {
                    step1: {
                        title: "Créer un nouvel e-mail",
                        content: "<p>Utilisez ce bouton pour envoyer un nouvel e-mail. <b>En remplissant le contenu de l'e-mail, les destinataires et les autres informations nécessaires</b>, vous pouvez envoyer rapidement vos e-mails personnels ou en masse.</p>"
                    },
                    step2: {
                        title: "Modèles d'e-mails",
                        content: "<p><b>Gérez</b> vos modèles d'e-mails à partir de cette section. Vous pouvez modifier, supprimer ou créer de nouveaux modèles. En utilisant des modèles pré-préparés, vous pouvez accélérer vos processus d'envoi d'e-mails et assurer une communication cohérente.</p>"
                    },
                    step3: {
                        title: "Envoyer des e-mails en masse",
                        content: "<p>Utilisez cette zone pour <b>envoyer des e-mails en masse</b> afin d'atteindre de larges audiences. En remplissant les champs requis, vous pouvez facilement envoyer des e-mails en masse à votre liste de clients ou à des groupes spécifiques dans Supsis.</p>"
                    },
                    step4: {
                        title: "Gérer vos groupes de clients",
                        content: "<p><b>Gérez efficacement</b> vos groupes de clients à partir de cette section. Vous pouvez modifier, supprimer ou créer de nouveaux groupes. Avec ces groupes, vous pouvez organiser des campagnes d'e-mails ciblées et personnaliser davantage votre communication.</p>"
                    }
                }
            },
            metaLead: {
                title: "Meta Lead",
                content: "Gérez les formulaires reçus de vos publicités Facebook et Instagram.",
                steps: {
                    step1: {
                        title: "Intégration Meta Lead",
                        content: "<p>Avec l'<b>intégration Meta Lead</b>, gérez les formulaires de clients potentiels reçus de vos publicités Facebook et Instagram directement via Supsis. Grâce à cette intégration, vous pouvez suivre plus efficacement les prospects que vous obtenez de vos campagnes publicitaires, accélérer votre communication avec les clients potentiels et augmenter vos taux de conversion.</p>"
                    }
                }
            },
            trendyol: {
                title: "Trendyol",
                content: "Gérez vos commandes et messages clients Trendyol.",
                steps: {
                    step1: {
                        title: "Intégration Trendyol",
                        content: "<p>Grâce aux <b>Opérations d'intégration Trendyol</b>, gérez de manière centralisée vos commandes reçues via Trendyol via Supsis. Après avoir terminé cette intégration, vous pouvez rendre vos processus de commande plus efficaces, faciliter votre communication client et réduire votre charge de travail opérationnelle.</p>"
                    }
                }
            },
            formSurvey: {
                title: "Formulaires et Sondages",
                content: "Créez des formulaires pour recueillir les commentaires des clients.",
                steps: {
                    step1: {
                        title: "Créer un nouveau formulaire",
                        content: "<p>Utilisez ce bouton pour <b>créer un nouveau formulaire ou sondage</b> afin de recueillir les commentaires de vos clients. Avec les formulaires que vous créez, vous pouvez recueillir des commentaires clients précieux et rendre votre communication plus efficace.</p>"
                    },
                    step2: {
                        title: "Gérer vos formulaires",
                        content: "<p><b>Gérez efficacement tous vos formulaires</b> à partir de cette zone. Vous pouvez modifier, archiver, supprimer ou créer de nouveaux formulaires. Vous pouvez également suivre les performances de vos formulaires publiés, afficher les taux de réponse et effectuer des modifications instantanées si nécessaire. Avec la gestion des formulaires, vous pouvez recueillir et analyser les commentaires des clients plus efficacement.</p>"
                    }
                }
            },
            processManagement: {
                title: "Gestion des processus",
                content: "Planifiez et gérez vos processus de support étape par étape.",
                steps: {
                    step1: {
                        title: "Gérer vos processus métier",
                        content: "<p>Cette section vous permet de gérer efficacement tous vos processus métier. <b>Vous pouvez créer des tâches, les attribuer aux membres de votre équipe et optimiser vos flux de travail.</b> De cette façon, vous pouvez rendre vos processus plus efficaces, suivre l'état des tâches instantanément et augmenter les performances de votre équipe.</p>"
                    },
                    step2: {
                        title: "Lister les tâches",
                        content: "<p><b>Affichez toutes vos tâches dans une vue de liste</b> à partir de cette section. Vous pouvez filtrer, supprimer ou créer de nouvelles tâches. Suivez facilement votre charge de travail avec une vue de liste complète.</p>"
                    },
                    step3: {
                        title: "Étiquettes de tâche",
                        content: "<p><b>Créez des étiquettes</b> pour mieux organiser et gérer vos tâches. En utilisant ces étiquettes, vous pouvez facilement classer les tâches et accélérer vos processus de recherche. Vous pouvez utiliser ce bouton pour créer des étiquettes.</p>"
                    },
                    step4: {
                        title: "Archiver les tâches",
                        content: "<p><b>Archivez les tâches terminées ou inactives pour garder votre espace de travail organisé</b>. Les tâches archivées sont listées ici et peuvent être facilement restaurées si nécessaire.</p>"
                    },
                    step5: {
                        title: "Tâches terminées",
                        content: "<p>Affichez vos <b>tâches terminées</b> à partir de cette section. Vous pouvez modifier le statut des tâches terminées et les archiver si vous le souhaitez. De cette façon, vous pouvez conserver un enregistrement de votre travail terminé et analyser les performances passées.</p>"
                    }
                }
            },
            calendar: {
                title: "Calendrier",
                content: "Gérez votre calendrier de réunions et de tâches.",
                steps: {
                    step1: {
                        title: "Calendrier",
                        content: "<p>Planifiez facilement vos réunions quotidiennement avec ce <b>calendrier</b> interactif. Vous pouvez créer de nouveaux rendez-vous, mettre à jour des réunions existantes via le calendrier ou les annuler. Optimisez votre gestion des rendez-vous et contrôlez efficacement votre emploi du temps.</p>"
                    },
                    step2: {
                        title: "Site Web de réservation",
                        content: "<p>Permettez à vos clients de prendre facilement rendez-vous en utilisant votre propre <b>site Web de réservation</b>. Vos clients peuvent faire des réservations, consulter, mettre à jour ou annuler leurs rendez-vous existants via ce site.</p>"
                    },
                    step3: {
                        title: "Afficher votre site Web",
                        content: "<p>Utilisez ce bouton pour afficher instantanément le site Web de réservation que vous avez créé. <b>Vérifiez la version finale de votre site Web</b> et découvrez comment vos clients verront leurs réservations. Toutes vos réservations actives seront listées sur votre site Web.</p>"
                    },
                    step4: {
                        title: "Créer une nouvelle réservation",
                        content: "<p>Utilisez ce bouton pour <b>créer manuellement une nouvelle réservation</b>. En remplissant toutes les informations nécessaires, vous pouvez rapidement ajouter le rendez-vous à votre calendrier et planifier vos réunions avec vos clients.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "Analyse du site Web",
                content: "Analysez le comportement des visiteurs et obtenez des informations.",
                steps: {
                    step1: {
                        title: "Total des visiteurs",
                        content: "<p>Affichez le <b>nombre total de visiteurs</b> de votre site Web depuis cette zone. Cette métrique indique le nombre total de visiteurs uniques sur votre site au cours d'une période spécifique et vous aide à comprendre la portée totale de votre site.</p>"
                    },
                    step2: {
                        title: "Visiteurs moyens",
                        content: "<p>Suivez le <b>nombre moyen de visiteurs quotidiens ou périodiques</b> de votre site Web ici. Cette métrique est un indicateur essentiel pour évaluer la performance constante de votre site au fil du temps.</p>"
                    },
                    step3: {
                        title: "Nombre maximal de visiteurs",
                        content: "<p>Observez les <b>moments où votre site Web a atteint le plus grand nombre de visiteurs</b> avec cette métrique. Elle indique le nombre le plus élevé de visiteurs sur votre site au cours d'une période spécifique, vous aidant à identifier les périodes de pointe pour les campagnes ou le contenu.</p>"
                    },
                    step4: {
                        title: "Nombre minimal de visiteurs",
                        content: "<p>Suivez les <b>moments où votre site Web a reçu le moins de visiteurs</b> avec cette métrique. Elle indique le nombre le plus bas de visiteurs sur votre site au cours d'une période spécifique, vous aidant à identifier les périodes de faible performance et à prendre les mesures nécessaires.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "Système de tickets de support",
                content: "Organisez les demandes des clients avec un système de tickets.",
                steps: {
                    step1: {
                        title: "Nouveau statut",
                        content: "<p><b>Créez de nouveaux statuts</b> pour faciliter la gestion de vos demandes de support. Par exemple, en définissant des statuts personnalisés tels que « En cours », « Résolu », « En attente », vous pouvez rendre le flux des demandes plus transparent.</p>"
                    },
                    step2: {
                        title: "Statuts",
                        content: "<p><b>Affichez les statuts actuels</b> pour chaque demande de support ouverte ici. En suivant des statuts tels que « Lu », « Répondu », « Annulé », vous pouvez facilement voir les étapes actuelles des demandes et permettre une gestion efficace des processus.</p>"
                    },
                    step3: {
                        title: "Mode d'affichage",
                        content: "<p>Vous pouvez basculer entre les <b>vues liste ou kanban</b> pour gérer plus efficacement vos demandes de support. En changeant le mode d'affichage, vous pouvez suivre visuellement les statuts des demandes et choisir la disposition qui correspond le mieux à votre flux de travail.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "Tableaux dynamiques",
                content: "Personnalisez et gérez vos données en filtrant.",
                steps: {
                    step1: {
                        title: "Créer une catégorie",
                        content: "<p><b>Organisez et gérez mieux vos données en catégorisant vos tableaux</b>. En utilisant le bouton de création de catégorie, vous pouvez définir de nouvelles catégories, grouper vos tableaux et accéder plus rapidement aux données que vous recherchez.</p>"
                    },
                    step2: {
                        title: "Créer un nouveau tableau",
                        content: "<p>Utilisez ce bouton pour <b>créer un nouveau tableau dynamique adapté à vos besoins</b>. En remplissant les informations requises sur l'écran de création de tableau, vous pouvez stocker et gérer vos données dans une structure personnalisée.</p>"
                    },
                    step3: {
                        title: "Créer un tableau avec l'IA",
                        content: "<p>Utilisez ce bouton pour <b>créer rapidement de nouveaux tableaux avec l'aide de l'IA</b>. Il suffit d'entrer les informations pertinentes pour créer un tableau avec l'IA ; le système vous aidera à concevoir des tableaux efficaces avec des suggestions intelligentes.</p>"
                    }
                }
            },
            aiVoice: {
                title: "Agent vocal IA",
                content: "Gérez les conversations de vos utilisateurs avec des agents vocaux alimentés par l'IA.",
                steps: {
                    step1: {
                        title: "Intégration de l'agent vocal IA",
                        content: "<p><b>Intégrez votre agent vocal IA à Supsis</b> pour automatiser et améliorer vos processus de communication client. Après avoir terminé l'intégration, vous pouvez gérer les interactions vocales plus efficacement et augmenter la satisfaction client.</p>"
                    }
                }
            }
        }
    },
};

export default messagesFR;
